// Kaggle.Transpile release Build, Version 5.0.3
// tslint:disable
export namespace Kaggle {
  export namespace Datasets {
    export interface BufferedStreamHolder {
      stream: (/*Stream*/ unknown) | null;
    }

    export interface DataUtils {}

    export interface FileStreamHolder {
      stream: (/*Stream*/ unknown) | null;
    }

    export interface IStreamHolder {
      stream: (/*Stream*/ unknown) | null;
    }

    export interface StreamAdapter {
      stream: (/*Stream*/ unknown) | null;
    }
  }

  export namespace Framework {
    export namespace GoogleMaps {
      export interface Place {
        city: string;
        country: string;
        id: string;
        region: string;
      }
    }

    export namespace Service {
      export interface IRequest {}

      export interface SearchResult<T> {
        total: number;
        items: T[];
      }

      export type ListSelection<L extends any[]> = Partial<
        { [P in keyof L[0]]: Selection<L[0][P]> }
      >;

      export type ObjectSelection<T> = Partial<
        { [P in keyof T]: Selection<T[P]> }
      >;

      export type Selection<T> = ListSelection<T[]> | ObjectSelection<T> | null;
    }
  }

  export namespace Models {}

  export namespace Sdk {
    export namespace Abuse {
      export interface AbuseClient {}
    }

    export namespace ActiveEvents {
      export namespace Protos {
        export interface DeleteActiveEventRequest {
          eventId: string;
        }

        export interface FirebaseConfig {
          apiKey: string;
          authDomain: string;
          databaseUrl: string;
          projectId: string;
          storageBucket: string;
          messagingSenderId: string;
          appId: string;
          proxyDomain: string;
        }

        export interface GetActiveEventsFirebaseConfigRequest {}

        export interface GetActiveEventsFirebaseConfigResponse {
          config: Kaggle.Sdk.ActiveEvents.Protos.FirebaseConfig | null;
          // Custom auth token for the current user (or empty if logged out).
          authToken: string;
        }
      }

      export interface ActiveEventsClient {}
    }

    export namespace Admin {
      export namespace Models {
        export interface ActivityLog {
          id: /*Int32*/ number;
          logDate: /*DateTime*/ string;
          userAgent: string | null;
          ipAddress: string | null;
          country: string | null;
          region: string | null;
          city: string | null;
          organization: string | null;
        }
      }

      export namespace Protos {
        export namespace CreateLogMessageRequest {
          // These intentionally match Microsoft.Extensions.Logging.LogLevel
          // and must match exactly or it won't parse correctly.
          export enum LogLevel {
            NONE = "none", // = 0
            CRITICAL = "critical", // = 1
            ERROR = "error", // = 2
            WARNING = "warning", // = 3
            INFORMATION = "information", // = 4
            DEBUG = "debug", // = 5
            TRACE = "trace", // = 6
          }
        }

        export interface ActivityLog {
          id: number;
          logDate: /* google.protobuf.Timestamp */ string | null;
          userAgent?: /* google.protobuf.StringValue */ string | null;
          ipAddress?: /* google.protobuf.StringValue */ string | null;
          country?: /* google.protobuf.StringValue */ string | null;
          region?: /* google.protobuf.StringValue */ string | null;
          city?: /* google.protobuf.StringValue */ string | null;
          organization?: /* google.protobuf.StringValue */ string | null;
        }

        export interface AddSiteConfigRequest {
          siteId: number;
          name: string;
          value: string;
          bypassCanary: boolean;
        }

        export interface AdminUser {
          id: number;
          mostRecentLog: Kaggle.Sdk.Admin.Protos.ActivityLog | null;
          lastVerifiedPhoneNumber?: /* google.protobuf.StringValue */
            | string
            | null;
        }

        export interface BatchResetRateLimitStatusesRequest {
          // The rate limits to reset (currently no limit).
          requests: Kaggle.Sdk.Admin.Protos.ResetRateLimitStatusRequest[];
        }

        export interface BatchResetRateLimitStatusesResponse {
          resetCount: number;
        }

        export interface CreateDelegatedUserAccessTokenRequest {
          // The user id that the token should represent.
          destinationUserId: number;
          // Reason for delegated access (e.g. support ticket).
          // NOTE: This could be passed to Gin in the future.
          justification: string;
        }

        export interface CreateDelegatedUserAccessTokenResponse {
          // Opaque token that can be used to impersonate another user.
          token: string;
        }

        export interface CreateInboxFileRequest {
          // Directory name used for tagging the uploaded file.
          virtualDirectory: string;
          // Token representing the uploaded file.
          blobFileToken: string;
        }

        // NOTE: This is sent to non-admins, so we're intentionally *NOT* sending back the
        // full InboxFile (with its URL for a direct download).
        export interface CreateInboxFileResponse {}

        export interface CreateIpBanRequest {
          // The exact IPv4 IP (e.g. "1.2.3.4") or a valid CIDR range
          // (e.g. "1.2.3.4/24").
          ipRange: string;
          // An optional comment explaining why the banned was performed.
          comment?: string;
        }

        export interface CreateLogMessageRequest {
          // The logger/source from where the log message will be generated from.
          source: string;
          // The severity level of the message to report.
          level: Kaggle.Sdk.Admin.Protos.CreateLogMessageRequest.LogLevel;
          // The message text to log.
          message: string;
        }

        export interface CreateLogMessageResponse {}

        export interface CreateOrganizationRequest {
          // The display name for the created organization
          displayName: string;
          // The slug for the created organization
          slug: string;
          // The token used for creating a new blob, used here for image resizing and cropping
          token: string;
          // Rectangle points for cropping the image
          rectangle: Kaggle.Sdk.Admin.Protos.Rectangle | null;
        }

        export interface CreateOrganizationResponse {
          // ID for the created organization
          organizationId: number;
        }

        export interface DeleteInboxFileRequest {
          // Id of the file to delete.
          inboxFileId: number;
        }

        export interface DeleteIpBanRequest {
          // The id of the existing ban to delete.
          ipBanId: number;
        }

        export interface DeleteSiteConfigRequest {
          id: number;
          bypassCanary: boolean;
        }

        export interface GetAdminUserRequest {
          userId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface GetDatabaseSizeRequest {}

        export interface GetDatabaseSizeResponse {
          databaseSize?: /* google.protobuf.DoubleValue */ number | null;
        }

        export interface GetLoggingConfigRequest {}

        export interface GetLoggingConfigResponse {
          loggingConfig: string;
        }

        export interface GetSampleRequestRequest {
          requestType: string;
        }

        export interface GetSampleRequestResponse {
          sampleRequest: string;
        }

        export interface GetSiteConfigsRequest {
          siteId: number;
        }

        export interface GetSiteConfigsResponse {
          siteConfigs: Kaggle.Sdk.Admin.Protos.SiteConfig[];
        }

        export interface InboxFile {
          // Unique id for the uploaded file.
          id: number;
          // The optional virtual directory that contains this file.
          virtualDirectory: string;
          // The user-visible filename.
          fileName: string;
          // The size (in bytes) of the file.
          contentLength: number;
          // Timestamp of when the file was uploaded.
          uploadTime: /* google.protobuf.Timestamp */ string | null;
          // The (signed) download URL (direct from GCS)
          directDownloadUrl: string;
          // Ideally we would just need the user's ID and would be able to fetch info for the avatar info,
          // but that currently is ready in the frontend, so we instead send the info that the frontend needs:
          // int32 uploader_user_id = 7;
          uploaderInfo: Kaggle.Sdk.Admin.Protos.InboxFileUserInfo | null;
        }

        // The existing frontend depended on this information. Future updates should just use
        // the user id and fetch whatever is needed.
        export interface InboxFileUserInfo {
          id: number;
          displayName: string;
          userUrl: string;
          // Performance tier should likely be an enum, but making an integer for backwards compatibility
          tier: number;
          thumbnailUrl: string;
        }

        export interface IpBan {
          // The unique identifier for the ban.
          ipBanId: number;
          // The exact IPv4 IP (e.g. "1.2.3.4") or a valid CIDR range
          // (e.g. "1.2.3.4/24").
          ipRange: string;
          // The Kaggle (admin) username who banned the IP range.
          creatorUsername: string;
          // An optional comment explaining why the banned was performed.
          comment: string;
          // The absolute point in time when the IP ban was created.
          createTime: /* google.protobuf.Timestamp */ string | null;
        }

        export interface ListInboxFilesRequest {
          // Optional virtual directory/tag to limit scope of listing.
          virtualDirectory: string;
          // The maximum number of bans to return.
          pageSize: number;
          // The `next_page_token` value returned from a previous request, if any.
          pageToken: string;
        }

        export interface ListInboxFilesResponse {
          // The virtual directory that the files belong to.
          virtualDirectory: string;
          // The listing of files available for download.
          inboxFiles: Kaggle.Sdk.Admin.Protos.InboxFile[];
          // Token to retrieve the next page of results, or empty if there are no more
          // results in the list.
          nextPageToken: string;
        }

        export interface ListIpBansRequest {
          // The maximum number of bans to return.
          pageSize: number;
          // The `next_page_token` value returned from a previous request, if any.
          pageToken: string;
        }

        export interface ListIpBansResponse {
          // A list of all active IP bans.
          ipBans: Kaggle.Sdk.Admin.Protos.IpBan[];
          // Token to retrieve the next page of results, or empty if there are no more
          // results in the list.
          nextPageToken: string;
        }

        export interface ListRateLimitsRequest {}

        export interface ListRateLimitsResponse {
          rateLimits: Kaggle.Sdk.Admin.Protos.RateLimit[];
        }

        export interface ListRateLimitStatusesRequest {
          // Optional filter/pattern passed directly to Redis (for efficient key searching)
          redisKeyPattern: string;
          // Optional regex to use on the rate limit (Redis) key names.
          keyRegex: string;
          // Should the response only include rate limits that have been exceeded/tripped?
          onlyExceeded: boolean;
          // Optional fields to order by (e.g. "key, tokens_count desc").
          orderBy: string;
        }

        export interface ListRateLimitStatusesResponse {
          // Number of rate limits that matched the filters (but irrespective of "only_exceeded").
          filtersMatchCount: number;
          // Time that the request was processed. All expiration times should be after this date.
          // Not using Timestamp until JSON serialization issue is resolved:
          // See https://kaggle.slack.com/archives/CEDHFMV6D/p1570810506045800?thread_ts=1570810037.045200&cid=CEDHFMV6D
          // google.protobuf.Timestamp server_time = 2;
          serverTimeString: string;
          // All rate limits that match the filters and "only_exceeded"
          // Optionally ordered by "order_by".
          rateLimitStatuses: Kaggle.Sdk.Admin.Protos.RateLimitStatus[];
        }

        export interface ListRequestTypesRequest {}

        export interface ListRequestTypesResponse {
          requestTypes: string[];
        }

        export interface RateLimit {
          // The name of the limit (e.g. "CompetitionApiRequest").
          name: string;
          // All of the scopes that apply for the rate limit.
          scopes: Kaggle.Sdk.Admin.Protos.RateLimitScope[];
        }

        export interface RateLimitFillRate {
          // Time period to fill completely (e.g. "minute", "hour")
          per: string;
          initialTokenCount: number;
        }

        export interface RateLimitScope {
          // The scope of the rate limit (e.g. "user", "all")
          scope: string;
          fillRates: Kaggle.Sdk.Admin.Protos.RateLimitFillRate[];
        }

        export interface RateLimitStatus {
          key: string;
          // Not using Timestamp until JSON serialization issue is resolved:
          // See https://kaggle.slack.com/archives/CEDHFMV6D/p1570810506045800?thread_ts=1570810037.045200&cid=CEDHFMV6D
          // google.protobuf.Timestamp update_time = 2;
          updateTimeString: string;
          // google.protobuf.Timestamp expiration_time = 3;
          expirationTimeString: string;
          tokensCount: number;
          blocksCount: number;
          initialTokensCount: number;
        }

        export interface Rectangle {
          // Left (X) crop point
          left: number;
          // Top (Y) crop point
          top: number;
          // Width of cropped image
          width: number;
          // Height of cropped image
          height: number;
        }

        export interface ResetRateLimitStatusRequest {
          // The Redis key of the rate limit reset.
          key: string;
        }

        export interface ResetRateLimitStatusResponse {
          // Was the limit reset?
          reset: boolean;
        }

        export interface ResetSearchIndexesRequest {}

        export interface ResetSearchIndexRequest {
          name: string;
        }

        export interface SiteConfig {
          id: number;
          siteId: number;
          name: string;
          value?: /* google.protobuf.StringValue */ string | null;
        }

        export interface TestIpBansRequest {
          // The IP address(es) (separated by spaces or commas) to test to see if they're banned.
          ips: string;
        }

        export interface TestIpBansResponse {
          // Maps between the parsed IP(s) from the request to its existing IpBan if it
          // exists. If it doesn't exist, an empty IpBan (with id 0) will be returned.
          ipBans: { [key: string]: Kaggle.Sdk.Admin.Protos.IpBan | null };
        }

        export interface UpdateLoggingConfigRequest {
          value: string;
        }

        export interface UpdateSiteConfigRequest {
          id: number;
          value: string;
          bypassCanary: boolean;
        }
      }

      export namespace Requests {
        export interface AuditLog {
          authenticationInfo: Kaggle.Sdk.Admin.Requests.AuthenticationInfo | null;
          methodName: string | null;
          resourceName: string | null;
          serviceName: string | null;
          request: Record<string, /*Object*/ unknown>;
          authorizationInfo: (Kaggle.Sdk.Admin.Requests.AuthorizationInfo)[];
          requestMetadata: Kaggle.Sdk.Admin.Requests.RequestMetadata | null;
        }

        export interface AuthenticationInfo {
          principalEmail: string | null;
        }

        export interface AuthorizationInfo {
          granted: boolean;
          permission: string | null;
          resource: string | null;
        }

        export interface IngestKaggleAuditLogsToGinRequest {
          auditLogs: (/*AuditLog*/ unknown)[];
          dryRun: boolean;
        }

        export interface IngestStackdriverLogToGinRequest {
          protoPayload: Kaggle.Sdk.Admin.Requests.AuditLog | null;
        }

        export interface RequestMetadata {
          callerIp: string | null;
        }

        export interface SiteConfigModifiedRequest {
          action: "none" | "set" | "unset";
          name: string | null;
          value: string | null;
          bypassCanary: boolean;
        }
      }

      export interface AdminClient {}

      export interface GenieClient {}
    }

    export namespace Bq2Mssql {
      export namespace Protos {
        export interface BigqueryImportRequest {}
      }
    }

    export namespace Chime {
      export namespace Protos {
        export interface SendSmsResponse {
          normalizedPhoneNumber?: /* google.protobuf.StringValue */
            | string
            | null;
          isSuccessful: boolean;
          apiTransactionId?: /* google.protobuf.StringValue */ string | null;
          errorMessage?: /* google.protobuf.StringValue */ string | null;
        }

        export interface TestSmsRequest {
          to?: /* google.protobuf.StringValue */ string | null;
          message?: /* google.protobuf.StringValue */ string | null;
        }
      }

      export interface ChimeClient {}
    }

    export namespace Cms {
      export namespace Protos {
        export interface CmsPage {
          isCreatingPage: boolean;
          isEditingPage: boolean;
          title?: /* google.protobuf.StringValue */ string | null;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          mimeType?: /* google.protobuf.StringValue */ string | null;
          pageContent?: /* google.protobuf.StringValue */ string | null;
          createTime: /* google.protobuf.Timestamp */ string | null;
          id: number;
          isPublished: boolean;
          url?: /* google.protobuf.StringValue */ string | null;
          userDisplayName?: /* google.protobuf.StringValue */ string | null;
          username?: /* google.protobuf.StringValue */ string | null;
          isDocPage: boolean;
          docPageOrder?: /* google.protobuf.Int32Value */ number | null;
          allowUnsanitizedHtml: boolean;
          isNewWorld: boolean;
        }

        export interface DocsPage {
          id: number;
          url?: /* google.protobuf.StringValue */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          createTime: /* google.protobuf.Timestamp */ string | null;
          docPageOrder?: /* google.protobuf.Int32Value */ number | null;
          content?: /* google.protobuf.StringValue */ string | null;
        }

        export interface ListDocsRequest {
          wantContent: boolean;
        }

        export interface ListDocsResponse {
          docsPages: Kaggle.Sdk.Cms.Protos.DocsPage[];
        }

        export interface ListPagesRequest {
          filter?: Kaggle.Sdk.Cms.Protos.CmsFilterBy;
          group?: Kaggle.Sdk.Cms.Protos.CmsGroupBy;
          sort?: Kaggle.Sdk.Cms.Protos.CmsSortBy;
          search?: string;
        }

        export interface ListPagesResponse {
          pages: Kaggle.Sdk.Cms.Protos.CmsPage[];
        }

        export interface UpdateDocPageOrderRequest {
          pageId: number;
          orderNum: number;
        }

        export interface UpdatePageRequest {
          id: number;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          isPublished: boolean;
          mimeType?: /* google.protobuf.StringValue */ string | null;
          pageContent?: /* google.protobuf.StringValue */ string | null;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          isDocPage: boolean;
          docPageOrder?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface UpdatePageResponse {
          url?: /* google.protobuf.StringValue */ string | null;
        }

        export enum CmsFilterBy {
          UNSPECIFIED = "unspecified", // = 0
          ALL = "all", // = 1
          PUBLISHED = "published", // = 2
          UNPUBLISHED = "unpublished", // = 3
        }
        export enum CmsGroupBy {
          UNSPECIFIED = "unspecified", // = 0
          ALL = "all", // = 1
          DOCUMENTATION_PAGES = "documentationPages", // = 2
        }
        export enum CmsSortBy {
          UNSPECIFIED = "unspecified", // = 0
          EARLIEST = "earliest", // = 1
          LATEST = "latest", // = 2
          DOC_PAGE_ORDER = "docPageOrder", // = 3
        }
      }

      export interface CmsClient {}
    }

    export namespace Common {
      export namespace Models {
        /*[NotNull]*/
        export interface Category {
          id: /*Int32*/ number;
          name: string;
          fullPath: string;
          listingUrl: string;
          description: string;
          isInherited: boolean;
          datasetCount: /*Int32*/ number;
          competitionCount: /*Int32*/ number;
          scriptCount: /*Int32*/ number;
          totalCount: /*Int32*/ number;
          tagUrl: string;
        }

        /*[NotNull]*/
        export interface CategoryTree {
          category: Kaggle.Sdk.Common.Models.Category;
          children: (Kaggle.Sdk.Common.Models.CategoryTree)[];
        }

        export interface PageMessage {
          id: string | null;
          type: "error" | "info" | "site" | "success" | "warning";
          message: string | null;
          dangerousHtmlMessage: string | null;
          isPersistent: boolean;
        }

        export interface Suggestion {
          entityType: "category" | "competition" | "dataset" | "kernel";
          entityId: /*Int32*/ number;
          title: string | null;
          entityUrl: string | null;
          thumbnailImageUrl: string | null;
          owner: Kaggle.Sdk.Datasets.Models.OwnerDto | null;
        }

        export interface UpvoteSuggestionDto {
          voteCount: /*Int32*/ number;
          medalVoteCount: /*Int32*/ number;
          upVoteUrl: string | null;
          upVoters: (Kaggle.Sdk.Users.Models.SimpleUserDto)[];
        }

        export interface ValueLabel {
          value: string | null;
          label: string | null;
        }
      }

      export namespace Protos {
        export interface CanonicalExceptionExtensions {}

        export interface ErrorResponseExtensions {}

        export interface FileDownloadContext {}

        // Represents an HTTP redirect (e.g. 301 or 302) response.
        // Patterned after ASP.NET MVC's RedirectResult.
        export interface HttpRedirect {
          // Destination URL for the redirect.
          url: string;
          // Should it be an HTTP 301 (permanent) redirect or just temporary (HTTP 302)?.
          permanent: boolean;
        }

        export interface Image {
          src?: /* google.protobuf.StringValue */ string | null;
          alt?: /* google.protobuf.StringValue */ string | null;
        }

        export interface IVisibilityFieldMasks {}

        export interface KnownProtoAnnotations {}

        export interface PaginationTokenExtensions {}

        export interface ProtoFieldMaskTester {}

        export interface RedirectRequiredException {
          redirect: Kaggle.Sdk.Common.Protos.HttpRedirect | null;
        }

        export interface VisibilityFieldMasks
          extends Kaggle.Sdk.Common.Protos.IVisibilityFieldMasks {
          includeMask: (/*FieldMask*/ unknown) | null;
          excludeMask: (/*FieldMask*/ unknown) | null;
          messageIsVisible: boolean;
          excludeFieldExistenceChecker: /*TMessage*/ unknown;
        }

        export interface VoteButton {
          totalVotes: number;
          medalVotes?: /* google.protobuf.Int32Value */ number | null;
          hasAlreadyVotedUp: boolean;
          hasAlreadyVotedDown: boolean;
          canUpvote: boolean;
          canDownvote: boolean;
          voteUpUrl?: /* google.protobuf.StringValue */ string | null;
          voteDownUrl?: /* google.protobuf.StringValue */ string | null;
          voters: Kaggle.Sdk.Users.Protos.User[];
          currentUserInfo: Kaggle.Sdk.Users.Protos.User | null;
          showVoters: boolean;
          alwaysShowVoters: boolean;
          kernelId?: /* google.protobuf.Int32Value */ number | null;
        }
      }

      export interface ForumSlugBuilder {
        forum: string | null;
        forumTopic: string | null;
        forumMessage: string | null;
      }

      export interface ProtoDefault {}

      export interface UrlUtil {}
    }

    export namespace Competitions {
      export namespace Models {
        export interface CompetitionCardDto {
          competitionId: /*Int32*/ number;
          competitionName: string | null;
          competitionTitle: string | null;
          competitionDescription: string | null;
          competitionUrl: string | null;
          coverImageUrl: string | null;
          thumbnailImageUrl: string | null;
          deadline: /*DateTime*/ string;
          totalTeams: /*Int32*/ number;
          totalKernels: /*Int32*/ number;
          rewardQuantity: (/*Decimal*/ number) | null;
          rewardTypeName: string | null;
          organizationName: string | null;
          organizationUrl: string | null;
          organizationAvatarUrl: string | null;
          hostSegment:
            | "analytics"
            | "datasets"
            | "featured"
            | "geQuests"
            | "gettingStarted"
            | "inClass"
            | "masters"
            | "playground"
            | "prospect"
            | "recruitment"
            | "research"
            | "unspecified";
          hostSegmentTitle: string | null;
          isLimited: boolean;
          isPrivate: boolean;
          isInClass: boolean;
          userHasEntered: boolean;
          userRank: (/*Int32*/ number) | null;
          medal: "bronze" | "gold" | "silver" | "unspecified" | null;
          userTeamUsers: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardMemberDto)[];
          categories: Kaggle.Sdk.Tags.Models.TagList | null;
          mergerDeadline: (/*DateTime*/ string) | null;
          newEntrantDeadline: (/*DateTime*/ string) | null;
          enabledDate: (/*DateTime*/ string) | null;
          maxDailySubmissions: /*Int32*/ number;
          maxTeamSize: (/*Int32*/ number) | null;
          evaluationMetric: string | null;
          awardsPoints: boolean;
          isKernelsSubmissionsOnly: boolean;
          submissionsDisabled: boolean;
          rewardDisplay: string | null;
          isOngoingCompetition: boolean;
        }

        export interface CompetitionGroupDto {
          grouping:
            | "active"
            | "activeAndCompleted"
            | "bookmarked"
            | "completed"
            | "entered"
            | "none"
            | "unlaunched";
          totalCompetitions: /*Int64*/ number;
          competitions: (Kaggle.Sdk.Competitions.Models.CompetitionCardDto)[];
        }

        export interface CompetitionLeaderboardMemberDto {
          profileUrl: string | null;
          thumbnailUrl: string | null;
          tier:
            | "contributor"
            | "expert"
            | "grandmaster"
            | "master"
            | "novice"
            | "recalc"
            | "staff";
          displayName: string | null;
        }

        export interface CompetitionLeaderboardSubmissionDto {
          teamId: /*Int32*/ number;
          rank: (/*Int32*/ number) | null;
          change: (/*Int32*/ number) | null;
          medal: "bronze" | "gold" | "silver" | "unspecified" | null;
          teamName: string | null;
          teamMembers: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardMemberDto)[];
          score: string | null;
          entries: /*Int32*/ number;
          lastSubmission: (/*DateTime*/ string) | null;
          sourceKernelName: string | null;
          sourceKernelUrl: string | null;
          submissionId: (/*Int32*/ number) | null;
        }

        export interface LegacyGetLeaderboardResponse {
          submissions: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardSubmissionDto)[];
          beforeUser: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardSubmissionDto)[];
          nearUser: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardSubmissionDto)[];
          afterUser: (Kaggle.Sdk.Competitions.Models.CompetitionLeaderboardSubmissionDto)[];
          userRanking: (/*Int32*/ number) | null;
          totalRankings: /*Int32*/ number;
        }

        export interface LegacyListCompetitionsResponse {
          sortByOptions: (Kaggle.Sdk.Common.Models.ValueLabel)[];
          tabOptions: (Kaggle.Sdk.Common.Models.ValueLabel)[];
          categoryOptions: (Kaggle.Sdk.Common.Models.ValueLabel)[];
          fullCompetitionGroups: (Kaggle.Sdk.Competitions.Models.CompetitionGroupDto)[];
          pagedCompetitionGroup: Kaggle.Sdk.Competitions.Models.CompetitionGroupDto | null;
          values: Kaggle.Sdk.Competitions.Models.ViewCompetitionListValuesDto | null;
        }

        export interface ViewCompetitionListValuesDto {
          page: /*Int32*/ number;
          tab:
            | "entered"
            | "general"
            | "hosted"
            | "inClass"
            | "unlaunched"
            | "unlaunchedInClass";
          sortBy:
            | "best"
            | "earliestDeadline"
            | "grouped"
            | "latestDeadline"
            | "numberOfTeams"
            | "prize"
            | "recentlyCreated"
            | "relevance";
          category:
            | "analytics"
            | "datasets"
            | "featured"
            | "geQuests"
            | "gettingStarted"
            | "inClass"
            | "masters"
            | "playground"
            | "prospect"
            | "recruitment"
            | "research"
            | "unspecified"
            | null;
          search: string | null;
        }
      }

      export namespace Protos {
        export namespace CreateSubmissionRequest {
          export interface FileSource {
            // Token for GCS upload of user's submission file in our temp (inbox) dir.
            gcsBlobToken: string;
          }

          export interface KernelSource {
            // AKA kernel_session_id AKA script_version_id
            kernelRunId: number;
            // Filename in the Output Files of the above Kernel Session
            fileName: string;
          }
        }

        export namespace Foreign {
          // Subset of the full Category object with seemingly everything needed for now.
          // Also known as Tag.
          export interface Category {
            id: number;
            // The name of the category.
            name: string;
            // The category's full path.
            fullPath: string;
            // A description of the category.
            description: string;
            // The number of datasets tagged with this category.
            datasetCount: number;
            // The number of competitions tagged with this category.
            competitionCount: number;
            // The number of kernels tagged with this category.
            scriptCount: number;
            // The name of the category, as it appears in the URL.
            slug: string;
            // The display name of the category.
            displayName: string;
          }

          /// <summary>
          /// This is to support getting required CurrentDatabundleVersionIds for
          /// Competition reruns, potentially in bulk.  If our query layer were extended
          /// outside the Competitions project, this should live in Datasets space.
          /// Keeping this intentionally thin for now to limit the dependency.
          /// </summary>
          export interface Databundle {
            id: number;
            currentDatabundleVersionId: number;
          }

          // Subset of the full Organization object with everything needed for our new world where Organization pages
          // are turned down, and only shown with minimal details in Comps and Datasets pages.
          export interface Organization {
            id: number;
            name: string;
            thumbnailImageUrl?: /* google.protobuf.StringValue */ string | null;
          }

          // Subset of the full User object, currently only using fields required by
          // Competitions code, specifically around Team Members and Admin Emails.
          export interface User {
            // The user's ID.
            id: number;
            // The user's display name.
            displayName: string;
            email: string;
            imageThumbName: string;
            // The name of the user as shown in the URL of their profile page.
            userName: string;
            performanceTier: number;
          }
        }

        export namespace InitiateBulkRerunRequest {
          export interface KernelRunSettings {
            // Currently unused.
            maxRamGb: number;
            // Currently unused.
            maxDiskGb: number;
            // Currently unused.
            maxCpuRuntimeHours: number;
            // Currently unused.
            maxGpuRuntimeHours: number;
            cpuWorkerPoolName?: /* google.protobuf.StringValue */ string | null;
            gpuWorkerPoolName?: /* google.protobuf.StringValue */ string | null;
          }

          export interface RerunSubmissionSelector {
            // If > 0, we won't select more Submissions than specified here.
            maxSubmissions: number;
            // If set and non-empty, we will only look for Submissions with the given Ids.
            submissionIds: number[];
            // If set, take unselected Submissions with highest Public Score up to
            // Competition.NumScoredSubmissions.
            autoSelect: boolean;
          }
        }

        export namespace Legacy {
          export namespace ColumnMapping {
            export enum Type {
              UNSPECIFIED = "unspecified", // = 0
              SOLUTION = "solution", // = 1
              SUBMISSION = "submission", // = 2
            }
          }

          export namespace RescoreSubmissionsRequest {
            export interface SpecificSubmissions {
              submissionIds: number[];
              teamIds: number[];
            }
          }

          export interface AddHostUserRequest {
            competitionId: number;
            hostUserId: number;
          }

          export interface AddHostUserResponse {}

          // Similar to https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
          // Has historically only been used by Competitions but could eventually be made into an official (non-Legacy) service.
          export interface BackgroundOperation {
            id: string;
            name: string;
            done: boolean;
            // This is an "any" type in the normal LongRunningOperation, but we only use it for this purpose.
            metadata: Kaggle.Sdk.Competitions.Protos.Legacy.SubmissionsRange | null;
            error?: /* google.protobuf.StringValue */ string | null;
            progress?: /* google.protobuf.StringValue */ string | null;
            // Convenience URL that allows manual polling of the latest status.
            statusUrl: string;
          }

          // Describes a single column in a dataframe.
          export interface ColumnDefinition {
            name: string;
            parsingDataType: string;
          }

          export interface ColumnMapping {
            type: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMapping.Type;
            warnings: string[];
            // Maps column keys to current selected column definition name.
            columnMappings: {
              [key: string]: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMappingValue | null;
            };
            columnDefinitions: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnDefinition[];
          }

          export interface ColumnMappingValue {
            name?: /* google.protobuf.StringValue */ string | null;
          }

          export interface CompetitionHostClaims {
            readSettings: boolean;
            writeSettings: boolean;
            writeDescriptions: boolean;
            writeDeadline: boolean;
            readSubmissions: boolean;
            writeSubmissions: boolean;
            invalidateSubmissions: boolean;
            rescoreSubmissions: boolean;
            readEvaluation: boolean;
            writeEvaluation: boolean;
            writeTeamVisibility: boolean;
            updateCategory: boolean;
            launchCompetition: boolean;
            writeBenchmarks: boolean;
            writeTeamMergers: boolean;
            isCompetitionHost: boolean;
          }

          export interface CreateCompetitionRequest {
            title: string;
            slug: string;
            briefDescription: string;
            hostSegment: Kaggle.Sdk.Competitions.Protos.HostSegment;
            useKernels: boolean;
          }

          export interface CreateCompetitionResponse {
            competitionUrl: string;
          }

          export interface EvaluationInfo {
            metrics: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationMetricMetadata[];
            metric: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationMetric | null;
            parameters: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationMetricParameter[];
            solutionColumnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMapping | null;
            submissionColumnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMapping | null;
            solutionInfo: Kaggle.Sdk.Competitions.Protos.Legacy.SolutionInfo | null;
            steps: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationStep[];
            isCompetitionEnabled: boolean;
            isCompetitionClosed: boolean;
          }

          export interface EvaluationMetric {
            id: number;
            name: string;
            abbreviation: string;
            description?: /* google.protobuf.StringValue */ string | null;
            isPublic: boolean;
            solutionColumns: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnDefinition[];
            submissionColumns: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnDefinition[];
            parameters: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationMetricParameter[];
          }

          export interface EvaluationMetricMetadata {
            id: number;
            name: string;
            isPublic: boolean;
            abbr: string;
          }

          // (Hyper)parameter used to configure an evaluation metric.
          export interface EvaluationMetricParameter {
            name: string;
            type: string;
            value: string;
          }

          export interface GetBackgroundOperationRequest {
            id: string;
          }

          export interface GetCompetitionHasSubmissionColumnMappingRequest {
            competitionId: number;
          }

          export interface GetCompetitionHasSubmissionColumnMappingResponse {
            hasSubmissionColumnMapping: boolean;
          }

          export interface GetEvaluationMetricRequest {
            competitionId: number;
            metricId: number;
          }

          export interface GetHostChecklistRequest {
            competitionId: number;
          }

          export interface GetHostClaimsRequest {
            competitionId: number;
          }

          // All things metrics related:
          export interface GetHostEvaluationInfoRequest {
            competitionId: number;
          }

          export interface GetMostRecentSubmissionStatusRequest {
            // Must be provided.
            competitionId: number;
            // All three are optional filters to restrict the Submission search.
            submissionId?: /* google.protobuf.Int32Value */ number | null;
            teamId?: /* google.protobuf.Int32Value */ number | null;
            greaterThanSubmissionId?: /* google.protobuf.Int32Value */
              | number
              | null;
            // Whether the skip the extra calculation of this field.
            ignoreRemainingDailySubmissions: boolean;
          }

          export interface GetSolutionColumnMappingRequest {
            competitionId: number;
          }

          export interface GetSolutionColumnMappingResponse {
            solutionColumnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMapping | null;
          }

          export interface GetSolutionInfoRequest {
            competitionId: number;
          }

          export interface GetSubmissionColumnMappingRequest {
            competitionId: number;
          }

          export interface GetSubmissionColumnMappingResponse {
            submissionColumnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.ColumnMapping | null;
          }

          export interface HostChecklist {
            isCompetitionPending: boolean;
            children: Kaggle.Sdk.Competitions.Protos.Legacy.HostChecklistItem[];
          }

          export interface HostChecklistItem {
            ok: boolean;
            message: string;
            action?: /* google.protobuf.StringValue */ string | null;
            url?: /* google.protobuf.StringValue */ string | null;
            tips: string[];
            useHistory: boolean;
          }

          export interface HostEvaluationInfo {
            evaluationInfo: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationInfo | null;
            topMetricIds: number[];
          }

          export interface HostUserAvatar {
            user: Kaggle.Sdk.Users.Protos.UserAvatar | null;
            isAlreadyHost: boolean;
          }

          export interface InvalidateSubmissionsRequest {
            competitionId: number;
            submissionIdsToInvalidate: number[];
            teamIdsToInvalidate: number[];
          }

          export interface LaunchCompetitionRequest {
            competitionId: number;
            // Optional time in the future to launch the competition rather than launching it immediately.
            futureTime: /* google.protobuf.Timestamp */ string | null;
          }

          export interface LaunchCompetitionResponse {
            // The time when the competition launched (or will launch).
            launchTime: /* google.protobuf.Timestamp */ string | null;
          }

          // Differs from ColumnMapping for historical reasons, but should eventually
          // merge that one and this one.
          export interface LegacyColumnMapping {
            mappedColumnNames: { [key: string]: string };
            samplingMethod?: string;
            samplingPercentage?: number;
          }

          // Specifically built for the ListSandboxSubmissions endpoint.
          export interface LegacySandboxSubmission {
            id: number;
            name: string;
            publicScoreFormatted?: /* google.protobuf.StringValue */
              | string
              | null;
            privateScoreFormatted?: /* google.protobuf.StringValue */
              | string
              | null;
            submissionStatus: Kaggle.Sdk.Competitions.Protos.Legacy.LegacySubmissionStatus;
            error?: /* google.protobuf.StringValue */ string | null;
            dateSubmitted: /* google.protobuf.Timestamp */ string | null;
            isBenchmark: boolean;
            downloadUrl: string;
          }

          // Contains raw Submission data, as well as extended data about scoring progress, such as position in pipeline and
          // estimated wait and score durations.
          export interface LegacySubmissionExtended {
            id: number;
            name: string;
            publicScoreFormatted?: /* google.protobuf.StringValue */
              | string
              | null;
            privateScoreFormatted?: /* google.protobuf.StringValue */
              | string
              | null;
            previousBestPublicScoreFormatted?: /* google.protobuf.StringValue */
              | string
              | null;
            submissionStatus: Kaggle.Sdk.Competitions.Protos.Legacy.LegacySubmissionStatus;
            error?: /* google.protobuf.StringValue */ string | null;
            estimatedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */
              | number
              | null;
            estimatedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */
              | number
              | null;
            // May not be set correctly if not requested by the caller.
            remainingDailySubmissions?: /* google.protobuf.Int32Value */
              | number
              | null;
            totalSubmissionsInLine: number;
            elapsedWaitDurationMilliseconds?: /* google.protobuf.Int32Value */
              | number
              | null;
            elapsedScoreDurationMilliseconds?: /* google.protobuf.Int32Value */
              | number
              | null;
            dateSubmitted: /* google.protobuf.Timestamp */ string | null;
            competitionName: string;
            competitionSlug: string;
            userDisplayName: string;
            userName: string;
            priority: Kaggle.Sdk.Competitions.Protos.Legacy.LegacyWorkerPriority;
            isBenchmark: boolean;
            downloadUrl: string;
          }

          export interface ListHostUsersRequest {
            competitionId: number;
          }

          export interface ListHostUsersResponse {
            hosts: Kaggle.Sdk.Users.Protos.UserAvatar[];
          }

          export interface ListSandboxSubmissionsRequest {
            competitionId: number;
          }

          export interface ListSandboxSubmissionsResponse {
            sandboxSubmissions: Kaggle.Sdk.Competitions.Protos.Legacy.LegacySandboxSubmission[];
          }

          export interface ObliterateEvaluationFromStepRequest {
            competitionId: number;
            // Used by frontend clients.
            stepId?: number;
            // Used internally for a specific step.
            evaluationStep?: Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationStep;
          }

          // Used by the UI to let admins pick a specific range of submissions.
          export interface PagingParameters {
            // Number of submissions to skip/ignore from the start of the ordered list.
            skip?: number;
            // Number of submissions to actually pick from the ordered list.
            take?: number;
            // Minimum submission id to pick.
            minId?: number;
            // Maximum submission id to pick.
            maxId?: number;
          }

          export interface RemoveHostUserRequest {
            competitionId: number;
            hostUserId: number;
          }

          export interface RescoreSubmissionsRequest {
            rescoreType: Kaggle.Sdk.Competitions.Protos.Legacy.BulkRescoreSubmissionsType;
            competitionId?: number;
            // Optional specific submissions by id or by team.
            specificSubmissionsToRescore: Kaggle.Sdk.Competitions.Protos.Legacy.RescoreSubmissionsRequest.SpecificSubmissions | null;
            pagingParameters: Kaggle.Sdk.Competitions.Protos.Legacy.PagingParameters | null;
            // Preview the rescore but don't actually do it.
            preview?: boolean;
          }

          export interface SearchHostUsersRequest {
            competitionId: number;
            query: string;
          }

          export interface SearchHostUsersResponse {
            users: Kaggle.Sdk.Competitions.Protos.Legacy.HostUserAvatar[];
          }

          export interface SetBenchmarkSubmissionNameRequest {
            competitionId: number;
            submissionId: number;
            name?: /* google.protobuf.StringValue */ string | null;
          }

          export interface SetEvaluationMetricParametersRequest {
            competitionId: number;
            nameValuePairs: { [key: string]: string };
          }

          export interface SetEvaluationMetricRequest {
            competitionId: number;
            metricId: number;
          }

          export interface SolutionInfo {
            hasRaw: boolean;
            hasDerived: boolean;
            rawFileName?: /* google.protobuf.StringValue */ string | null;
            rawDownloadUrl?: /* google.protobuf.StringValue */ string | null;
            derivedFileName?: /* google.protobuf.StringValue */ string | null;
            derivedDownloadUrl?: /* google.protobuf.StringValue */
              | string
              | null;
            uploadDate: /* google.protobuf.Timestamp */ string | null;
            usageColumnName?: /* google.protobuf.StringValue */ string | null;
            samplingPercentage: number;
            totalSolutionPrivateRows?: /* google.protobuf.Int32Value */
              | number
              | null;
            totalSolutionPublicRows?: /* google.protobuf.Int32Value */
              | number
              | null;
            totalSolutionRows?: /* google.protobuf.Int32Value */ number | null;
          }

          export interface SubmissionsRange {
            count: number;
            minId: number;
            maxId: number;
          }

          export interface ToggleBenchmarkSubmissionRequest {
            competitionId: number;
            submissionId: number;
          }

          export interface UpdateCompetitionSettingsRequest {
            competitionId: number;
            title?: /* google.protobuf.StringValue */ string | null;
            slug: string;
            briefDescription?: /* google.protobuf.StringValue */ string | null;
            hostSegment: Kaggle.Sdk.Competitions.Protos.HostSegment;
            organizationId?: /* google.protobuf.Int32Value */ number | null;
            deadline: /* google.protobuf.Timestamp */ string | null;
            maxTeamSize?: /* google.protobuf.Int32Value */ number | null;
            allowTeamMergers: boolean;
            allowAnonymousTeams: boolean;
            maxDailySubmissions: number;
            numScoredPrivateSubmissions: number;
            countsTowardsRanking: boolean;
            countsTowardsTiers: boolean;
          }

          export interface UpdateSolutionColumnMappingRequest {
            competitionId: number;
            columnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.LegacyColumnMapping | null;
          }

          export interface UpdateSubmissionColumnMappingRequest {
            competitionId: number;
            columnMapping: Kaggle.Sdk.Competitions.Protos.Legacy.LegacyColumnMapping | null;
          }

          export interface UpdateTeamVisibilityRequest {
            competitionId: number;
            hideTeam: boolean;
            teamIds: number[];
          }

          export interface WaitBackgroundOperationRequest {
            id: string;
          }

          export enum BulkRescoreSubmissionsType {
            UNSPECIFIED = "unspecified", // = 0
            ALL = "all", // = 1
            COMPLETED = "completed", // = 2
            COMPLETED_WITHOUT_DETAIL = "completedWithoutDetail", // = 3
            AFTER_DEADLINE = "afterDeadline", // = 4
            PENDING = "pending", // = 5
            ERRORED = "errored", // = 6
            SPECIFIC = "specific", // = 7
            SITEWIDE_SPECIFIC = "sitewideSpecific", // = 8
            SITEWIDE_PENDING = "sitewidePending", // = 9
          }
          export enum EvaluationStep {
            UNSPECIFIED = "unspecified", // = 0
            METRIC = "metric", // = 1
            PARAMETER = "parameter", // = 2
            SOLUTION = "solution", // = 3
            SOLUTION_MAPPING = "solutionMapping", // = 4
            SUBMISSION = "submission", // = 5
            SUBMISSION_MAPPING = "submissionMapping", // = 6
          }
          export enum LegacySubmissionStatus {
            // Prefixing these to deconflict with BulkRescoreSubmissionsType
            PENDING = "pending", // = 0
            COMPLETE = "complete", // = 1
            ERROR = "error", // = 2
          }
          export enum LegacyWorkerPriority {
            NORMAL = "normal", // = 0
            BACKGROUND = "background", // = -1
          }
        }

        export namespace ListCompetitionsRequest {
          export namespace Selector {
            // Predefined query types.
            export enum ListOption {
              // Displays launched competitions.
              // (-- KAGGLE_INTERNAL: DateEnabled in the past --)
              DEFAULT = "default", // = 0
              // Competitions that the current user has entered.
              // (-- KAGGLE_INTERNAL: Specifically, competitions where the user has a
              // team. --)
              USER_ENTERED = "userEntered", // = 1
              // Competitions that the current user is a host for.
              // (-- KAGGLE_INTERNAL: host-via-admin ignored. --)
              USER_HOSTED = "userHosted", // = 2
              // Unlaunched competitions.  Must be admin to use this.
              UNLAUNCHED = "unlaunched", // = 3
              // Displays active competitions.
              // (-- KAGGLE_INTERNAL: date_enabled <= NOW < deadline. --)
              ACTIVE = "active", // = 4
              // Displays completed competitions
              // (-- KAGGLE_INTERNAL: date_enabled != null && deadline < NOW. --)
              COMPLETED = "completed", // = 5
              // Displays all competitions in the Current User's Your Work section.
              // (-- KAGGLE_INTERNAL: Complex query combining recent submissions,
              // rules acceptances, and Leaderboard presence. --)
              USER_YOUR_WORK = "userYourWork", // = 6
              // Displays bookmarked competitions
              USER_BOOKMARKED = "userBookmarked", // = 7
            }
            // Optional filters for competition prestige type.
            export enum PrestigeFilter {
              // Does not add a constraint for prestige type.
              UNSPECIFIED = "unspecified", // = 0
              // Only returns competitions with monetary prizes.
              MONEY = "money", // = 1
              // Only returns competitions which award medals.
              MEDALS = "medals", // = 2
              // Only returns competitions which do not award money nor medals.
              OTHER = "other", // = 3
            }
            // Predefined sort orders.
            export enum SortOption {
              // Currently equal to NEWEST.
              DEFAULT = "default", // = 0
              // Shows the newest competitions first.
              // (-- KAGGLE_INTERNAL: Order by DateEnabled descending. --)
              NEWEST = "newest", // = 1
              // Shows the oldest competitions first.
              // (-- KAGGLE_INTERNAL: Order by Deadline ascending. --)
              OLDEST = "oldest", // = 2
              // Sorts by the competition's prize money.
              // (-- KAGGLE_INTERNAL: Orders by RewardQuantity descending. --)
              REWARD = "reward", // = 3
              // Sorts by the number of teams.
              // (-- KAGGLE_INTERNAL: Order by Comp's (TeamCountOverride ?? TotalTeams)
              // descending. --)
              NUM_TEAMS = "numTeams", // = 4
            }
            // Optional filters for competition visibility.
            export enum VisibilityFilter {
              // Does not add a constraint for visibility.
              UNSPECIFIED = "unspecified", // = 0
              // Only returns publicly visible competitions (anonymous users can see).
              PUBLIC = "public", // = 1
              // Only returns publicly visible competitions whose Private Leaderboard
              // is also visible.
              PUBLIC_AND_PRIVATE_LEADERBOARD = "publicAndPrivateLeaderboard", // = 2
            }
          }

          // Defines the query parameters.
          export interface Selector {
            // Returns competitions matching the provided ID's. If ID's are specified
            // here, the below fields are not used.
            competitionIds: number[];
            // Defines the type of competitions to be returned. Only has an effect if
            // competition_ids is unset.
            listOption: Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest.Selector.ListOption;
            // If specified, lists relative to the given user, otherwise lists relative to
            // calling user by default. Only allowed if list_option is USER_ENTERED or
            // USER_HOSTED. Results will still be restricted and scrubbed relative to the
            // calling user.
            listForUserId?: /* google.protobuf.Int32Value */ number | null;
            // Defines the category of competitions to be returned. This is temporarily
            // an int32, but will eventually be migrated to an enum. The category values
            // are:
            // UNSPECIFIED = 0
            // FEATURED = 1
            // RESEARCH = 2
            // RECRUITMENT = 3
            // GETTING_STARTED = 5
            // MASTERS = 6
            // PLAYGROUND = 8
            // IN_CLASS = 10
            // Only has an effect if competition_ids is unset.
            // (-- KAGGLE_INTERNAL
            // If set, only take Comps with the given HostSegment.  If unset, and
            // `list_option` is neither USER_ENTERED nor USER_HOSTED, we will ignore
            // InClass competitions from the query.
            // Using HostSegment directly is buggy (build-sdk fails), so just use the
            // id for now.
            // --)
            hostSegmentIdFilter: number;
            // If true, only return simulation competitions (Competition.EvaluationAlgorithm.IsEnvironment = 1)
            requireSimulations: boolean;
            // If provided, add a constraint for competitions with matching prestige.
            prestigeFilter: Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest.Selector.PrestigeFilter;
            // If provided, add a constraint for competitions' visibility status
            visibilityFilter: Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest.Selector.VisibilityFilter;
            // Foreign keys to Categories table. If provided, we only take Comps with
            // matching CompetitionCategory entries.
            tagIds: number[];
            // Defines the order in which results should be returned. Only has an
            // effect if competition_ids is unset.
            sortOption: Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest.Selector.SortOption;
            // String search term. Only has an effect if competition_ids is unset.
            // (-- KAGGLE_INTERNAL Hooks up to SearchService. --)
            searchQuery: string;
          }
        }

        export namespace ListSubmissionsRequest {
          export namespace Selector {
            export enum ListOption {
              // List all otherwise matching submissions.
              DEFAULT = "default", // = 0
              // List only successful submissions.
              SUCCESSFUL = "successful", // = 1
              // List only selected submissions.
              SELECTED = "selected", // = 2
            }
            export enum SortOption {
              // Sort by date submitted, newest submissions first.
              DEFAULT = "default", // = 0
              // Sort by the name in alphabetical order.
              NAME = "name", // = 1
              // Sort by the private score, highest score first.
              PRIVATE_SCORE = "privateScore", // = 2
              // Sort by the public score, highest score first.
              PUBLIC_SCORE = "publicScore", // = 3
            }
          }

          export interface Selector {
            listOption: Kaggle.Sdk.Competitions.Protos.ListSubmissionsRequest.Selector.ListOption;
            sortOption: Kaggle.Sdk.Competitions.Protos.ListSubmissionsRequest.Selector.SortOption;
          }
        }

        export namespace SearchTeamsResponse {
          export interface FoundTeam {
            teamId: number;
            teamName: string;
          }
        }

        export namespace UpdateSubmissionSelectionResponse {
          // If we fail for known reasons, we throw CanonicalException with ErrorInfo using one of these values.
          // On success we return an empty message.
          export enum ErrorReason {
            UNSPECIFIED = "unspecified", // = 0
            SELECTIONS_DISABLED = "selectionsDisabled", // = 1
            NOT_TEAM_LEADER = "notTeamLeader", // = 2
            TOO_MANY_SELECTED = "tooManySelected", // = 3
            INVALID_SUBMISSION = "invalidSubmission", // = 4
            ALREADY_HAS_VALUE = "alreadyHasValue", // = 5
          }
        }

        export interface AcceptRulesRequest {
          competitionId: number;
        }

        export interface AcceptTeamMergeRequest {
          mergeRequestId: number;
        }

        export interface ArchiveCompetitionRequest {
          competitionId: number;
        }

        export interface ArchiveCompletedCompetitionForumsRequest {}

        export interface BulkCreateEpisodeRequest {
          requests: Kaggle.Sdk.Competitions.Protos.CreateEpisodeRequest[];
        }

        export interface BulkCreateEpisodeResponse {
          episodes: Kaggle.Sdk.Competitions.Protos.Episode[];
        }

        export interface BulkRerunInfo {
          id: number;
          dateInitiated: /* google.protobuf.Timestamp */ string | null;
          stateCounts: Kaggle.Sdk.Competitions.Protos.RerunStateCount[];
        }

        export interface CalculateClosedCompetitionStrongLeaderboardRequest {}

        export interface CancelBulkRerunRequest {
          bulkRerunId: number;
        }

        export interface CanSubmitRequest {
          createRequest: Kaggle.Sdk.Competitions.Protos.CreateSubmissionRequest | null;
        }

        export interface CanSubmitResponse {
          canSubmit: boolean;
          // can_submit == not_allowed_reasons.is_empty()
          notAllowedReasons: Kaggle.Sdk.Competitions.Protos.SubmissionNotAllowedReason[];
          // The Team under which the Submission would be made. Can be null if the team
          // doesn't exist, for example first submission if RulesRequired = false.
          team: Kaggle.Sdk.Competitions.Protos.Team | null;
          // The Team's submission limit stats, including how many they are allowed to submit right now, if team present.
          submissionLimitInfo: Kaggle.Sdk.Competitions.Protos.SubmissionLimitInfo | null;
          // The filename required for all Kernel Submissions for this Competition,
          // or "" if the Competition has no such constraint.
          requiredFileName: string;
        }

        export interface Competition {
          // The competition ID.
          id: number;
          // The name of the competition as it appears in the URL.
          competitionName: string;
          // The name of the competition as it appears in the title.
          title: string;
          // A short description of the competition.
          briefDescription: string;
          // The competition's start date.
          dateEnabled: /* google.protobuf.Timestamp */ string | null;
          // The competition's deadline.
          deadline: /* google.protobuf.Timestamp */ string | null;
          hasLeaderboard: boolean;
          evaluationAlgorithmId: number;
          leaderboardPercentage: number;
          // The maximum number of submissions a team can make each day.
          maxDailySubmissions: number;
          numScoredSubmissions: number;
          hasSolution: boolean;
          numPrizes: number;
          forumId: number;
          leaderboardDisplayFormat: string;
          finalLeaderboardHasBeenVerified: boolean;
          disableSubmissions: boolean;
          isPrivate: boolean;
          hasHeaderImage: boolean;
          userRankMultiplier: number;
          privateGroupId: number;
          limitedParticipationGroupId: number;
          witholdFinalLeaderboardUntilItHasBeenVerified: boolean;
          hostGroupId: number;
          rewardTypeId: number;
          // The quantity of the reward, if applicable.
          rewardQuantity: number;
          publicLeaderboardDisclaimerMessage: string;
          finalLeaderboardDisclaimerMessage: string;
          dateCreated: /* google.protobuf.Timestamp */ string | null;
          disableLeaderboardPrizeIndicator: boolean;
          competitionHostSegmentId: number;
          modelSubmissionDeadline: /* google.protobuf.Timestamp */
            | string
            | null;
          maxTeamSize: number;
          banTeamMergers: boolean;
          dateSubmitted: /* google.protobuf.Timestamp */ string | null;
          prohibitNewEntrants: boolean;
          medalsAllowed: boolean;
          enableTeamModels: boolean;
          teamModelDeadline: /* google.protobuf.Timestamp */ string | null;
          solutionSalt: string;
          prohibitSolutionDownload: boolean;
          solutionColumnMapping: string;
          submissionColumnMapping: string;
          evaluationAlgorithmParameters: string;
          totalSolutionRows: number;
          totalSolutionPublicRows: number;
          totalSolutionPrivateRows: number;
          isTemplate: boolean;
          teamMergerExplicitDeadline: /* google.protobuf.Timestamp */
            | string
            | null;
          prohibitNewEntrantsExplicitDeadline: /* google.protobuf.Timestamp */
            | string
            | null;
          organizationId: number;
          competitionTypeId: number;
          thumbnailImageUrl: string;
          coverImageUrl: string;
          cardImageUrl: string;
          rowVersion: any;
          showPrivateLeaderboard: boolean;
          // Skip this DB field and just override total_teams in EntityExtensions.cs
          // int32 team_count_override = 99;
          hasScripts: boolean;
          shareToken: string;
          onlyAllowKernelSubmissions: boolean;
          totalTeams: number;
          totalCompetitors: number;
          totalSubmissions: number;
          databundleId: number;
          evaluationSetupStatus: any;
          rulesRequired: boolean;
          usesSynchronousReruns: boolean;
          rerunOverrideDatabundleId: number;
          postProcessorKernelId: number;
          // The last time all Teams' Leaderboard ranks were cached, if applicable.
          leaderboardCacheDate: /* google.protobuf.Timestamp */ string | null;
          // Override for placement on Competition Listing page.
          listingOrderOverride?: /* google.protobuf.Int32Value */ number | null;
          maxCpuRuntimeMinutes?: /* google.protobuf.Int32Value */ number | null;
          maxGpuRuntimeMinutes?: /* google.protobuf.Int32Value */ number | null;
          // Linked reference types.
          databundle: Kaggle.Sdk.Competitions.Protos.Foreign.Databundle | null;
          rerunOverrideDatabundle: Kaggle.Sdk.Competitions.Protos.Foreign.Databundle | null;
          evaluationAlgorithm: Kaggle.Sdk.Competitions.Protos.EvaluationAlgorithm | null;
          // The categories assigned to the competition.
          categories: Kaggle.Sdk.Competitions.Protos.Foreign.Category[];
          organization: Kaggle.Sdk.Competitions.Protos.Foreign.Organization | null;
          // Helper derived fields.
          mergeRequestDeadline: /* google.protobuf.Timestamp */ string | null;
          // The competition's reward type.
          rewardType: Kaggle.Sdk.Competitions.Protos.RewardType | null;
          // TODO: Remove when frontend is using reward_type above instead.
          rewardTypeName: string;
          // This field indicates whether or not a user has bookmarked this competition. It will only be populated properly if
          // Refs.CompetitionUserBookmarks has been passed in along with the repository method.
          userBookmarked: boolean;
          // Indicates if the competition is launched or not
          launched: boolean;
        }

        export interface CompetitionEmail {
          id: number;
          sendDate: /* google.protobuf.Timestamp */ string | null;
          senderUserId: number;
          competitionId: number;
          fromEmail: string;
          emailSubject: string;
          emailBody: string;
          totalEmailsSent: number;
        }

        export interface CompetitionExtensions {}

        export interface CompetitionKernelRerunState {}

        export interface CompetitionKernelRerunState {
          id: Kaggle.Sdk.Competitions.Protos.RerunState;
          name: Kaggle.Sdk.Competitions.Protos.RerunStateName;
          errorCause: Kaggle.Sdk.Competitions.Protos.RerunStateErrorCause;
          // The status we should apply to the source Submission when moving to this Rerun State.
          // Should not be applicable to non-sync rerun comps, which rely on Publish to cause changes.
          sourceSubmissionStatus: Kaggle.Sdk.Competitions.Protos.SubmissionStatus;
        }

        export interface CompetitionUserConfig {
          userId: number;
          // Optional Competition this Config is tied to.  If 0, indicates a "global"
          // Config.
          competitionId: number;
          // The "key" for this config, for example "ListingPageGettingStartedDisabled"
          name: string;
          // The optional "value" for this config.  For many Configs, the presence of
          // the Config represents a flag was flipped, and so value will be null as it
          // has no meaning.  In general, each "name" value implies its own space of
          // values.
          value?: /* google.protobuf.StringValue */ string | null;
          dateCreated: /* google.protobuf.Timestamp */ string | null;
          dateUpdated: /* google.protobuf.Timestamp */ string | null;
        }

        export interface CreateCompetitionSampleSubmissionRequest {
          competitionId: number;
          blobToken: string;
        }

        export interface CreateCompetitionSolutionRequest {
          competitionId: number;
          blobToken: string;
        }

        export interface CreateEnvironmentMetricRequest {
          // This should match the folder name for this environment in https://github.com/Kaggle/kaggle-environments/tree/master/kaggle_environments/envs
          environmentName: string;
          name: string;
          // This configuration will be patched on top of the environment's default configuration for all episodes using this algorithm
          configuration: string;
          // This is a comma separated list of the number of players that can play in each game, e.g. 1,2,4 or 2,2,2,4 (the latter giving a higher chance of 2-player games)
          playerCountSpecification: string;
          renderType: Kaggle.Sdk.Competitions.Protos.EnvironmentRenderType;
        }

        export interface CreateEpisodeRequest {
          submissionIds: number[];
          type: Kaggle.Sdk.Competitions.Protos.EpisodeType;
        }

        export interface CreatePageRequest {
          page: Kaggle.Sdk.Competitions.Protos.Page | null;
        }

        export interface CreateSubmissionRequest {
          competitionId: number;
          kernelSource?: Kaggle.Sdk.Competitions.Protos.CreateSubmissionRequest.KernelSource | null;
          fileSource?: Kaggle.Sdk.Competitions.Protos.CreateSubmissionRequest.FileSource | null;
          // If empty string, a default based on the filename will be chosen.
          description: string;
          // Only hosts or admins can set true.  If set, submission will be made under
          // the Sandbox team, where it can later be converted to a Benchmark team.
          sandbox: boolean;
        }

        export interface CreateTeamsInfo {
          // Team Id is ignored on request, and populated on response.
          id: number;
          name: string;
          leaderId: number;
          memberIds: number[];
        }

        export interface CreateTeamsRequest {
          competitionId: number;
          teams: Kaggle.Sdk.Competitions.Protos.CreateTeamsInfo[];
        }

        export interface CreateTeamsResponse {
          teams: Kaggle.Sdk.Competitions.Protos.CreateTeamsInfo[];
        }

        export interface DeletePageRequest {
          id: number;
        }

        export interface EmailParticipantsRequest {
          competitionId: number;
          userFilter: Kaggle.Sdk.Competitions.Protos.UserFilter;
          fromEmail: string;
          emailSubject: string;
          // Contents of the email to send. Will automatically replace the following:
          // @user.DisplayName (with the recipient's display name)
          // @team.Name (with the name of recipient's team for the given competition)
          // @team.OrdinalRanking (with the current rank of the recipient's team for the
          // given competition)
          emailBody: string;
          // Optional. If set, a sample email will be sent to this address, and no
          // emails will be sent to any other users.
          sendSampleTo: string;
          // If true, no emails will be sent, and the response will contain a sample
          // formatted email body as though the email was sent to the requesting user.
          dryRun: boolean;
        }

        // An episode is an individual run of a simulation with a set of agents
        export interface Episode {
          id: number;
          competitionId: number;
          // For our purposes, create_time is the same as start_time
          createTime: /* google.protobuf.Timestamp */ string | null;
          endTime: /* google.protobuf.Timestamp */ string | null;
          replayUrl?: /* google.protobuf.StringValue */ string | null;
          // This field is used to record any miscellaneous logging / meta info like reasons why an Episode failed
          adminNotes?: /* google.protobuf.StringValue */ string | null;
          state: Kaggle.Sdk.Competitions.Protos.EpisodeState;
          type: Kaggle.Sdk.Competitions.Protos.EpisodeType;
          agents: Kaggle.Sdk.Competitions.Protos.EpisodeAgent[];
        }

        // An episode agent represents a single competition submission participating in this episode
        export interface EpisodeAgent {
          id: number;
          submissionId: number;
          reward?: /* google.protobuf.DoubleValue */ number | null;
          index: number;
          // Score and Confidence of Submission at the time the Episode completed,
          // before updates were applied (if applicable).
          initialScore?: /* google.protobuf.DoubleValue */ number | null;
          initialConfidence?: /* google.protobuf.DoubleValue */ number | null;
          // Updated Submission Score and Confidence, if applicable.
          updatedScore?: /* google.protobuf.DoubleValue */ number | null;
          updatedConfidence?: /* google.protobuf.DoubleValue */ number | null;
          state: Kaggle.Sdk.Competitions.Protos.EpisodeAgentState;
          submission: Kaggle.Sdk.Competitions.Protos.Submission | null;
        }

        export interface EvaluationAlgorithm {
          id: number;
          abbreviation: string;
          name: string;
          description: string;
          isMax: boolean;
          isPublic: boolean;
          submissionFileFormatId: number;
          competitionId: number;
          requiresSameRowCountInSubmissionAndSolution: boolean;
          solutionSchema: string;
          submissionSchema: string;
          parametersSchema: string;
          dateModified: /* google.protobuf.Timestamp */ string | null;
          requiresSpecialHandling: boolean;
          isEnvironment: boolean;
          environmentConfiguration?: /* google.protobuf.StringValue */
            | string
            | null;
          environmentNumPlayersSpec?: /* google.protobuf.StringValue */
            | string
            | null;
          environmentRenderType: Kaggle.Sdk.Competitions.Protos.EnvironmentRenderType;
        }

        export interface ExpireGettingStartedSubmissionsRequest {}

        export interface GenerateEpisodesRequest {
          // Must be provided.
          competitionId: number;
          // Maximum number of episodes to create.  Currently we limit this to 100.
          numEpisodes: number;
          // Must be set.
          numAgentsPerEpisode: number;
          // If set, we won't call BulkCreateEpisode.
          dryRun: boolean;
        }

        export interface GenerateEpisodesResponse {
          // The BulkCreateEpisodeRequest we generated.
          bulkCreateEpisodeRequest: Kaggle.Sdk.Competitions.Protos.BulkCreateEpisodeRequest | null;
          // The response from calling BulkCreateEpisode, if dry_run was false.
          bulkCreateEpisodeResponse: Kaggle.Sdk.Competitions.Protos.BulkCreateEpisodeResponse | null;
        }

        export interface GetCompetitionRequest {
          // Look up a specific competition by ID.
          competitionId: number;
          // Look up a specific competition by name. If both this and competition_id are
          // set, competition_id will take precedence.
          competitionName: string;
        }

        export interface GetEpisodeReplayRequest {
          episodeId: number;
        }

        export interface GetEpisodeReplayResponse {
          replay?: /* google.protobuf.StringValue */ string | null;
        }

        export interface GetLeaderboardRequest {
          // The competition to get the leaderboard for.
          competitionId: number;
          // Must be admin to set to non-default value.
          // Determines which level of LB caching to draw data from.
          leaderboardMode: Kaggle.Sdk.Competitions.Protos.LeaderboardMode;
        }

        export interface GetLeaderboardResponse {
          // List of all entries on the leaderboard, including benchmark teams.
          // Sorted by rank-order; benchmark teams are in their correct location per
          // score, though their rank is 0 since they are not a real team.
          publicLeaderboard: Kaggle.Sdk.Competitions.Protos.LeaderboardEntry[];
          // Same as above, but for Private LB, provided the Current User can view the
          // Private LB. If not, this will be empty.
          privateLeaderboard: Kaggle.Sdk.Competitions.Protos.LeaderboardEntry[];
          // The unordered list of Leaderboard teams.  This should be treated as a
          // dictionary into which each LeaderboardEntry above can lookup using TeamId
          // to get more detailed information, such as TeamName and TeamMembers.
          teams: Kaggle.Sdk.Competitions.Protos.LeaderboardTeam[];
          // The unordered list of public Notebooks, if present, for all
          // LeaderboardEntry
          // objects above.  This should be treated as a dictionary into which each
          // LeaderboardEntry above can lookup using SubmissionId.
          notebooks: Kaggle.Sdk.Competitions.Protos.LeaderboardNotebook[];
        }

        // Gets a Page by some set of unique identifiers.
        // Requires either that 'id' is set or that both 'competition_id' and 'name' are
        // set. If all three are set, will use 'id'.
        export interface GetPageRequest {
          id: number;
          competitionId: number;
          name: string;
        }

        export interface GetPrivacySettingsRequest {
          competitionId: number;
        }

        export interface GetProfileUserStatsRequest {
          // user whose profile is being viewed
          userId: number;
        }

        export interface GetProfileUserStatsResponse {
          // how many competitions has user_id participated in
          competitionsCount: number;
          // how many competitions has user_id participated in without being in a team
          soloCompetitionsCount: number;
          // how many competitions has user_id participated in while in a team
          teamCompetitionsCount: number;
        }

        export interface GetRanksForUsersRequest {
          // The competition to get the leaderboard for.
          competitionId: number;
          // The userIds to lookup Ranks for.
          userIds: number[];
          // Must be admin to set to non-default value.
          // Determines which level of LB caching to draw data from.
          leaderboardMode: Kaggle.Sdk.Competitions.Protos.LeaderboardMode;
        }

        export interface GetRanksForUsersResponse {
          // Maps userId to rank.  If a provided userId is missing here, it means
          // they didn't have a Team on the current main (public vs private) Leaderboard.
          userRanks: { [key: number]: number };
        }

        export interface GetUserRequest {
          // Oneof the following is required to lookup the user specific fields.
          competitionId: number;
          competitionName: string;
        }

        export interface GetUserResponse {
          // The competition these user fields are associated with.
          competitionId: number;
          // The user. Unset for anonymous users.
          user: Kaggle.Sdk.Competitions.Protos.Foreign.User | null;
          // Whether the user is a site admin.
          isAdmin: boolean;
          // Whether the user has been phone-verified.
          isPhoneVerified: boolean;
          // Whether the user has accepted the competition rules, if necessary.
          // If no rules acceptance is required, will always be "true".
          hasAcceptedRules: boolean;
          // Whether the user is a host for this competition.
          isHost: boolean;
          // The user's team for this competition, if present.
          team: Kaggle.Sdk.Competitions.Protos.Team | null;
          // The user's team's submission limit stats and num allowed right now, if team present.
          submissionLimitInfo: Kaggle.Sdk.Competitions.Protos.SubmissionLimitInfo | null;
          // Whether the user can participate in this competition.
          canParticipate: boolean;
        }

        export interface HasAcceptedRulesRequest {
          competitionId: number;
        }

        export interface HasAcceptedRulesResponse {
          hasAccepted: boolean;
          // This can be unset despite has_accepted being true, for example if the comp
          // doesn't require rules acceptance.
          dateAccepted: /* google.protobuf.Timestamp */ string | null;
        }

        export interface InitiateBulkRerunRequest {
          competitionId: number;
          // Object which helps select Submissions.  Each selected Submission yields
          // exactly one child Rerun.
          submissionSelector: Kaggle.Sdk.Competitions.Protos.InitiateBulkRerunRequest.RerunSubmissionSelector | null;
          // Object which controls the Kernel Run for each Rerun.
          kernelRunSettings: Kaggle.Sdk.Competitions.Protos.InitiateBulkRerunRequest.KernelRunSettings | null;
          // Filename to look for in Kernel Run output to send for Submission.  If
          // unset, will use existing Submission's filename.
          expectedSubmissionFilename: string;
          // Max number of times to attempt a Rerun.  Default is 3.
          maxRetries: number;
          // Whether to take latest versions of all datasources or the previous
          // versions from the user's Kernel Commit.
          useUpdatedDatasources: boolean;
        }

        export interface InitiateBulkRerunResponse {
          numCreated: number;
        }

        export interface InvalidateErroringSimulationsSubmissionsRequest {
          // Look at N most recent Episodes per Submission.  Default of 40.
          episodeLookbackCount: number;
          // Max allowed error rate for a Submission.
          // If we find more than max_error_ratio * episode_lookback_count errors,
          // we will invalidate the Submission.  Default value is set by the
          // invalidate-erroring-simulations-submissions-max-error-rate config flag.
          // Note this means a Submission will have to have a certain amount of total
          // Episodes played to be invalidated, even if error rate is 100%.
          maxErrorRate: number;
          // If set, we won't modify the erroring Submissions, only return their Ids.
          dryRun: boolean;
        }

        export interface InvalidateErroringSimulationsSubmissionsResponse {
          erroringSubmissionIds: number[];
        }

        export interface InvalidateSubmissionsRequest {
          // Submission ids to invalidate
          submissionIds: number[];
          // Filled in by admin / engineer to specify why an episode is invalidated.
          userVisibleReason: string;
        }

        export interface LeaderboardEntry {
          // The Id of the team who made the entry.
          teamId: number;
          // The Id of the Team's Submission representing this entry.
          submissionId: number;
          // The rank of the entry. Should only be 0 for benchmark teams.
          rank: number;
          // The score for this entry, possibly truncated.
          displayScore: string;
          // The medal for this entry and the leaderboard it's on.  If the competition
          // is finalized, we'll use the true Team.Medal values on the final LB (public
          // LB if comp has no private LB, otherwise private).  Otherwise, we estimate
          // the medal given current standings and Team Count.
          medal: Kaggle.Sdk.Competitions.Protos.LeaderboardMedal;
        }

        export interface LeaderboardNotebook {
          // The submissionId linked to this Notebook.
          submissionId: number;
          // The title of the Notebook.
          title: string;
          // Denotes the specific Notebook Version; can optionally be part of the URL.
          // (-- KAGGLE_INTERNAL: Primary key of KernelSessions table. --)
          kernelRunId: number;
          // The author of the Notebook; part of the Notebook's URL.
          authorUserName: string;
          // Slug of the Notebook, like `notebook-title`; part of the Notebook's URL.
          slug: string;
        }

        // Subset of Team object to limit return object size, as well as allowing us
        // to read from covering indexes for optimal DB performance.
        export interface LeaderboardTeam {
          teamId: number;
          teamName: string;
          isBenchmark: boolean;
          submissionCount: number;
          lastSubmissionDate: /* google.protobuf.Timestamp */ string | null;
          // The list of users on the team.
          teamMembers: Kaggle.Sdk.Competitions.Protos.Foreign.User[];
        }

        export interface LegacyRecalculateLeaderboardRequest {
          competitionId: number;
        }

        export interface LegacyRecalculateLeaderboardResponse {
          // Number of database rows affected by the leaderboard update.
          rowsAffected: number;
        }

        export interface ListBulkRerunsRequest {
          competitionId: number;
        }

        export interface ListBulkRerunsResponse {
          bulkReruns: Kaggle.Sdk.Competitions.Protos.BulkRerunInfo[];
        }

        export interface ListCompetitionsRequest {
          // Defines the query to perform.
          selector: Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest.Selector | null;
          // Max number of results to return.  Defaults to 1000 if unset.
          pageSize: number;
          // Enables retrieval of more data from the same query.  Should only be set
          // to the `ListCompetitionsResponse.next_page_token` value returned by a
          // previous ListCompetitions call with the exact same `selector` value.
          // Otherwise should be set to "", indicating a fresh query.
          pageToken: string;
        }

        // Lists the requests competitions as well as the user's teams in those
        // competitions.
        export interface ListCompetitionsResponse {
          // The results of the listing.
          competitions: Kaggle.Sdk.Competitions.Protos.Competition[];
          // The current user's active team for each of the returned competitions, if it
          // exists. Order is unspecified, but can be matched with team.competition_id.
          userTeams: Kaggle.Sdk.Competitions.Protos.Team[];
          // The submission limit data for each user_team above, keyed by team_id.
          // Only populated if list_for_user_id is unset or set to current user, for privacy reasons.
          submissionLimitInfos: {
            [key: number]: Kaggle.Sdk.Competitions.Protos.SubmissionLimitInfo | null;
          };
          // Enables retrieval of more data from the same query.  See the `page_token`
          // field from `ListCompetitionsRequest` above.  If the value is "", it means
          // no further results for the request.
          nextPageToken: string;
          // Used for pagination or otherwise displaying how many results are in a filtered
          // collection before pageSize and page are applied
          totalResults: number;
        }

        // If neither is set, we will return all configs for the Current User.
        export interface ListConfigsRequest {
          competitionId?: /* google.protobuf.Int32Value */ number | null;
          // ^Optional value to only get results for the given comp.  If unset, we skip
          // the comp filter. ^If set to 0, we filter on comp == null in the DB,
          // otherwise filter on the given id.
          names: string[];
        }

        export interface ListConfigsResponse {
          configs: Kaggle.Sdk.Competitions.Protos.CompetitionUserConfig[];
        }

        // Only the first populated filter will be used. Exception thrown if none
        // are populated.
        export interface ListEpisodesRequest {
          ids: number[];
          submissionId?: /* google.protobuf.Int32Value */ number | null;
          teamId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface ListEpisodesResponse {
          // EpisodeAgents refs populated, each with no refs, instead pulled out below.
          episodes: Kaggle.Sdk.Competitions.Protos.Episode[];
          // Distinct Submissions that would've been used for EpisodeAgent.Submission
          // in above.  No refs.
          submissions: Kaggle.Sdk.Competitions.Protos.Submission[];
          // Distinct Teams that would've been used for Submission.Team above.  No refs.
          teams: Kaggle.Sdk.Competitions.Protos.Team[];
        }

        export interface ListSubmissionsForUserRequest {
          userId: number;
          // Defaults to 5.
          amount: number;
        }

        export interface ListSubmissionsForUserResponse {
          submissions: Kaggle.Sdk.Competitions.Protos.Submission[];
        }

        export interface ListSubmissionsRequest {
          teamId: number;
          selector: Kaggle.Sdk.Competitions.Protos.ListSubmissionsRequest.Selector | null;
          pageSize: number;
          // Enables retrieval of more data from the same query.  Should only be set
          // to the `ListSubmissionsResponse.next_page_token` value returned by a
          // previous ListSubmissions call with the exact same `selector` value.
          // Otherwise should be set to "", indicating a fresh query.
          pageToken: string;
        }

        export interface ListSubmissionsResponse {
          submissions: Kaggle.Sdk.Competitions.Protos.Submission[];
          // Enables retrieval of more data from the same query.  See the `page_token`
          // field from `ListSubmissionsRequest` above.  If the value is "", it means
          // no further results for the request.
          nextPageToken: string;
        }

        export interface ListTeamMergeRequestsRequest {
          competitionId: number;
        }

        export interface ListTeamMergeRequestsResponse {
          inbound: Kaggle.Sdk.Competitions.Protos.TeamMergeRequest[];
          outbound: Kaggle.Sdk.Competitions.Protos.TeamMergeRequest[];
        }

        export interface ListTeamsByUserRequest {
          userId: number;
        }

        export interface ListTeamsByUserResponse {
          teams: Kaggle.Sdk.Competitions.Protos.Team[];
        }

        export interface ListTeamsRequest {
          // If set, returns all Teams for given Competition.
          // If unset, returns all Teams for the Current User.
          competitionId: number;
        }

        export interface ListTeamsResponse {
          teams: Kaggle.Sdk.Competitions.Protos.Team[];
        }

        // Representation of a top-level Competition page.
        //
        // Note that this does not map directly to the Page database entity,
        // as it also includes elements of the Post entity (contents, mime_type).
        export interface Page {
          // Unique identifier of the Page
          id: number;
          // Unique identifier of the containing Competition
          competitionId: number;
          // The Page name/title
          name: string;
          // Contents of the page (to be rendered according to 'mime_type')
          content: string;
          // The MIME type of the 'content' field
          mimeType: string;
          // Whether the page is publicly visible
          isPublished: boolean;
          // The last time this page was updated
          updatedDate: /* google.protobuf.Timestamp */ string | null;
          // The order of the page within the competition
          order: number;
        }

        export interface PrivacySettings {
          privacy: Kaggle.Sdk.Competitions.Protos.CompetitionPrivacy;
          shareToken: string;
        }

        export interface PublishBulkRerunRequest {
          bulkRerunId: number;
        }

        export interface RecalculateLeaderboardRequest {
          competitionId: number;
          // If STRONG is provided (or chosen as Default, which is possible even if the
          // competition hasn't calculated a Strong LB yet), we will also recalculate
          // the Weak LB cached fields.
          leaderboardMode: Kaggle.Sdk.Competitions.Protos.LeaderboardMode;
          // If true, we won't persist changes, but still return updated_teams.
          dryRun: boolean;
        }

        export interface RecalculateLeaderboardResponse {
          // Teams whose Weak LB cached fields had an update.
          weakUpdatedTeams: Kaggle.Sdk.Competitions.Protos.Team[];
          // Teams whose Strong LB cached fields had an update.
          strongUpdatedTeams: Kaggle.Sdk.Competitions.Protos.Team[];
        }

        export interface RegenerateShareTokenRequest {
          competitionId: number;
        }

        export interface RejectTeamMergeRequest {
          mergeRequestId: number;
        }

        export interface RequestTeamMergeRequest {
          childTeamId: number;
          parentTeamId: number;
        }

        export interface RerunStateCount {
          name: Kaggle.Sdk.Competitions.Protos.RerunStateName;
          count: number;
        }

        export interface RewardType {}

        export interface RewardType {
          id: Kaggle.Sdk.Competitions.Protos.RewardTypeId;
          name: string;
        }

        export interface SearchTeamsRequest {
          competitionId: number;
          // Checks for team names beginning with this value.
          teamNamePrefix: string;
        }

        export interface SearchTeamsResponse {
          teams: Kaggle.Sdk.Competitions.Protos.SearchTeamsResponse.FoundTeam[];
        }

        export interface SetCompetitionDeadlineNowRequest {
          competitionId: number;
        }

        export interface SetCompetitionDeadlineNowResponse {
          // The new/updated competition deadline.
          deadline: /* google.protobuf.Timestamp */ string | null;
        }

        // This sets Episode.State = EpisodeState.ERRORED
        export interface SetEpisodeErroredRequest {
          episodeId: number;
        }

        export interface Submission {
          id: number;
          title: string;
          details: string;
          submittedUserId: number;
          dateSubmitted: /* google.protobuf.Timestamp */ string | null;
          teamId: number;
          privateScore?: /* google.protobuf.DoubleValue */ number | null;
          publicScore?: /* google.protobuf.DoubleValue */ number | null;
          isSelected: boolean;
          status: Kaggle.Sdk.Competitions.Protos.SubmissionStatus;
          isAfterDeadline: boolean;
          publicScoreAdditionalDetails: string;
          privateScoreAdditionalDetails: string;
          processingDetails: string;
          contentLength: number;
          sourceScriptVersionId: number;
          clonedFromSubmissionId: number;
          dateInvalidated: /* google.protobuf.Timestamp */ string | null;
          syncRerunId: number;
          // This field is specific to Simulation Comps and represents the sigma
          // (stddev) for TrueSkill, and thus is "inverse" of confidence.
          publicConfidence?: /* google.protobuf.DoubleValue */ number | null;
          // TODO: Migrate Kaggle.Worker.Shared.WorkerPriority from C# Enum to Proto Enum and integrate here.
          workerPriority: number;
          // Foreign key references.
          team: Kaggle.Sdk.Competitions.Protos.Team | null;
          syncRerunState: Kaggle.Sdk.Competitions.Protos.CompetitionKernelRerunState | null;
        }

        export interface SubmissionExtensions {}

        export interface SubmissionLimitInfo {}

        // Stats about a Team's submissions that count towards daily and global limits, and how many submissions they are
        // currently allowed. Implicitly tied to one Team, and should only be surfaced to members of that Team for privacy
        // reasons.
        export interface SubmissionLimitInfo {
          // Number of valid submissions submitted after the beginning of today UTC.
          numToday: number;
          // Number of valid submissions ever.
          numTotal: number;
          // Number of submissions allowed for the rest of today UTC. If unset, there is no limit (eg, comp is closed).
          numAllowedNow?: /* google.protobuf.Int32Value */ number | null;
          // Whether num_allowed_now was limited by num_total rather than num_today. Very rare, should only occur on the same
          // day that two Teams merge and they barely fit under the num_total limit to be a valid merge. In that case, it may
          // cause user confusion, so we may want to highlight it in the UI somehow.
          limitedByTotal: boolean;
        }

        export interface SubmissionNotAllowedReason {
          code: Kaggle.Sdk.Competitions.Protos.SubmissionNotAllowedReasonCode;
          message: string;
        }

        export interface SubmissionScoringEndedEvent {}

        export interface Team {
          id: number;
          // The name of the team.
          teamName: string;
          // The ID of the competition that the team is entered in.
          competitionId: number;
          // The userId of the team leader. Can be referenced with team_members to
          // determine the user name.
          teamLeaderId: number;
          // Whether or not the team is a benchmark team.
          isBenchmark: boolean;
          // Whether or not the team was created after the competition's deadline.
          createdAfterDeadline: boolean;
          // The current medal placement of this team.  If comp is finalized, uses
          // the stored value representing final private leaderboard rank; otherwise
          // uses current public leaderboard rank.  Value corresponds with
          // Users.Medal.
          medal: number;
          // The date that the private LB medal was awarded, if applicable.
          dateMedalAwarded: /* google.protobuf.Timestamp */ string | null;
          // The number of leaderboard-valid submissions that this team has made (submissions made before deadline with status
          // Complete). This may differ from counts related to submission limits, eg Pending submissions count towards limits
          // but not the leaderboard.
          submissionCount: number;
          // The date of this team's latest submission.
          lastSubmissionDate: /* google.protobuf.Timestamp */ string | null;
          // This will be kept up-to-date while comp is ongoing, if the Team has
          // valid submissions.
          publicLeaderboardSubmissionId?: /* google.protobuf.Int32Value */
            | number
            | null;
          // This will be kept up-to-date while comp is ongoing.
          // This is intended to be a dupe of PublicLeaderboardSubmission.PublicScore
          // which is not ideal, but improves performance of GetLeaderboard.
          publicLeaderboardScore?: /* google.protobuf.DoubleValue */
            | number
            | null;
          // This will be written when the comp is finalized and LB is "locked".
          publicLeaderboardRank?: /* google.protobuf.Int32Value */
            | number
            | null;
          // This will be written when the comp is finalized and LB is "locked".
          privateLeaderboardSubmissionId?: /* google.protobuf.Int32Value */
            | number
            | null;
          // This will be written when the comp is finalized and LB is "locked".
          // This is intended to be a dupe of PrivateLeaderboardSubmission.PrivateScore
          // which is not ideal, but improves performance of GetLeaderboard.
          privateLeaderboardScore?: /* google.protobuf.DoubleValue */
            | number
            | null;
          // This will be written when the comp is finalized and LB is "locked".
          privateLeaderboardRank?: /* google.protobuf.Int32Value */
            | number
            | null;
          // TODO(b/172009687): This should be captured by a new State enum field.
          sandbox: boolean;
          competition: Kaggle.Sdk.Competitions.Protos.Competition | null;
          // The list of users on the team.
          teamMembers: Kaggle.Sdk.Competitions.Protos.Foreign.User[];
          inboundMergeRequests: Kaggle.Sdk.Competitions.Protos.TeamMergeRequest[];
          outboundMergeRequests: Kaggle.Sdk.Competitions.Protos.TeamMergeRequest[];
        }

        export interface TeamMergeRequest {
          id: number;
          childTeamId: number;
          parentTeamId: number;
          state: Kaggle.Sdk.Competitions.Protos.TeamMergeRequestState;
          dateInitiated: /* google.protobuf.Timestamp */ string | null;
          dateUpdated: /* google.protobuf.Timestamp */ string | null;
          childTeam: Kaggle.Sdk.Competitions.Protos.Team | null;
          parentTeam: Kaggle.Sdk.Competitions.Protos.Team | null;
        }

        export interface UpdatePageRequest {
          page: Kaggle.Sdk.Competitions.Protos.Page | null;
          updateMask: google.protobuf.FieldMask | null;
        }

        export interface UpdatePrivacySettingsRequest {
          competitionId: number;
          privacySettings: Kaggle.Sdk.Competitions.Protos.PrivacySettings | null;
        }

        export interface UpdateSubmissionSelectionRequest {
          competitionId: number;
          submissionId: number;
          // True to select, false to unselect.
          select: boolean;
        }

        export interface UpdateSubmissionSelectionResponse {}

        export interface UpdateTeamRequest {
          teamId: number;
          teamName: string;
          teamLeaderId: number;
        }

        export interface UpsertConfigRequest {
          // Comp to link to.  If 0, implies a "global" Config which will be written as
          // null into the DB.
          competitionId: number;
          // "key" string for the configuration entry.  Cannot be null or empty string.
          name: string;
          // Optional value for more complex (than flags, eg) configuration.
          value?: /* google.protobuf.StringValue */ string | null;
        }

        export interface WaitForCompetitionAdminEvaluationEventRequest {
          competitionId: number;
          waitEvent: Kaggle.Sdk.Competitions.Protos.CompetitionAdminEvaluationEvent;
        }

        export interface WaitForCompetitionAdminEvaluationEventResponse {
          event: Kaggle.Sdk.Competitions.Protos.CompetitionAdminEvaluationEvent;
          status: Kaggle.Sdk.Competitions.Protos.CompetitionAdminEvaluationEventStatus;
          errorMessage: string;
        }

        export enum CompetitionAdminEvaluationEvent {
          UNSPECIFIED = "unspecified", // = 0
          SOLUTION_COLUMN_MAPPING_CREATED = "solutionColumnMappingCreated", // = 1
          SOLUTION_SAMPLED = "solutionSampled", // = 2
          SUBMISSION_COLUMN_MAPPING_CREATED = "submissionColumnMappingCreated", // = 3
        }
        export enum CompetitionAdminEvaluationEventStatus {
          UNSPECIFIED = "unspecified", // = 0
          COMPLETED = "completed", // = 1
          ERROR = "error", // = 2
          TIMED_OUT = "timedOut", // = 3
        }
        // Used via WithErrorInfo
        export enum CompetitionError {
          UNSPECIFIED = "unspecified", // = 0
          // User needs to accept the rules of a competition.
          RULES_ACCEPTANCE_REQUIRED = "rulesAcceptanceRequired", // = 1
          // Competition does not allow new entrants.
          NEW_ENTRANTS_NOT_ALLOWED = "newEntrantsNotAllowed", // = 2
        }
        export enum CompetitionPrivacy {
          UNSPECIFIED = "unspecified", // = 0
          PUBLIC = "public", // = 1
          LIMITED = "limited", // = 2
          PRIVATE = "private", // = 3
        }
        export enum EnvironmentRenderType {
          UNSPECIFIED = "unspecified", // = 0
          JSON = "json", // = 1
          // Generate .html file from episode json
          HTML = "html", // = 2
          // Generate .webm file from episode json
          VIDEO = "video", // = 3
          // Generate .webm file and episode json simultaneously during the episode run
          LIVE_VIDEO = "liveVideo", // = 4
        }
        export enum EpisodeAgentState {
          UNSPECIFIED = "unspecified", // = 0
          // The Episode has not yet completed.
          PENDING = "pending", // = 1
          // The Agent completed the Episode.
          COMPLETE = "complete", // = 2
          // The Agent threw an Exception during evaluation, or similar.
          ERROR_EVALUATION = "errorEvaluation", // = 3
          // The Agent returned an invalid action and was disqualified.
          ERROR_INVALID_ACTION = "errorInvalidAction", // = 4
          // The Agent did not return its action in the required time.
          ERROR_TIMEOUT = "errorTimeout", // = 5
          // The Episode failed for unexpected reasons.
          ERROR_ON_EPISODE = "errorOnEpisode", // = 6
        }
        export enum EpisodeState {
          UNSPECIFIED = "unspecified", // = 0
          CREATED = "created", // = 1
          COMPLETED = "completed", // = 2
          ERRORED = "errored", // = 3
          INVALIDATED = "invalidated", // = 4
        }
        // Controls whether score is written and where
        export enum EpisodeType {
          UNSPECIFIED = "unspecified", // = 0
          PUBLIC = "public", // = 1
          // This is deprecated / was never supported.
          PRIVATE = "private", // = 2
          EXHIBITION = "exhibition", // = 3
          VALIDATION = "validation", // = 4
        }
        // NOTE: Keep in Sync with Kaggle.Models.HostSegment until migrated! Also keep
        // the comment in competition_service.ListCompetitionsRequest.Selector.host_segment_id_filter
        // up to date
        export enum HostSegment {
          UNSPECIFIED = "unspecified", // = 0
          DATASETS = "datasets", // = 9
          FEATURED = "featured", // = 1
          GE_QUESTS = "geQuests", // = 7
          GETTING_STARTED = "gettingStarted", // = 5
          MASTERS = "masters", // = 6
          PLAYGROUND = "playground", // = 8
          PROSPECT = "prospect", // = 4
          RECRUITMENT = "recruitment", // = 3
          RESEARCH = "research", // = 2
          IN_CLASS = "inClass", // = 10
          ANALYTICS = "analytics", // = 11
        }
        export enum LeaderboardMedal {
          UNSPECIFIED = "unspecified", // = 0
          NONE = "none", // = 1
          BRONZE = "bronze", // = 2
          SILVER = "silver", // = 3
          GOLD = "gold", // = 4
          IN_THE_MONEY = "inTheMoney", // = 5
        }
        export enum LeaderboardMode {
          // Default indicates to decide between Weak or Strong based on the
          // competition's current state.
          //
          // For read operations like GetLeaderboard and GetRanksForUsers, Strong is
          // used if the competition is completed, private LB is visible, and
          // Strong LB has been written; otherwise Weak is used.
          //
          // RecalculateLeaderboard will do the full Strong LB generation (in addition
          // to Weak) if the comp is completed, otherwise Weak.
          DEFAULT = "default", // = 0
          // Weak Leaderboard means it only uses localized caching of the best public
          // submission per team, stored in the Teams.PublicLeaderboard[SubmissionId,
          // Score, Date] fields (note -Rank is not used).
          // These fields should be kept current synchronously as the comp
          // progresses, along with Teams' SubmissionCount and LastSubmissionDate
          // fields.
          //
          // GetLeaderboard in Weak mode will use the cached data to efficiently get
          // the public LB.  The private LB, which should only be available to admins
          // while Weak is the default, will require a more expensive full calculation.
          //
          // RecalculateLeaderboard in Weak mode will recalculate the Team-localized
          // cached data described above, although ideally those fields are kept in
          // sync already.
          WEAK = "weak", // = 1
          // Strong Leaderboard caches full information about both public and private
          // LBs within the Teams table, including competition-wide Ranks.
          // These fields are only written by RecalculateLeaderboard, which can be
          // invoked manually by admins, or by a forthcoming ScheduledHandler which
          // looks for Competitions which have ended but haven't calculated their
          // Strong Leaderboard.
          //
          // We track whether a Competition has calculated its Strong Leaderboard via
          // Competitions.LeaderboardCacheDate field.
          //
          // GetLeaderboard in Strong mode will be able to get Public and Private LBs
          // efficiently for all users.
          STRONG = "strong", // = 2
        }
        export enum RerunState {
          UNSPECIFIED = "unspecified", // = 0
          INITIATED = "initiated", // = 1
          KERNEL_RUN_QUEUED = "kernelRunQueued", // = 2
          KERNEL_RUN_RUNNING = "kernelRunRunning", // = 3
          KERNEL_RUN_FAILED_TO_START = "kernelRunFailedToStart", // = 4
          KERNEL_RUN_OUT_OF_MEMORY = "kernelRunOutOfMemory", // = 5
          KERNEL_RUN_OUT_OF_DISK = "kernelRunOutOfDisk", // = 6
          KERNEL_RUN_TIMEOUT = "kernelRunTimeout", // = 7
          SUBMISSION_RUNNING = "submissionRunning", // = 8
          SUBMISSION_CSV_NOT_FOUND = "submissionCsvNotFound", // = 9
          SUBMISSION_FAILED_TO_START = "submissionFailedToStart", // = 10
          SUBMISSION_GENERIC_FAILURE = "submissionGenericFailure", // = 11
          SUBMISSION_SUCCEEDED = "submissionSucceeded", // = 12
          PUBLISHED = "published", // = 13
          KERNEL_RUN_CANCELLED = "kernelRunCancelled", // = 14
          KERNEL_RUN_UNKNOWN_ERROR = "kernelRunUnknownError", // = 15
          SUBMISSION_UNKNOWN_ERROR = "submissionUnknownError", // = 16
          KERNEL_RUN_KILLED = "kernelRunKilled", // = 17
          KERNEL_RUN_LIKELY_USER_CODE_ERROR = "kernelRunLikelyUserCodeError", // = 18
          KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS = "kernelRunViolatedComputeConstraints", // = 19
          KERNEL_RUN_REAPED = "kernelRunReaped", // = 20
          SUBMISSION_REAPED = "submissionReaped", // = 21
          SUBMISSION_FAILED_TO_PUBLISH = "submissionFailedToPublish", // = 22
          KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED = "kernelRunMaxOutputFilesExceeded", // = 23
          KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT = "kernelRunAbortedForSubmissionLimit", // = 24
          KERNEL_RUN_NOT_FOUND = "kernelRunNotFound", // = 25
        }
        export enum RerunStateErrorCause {
          // This can be used for non-error states and is a reasonable default.
          NONE = "none", // = 0
          // This is a real value used for error states.
          UNKNOWN = "unknown", // = 1
          KERNEL_RUN_FAILED_TO_START = "kernelRunFailedToStart", // = 2
          KERNEL_RUN_OUT_OF_MEMORY = "kernelRunOutOfMemory", // = 3
          KERNEL_RUN_OUT_OF_DISK = "kernelRunOutOfDisk", // = 4
          KERNEL_RUN_TIMEOUT = "kernelRunTimeout", // = 5
          KERNEL_RUN_KILLED = "kernelRunKilled", // = 6
          KERNEL_RUN_LIKELY_USER_CODE_ERROR = "kernelRunLikelyUserCodeError", // = 7
          KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS = "kernelRunViolatedComputeConstraints", // = 8
          KERNEL_RUN_REAPED = "kernelRunReaped", // = 9
          SUBMISSION_CSV_NOT_FOUND = "submissionCsvNotFound", // = 10
          SUBMISSION_FAILED_TO_START = "submissionFailedToStart", // = 11
          SUBMISSION_GENERIC_FAILURE = "submissionGenericFailure", // = 12
          SUBMISSION_REAPED = "submissionReaped", // = 13
          SUBMISSION_FAILED_TO_PUBLISH = "submissionFailedToPublish", // = 14
          KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED = "kernelRunMaxOutputFilesExceeded", // = 15
          KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT = "kernelRunAbortedForSubmissionLimit", // = 16
          KERNEL_RUN_NOT_FOUND = "kernelRunNotFound", // = 17
        }
        export enum RerunStateName {
          // Should never actually be used, but best practice for proto enum.
          UNSPECIFIED = "unspecified", // = 0
          INITIATED = "initiated", // = 1
          KERNEL_RUN_QUEUED = "kernelRunQueued", // = 2
          KERNEL_RUN_RUNNING = "kernelRunRunning", // = 3
          KERNEL_RUN_ERROR = "kernelRunError", // = 4
          SUBMISSION_RUNNING = "submissionRunning", // = 5
          SUBMISSION_ERROR = "submissionError", // = 6
          SUBMISSION_SUCCEEDED = "submissionSucceeded", // = 7
          PUBLISHED = "published", // = 8
          KERNEL_RUN_CANCELLED = "kernelRunCancelled", // = 9
        }
        export enum RewardTypeId {
          UNSPECIFIED = "unspecified", // = 0
          USD = "usd", // = 1
          KUDOS = "kudos", // = 2
          AUD = "aud", // = 3
          EUR = "eur", // = 4
          JOBS = "jobs", // = 5
          SWAG = "swag", // = 6
          GBP = "gbp", // = 7
          KNOWLEDGE = "knowledge", // = 8
          PRIZES = "prizes", // = 9
        }
        export enum SubmissionNotAllowedReasonCode {
          UNSPECIFIED = "unspecified", // = 0
          // The Comp has disabled submissions.
          COMPETITION_DISABLED = "competitionDisabled", // = 1
          // Current User did not have Team in given comp.
          TEAM_NOT_FOUND = "teamNotFound", // = 2
          // Checks the Current User's Team's Daily/Global Submission allowance.
          TEAM_ALLOWANCE_EXCEEDED = "teamAllowanceExceeded", // = 3
          KERNEL_STILL_RUNNING = "kernelStillRunning", // = 4
          KERNEL_RUNTIME_EXCEEDED = "kernelRuntimeExceeded", // = 5
          MISSING_COMPETITION_DATASOURCE = "missingCompetitionDatasource", // = 6
          HAS_OTHER_COMPETITION_DATASOURCE = "hasOtherCompetitionDatasource", // = 7
          HAS_DATASET_DATASOURCE = "hasDatasetDatasource", // = 8
          HAS_KERNEL_DATASOURCE = "hasKernelDatasource", // = 9
          USES_GPU = "usesGpu", // = 10
          USES_INTERNET = "usesInternet", // = 11
          USES_CUSTOM_DOCKER_IMAGE = "usesCustomDockerImage", // = 12
          INPUT_KERNEL_REJECTED = "inputKernelRejected", // = 13
          WRONG_FILE_NAME = "wrongFileName", // = 14
          // GetKernelRun() can fail if the Kernel was determined to be orphaned
          // and reaped.
          KERNEL_READ_ERROR = "kernelReadError", // = 15
          USES_TPU = "usesTpu", // = 16
          USES_NON_STANDARD_DATASET = "usesNonStandardDataset", // = 17
          DATASET_SIZE_EXCEEDED = "datasetSizeExceeded", // = 18
          NOT_PYTHON = "notPython", // = 19
          USES_NON_VERSIONED_DATASET = "usesNonVersionedDataset", // = 20
          EVALUATION_NOT_SETUP = "evaluationNotSetup", // = 21
          COMPETITION_NOT_LAUNCHED = "competitionNotLaunched", // = 22
          KERNEL_USES_PAID_TIER = "kernelUsesPaidTier", // = 23
          FILE_BLOB_NOT_FOUND = "fileBlobNotFound", // = 24
          FILE_TOO_LARGE = "fileTooLarge", // = 25
          KERNEL_FILE_NOT_FOUND = "kernelFileNotFound", // = 26
          INCORRECT_SUBMISSION_TYPE = "incorrectSubmissionType", // = 27
          NEW_ENTRANTS_DISABLED = "newEntrantsDisabled", // = 28
        }
        export enum SubmissionStatus {
          PENDING = "pending", // = 0
          COMPLETE = "complete", // = 1
          ERROR = "error", // = 2
        }
        export enum TeamMergeRequestState {
          UNSPECIFIED = "unspecified", // = 0
          REQUESTED = "requested", // = 1
          ACCEPTED = "accepted", // = 2
          REJECTED = "rejected", // = 3
          DEACTIVATED = "deactivated", // = 4
        }
        // Specifies a subset of users involved in a competition
        export enum UserFilter {
          UNSPECIFIED = "unspecified", // = 0
          SUBMITTED = "submitted", // = 1
          SUBMITTED_NONE_SELECTED = "submittedNoneSelected", // = 2
          ACCEPTED_RULES = "acceptedRules", // = 3
          ACCEPTED_RULES_UNSUBMITTED = "acceptedRulesUnsubmitted", // = 4
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface GetTeamsForUserRequest {
          userId: /*Int32*/ number;
        }

        export interface LegacyGetLeaderboardRequest {
          competitionId: /*Int32*/ number;
          leaderboardType: "active" | "private" | "public";
          pageSize: (/*Int32*/ number) | null;
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Competitions.Models.LegacyGetLeaderboardResponse
          >;
        }

        export interface LegacyListCompetitionsRequest {
          tab:
            | "entered"
            | "general"
            | "hosted"
            | "inClass"
            | "unlaunched"
            | "unlaunchedInClass";
          category:
            | "analytics"
            | "datasets"
            | "featured"
            | "geQuests"
            | "gettingStarted"
            | "inClass"
            | "masters"
            | "playground"
            | "prospect"
            | "recruitment"
            | "research"
            | "unspecified"
            | null;
          sortBy:
            | "best"
            | "earliestDeadline"
            | "grouped"
            | "latestDeadline"
            | "numberOfTeams"
            | "prize"
            | "recentlyCreated"
            | "relevance";
          search: string | null;
          userId: /*Int32*/ number;
          isProfileListing: boolean;
          page: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface SearchCompetitionsRequest {
          hostUserId: (/*Int32*/ number) | null;
          competitionIds: (/*Int32*/ number)[];
        }
      }

      export interface CompetitionClient {}

      export interface LegacyCompetitionClient {}
    }

    export namespace Datasets {
      export namespace Databundles {
        export namespace Models {
          export namespace Data {
            export interface BooleanMetrics {
              trueCount: /*Int32*/ number;
              falseCount: /*Int32*/ number;
              histogram: Kaggle.Sdk.Datasets.Databundles.Models.Data.Histogram | null;
            }

            export interface CountryMetrics {
              counts: Kaggle.Sdk.Datasets.Databundles.Models.Data.FrequencyCount[];
              uniqueValueCount: /*Int32*/ number;
              mostCommonValue: string | null;
              mostCommonValueCount: /*Int32*/ number;
            }

            export interface DataFilterCriteria {
              maxRows: (/*Int32*/ number) | null;
              startRow: (/*Int32*/ number) | null;
            }

            export interface DataRow
              extends Kaggle.Sdk.Datasets.Databundles.Models.Data.IDataRow {
              count: /*Int32*/ number;
              table: Kaggle.Sdk.Datasets.Databundles.Models.Data.DataTable | null;
            }

            export interface DataTable {
              source: "bigQueryTable" | "csv" | "excel" | "generic" | "sqlite";
              columns: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn)[];
            }

            /*[NotNull]*/
            export interface DateTimeHistogram {
              buckets: Kaggle.Sdk.Datasets.Databundles.Models.Data.DateTimeHistogramBucket[];
            }

            /*[NotNull]*/
            export interface DateTimeHistogramBucket {
              index: /*Int32*/ number;
              label: string;
              leftValue: /*DateTime*/ string;
              rightValue: /*DateTime*/ string;
              count: /*Int32*/ number;
            }

            export interface DateTimeMetrics {
              mean: /*DateTime*/ string;
              minimum: /*DateTime*/ string;
              maximum: /*DateTime*/ string;
              histogram: Kaggle.Sdk.Datasets.Databundles.Models.Data.DateTimeHistogram | null;
            }

            /*[NotNull]*/
            export interface FrequencyCount {
              key: string;
              value: /*Int32*/ number;
            }

            /*[NotNull]*/
            export interface Histogram {
              buckets: Kaggle.Sdk.Datasets.Databundles.Models.Data.HistogramBucket[];
              type: "boolean" | "dateTime" | "numeric" | "string" | "unknown";
            }

            /*[NotNull]*/
            export interface HistogramBucket {
              index: /*Int32*/ number;
              label: string;
              leftValue: /*Double*/ number;
              rightValue: /*Double*/ number;
              count: /*Int32*/ number;
            }

            export interface IDataRow {
              count: /*Int32*/ number;
              table: Kaggle.Sdk.Datasets.Databundles.Models.Data.DataTable | null;
            }

            export interface NumericMetrics {
              finiteCount: /*Int32*/ number;
              infiniteCount: /*Int32*/ number;
              mean: /*Double*/ number;
              standardDeviation: /*Double*/ number;
              minimum: /*Double*/ number;
              minimumFinite: /*Double*/ number;
              maximum: /*Double*/ number;
              maximumFinite: /*Double*/ number;
              quantiles: Kaggle.Sdk.Datasets.Databundles.Models.Data.Quantile[];
              histogram: Kaggle.Sdk.Datasets.Databundles.Models.Data.Histogram | null;
            }

            export interface ProjectedDataRow
              extends Kaggle.Sdk.Datasets.Databundles.Models.Data.IDataRow {
              count: /*Int32*/ number;
              table: Kaggle.Sdk.Datasets.Databundles.Models.Data.DataTable | null;
            }

            /*[NotNull]*/
            export interface Quantile {
              point: /*Double*/ number;
              value: /*Double*/ number;
            }

            /*[NotNull]*/
            export interface SimpleDateTimeMetrics
              extends Kaggle.Sdk.Datasets.Databundles.Models.Data
                .SimpleMetrics {
              minimum: /*DateTime*/ string;
              maximum: /*DateTime*/ string;
              average: /*DateTime*/ string;
            }

            /*[NotNull]*/
            export interface SimpleMetrics {
              count: /*Int32*/ number;
            }

            /*[NotNull]*/
            export interface SimpleNumericMetrics
              extends Kaggle.Sdk.Datasets.Databundles.Models.Data
                .SimpleMetrics {
              minimum: /*Double*/ number;
              maximum: /*Double*/ number;
              average: /*Double*/ number;
            }

            export interface StringMetrics {
              counts: Kaggle.Sdk.Datasets.Databundles.Models.Data.FrequencyCount[];
              uniqueValueCount: /*Int32*/ number;
              mostCommonValue: string | null;
              mostCommonValueCount: /*Int32*/ number;
            }
          }

          export namespace DataObjects {
            export interface Databundle
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              databundleInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DatabundleInfo;
              datasetInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DatasetInfo | null;
              competitionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.CompetitionInfo | null;
              remoteDatasourceInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteDatasourceInfo | null;
              bigqueryInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.BigqueryInfo | null;
              githubInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.GithubInfo | null;
            }

            export interface DatabundleVersion
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              databundleVersionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DatabundleVersionInfo;
              datasetVersionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DatasetVersionInfo | null;
              /*[NotNull]*/
              statusInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.StatusInfo;
              exceptionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ExceptionInfo | null;
              filesetInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DirectoryInfo | null;
              originalCompressionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.CompressionInfo | null;
              bundleCompressionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.CompressionInfo | null;
              bigquerySnapshotInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.BigquerySnapshotInfo | null;
              storageInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.StorageInfo | null;
              fileSummaryInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.FileSummaryInfo | null;
              columnSummaryInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ColumnSummaryInfo | null;
              externalCopyInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ExternalCopyInfo | null;
              originalRemoteUrlInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.OriginalRemoteUrlInfo | null;
            }

            export interface DatabundleVersionList {
              databundleVersions: (/**/ unknown)[];
            }

            export interface DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              key: string;
              /*[NotNull]*/
              path: string;
              legacyEntityId: (/*Int32*/ number) | null;
              /*[NotNull]*/
              relativeUrl: string;
              /*[NotNull]*/
              name: string;
              description: string | null;
            }

            export interface DataSource
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              databundle: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Databundle;
              /*[NotNull]*/
              databundleVersion: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion;
              /*[NotNull]*/
              imageUrl: string;
              /*[NotNull]*/
              sourceUrl: string;
              slug: string | null;
              mountSlug: string | null;
              lastUpdated: (/*DateTime*/ string) | null;
              subtitle: string | null;
              sourceType:
                | "competition"
                | "dataset"
                | "notebook"
                | "notebookOutput"
                | "utilityScript";
              sourceId: /*Int32*/ number;
              versionNumber: (/*Int32*/ number) | null;
              state: "deleted" | "private" | "privateButVisible" | "public";
              kernelOutputInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.KernelOutputInfo | null;
            }

            export interface Directory
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              directoryInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DirectoryInfo;
              compressionInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.CompressionInfo | null;
            }

            export interface File
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              fileInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.FileInfo;
              fileTableInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.FileTableInfo | null;
              tableInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableInfo | null;
              sqliteInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.SqliteInfo | null;
              excelInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ExcelInfo | null;
              remoteUrlInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteUrlInfo | null;
            }

            export interface Table
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              tableInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableInfo;
            }

            export interface TableColumn
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataObjects
                .DataObject {
              type:
                | "databundle"
                | "databundleVersion"
                | "dataSource"
                | "directory"
                | "file"
                | "generic"
                | "table"
                | "tableColumn";
              /*[NotNull]*/
              tableColumnInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableColumnInfo;
              tableColumnMetrics: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableColumnMetrics | null;
            }
          }

          export namespace DataProperties {
            /*[NotNull]*/
            export interface BigqueryInfo {
              projectId: string;
              datasetId: string;
              sourceLastModifiedDate: /*DateTime*/ string;
            }

            /*[NotNull]*/
            export interface BigquerySnapshotInfo {
              sourceLastModifiedDate: /*DateTime*/ string;
              bigqueryTables: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableCollection;
            }

            /*[NotNull]*/
            export interface ColumnBaseInfo {
              name: string;
              firestorePath: string;
              order: /*Int32*/ number;
            }

            export interface ColumnSummaryInfo {
              columnTypes: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ColumnTypeSummaryInfo)[];
              sampleColumnNames: (string)[];
              totalColumnCount: /*Int64*/ number;
            }

            export interface ColumnTypeSummaryInfo {
              columnType: string | null;
              columnCount: /*Int64*/ number;
              rowCount: /*Int64*/ number;
            }

            /*[NotNull]*/
            export interface CompetitionInfo {
              competitionId: /*Int32*/ number;
              competitionSlug: string;
            }

            /*[NotNull]*/
            export interface CompressionInfo {
              filename: string;
              fileExtension: string;
              fileSize: /*Int64*/ number;
              contentEncoding: string;
              contentMD5: string;
              archiveGcsUrl: string;
              creationLastUpdate: (/*DateTime*/ string) | null;
              creationPercentComplete: (/*Double*/ number) | null;
            }

            export interface ContainerInfoConverter
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {}

            export interface DatabundleInfo {
              currentDatabundleVersionId: (/*Int32*/ number) | null;
              /*[NotNull]*/
              databundleType:
                | "competition"
                | "dataset"
                | "general"
                | "notebook";
              /*[NotNull]*/
              diffType: "realtime" | "unversioned" | "versioned";
              /*[NotNull]*/
              creationDate: /*DateTime*/ string;
              /*[NotNull]*/
              creatorUserId: /*Int32*/ number;
              removalDate: (/*DateTime*/ string) | null;
              currentGoodVersionKey: string | null;
              lastestVersionKey: string | null;
              versions: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DatabundleVersionCollection | null;
            }

            export interface DatabundleVersionCollection
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {
              children: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion)[];
            }

            export interface DatabundleVersionInfo {
              versionNumber: /*Int32*/ number;
              versionNotes: string | null;
              creatorUserId: /*Int32*/ number;
              creationDate: /*DateTime*/ string;
              removalDate: (/*DateTime*/ string) | null;
              databundleVersionType:
                | "bigQuery"
                | "fileset"
                | "gcsFileSet"
                | "kernelOutputFileSet"
                | "remoteGitRepositoryFileSet"
                | "remoteUrlFileSet";
              objectTypeCount: Record<string, /*Int32*/ number>;
            }

            /*[NotNull]*/
            export interface DatasetInfo {
              datasetId: /*Int32*/ number;
              datasetSlug: string;
              isPrivate: boolean;
            }

            /*[NotNull]*/
            export interface DatasetVersionInfo {
              datasetVersionId: /*Int32*/ number;
            }

            export interface DirectoryCollection
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {
              children: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Directory)[];
            }

            /*[NotNull]*/
            export interface DirectoryInfo {
              totalSize: /*Int64*/ number;
              directories: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.DirectoryCollection;
              files: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.FileCollection;
            }

            /*[NotNull]*/
            export interface ExcelInfo {
              tables: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableCollection;
            }

            export interface ExceptionInfo {
              criticalException: string | null;
              /*[NotNull]*/
              warningExceptions: (string)[];
            }

            /*[NotNull]*/
            export interface ExternalCopy {
              bucket: string;
              path: string;
              region: string;
              lastCopied: /*DateTime*/ string;
              status: "finished" | "started";
              lastUpdate: (/*DateTime*/ string) | null;
              percentFinished: (/*Double*/ number) | null;
            }

            /*[NotNull]*/
            export interface ExternalCopyInfo {
              externalCopies: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ExternalCopy)[];
            }

            export interface FileCollection
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {
              children: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.File)[];
            }

            /*[NotNull]*/
            export interface FileExtensionSummaryInfo {
              extension: string;
              fileCount: /*Int64*/ number;
              totalSize: /*Int64*/ number;
            }

            export interface FileInfo {
              size: /*Int64*/ number;
              /*[NotNull]*/
              fullPath: string;
              downloadUrl: string | null;
              /*[NotNull]*/
              fileExtension: string;
              /*[NotNull]*/
              contentType: string;
              /*[NotNull]*/
              contentMD5: string;
              gcsUrl: string | null;
              gcsCompressedUrl: string | null;
            }

            /*[NotNull]*/
            export interface FileSummaryInfo {
              fileTypes: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.FileExtensionSummaryInfo)[];
              sampleFileNames: (string)[];
              totalFileCount: /*Int64*/ number;
            }

            /*[NotNull]*/
            export interface FileTableInfo {
              includesHeader: boolean;
              headerRow: /*Int32*/ number;
              delimiter: string;
            }

            export interface GithubInfo {
              /*[NotNull]*/
              ownerSlug: string;
              /*[NotNull]*/
              repositorySlug: string;
              lastUpdatedHash: string | null;
            }

            export interface IContainerInfo {
              totalChildren: /*Int32*/ number;
              count: /*Int32*/ number;
            }

            export interface KernelOutputInfo {
              kernelId: /*Int32*/ number;
              /*[NotNull]*/
              url: string;
            }

            export interface ListBasedContainerInfoConverter
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {}

            /*[NotNull]*/
            export interface OriginalRemoteUrlInfo {
              originalRemoteUrls: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteUrlInfo)[];
            }

            /*[NotNull]*/
            export interface RemoteDatasourceInfo {
              updateFrequency: "daily" | "monthly" | "never" | "weekly";
            }

            /*[NotNull]*/
            export interface RemoteUrlInfo {
              url: string;
              name: string;
            }

            /*[NotNull]*/
            export interface SqliteInfo {
              tables: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableCollection;
            }

            /*[NotNull]*/
            export interface StatusInfo {
              status: "created" | "error" | "processing" | "ready";
              statusMessage: string;
              percentageCompleted: /*Double*/ number;
            }

            /*[NotNull]*/
            export interface StorageInfo {
              uploadDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation;
              rawDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation;
              individualCompressedLocation: Kaggle.Sdk.Datasets.Models.StorageLocation;
              bundleArchiveLocation: Kaggle.Sdk.Datasets.Models.StorageLocation;
              fileSystemLocation: Kaggle.Sdk.Datasets.Models.StorageLocation;
            }

            export interface TableCollection
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {
              children: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Table)[];
            }

            export interface TableColumnCollection
              extends Kaggle.Sdk.Datasets.Databundles.Models.DataProperties
                .IContainerInfo {
              children: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn)[];
            }

            export interface TableColumnInfo {
              order: (/*Int32*/ number) | null;
              originalType: string | null;
              type: "boolean" | "dateTime" | "numeric" | "string" | "unknown";
              extendedType:
                | "address"
                | "city"
                | "coordinates"
                | "country"
                | "decimal"
                | "email"
                | "id"
                | "integer"
                | "latitude"
                | "longitude"
                | "postalCode"
                | "province"
                | "url"
                | "uuid"
                | null;
              isNullable: boolean | null;
              isPrimaryKey: boolean | null;
              isLabel: boolean | null;
            }

            export interface TableColumnMetrics {
              errorMessage: string | null;
              nullCount: /*Int32*/ number;
              nonNullCount: /*Int32*/ number;
              validCount: /*Int32*/ number;
              invalidCount: /*Int32*/ number;
              totalCount: /*Int32*/ number;
              booleanMetrics: Kaggle.Sdk.Datasets.Databundles.Models.Data.BooleanMetrics | null;
              numericMetrics: Kaggle.Sdk.Datasets.Databundles.Models.Data.NumericMetrics | null;
              dateTimeMetrics: Kaggle.Sdk.Datasets.Databundles.Models.Data.DateTimeMetrics | null;
              stringMetrics: Kaggle.Sdk.Datasets.Databundles.Models.Data.StringMetrics | null;
              countryMetrics: Kaggle.Sdk.Datasets.Databundles.Models.Data.CountryMetrics | null;
            }

            /*[NotNull]*/
            export interface TableInfo {
              totalColumns: /*Int32*/ number;
              totalRows: /*Int64*/ number;
              tableColumns: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.TableColumnCollection;
            }
          }

          export namespace Upload {
            export interface ColumnUpdateInfo {
              /*[NotNull]*/
              firestorePath: string;
              /*[NotNull]*/
              description: string;
              /*[NotNull]*/
              type: "boolean" | "dateTime" | "numeric" | "string" | "unknown";
              extendedType:
                | "address"
                | "city"
                | "coordinates"
                | "country"
                | "decimal"
                | "email"
                | "id"
                | "integer"
                | "latitude"
                | "longitude"
                | "postalCode"
                | "province"
                | "url"
                | "uuid"
                | null;
            }

            /*[NotNull]*/
            export interface ExistingDirectoryInfo {
              name: string;
              directories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingDirectoryInfo)[];
              files: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingFileInfo)[];
            }

            export interface ExistingFileInfo {
              /*[NotNull]*/
              name: string;
              size: /*Int64*/ number;
              gcsPath: string | null;
              legacyInfo: Kaggle.Sdk.Datasets.Databundles.Models.Upload.LegacyExistingFileInfo | null;
            }

            export interface GcsFileSetInfo {
              gcsUrl: string | null;
            }

            export interface KernelOutputFileInfo {
              /*[NotNull]*/
              kernelVersionOutputFileId: (/*Int32*/ number) | null;
              kernelVersionId: (/*Int32*/ number) | null;
              kernelId: (/*Int32*/ number) | null;
              size: (/*Int64*/ number) | null;
              name: string | null;
            }

            export interface KernelOutputInfo {
              kernelVersionId: /*Int32*/ number;
              kernelId: /*Int32*/ number;
              kernelOutputFiles: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.KernelOutputFileInfo)[];
            }

            /*[NotNull]*/
            export interface LegacyExistingFileInfo {
              databundleVersionObjectId: /*Int32*/ number;
              blobFileId: /*Int32*/ number;
            }

            /*[NotNull]*/
            export interface UploadDirectoryInfo {
              name: string;
              directories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.UploadDirectoryInfo)[];
              files: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.UploadFileInfo)[];
            }

            /*[NotNull]*/
            export interface UploadFileInfo {
              name: string;
              token: string;
            }
          }

          export namespace Worker {
            export interface ActionFlags {
              disableWorker: boolean;
              disableBundleCreation: boolean;
              disableIndividualZipCreation: boolean;
              disableRawUpload: boolean;
              disableMetadata: boolean;
              disableStatus: boolean;
              disableStatusPubSub: boolean;
              disableFinalResult: boolean;
              disableEmbeddedFilesystem: boolean;
              disableDecompression: boolean;
              disableDirectoryZipCreation: boolean;
              useStandaloneZipperForBundle: boolean;
              reuseOriginalSingleGcsZip: boolean;
              gcsUploadUrl: string | null;
              migration: boolean;
              migrationIsCurrentDatabundleVersion: boolean;
            }

            export interface ActionInput {
              /*[NotNull]*/
              actionId: string;
              uploadDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
              rawDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
              individualCompressedLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
              bundleArchiveLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
              fileSystemLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
              /*[NotNull]*/
              databundle: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Databundle;
              /*[NotNull]*/
              databundleVersion: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion;
              userInfo: Kaggle.Sdk.Datasets.Databundles.Models.Worker.UserInfo | null;
              limits: Kaggle.Sdk.Datasets.Models.DatasetLimits | null;
              uploadSize: (/*Int64*/ number) | null;
              databundleVersionType:
                | "bigQuery"
                | "fileset"
                | "gcsFileSet"
                | "kernelOutputFileSet"
                | "remoteGitRepositoryFileSet"
                | "remoteUrlFileSet";
              githubInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.GithubInfo | null;
              remoteUrls: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteUrlInfo)[];
              /*[NotNull]*/
              flags: Kaggle.Sdk.Datasets.Databundles.Models.Worker.ActionFlags;
            }

            export interface ActionResult {
              databundleVersion: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion | null;
            }

            export interface GcsLocations {}

            export interface UserInfo {
              id: /*Int32*/ number;
              ipAddress: string | null;
              userAgentId: /*Int32*/ number;
              isAdmin: boolean;
            }
          }
        }

        export namespace Requests {
          export interface CopyGcsDataRequest {
            source: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
            destination: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
            firestoreTrackingPath: string | null;
          }

          export interface DatabundleWorkerRequest {
            input: Kaggle.Sdk.Datasets.Databundles.Models.Worker.ActionInput | null;
            deleteOldVersions: boolean;
          }

          export interface DatabundleWorkerStatusRequest {
            actionId: string | null;
            legacyDatabundleVersionId: /*Int32*/ number;
            databundleVersionPath: string | null;
            statusInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.StatusInfo | null;
            deleteOldVersions: boolean;
            flags: Kaggle.Sdk.Datasets.Databundles.Models.Worker.ActionFlags | null;
          }

          export interface DatabundleZipperBundleRequest {
            actionId: string | null;
            firestorePath: string | null;
            gcsOriginalLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
            gcsTargetLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
          }

          export interface DatabundleZipperDirectoryRequest {
            actionId: string | null;
            firestorePath: string | null;
            gcsOriginalLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
            gcsTargetLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
          }

          export interface DatabundleZipperRequest {
            actionId: string | null;
            firestorePath: string | null;
            gcsOriginalLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
            gcsTargetLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
          }

          export interface GetBundleZipSignedUrlRequest {
            verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo | null;
            expiry: /*TimeSpan*/ string;
          }

          export interface GetDatabundleObjectChildrenRequest {
            /*[NotNull]*/
            relativePath: string;
            offset: (/*Int32*/ number) | null;
            maxChildrenPerObject: (/*Int32*/ number) | null;
            depth: (/*Int32*/ number) | null;
          }

          export interface GetDatabundleObjectChildrenResponse {
            databundleVersions: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion)[];
            directories: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Directory)[];
            files: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.File)[];
            tables: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Table)[];
            tableColumns: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn)[];
          }

          export interface GetDatabundleObjectRequest {
            /*[NotNull]*/
            relativePath: string;
          }

          export interface GetDatabundleObjectResponse {
            type:
              | "databundle"
              | "databundleVersion"
              | "dataSource"
              | "directory"
              | "file"
              | "generic"
              | "table"
              | "tableColumn";
            errorMessage: string | null;
            databundle: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Databundle | null;
            databundleVersion: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion | null;
            directory: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Directory | null;
            file: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.File | null;
            table: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Table | null;
            tableColumn: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn | null;
          }

          /*[ClientRequest]*/
          export interface GetDatabundleVersionsForDatasetVersionIdsRequest {
            /*[NotNull]*/
            datasetVersionIds: (/*Int32*/ number)[];
          }

          /*[ClientRequest]*/
          export interface GetExistingUploadFilesRequest {
            /*[NotNull]*/
            firestorePath: string;
          }

          /*[ClientRequest]*/
          export interface UpdateDatabundleColumnsRequest {
            /*[NotNull]*/
            ownerInfo: Kaggle.Sdk.Datasets.Models.DatabundleOwnerInfo;
            /*[NotNull]*/
            columns: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ColumnUpdateInfo)[];
          }

          /*[ClientRequest]*/
          export interface UpdateDatabundleMetadataExternalRequest {
            /*[NotNull]*/
            verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
            /*[NotNull]*/
            firestorePath: string;
            description: string | null;
            columns: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ColumnUpdateInfo)[];
          }

          /*[ClientRequest]*/
          export interface UpdateDatabundleObjectRequest {
            /*[NotNull]*/
            firestorePath: string;
            /*[NotNull]*/
            objectType:
              | "databundle"
              | "databundleVersion"
              | "dataSource"
              | "directory"
              | "file"
              | "generic"
              | "table"
              | "tableColumn";
            ownerInfo: Kaggle.Sdk.Datasets.Models.DatabundleOwnerInfo | null;
            verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo | null;
            /*[NotNull]*/
            description: string;
            columnType:
              | "boolean"
              | "dateTime"
              | "numeric"
              | "string"
              | "unknown"
              | null;
            columnExtendedType:
              | "address"
              | "city"
              | "coordinates"
              | "country"
              | "decimal"
              | "email"
              | "id"
              | "integer"
              | "latitude"
              | "longitude"
              | "postalCode"
              | "province"
              | "url"
              | "uuid"
              | null;
          }
        }

        export namespace Responses {
          export interface GetBundleZipSignedUrlResponse {
            url: string | null;
          }

          export interface GetExistingUploadFilesResponse {
            existingFiles: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingFileInfo)[];
            existingDirectories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingDirectoryInfo)[];
          }

          export interface UpdateDatabundleResponse {
            errorMessage: string | null;
            requiresReprocessing: boolean;
            blocked: boolean;
            usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
          }
        }

        export interface CollectObjectsDatabundleVisitor
          extends Kaggle.Sdk.Datasets.Databundles.IDatabundleVisitor {
          collectedObjects: (/*T*/ unknown)[];
        }

        export interface IDatabundleQueryStrategy {}

        export interface IDatabundleVisitor {}

        export interface PrintDatabundleVisitor
          extends Kaggle.Sdk.Datasets.Databundles.IDatabundleVisitor {}
      }

      export namespace DataViewer {
        export namespace Protos {
          export namespace DateTimeFilter {
            export enum DateTimeOperator {
              EQUALS = "equals", // = 0
              LESS_THAN = "lessThan", // = 1
              GREATER_THAN = "greaterThan", // = 2
              LESS_EQUALS = "lessEquals", // = 3
              GREATER_EQUALS = "greaterEquals", // = 4
            }
          }

          export namespace NumericFilter {
            export enum NumericOperator {
              EQUALS = "equals", // = 0
              LESS_THAN = "lessThan", // = 1
              GREATER_THAN = "greaterThan", // = 2
              LESS_EQUALS = "lessEquals", // = 3
              GREATER_EQUALS = "greaterEquals", // = 4
            }
          }

          export namespace StringFilter {
            export enum StringOperator {
              IN = "in", // = 0
              EQUALS = "equals", // = 1
              CONTAINS = "contains", // = 2
            }
          }

          export interface AndFilter {}

          export interface AndFilter {
            // When evaluated, all these filters have to be true for the overall filter to become true
            filters: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter[];
          }

          export interface BooleanFilter {
            // For booleans, we only allow to filter by equality
            value: boolean;
          }

          export interface Column {}

          export interface Column {
            // Firestore path uniquely identifying the column
            firestorePath: string;
          }

          export interface ColumnFilter {}

          export interface ColumnFilter {
            // Which column to filter on
            column: Kaggle.Sdk.Datasets.DataViewer.Protos.Column | null;
            booleanFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.BooleanFilter | null;
            numericFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilter | null;
            dateTimeFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilter | null;
            stringFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilter | null;
          }

          export interface ConstantFilter {}

          export interface ConstantFilter {
            // For completeness only
            value: boolean;
          }

          export interface DataRaw {
            // Raw responses contain the file data as a string.
            data: string;
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRawType;
            totalBytes: number;
            previewBytes: number;
          }

          export interface DataRow {
            // The row number identifier.
            rowNumber: number;
            // The raw data for a particular row. Each value represents one column.
            text: string[];
          }

          export interface DataTable {
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataTableType;
            // The total number of rows contained in this file.
            totalRows: number;
            // The total number of rows returned in this request.
            // This could be different than total_rows if there are query filters applied.
            rowsReturned: number;
            // The raw row data for the returned file.
            rows: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRow[];
          }

          export interface DataUrl {
            // Image responses contain the url of the image to preview.
            url: string;
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrlType;
          }

          ////// Response objects / messages //////
          export interface DataView {
            // The type of this DataView.
            type: Kaggle.Sdk.Datasets.DataViewer.Protos.DataViewType;
            // The data returned for tabular files.
            dataTable?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataTable | null;
            // The data returned for image files.
            dataUrl?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataUrl | null;
            // The raw data returned for "other" files.
            dataRaw?: Kaggle.Sdk.Datasets.DataViewer.Protos.DataRaw | null;
          }

          export interface DateTimeFilter {
            // Operator to use for comparisons
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.DateTimeFilter.DateTimeOperator;
            // Operand to compare against
            operand: /* google.protobuf.Timestamp */ string | null;
          }

          export interface Expressions {}

          export interface Filter {}

          export interface Filter {
            columnFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.ColumnFilter | null;
            constantFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.ConstantFilter | null;
            andFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.AndFilter | null;
            orFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.OrFilter | null;
            notFilter?: Kaggle.Sdk.Datasets.DataViewer.Protos.NotFilter | null;
          }

          export interface GetDataViewRequest {}

          export interface GetDataViewResponse {}

          export interface GetDataViewResponse {
            // The materialized view of the file.
            dataView: Kaggle.Sdk.Datasets.DataViewer.Protos.DataView | null;
          }

          export interface GetSimpleDataViewRequest {}

          export interface NotFilter {}

          export interface NotFilter {
            // When evaluated, the given filter has to return false for the overall filter to become true
            filter: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter | null;
          }

          export interface NumericFilter {
            // Operator to use for comparisons
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.NumericFilter.NumericOperator;
            // Operand to compare against (using double as the widest numerical type)
            operand: number;
          }

          export interface OrFilter {}

          export interface OrFilter {
            // When evaluated, one of these filters have to be true for the overall filter to become true
            filters: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter[];
          }

          export interface SortBy {
            // What column to sort by
            column: Kaggle.Sdk.Datasets.DataViewer.Protos.Column | null;
            // Which direction?
            direction: Kaggle.Sdk.Datasets.DataViewer.Protos.SortDirection;
          }

          export interface StringFilter {
            // Operator to use for comparisons (we only allow IN here, but might extend in the future)
            operator: Kaggle.Sdk.Datasets.DataViewer.Protos.StringFilter.StringOperator;
            // Operands to compare against .
            // - IN uses the whole list of operands to compare against.
            // - EQUALS and CONTAINS use only the first one.
            operands: string[];
          }

          ////// Request objects / messages //////
          export interface TableQuery {
            // Row offset
            skip: number;
            // How many rows to return
            take: number;
            // Since we can combine filters in an AND and OR fashion, the top level filter only needs to be
            // a single entry (which itself can be a combination of filters)
            filter: Kaggle.Sdk.Datasets.DataViewer.Protos.Filter | null;
            // Which columns to return
            selectedColumns: Kaggle.Sdk.Datasets.DataViewer.Protos.Column[];
            // Which columns to sort on
            sorts: Kaggle.Sdk.Datasets.DataViewer.Protos.SortBy[];
          }

          /*[ClientRequest]*/
          export interface TestApiRequest {}

          export interface TestApiResponse {}

          export enum DataRawType {
            MARKDOWN = "markdown", // = 0
            JSON = "json", // = 1
            TEXT = "text", // = 2
          }
          export enum DataTableType {
            // Table is a csv file in cloud storage.
            CSV = "csv", // = 0
            BIGQUERY = "bigquery", // = 1
            SQLITE = "sqlite", // = 2
            EXCEL = "excel", // = 3
          }
          export enum DataUrlType {
            IMAGE = "image", // = 0
            PDF = "pdf", // = 1
            AUDIO = "audio", // = 2
            VIDEO = "video", // = 3
          }
          export enum DataViewType {
            TABULAR = "tabular", // = 0
            URL = "url", // = 1
            RAW = "raw", // = 2
          }
          export enum SortDirection {
            ASC = "asc", // = 0
            DESC = "desc", // = 1
          }
        }

        export namespace Requests {
          /*[ClientRequest]*/
          export interface GetDataViewExternalRequest {
            /*[NotNull]*/
            verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
            /*[NotNull]*/
            firestorePath: string;
            tableQuery: Kaggle.Sdk.Datasets.DataViewer.Protos.TableQuery | null;
          }

          /*[ClientRequest]*/
          export interface GetKernelOutputDataViewExternalRequest {
            kernelSessionId: /*Int32*/ number;
            fileName: string | null;
            kernelOutputFileId: /*Int32*/ number;
            tableQuery: Kaggle.Sdk.Datasets.DataViewer.Protos.TableQuery | null;
          }
        }
      }

      export namespace Models {
        export namespace Creation {
          /*[NotNull]*/
          export interface BaseUploaderConfig {
            existingUploadDirectories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingDirectoryInfo)[];
            existingUploadFiles: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingFileInfo)[];
            existingRemoteUrls: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteUrlInfo)[];
          }

          /*[NotNull]*/
          export interface CompetitionUploaderConfig
            extends Kaggle.Sdk.Datasets.Models.Creation.BaseUploaderConfig {}

          export interface DataCreationResponse {
            /*[NotNull]*/
            status: "error" | "ok";
            errorMessage: string | null;
            url: string | null;
            databundleVersionReference: Kaggle.Sdk.Datasets.Models.DatabundleVersionReference | null;
          }

          export interface DataCreationSettings {
            actions: (string)[];
            flags: (string)[];
          }

          export interface DatasetCreationResponse
            extends Kaggle.Sdk.Datasets.Models.Creation.DataCreationResponse {
            datasetVersionReference: Kaggle.Sdk.Datasets.Models.Creation.DatasetVersionReference | null;
          }

          /*[NotNull]*/
          export interface DatasetImageData {
            originalImageUrl: string;
            cardImageUrl: string;
            coverImageUrl: string;
            thumbnailImageUrl: string;
            cardImagePosition: Kaggle.Sdk.Datasets.Models.Creation.DatasetImagePosition;
            coverImagePosition: Kaggle.Sdk.Datasets.Models.Creation.DatasetImagePosition;
          }

          /*[NotNull]*/
          export interface DatasetImagePosition {
            width: /*Int32*/ number;
            height: /*Int32*/ number;
            top: /*Int32*/ number;
            left: /*Int32*/ number;
          }

          /*[NotNull]*/
          export interface DatasetUploaderConfig
            extends Kaggle.Sdk.Datasets.Models.Creation.BaseUploaderConfig {
            allowedOwners: (Kaggle.Sdk.Datasets.Models.OwnerDto)[];
            licenseGroups: (Kaggle.Sdk.Datasets.Models.LicenseGroupDto)[];
            limits: Kaggle.Sdk.Datasets.Models.DatasetLimits;
          }

          /*[NotNull]*/
          export interface DatasetVersionReference {
            datasetId: /*Int32*/ number;
            datasetVersionId: /*Int32*/ number;
            slug: string;
            ownerSlug: string;
          }

          /*[NotNull]*/
          export interface DuplicationReference {
            type: "competition" | "dataset";
            name: string;
            url: string;
            id: /*Int32*/ number;
          }

          /*[NotNull]*/
          export interface GithubRepositoryContent {
            type: "file" | "folder";
            name: string;
            repositoryPath: string;
          }

          /*[NotNull]*/
          export interface GithubRepositoryFile
            extends Kaggle.Sdk.Datasets.Models.Creation
              .GithubRepositoryContent {
            size: /*Int64*/ number;
          }

          /*[NotNull]*/
          export interface GithubRepositoryFolder
            extends Kaggle.Sdk.Datasets.Models.Creation
              .GithubRepositoryContent {
            children: (Kaggle.Sdk.Datasets.Models.Creation.GithubRepositoryContent)[];
          }
        }

        export namespace DatasetFileType {
          export enum Enum {
            DATASET_FILE_TYPE_UNSPECIFIED = "datasetFileTypeUnspecified", // = 0
            CSV = "csv", // = 1
            JSON = "json", // = 2
            SQLITE = "sqlite", // = 3
            OTHER = "other", // = 4
          }
        }

        /*[NotNull]*/
        export interface ActivityNotGeneratedBanner {
          title: string;
          subtitle: string;
          img: Kaggle.Sdk.Common.Protos.Image;
          href: string;
        }

        /*[NotNull]*/
        export interface ActivityPage {
          status: "hasSummary" | "noSummaryGenerated" | "notRelevant";
          banner: Kaggle.Sdk.Datasets.Models.ActivityNotGeneratedBanner;
          summaryStats: Kaggle.Sdk.Datasets.Models.ActivitySummaryStats;
        }

        /*[NotNull]*/
        export interface ActivityPageContributorLocation {
          location: string;
          count: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface ActivityPageTimeSeries {
          key: string;
          title: string;
          points: (Kaggle.Sdk.Datasets.Models.ActivityPageTimeSeriesPoint)[];
        }

        /*[NotNull]*/
        export interface ActivityPageTimeSeriesPoint {
          date: /*DateTime*/ string;
          count: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface ActivitySummaryStats {
          id: /*Int32*/ number;
          schemaVersion: /*Int32*/ number;
          datasetId: /*Int32*/ number;
          generatedDate: /*DateTime*/ string;
          datasetStats: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageStat)[];
          timeSeries: Record<
            string,
            Kaggle.Sdk.Datasets.Models.ActivityPageTimeSeries
          >;
          topContributors: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageContributor)[];
          contributorLocations: (Kaggle.Sdk.Datasets.Models.ActivityPageContributorLocation)[];
          kernelStats: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageStat)[];
          kernelMedals: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageMedal)[];
          topKernels: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageKernel)[];
          tags: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageTag)[];
          relatedDatasets: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageRelatedDataset)[];
          discussionStats: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageStat)[];
          discussionMedals: (Kaggle.Sdk.Datasets.Models.DatasetActivityPageMedal)[];
          topDiscussions: (Kaggle.Sdk.Datasets.Protos.DatasetActivityPageDiscussion)[];
        }

        export interface AutoGeneratedSource {
          kernelReference: Kaggle.Sdk.Datasets.Models.KernelOutputKernelReference | null;
          externalSourceUrl: string | null;
        }

        export interface BigQuerySettingsDto {
          projectId: string | null;
          datasetId: string | null;
          tableId: string | null;
        }

        /*[NotNull]*/
        export interface ContributorDto {
          userId: /*Int32*/ number;
          totalScriptVotes: /*Int32*/ number;
          totalScripts: /*Int32*/ number;
          totalForumMessages: /*Int32*/ number;
          totalForumMessageVotes: /*Int32*/ number;
          totalScore: /*Double*/ number;
          displayName: string;
          performanceTier: string;
          userUrl: string;
          rank: string;
          userAvatarUrl: string;
        }

        export interface Databundle {
          id: /*Int32*/ number;
          creatorUserId: /*Int32*/ number;
          creationDate: /*DateTime*/ string;
          type: "competition" | "dataset" | "general" | "notebook";
          diffType: "realtime" | "unversioned" | "versioned";
          currentDataBundleVersionId: (/*Int32*/ number) | null;
        }

        export interface DatabundleOwnerCompetitionInfo {
          competitionId: /*Int32*/ number;
          scope: string | null;
        }

        export interface DatabundleOwnerDatasetInfo {
          datasetId: /*Int32*/ number;
          datasetVersionId: /*Int32*/ number;
          scope: string | null;
        }

        export interface DatabundleOwnerInfo {
          databundleVersionId: /*Int32*/ number;
          dataset: Kaggle.Sdk.Datasets.Models.DatabundleOwnerDatasetInfo | null;
          competition: Kaggle.Sdk.Datasets.Models.DatabundleOwnerCompetitionInfo | null;
          kernel: Kaggle.Sdk.Datasets.Models.DatabundleOwnerKernelInfo | null;
          previewsDisabled: boolean;
        }

        export interface DatabundleOwnerKernelInfo {
          kernelId: /*Int32*/ number;
          kernelVersionId: /*Int32*/ number;
          scope: string | null;
        }

        export interface DatabundleVerificationInfo {
          databundleVersionId: /*Int32*/ number;
          competitionId: (/*Int32*/ number) | null;
          datasetId: (/*Int32*/ number) | null;
          datasetHashLink: string | null;
        }

        export interface DatabundleVersion {
          id: /*Int32*/ number;
          databundleId: /*Int32*/ number;
          creatorUserId: /*Int32*/ number;
          creationDate: /*DateTime*/ string;
          versionNumber: (/*Int32*/ number) | null;
          versionNotes: string | null;
          type:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          status:
            | "blobsCopiedToSds"
            | "blobsDecompressed"
            | "blobsReceived"
            | "deleted"
            | "failed"
            | "individualBlobsCompressed"
            | "notYetPersisted"
            | "ready"
            | "reprocessing";
          creationStatus: Kaggle.Sdk.Datasets.Models.DatabundleVersionCreationStatus | null;
        }

        export interface DatabundleVersionCreationStatus {
          status:
            | "blobsCopiedToSds"
            | "blobsDecompressed"
            | "blobsReceived"
            | "deleted"
            | "failed"
            | "individualBlobsCompressed"
            | "notYetPersisted"
            | "ready"
            | "reprocessing";
          creationPercentComplete: /*Double*/ number;
          creationException: string | null;
          creationLastUpdate: (/*DateTime*/ string) | null;
          creationStep: string | null;
          creationStart: (/*DateTime*/ string) | null;
          userMessage: string | null;
        }

        export interface DatabundleVersionReference {
          databundleId: /*Int32*/ number;
          databundleType: "competition" | "dataset" | "general" | "notebook";
          databundleVersionId: /*Int32*/ number;
          databundleVersionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          diffType: "realtime" | "unversioned" | "versioned";
        }

        export interface DatabundleVersionStorageSettings {
          webDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
          sdsDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
          responseDataLocation: Kaggle.Sdk.Datasets.Models.StorageLocation | null;
        }

        export interface DataCoverageAttribute {
          temporalCoverageFrom: (/*DateTime*/ string) | null;
          temporalCoverageTo: (/*DateTime*/ string) | null;
          spatialCoverage: string | null;
        }

        /*[NotNull]*/
        export interface DatasetActivityDto {
          activityType:
            | "comment"
            | "dataset"
            | "datasetVersion"
            | "script"
            | "scriptComment"
            | "scriptFork"
            | "scriptRun"
            | "topic";
          url: string;
          userName: string;
          userAvatarUrl: string;
          date: /*DateTime*/ string;
          userDisplayName: string;
          title: string;
          versionNumber: (/*Int32*/ number) | null;
          userUrl: string;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageContributor
          extends Kaggle.Sdk.Users.Models.UserAvatar {
          totalUpvotesCount: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageKernel {
          id: /*Int32*/ number;
          voteButtonDto: Kaggle.Sdk.Common.Protos.VoteButton;
          avatar: Kaggle.Sdk.Users.Models.UserAvatar;
          medal: Kaggle.Sdk.Common.Protos.Image;
          title: string;
          timeSinceLastActivity: string;
          tags: (Kaggle.Sdk.Kernels.Models.Tag)[];
          url: string;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageMedal {
          type: "bronze" | "gold" | "silver" | "unspecified";
          count: /*Int32*/ number;
          image: Kaggle.Sdk.Common.Protos.Image;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageRelatedDataset {
          id: /*Int32*/ number;
          voteButtonDto: Kaggle.Sdk.Common.Protos.VoteButton;
          thumbnailImageUrl: string;
          title: string;
          subTitle: string;
          timeSinceLastActivity: string;
          url: string;
          kernelsCount: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageStat {
          name: string;
          value: /*Double*/ number;
        }

        /*[NotNull]*/
        export interface DatasetActivityPageTag {
          name: string;
          url: string;
          kernelCount: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface DatasetBaseDto {
          title: string;
          slug: string;
          licenseId: /*Int32*/ number;
          data: Kaggle.Sdk.Datasets.Models.LegacyDatabundleInfo;
          isPrivate: boolean;
          owner: Kaggle.Sdk.Datasets.Models.OwnerDto;
        }

        export interface DatasetConstants {}

        export interface DatasetCoreIds {
          datasetId: /*Int32*/ number;
          databundleId: /*Int32*/ number;
          datasetVersionId: /*Int32*/ number;
          databundleVersionId: /*Int32*/ number;
        }

        /*[NotNull]*/
        export interface DatasetDatasourceList {
          items: (Kaggle.Sdk.Datasets.Models.DatasetDatasourceListItem)[];
        }

        /*[NotNull]*/
        export interface DatasetDatasourceListItem {
          datasetId: /*Int32*/ number;
          currentDatasetVersionId: /*Int32*/ number;
          currentDatasetVersionNumber: (/*Int32*/ number) | null;
          type:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          diffType: "realtime" | "unversioned" | "versioned";
          title: string;
          overview: string;
          thumbnailImageUrl: string;
          isPrivate: boolean;
          isDeleted: boolean;
          isFeatured: boolean;
          isSuperFeatured: boolean;
        }

        export interface DatasetDto
          extends Kaggle.Sdk.Datasets.Models.DatasetRootDto {
          discussion: Kaggle.Sdk.Discussions.Models.TopicListDto | null;
          currentTab:
            | "activity"
            | "code"
            | "data"
            | "dataOld"
            | "discussion"
            | "home"
            | "kernels"
            | "metadata"
            | "notebooks"
            | "settings"
            | "tasks";
          newTopic: Kaggle.Sdk.Discussions.Models.NewTopicDto | null;
          categories: Kaggle.Sdk.Tags.Models.TagList | null;
          upvoteSuggestion: Kaggle.Sdk.Common.Models.UpvoteSuggestionDto | null;
          readerGroupId: (/*Int32*/ number) | null;
          writerGroupId: (/*Int32*/ number) | null;
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
          isCollaborator: boolean;
          deletionNeedsReview: boolean;
          hasDatasetDoiApproved: boolean;
          canSeeConfigAsCode: boolean | null;
          canCreateDatasetTasks: boolean;
          blockTaskCreation: boolean;
          canSeeDatasetHashLink: boolean;
          medalUrl: string | null;
          datasetHashLink: string | null;
        }

        export interface DatasetEmbedCard {
          title: string | null;
          subtitle: string | null;
          imageUrl: string | null;
          datasetUrl: string | null;
        }

        /*[NotNull]*/
        export interface DatasetFileSummary {
          fileType:
            | "csv"
            | "datasetFileTypeUnspecified"
            | "json"
            | "other"
            | "sqlite";
          count: /*Int32*/ number;
          totalSize: /*Int64*/ number;
        }

        export interface DatasetFileType {}

        export interface DatasetHistory {
          items: (Kaggle.Sdk.Datasets.Models.DatasetHistoryItem)[];
          totalItems: /*Int32*/ number;
        }

        export interface DatasetHistoryItem {
          type:
            | "create"
            | "feature"
            | "intraVersionSchemaUpdate"
            | "makePrivate"
            | "makePublic"
            | "newVersion"
            | "publish"
            | "remove"
            | "removeVersion"
            | "superFeature"
            | "unFeature"
            | "unPublish"
            | "unSuperFeature";
          user: Kaggle.Sdk.Datasets.Models.OwnerDto | null;
          changes: (Kaggle.Sdk.Datasets.Models.DatasetSchemaDiff)[];
          date: /*DateTime*/ string;
          summary: Kaggle.Sdk.Datasets.Models.DatasetSchemaDiffSummary | null;
          versionInfo: Kaggle.Sdk.Datasets.Models.DatasetHistoryVersionInfo | null;
        }

        export interface DatasetHistoryVersionInfo {
          versionNumber: (/*Int32*/ number) | null;
          versionNotes: string | null;
          versionUrl: string | null;
          userMessage: string | null;
          databundleVersionId: /*Int32*/ number;
          status:
            | "blobsCopiedToSds"
            | "blobsDecompressed"
            | "blobsReceived"
            | "deleted"
            | "failed"
            | "individualBlobsCompressed"
            | "notYetPersisted"
            | "ready"
            | "reprocessing";
        }

        /*[NotNull]*/
        export interface DatasetIdList {
          totalResults: (/*Int32*/ number) | null;
          datasetIds: (/*Int32*/ number)[];
        }

        /*[NotNull]*/
        export interface DatasetJoinSuggestion {
          dataset: Kaggle.Sdk.Datasets.Models.DatasetListItem;
          suggestionType: "mds" | "pretrained" | "tag";
          confidence: /*Double*/ number;
        }

        /*[NotNull]*/
        export interface DatasetLimits {
          publicLimits: Kaggle.Sdk.Datasets.Models.DatasetPublicLimits;
          privateLimits: Kaggle.Sdk.Datasets.Models.DatasetPrivateLimits;
          maxFiles: /*Int64*/ number;
        }

        /*[NotNull]*/
        export interface DatasetList {
          totalResults: (/*Int32*/ number) | null;
          items: (Kaggle.Sdk.Datasets.Models.DatasetListItem)[];
        }

        export interface DatasetListItem
          extends Kaggle.Sdk.Datasets.Models.DatasetDatasourceListItem {
          /*[NotNull]*/
          datasetUrl: string;
          /*[NotNull]*/
          ownerAvatarUrl: string;
          /*[NotNull]*/
          ownerName: string;
          /*[NotNull]*/
          ownerUrl: string;
          ownerUserId: (/*Int32*/ number) | null;
          ownerTier: (/*Int32*/ number) | null;
          /*[NotNull]*/
          creatorName: string;
          /*[NotNull]*/
          creatorUrl: string;
          creatorUserId: /*Int32*/ number;
          scriptCount: /*Int32*/ number;
          taskCount: /*Int32*/ number;
          /*[NotNull]*/
          scriptsUrl: string;
          topicCount: /*Int32*/ number;
          /*[NotNull]*/
          forumUrl: string;
          viewCount: /*Int32*/ number;
          downloadCount: /*Int32*/ number;
          fileCount: /*Int32*/ number;
          /*[NotNull]*/
          dateCreated: /*DateTime*/ string;
          /*[NotNull]*/
          dateUpdated: /*DateTime*/ string;
          isHidden: boolean;
          isFailed: boolean;
          bookmarked: boolean;
          isCollaborator: boolean;
          /*[NotNull]*/
          voteButton: Kaggle.Sdk.Common.Protos.VoteButton;
          /*[NotNull]*/
          categories: (Kaggle.Sdk.Tags.Protos.Tag)[];
          /*[NotNull]*/
          licenseName: string;
          /*[NotNull]*/
          licenseShortName: string;
          datasetSize: (/*Int64*/ number) | null;
          /*[NotNull]*/
          commonFileTypes: (Kaggle.Sdk.Datasets.Models.DatasetFileSummary)[];
          maintainerOrganization: Kaggle.Sdk.Datasets.Models.OwnerDto | null;
          /*[NotNull]*/
          downloadUrl: string;
          /*[NotNull]*/
          newKernelNotebookUrl: string;
          /*[NotNull]*/
          newKernelScriptUrl: string;
          /*[NotNull]*/
          description: string;
          usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
          firestorePath: string | null;
          datasetSlug: string | null;
          rank: /*Int32*/ number;
          medalUrl: string | null;
          hasHashLink: boolean;
        }

        /*[NotNull]*/
        export interface DatasetListItemOrSegment {
          isSegment: boolean;
          segmentTitle: string;
          item: Kaggle.Sdk.Datasets.Models.DatasetListItem;
        }

        export interface DatasetMetadata {
          /*[NotNull]*/
          autoGeneratedSources: (Kaggle.Sdk.Datasets.Models.AutoGeneratedSource)[];
          /*[NotNull]*/
          collaboratorList: Kaggle.Sdk.Users.Models.CollaboratorList;
          collectionMethods: string | null;
          currentVersionNumber: (/*Int32*/ number) | null;
          /*[NotNull]*/
          databundleDiffType: "realtime" | "unversioned" | "versioned";
          /*[NotNull]*/
          dataCoverageAttribute: Kaggle.Sdk.Datasets.Models.DataCoverageAttribute;
          /*[NotNull]*/
          datasetCreationTimestamp: /*DateTime*/ string;
          datasetId: /*Int32*/ number;
          /*[NotNull]*/
          datasetVersionAuthors: (Kaggle.Sdk.Datasets.Models.DatasetVersionAuthor)[];
          datasetVersionId: /*Int32*/ number;
          doi: string | null;
          /*[NotNull]*/
          expectedUpdateFrequency: Kaggle.Sdk.Datasets.Models.ExpectedUpdateFrequency;
          hasHashLink: boolean;
          isDatasetDoiApproved: boolean;
          isEditable: boolean;
          isPrivate: boolean;
          lastDataUpdatedTimestamp: (/*DateTime*/ string) | null;
          licenseGroups: (Kaggle.Sdk.Datasets.Models.LicenseGroupDto)[];
          licenseId: /*Int32*/ number;
          userSpecifiedSources: string | null;
        }

        /*[NotNull]*/
        export interface DatasetPrivateLimits {
          totalBytes: /*Int64*/ number;
          usedBytes: /*Int64*/ number;
          remainingBytes: /*Int64*/ number;
          totalBytesAllVersions: /*Int64*/ number;
          usedBytesAllVersions: /*Int64*/ number;
          remainingBytesAllVersions: /*Int64*/ number;
        }

        /*[NotNull]*/
        export interface DatasetPublicLimits {
          maxBytes: /*Int64*/ number;
          isOrganizationLimit: boolean;
          isAdminLimit: boolean;
        }

        /*[NotNull]*/
        export interface DatasetRootDto
          extends Kaggle.Sdk.Datasets.Models.DatasetUploadDto {
          datasetId: /*Int32*/ number;
          isRemoved: boolean;
          isVersionRemoved: boolean;
          isFeatured: boolean;
          isSuperFeatured: boolean;
          scheduledToBeFeatured: (/*DateTime*/ string) | null;
          scheduledToBeUnFeatured: (/*DateTime*/ string) | null;
          scheduledToBeSuperFeatured: (/*DateTime*/ string) | null;
          scheduledToBeUnSuperFeatured: (/*DateTime*/ string) | null;
          datasetVersionId: /*Int32*/ number;
          datasetVersionNumber: /*Int32*/ number;
          lastVersionNumber: /*Int32*/ number;
          datasetUrl: string;
          datasetExternalUrl: string;
          originalImageUrl: string;
          coverImageUrl: string;
          cardImageUrl: string;
          thumbnailImageUrl: string;
          license: Kaggle.Sdk.Datasets.Models.LicenseDto;
          voteCount: /*Int32*/ number;
          upVoteUrl: string;
          creatorUserId: /*Int32*/ number;
          creatorDisplayName: string;
          ownerTwitter: string;
          lastUpdated: /*DateTime*/ string;
          downloadUrl: string;
          newNotebookUrl: string;
          newScriptUrl: string;
          hasAlreadyVotedUp: boolean;
          isOldDatasetVersion: boolean;
          numberOfViews: /*Int32*/ number;
          numberOfDownloads: /*Int32*/ number;
          numberOfScripts: /*Int32*/ number;
          numberOfTopics: /*Int32*/ number;
          numberOfTasks: /*Int32*/ number;
          canEdit: boolean;
          canPerformOwnerTasks: boolean;
          canEditSlug: boolean;
          canEditPublishStatus: boolean;
          canEditFeatureStatus: boolean;
          canEditDescription: boolean;
          hideVersionStatuses: boolean;
          cardImageLeft: (/*Int32*/ number) | null;
          cardImageTop: (/*Int32*/ number) | null;
          cardImageWidth: (/*Int32*/ number) | null;
          cardImageHeight: (/*Int32*/ number) | null;
          coverImageLeft: (/*Int32*/ number) | null;
          coverImageTop: (/*Int32*/ number) | null;
          coverImageWidth: (/*Int32*/ number) | null;
          coverImageHeight: (/*Int32*/ number) | null;
          datasetVersions: (Kaggle.Sdk.Datasets.Models.DatasetVersionDto)[];
          datasetVersionTotalCount: /*Int32*/ number;
          feed: (Kaggle.Sdk.Datasets.Models.DatasetActivityDto)[];
          topicId: (/*Int32*/ number) | null;
          isNewTopic: boolean;
          canSeeDeletionButton: boolean;
          checklistDismissed: boolean;
          type:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          diffType: "realtime" | "unversioned" | "versioned";
          checklistCollapsed: boolean;
          isInFlight: boolean;
          maintainerOrganization: Kaggle.Sdk.Datasets.Models.OwnerDto;
          createdByKernel: Kaggle.Sdk.Datasets.Models.KernelOutputKernelReference;
          usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating;
          bookmarked: boolean;
        }

        export interface DatasetsActivityLogReference {
          datasetsActivityLogId: /*Int32*/ number;
        }

        export interface DatasetSchemaDiff {
          action:
            | "add"
            | "delete"
            | "modifyDescription"
            | "modifyType"
            | "rowCountChange"
            | "sizeChange";
          level: "column" | "dataset" | "file" | "table" | "unknown";
          parentLevel: "column" | "dataset" | "file" | "table" | "unknown";
          oldValue: string | null;
          newValue: string | null;
          path: string | null;
        }

        export interface DatasetSchemaDiffSummary {
          addedCount: /*Int32*/ number;
          modifiedCount: /*Int32*/ number;
          deletedCount: /*Int32*/ number;
          totalChangedEntities: /*Int32*/ number;
          changedEntities: (Kaggle.Sdk.Datasets.Models.DatasetSchemaEntity)[];
        }

        export interface DatasetSchemaEntity {
          name: string | null;
          level: "column" | "dataset" | "file" | "table" | "unknown";
        }

        export interface DataSettingsDto {
          bigQuerySettings: Kaggle.Sdk.Datasets.Models.BigQuerySettingsDto | null;
          storageSettings: Kaggle.Sdk.Datasets.Models.DatabundleVersionStorageSettings | null;
          remoteUrlSettings: Kaggle.Sdk.Datasets.Models.RemoteUrlSettings | null;
          remoteGithubSettings: Kaggle.Sdk.Datasets.Models.RemoteGithubSettings | null;
        }

        /*[NotNull]*/
        export interface DatasetUploadDto
          extends Kaggle.Sdk.Datasets.Models.DatasetBaseDto {
          licenseGroups: (Kaggle.Sdk.Datasets.Models.LicenseGroupDto)[];
          owners: (Kaggle.Sdk.Datasets.Models.OwnerDto)[];
          referrer: string;
          convertToStandardCsvFormat: boolean;
          overview: string;
          description: string;
          actions: (string)[];
          flags: (string)[];
        }

        export interface DatasetUsabilityRating {
          score: /*Single*/ number;
          columnDescriptionScore: (/*Single*/ number) | null;
          coverImageScore: /*Single*/ number;
          fileDescriptionScore: /*Single*/ number;
          fileFormatScore: /*Single*/ number;
          licenseScore: /*Single*/ number;
          overviewScore: /*Single*/ number;
          provenanceScore: /*Single*/ number;
          publicKernelScore: /*Single*/ number;
          subtitleScore: /*Single*/ number;
          tagScore: /*Single*/ number;
          updateFrequencyScore: /*Single*/ number;
        }

        export interface DatasetVersionAuthor {
          datasetVersionAuthorId: (/*Int32*/ number) | null;
          /*[NotNull]*/
          authorName: string;
          authorBio: string | null;
        }

        export interface DatasetVersionCopyStatus {
          status: "finished" | "started";
          operationId: string | null;
          gcsPath: string | null;
        }

        export interface DatasetVersionDto {
          id: /*Int32*/ number;
          /*[NotNull]*/
          slug: string;
          /*[NotNull]*/
          name: string;
          /*[NotNull]*/
          creationDate: /*DateTime*/ string;
          versionNumber: (/*Int32*/ number) | null;
          /*[NotNull]*/
          versionNotes: string;
          /*[NotNull]*/
          thumbnailImageUrl: string;
          /*[NotNull]*/
          datasetVersionUrl: string;
          status:
            | "blobsCopiedToSds"
            | "blobsDecompressed"
            | "blobsReceived"
            | "deleted"
            | "failed"
            | "individualBlobsCompressed"
            | "notYetPersisted"
            | "ready"
            | "reprocessing";
          userMessage: string | null;
          isRemoved: boolean;
          /*[NotNull]*/
          creator: Kaggle.Sdk.Datasets.Models.OwnerDto;
          userSpecifiedSources: string | null;
          doi: string | null;
          /*[NotNull]*/
          databundleVersionId: /*Int32*/ number;
        }

        export interface DatasetVersionIdWithHashLink {}

        export interface ExpectedUpdateFrequency {
          isAutoUpdatedTypedDataset: boolean;
          /*[NotNull]*/
          updateFrequency: string;
        }

        export interface GetDatasetsKernelRedirectResponse {
          kernelUserName: string | null;
          kernelSlug: string | null;
          scriptVersionId: string | null;
          tab: string | null;
          isEdit: boolean;
        }

        /*[NotNull]*/
        export interface KernelOutputDatasetReference {
          datasetId: /*Int32*/ number;
          currentDatasetVersionId: /*Int32*/ number;
          title: string;
          isPrivate: boolean;
          slug: string;
          license: Kaggle.Sdk.Datasets.Models.LicenseDto;
        }

        /*[NotNull]*/
        export interface KernelOutputKernelReference {
          kernelId: /*Int32*/ number;
          isPrivate: boolean;
          url: string;
          title: string;
          owner: Kaggle.Sdk.Datasets.Models.OwnerDto;
          outputFiles: (Kaggle.Sdk.Kernels.Models.KernelSessionOutputFile)[];
        }

        export interface KernelTaskSubmissionInfo {
          taskUrl: string | null;
          taskTitle: string | null;
          datasetUrl: string | null;
          datasetTitle: string | null;
          isAcceptedSolution: boolean;
        }

        export interface LegacyDatabundleInfo {
          firestorePath: string | null;
          databundleVersionId: /*Int32*/ number;
          databundle: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Databundle | null;
          databundleVersion: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersion | null;
        }

        /*[NotNull]*/
        export interface LicenseDto {
          id: /*Int32*/ number;
          name: string;
          description: string;
          url: string;
          displaySequence: (/*Int32*/ number) | null;
        }

        /*[NotNull]*/
        export interface LicenseGroupDto {
          id: /*Int32*/ number;
          name: string;
          licenses: (Kaggle.Sdk.Datasets.Models.LicenseDto)[];
          displaySequence: (/*Int32*/ number) | null;
        }

        /*[NotNull]*/
        export interface OwnerDto {
          id: /*Int32*/ number;
          imageUrl: string;
          isOrganization: boolean;
          name: string;
          profileUrl: string;
          slug: string;
          maxFileSizeBytes: (/*Int64*/ number) | null;
          userTier: (/*Byte*/ number) | null;
          organizationMemberCount: (/*Int32*/ number) | null;
        }

        export interface RemoteGithubSettings {
          ownerSlug: string | null;
          repositorySlug: string | null;
          updateFrequency: "daily" | "monthly" | "never" | "weekly" | null;
        }

        export interface RemoteUrlSettings {
          /*[NotNull]*/
          url: string;
          updateFrequency: "daily" | "monthly" | "never" | "weekly" | null;
        }

        export interface RemoteUrlUploadFile {
          name: string | null;
          url: string | null;
          warning: string | null;
          contentLength: /*Int64*/ number;
          contentType: string | null;
        }

        export interface StorageLocation {
          bucket: string | null;
          path: string | null;
        }

        export interface TaskAuthor {
          id: /*Int32*/ number;
          /*[NotNull]*/
          displayName: string;
          /*[NotNull]*/
          slug: string;
          thumbnailImageUrl: string | null;
          tier: (/*Byte*/ number) | null;
          isOrganization: boolean;
        }

        /*[NotNull]*/
        export interface TaskDatasetInfo {
          datasetId: /*Int32*/ number;
          datasetTitle: string;
          datasetSlug: string;
          datasetThumbnailImageUrl: string;
          usabilityRating: /*Double*/ number;
          datasetOwnerName: string;
          datasetOwnerSlug: string;
        }

        export interface TaskListItem {
          id: /*Int32*/ number;
          /*[NotNull]*/
          title: string;
          subtitle: string | null;
          submissionCount: /*Int32*/ number;
          /*[NotNull]*/
          hasAcceptedSubmission: boolean;
          /*[NotNull]*/
          author: Kaggle.Sdk.Datasets.Models.TaskAuthor;
          /*[NotNull]*/
          voteButton: Kaggle.Sdk.Datasets.Models.TaskVoteButton;
          /*[NotNull]*/
          datasetInfo: Kaggle.Sdk.Datasets.Models.TaskDatasetInfo;
          /*[NotNull]*/
          tags: Kaggle.Sdk.Tags.Models.TagList;
          creationDate: /*DateTime*/ string;
          deadline: (/*DateTime*/ string) | null;
          forumId: (/*Int32*/ number) | null;
        }

        export interface TaskModel
          extends Kaggle.Sdk.Datasets.Models.TaskListItem {
          /*[NotNull]*/
          description: string;
          removedTags: Kaggle.Sdk.Tags.Models.TagList | null;
        }

        /*[NotNull]*/
        export interface TaskSubmissionDatasetInfo {
          datasetId: /*Int32*/ number;
          fileCount: /*Int32*/ number;
        }

        export interface TaskSubmissionListItem {
          id: /*Int32*/ number;
          /*[NotNull]*/
          type: "dataset" | "notebook";
          /*[NotNull]*/
          url: string;
          /*[NotNull]*/
          title: string;
          /*[NotNull]*/
          author: Kaggle.Sdk.Datasets.Models.TaskAuthor;
          submittedDate: (/*DateTime*/ string) | null;
          lastUpdated: /*DateTime*/ string;
          acceptedDate: (/*DateTime*/ string) | null;
          voteButton: Kaggle.Sdk.Common.Protos.VoteButton | null;
          /*[NotNull]*/
          commentCount: /*Int32*/ number;
          notebookInfo: Kaggle.Sdk.Datasets.Models.TaskSubmissionNotebookInfo | null;
          datasetInfo: Kaggle.Sdk.Datasets.Models.TaskSubmissionDatasetInfo | null;
        }

        /*[NotNull]*/
        export interface TaskSubmissionNotebookInfo {
          kernelId: /*Int32*/ number;
          language: string;
        }

        /*[NotNull]*/
        export interface TaskVoteButton {
          totalVotes: /*Int32*/ number;
          hasVotedUp: boolean;
          isDisabled: boolean;
        }
      }

      export namespace Protos {
        // This is just enough information for the datasets basics
        // to render.
        export interface BasicKernelOutputKernelReference {
          url: string;
        }

        export interface Collaborator {
          type: Kaggle.Sdk.Users.Protos.CollaboratorType;
        }

        export interface CollaboratorList {
          owner: Kaggle.Sdk.Datasets.Protos.Collaborator | null;
          collaborators: Kaggle.Sdk.Datasets.Protos.Collaborator[];
        }

        export interface DatabundleInfo {
          totalSize: number;
          isFileset: boolean;
          canSeeDownload: boolean;
          canUpdate: boolean;
          firestorePath: string;
          downloadUrl: string;
          versionId: number;
        }

        export interface DatasetActivityPageDiscussion {
          id: number;
          voteButtonDto: Kaggle.Sdk.Common.Protos.VoteButton | null;
          avatar: Kaggle.Sdk.Users.Protos.UserAvatar | null;
          medal: Kaggle.Sdk.Common.Protos.Image | null;
          title?: /* google.protobuf.StringValue */ string | null;
          timeSinceLastActivity?: /* google.protobuf.StringValue */
            | string
            | null;
          replyCount: number;
          url?: /* google.protobuf.StringValue */ string | null;
        }

        // This is all of the data needed to render the header of the dataset detail
        // page
        export interface DatasetBasics {
          datasetId: number;
          slug: string;
          title: string;
          removed: boolean;
          private: boolean;
          description: string;
          viewCount: number;
          downloadCount: number;
          scriptCount: number;
          topicCount: number;
          owner: Kaggle.Sdk.Datasets.Protos.Owner | null;
          license: Kaggle.Sdk.Datasets.Protos.License | null;
          overview: string;
          canEdit: boolean;
          creatorKernel: Kaggle.Sdk.Datasets.Protos.BasicKernelOutputKernelReference | null;
          collaborators: Kaggle.Sdk.Datasets.Protos.CollaboratorList | null;
          coverImageUrl: string;
          data: Kaggle.Sdk.Datasets.Protos.DatabundleInfo | null;
          voteCount: number;
          medalUrl: string;
          downloadUrl: string;
          lastUpdateTime: /* google.protobuf.Timestamp */ string | null;
          datasetVersionNumber: number;
          alreadyVotedUp: boolean;
          upvoteUrl: string;
          inFlight: boolean;
          creatorDisplayName: string;
          cardImageUrl: string;
          categories: Kaggle.Sdk.Datasets.Protos.TagList | null;
          bookmarked: boolean;
          datasetExternalUrl: string;
          ownerTwitter: string;
          collaborator: boolean;
          forumId: number;
          datasetVersionId: number;
          canCreateTasks: boolean;
        }

        export interface DatasetImageInfo {
          cardImageUrl: string;
          cardImageLeft: number;
          cardImageTop: number;
          cardImageHeight: number;
          cardImageWidth: number;
          coverImageLeft: number;
          coverImageHeight: number;
          coverImageTop: number;
          coverImageWidth: number;
          coverImageUrl: string;
          originalImageUrl: string;
          thumbnailImageUrl: string;
        }

        export interface DatasetSettings {
          title?: /* google.protobuf.StringValue */ string | null;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          description?: /* google.protobuf.StringValue */ string | null;
          isPrivate: boolean;
          keywords: string[];
          licenses: Kaggle.Sdk.Datasets.Protos.SettingsLicense[];
          collaborators: Kaggle.Sdk.Datasets.Protos.UserRole[];
          data: Kaggle.Sdk.Datasets.Protos.DatasetSettingsFile[];
        }

        export interface DatasetSettingsFile {
          name: string;
          description?: /* google.protobuf.StringValue */ string | null;
          totalBytes: number;
          columns: Kaggle.Sdk.Datasets.Protos.DatasetSettingsFileColumn[];
        }

        export interface DatasetSettingsFileColumn {
          name: string;
          description?: /* google.protobuf.StringValue */ string | null;
          type?: /* google.protobuf.StringValue */ string | null;
        }

        export interface DatasetUsabilityRating {
          score: number;
          columnDescriptionScore?: number;
          coverImageScore: number;
          fileDescriptionScore: number;
          fileFormatScore: number;
          licenseScore: number;
          overviewScore: number;
          provenanceScore: number;
          publicKernelScore: number;
          subtitleScore: number;
          tagScore: number;
          updateFrequencyScore: number;
        }

        export interface DeleteDuplicatedDatasetsRequest {}

        export interface DeleteExpiredGcsBucketsRequest {}

        export interface GetDatasetBasicsRequest {
          ownerSlug: string;
          datasetSlug: string;
        }

        export interface GetDatasetImageInfoRequest {
          datasetId: number;
          datasetVersionId: number;
        }

        export interface GetDatasetImageInfoResponse {
          info?: Kaggle.Sdk.Datasets.Protos.DatasetImageInfo | null;
        }

        export interface GetDatasetSettingsRequest {
          datasetId: number;
        }

        export interface GetDatasetUsabilityRatingRequest {
          datasetId: number;
        }

        export interface GetDatasetUsabilityRatingResponse {
          rating?: Kaggle.Sdk.Datasets.Protos.DatasetUsabilityRating | null;
        }

        export interface GetProfileDatasetStatsRequest {
          // What user's data are we interested in?
          userId: number;
        }

        export interface GetProfileDatasetStatsResponse {
          // How many datasets has user_id created?
          datasetsCount: number;
          // How many upvotes on datasets has user_id received?
          upvotesCount: number;
          // How many Tasks has user_id created?
          tasksCount: number;
          // How many of user_id's submissions have been accepted?
          acceptedSubmissionsCount: number;
        }

        export interface License {
          id: number;
          name: string;
          url: string;
        }

        export interface Owner {
          id: number;
          imageUrl: string;
          organization: boolean;
          maxFileSizeBytes: number;
          name: string;
          organizationMemberCount: number;
          profileUrl: string;
          slug: string;
          userTier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
        }

        export interface RecreateDatasetArchiveRequest {
          // The dataset that needs to have the zip file recreated
          datasetId: number;
          // Force recreate the zip file even if archive file already exists or if another zipper process is on going
          force: boolean;
        }

        export interface RecreateDatasetArchiveResponse {
          // The databundle version that is getting zip file recreated
          databundleVersionId: number;
          // Status of the request
          message: string;
        }

        export interface SendPrivateDatasetSummaryRequest {}

        export interface SetDatasetSettingsRequest {
          datasetId: number;
          settings: Kaggle.Sdk.Datasets.Protos.DatasetSettings | null;
        }

        export interface SettingsLicense {
          name?: /* google.protobuf.StringValue */ string | null;
        }

        export interface SummarizeDailyDownloadActivitiesRequest {}

        export interface SummarizeDailyKernelUsagesRequest {}

        export interface SummarizeDailyViewsRequest {}

        export interface TagList {
          tags: Kaggle.Sdk.Tags.Protos.Tag[];
        }

        export interface UpdateDatasetCategoryRecommendationsRequest {}

        export interface UpdateDatasetHotnessRequest {}

        export interface UpdatePopularDatasetsRequest {}

        export interface UpdateTrendingDatasetsRequest {}

        export interface UpdateTrendingDatasetTasksRequest {}

        export interface UserRole {
          username: string;
          role: Kaggle.Sdk.Users.Protos.CollaboratorType;
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface AcceptTaskSubmissionRequest {
          taskSubmissionId: /*Int32*/ number;
        }

        export interface AddDatabundleDownloadRequest {
          /*[NotNull]*/
          databundleVersionId: /*Int32*/ number;
          /*[NotNull]*/
          isBundleDownload: boolean;
          filePath: string | null;
        }

        /*[ClientRequest, NotNull]*/
        export interface AddDatasetCategoriesRequest {
          datasetId: /*Int32*/ number;
          categoryIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface AttachCompetitionDatasetRequest {
          competitionId: /*Int32*/ number;
          datasetId: /*Int32*/ number;
        }

        export interface AutoTagDatasetRequest {
          datasetId: /*Int32*/ number;
        }

        export interface BatchAutoTagDatasetRequest {
          startDatasetId: /*Int32*/ number;
          batchSize: /*Int32*/ number;
          logInterval: /*Int32*/ number;
        }

        export interface BatchUpdateDatasetHotnessFromRawRecordsRequest {
          startDatasetId: /*Int32*/ number;
          datasetCount: /*Int32*/ number;
          updateDate: /*DateTime*/ string;
        }

        export interface BatchUpdateDatasetHotnessRequest {
          startDatasetId: /*Int32*/ number;
          datasetCount: /*Int32*/ number;
          updateDate: /*DateTime*/ string;
        }

        export interface BatchUpdateDatasetHotnessSummariesRequest {
          startDatasetId: /*Int32*/ number;
          datasetCount: /*Int32*/ number;
          summaryDate: /*DateTime*/ string;
        }

        export interface CheckDatasetAccessRequest {
          datasetId: /*Int32*/ number;
          userId: (/*Int32*/ number) | null;
          hashLink: string | null;
          accessType: "own" | "see" | "update";
        }

        export interface CheckIfDeletionNeedsDatasetReviewRequest {
          userId: /*Int32*/ number;
        }

        export interface CopyDatasetVersionMetadataRequest {
          fromDatasetVersionId: /*Int32*/ number;
          toDatasetVersionId: /*Int32*/ number;
          deleteExistingToDatasetVersionMetadata: boolean;
        }

        export interface CopyDatasetVersionToGcsRequest {
          datasetVersionId: (/*Int32*/ number) | null;
          /*[NotNull]*/
          region: string;
          /*[NotNull]*/
          destinationBucket: string;
          destinationPath: string | null;
          databundleVersionId: (/*Int32*/ number) | null;
        }

        export interface CopyDatasetVersionToGcsRequestV2 {
          datasetVersionId: (/*Int32*/ number) | null;
          /*[NotNull]*/
          region: string;
          /*[NotNull]*/
          destinationBucket: string;
          destinationPath: string | null;
          databundleVersionId: (/*Int32*/ number) | null;
        }

        export interface CopyDatasetVersionToKnownGcsBucketAdminRequest {
          databundleVersionId: /*Int32*/ number;
          region: string | null;
          ttlDays: /*Int32*/ number;
        }

        export interface CopyDatasetVersionToKnownGcsBucketRequest {
          mountSlug: string | null;
          integrationType: "autoMl" | "tpu";
        }

        export interface CreateBigQueryDatasetRequest
          extends Kaggle.Sdk.Datasets.Requests.CreateRequestV2 {
          /*[NotNull]*/
          projectId: string;
          /*[NotNull]*/
          datasetId: string;
          slug: string | null;
          ownerOrganizationSlug: string | null;
          databundleVersionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
        }

        /*[ClientRequest]*/
        export interface CreateCompetitionDataRequestV2
          extends Kaggle.Sdk.Datasets.Requests.CreateRequestV2 {
          /*[NotNull]*/
          competitionId: /*Int32*/ number;
          /*[NotNull]*/
          versionNotes: string;
          existingDirectories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingDirectoryInfo)[];
          existingFiles: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingFileInfo)[];
        }

        export interface CreateDatabundleRequest {
          creatorUserId: /*Int32*/ number;
          type: "competition" | "dataset" | "general" | "notebook";
          versionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          storageSettings: Kaggle.Sdk.Datasets.Models.DatabundleVersionStorageSettings | null;
          diffType: "realtime" | "unversioned" | "versioned";
          versionNotes: string | null;
        }

        export interface CreateDatabundleVersionRequest {
          creatorUserId: /*Int32*/ number;
          databundleId: /*Int32*/ number;
          versionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          versionNotes: string | null;
          versionSettings: Kaggle.Sdk.Datasets.Models.DataSettingsDto | null;
        }

        export interface CreateDatasetActivityRequest {
          datasetId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface CreateDatasetHashLinkRequest {
          datasetId: /*Int32*/ number;
        }

        export interface CreateDatasetInterVersionSchemaDiffRequest {
          datasetId: /*Int32*/ number;
          databundleVersionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          userId: /*Int32*/ number;
          previousDatabundleVersionId: /*Int32*/ number;
          latestDatabundleVersionId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface CreateDatasetRequestV2
          extends Kaggle.Sdk.Datasets.Requests.CreateRequestV2 {
          /*[NotNull]*/
          title: string;
          /*[NotNull]*/
          slug: string;
          overview: string | null;
          description: string | null;
          /*[NotNull]*/
          isPrivate: boolean;
          /*[NotNull]*/
          licenseId: /*Int32*/ number;
          /*[NotNull]*/
          referrer: string;
          ownerOrganizationId: (/*Int32*/ number) | null;
          ownerUserId: (/*Int32*/ number) | null;
          taskId: (/*Int32*/ number) | null;
          competitionId: (/*Int32*/ number) | null;
        }

        export interface CreateDatasetsActivityLogRequest {
          userId: /*Int32*/ number;
          datasetId: /*Int32*/ number;
          type:
            | "create"
            | "feature"
            | "intraVersionSchemaUpdate"
            | "makePrivate"
            | "makePublic"
            | "newVersion"
            | "publish"
            | "remove"
            | "removeVersion"
            | "superFeature"
            | "unFeature"
            | "unPublish"
            | "unSuperFeature";
          previousDatabundleVersionId: (/*Int32*/ number) | null;
          latestDatabundleVersionId: (/*Int32*/ number) | null;
          datasetSchemaChanges: string | null;
        }

        /*[ClientRequest]*/
        export interface CreateDatasetVersionRequestV2
          extends Kaggle.Sdk.Datasets.Requests.CreateRequestV2 {
          /*[NotNull]*/
          datasetId: /*Int32*/ number;
          /*[NotNull]*/
          versionNotes: string;
          overview: string | null;
          description: string | null;
          /*[NotNull]*/
          deleteOldVersions: boolean;
          existingDirectories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingDirectoryInfo)[];
          existingFiles: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.ExistingFileInfo)[];
        }

        /*[ClientRequest]*/
        export interface CreateDoiApproverRequest {
          datasetId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface CreateDoiRequest {
          datasetVersionId: /*Int32*/ number;
          replaceExistingDoi: boolean;
          addDatasetPersistenceApproval: boolean;
        }

        /*[ClientRequest]*/
        export interface CreateRequestV2 {
          /*[NotNull]*/
          databundleVersionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          directories: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.UploadDirectoryInfo)[];
          files: (Kaggle.Sdk.Datasets.Databundles.Models.Upload.UploadFileInfo)[];
          remoteUrlInfos: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.RemoteUrlInfo)[];
          githubInfo: Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.GithubInfo | null;
          kernelOutputInfo: Kaggle.Sdk.Datasets.Databundles.Models.Upload.KernelOutputInfo | null;
          gcsFileSetInfo: Kaggle.Sdk.Datasets.Databundles.Models.Upload.GcsFileSetInfo | null;
          flags: Kaggle.Sdk.Datasets.Databundles.Models.Worker.ActionFlags | null;
        }

        /*[ClientRequest]*/
        export interface CreateTaskRequest {
          datasetId: /*Int32*/ number;
          /*[NotNull]*/
          title: string;
          subtitle: string | null;
          /*[NotNull]*/
          description: string;
          deadline: (/*DateTime*/ string) | null;
        }

        /*[ClientRequest]*/
        export interface CreateTaskSubmissionRequest {
          datasetTaskId: /*Int32*/ number;
          kernelId: (/*Int32*/ number) | null;
          datasetId: (/*Int32*/ number) | null;
        }

        export interface CreateUserDatasetViewRequest {
          userId: (/*Int32*/ number) | null;
          datasetId: /*Int32*/ number;
          viewDate: /*DateTime*/ string;
        }

        export interface DatabundlePubSubDeleteRequest {
          path: string | null;
        }

        export interface DeleteCompetitionDatasetRequest {
          competitionId: /*Int32*/ number;
          datasetId: /*Int32*/ number;
        }

        export interface DeleteDatabundleRequest {
          databundleId: /*Int32*/ number;
        }

        export interface DeleteDatabundleVersionRequest {
          databundleVersionId: /*Int32*/ number;
        }

        export interface DeleteDatasetByIdRequest {
          id: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteDatasetBySlugRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
        }

        /*[ClientRequest, NotNull]*/
        export interface DeleteDatasetCategoriesRequest {
          datasetId: /*Int32*/ number;
          categoryIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface DeleteDatasetHashLinkRequest {
          datasetId: /*Int32*/ number;
        }

        export interface DeleteDatasetRequest {
          datasetId: /*Int32*/ number;
          ignoreChecks: boolean;
        }

        export interface DeleteDatasetVersionRequest {
          datasetVersionId: /*Int32*/ number;
        }

        export interface DeleteOldDatasetVersionsRequest {
          datasetId: /*Int32*/ number;
          userId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface DeleteTaskRequest {
          taskId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteTaskSubmissionRequest {
          taskSubmissionId: /*Int32*/ number;
        }

        export interface DeleteUserDatasetViewsRequest {
          userId: /*Int32*/ number;
        }

        export interface DeleteUserDatasetVotesRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface DeleteUserTasksRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DetectDuplicateRequest {
          /*[NotNull]*/
          blobFileToken: string;
          currentDatasetId: (/*Int32*/ number) | null;
          currentCompetitionId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface EditDatasetDescriptionRequest {
          datasetId: /*Int32*/ number;
          description: string | null;
        }

        /*[ClientRequest]*/
        export interface EditTaskRequest {
          taskId: /*Int32*/ number;
          /*[NotNull]*/
          title: string;
          subtitle: string | null;
          /*[NotNull]*/
          description: string;
          deadline: (/*DateTime*/ string) | null;
        }

        export interface FixDatabundleVersionRequest {
          databundleId: /*Int32*/ number;
          databundleVersionId: /*Int32*/ number;
          updatedDatabundleVersionStatus:
            | "blobsCopiedToSds"
            | "blobsDecompressed"
            | "blobsReceived"
            | "deleted"
            | "failed"
            | "individualBlobsCompressed"
            | "notYetPersisted"
            | "ready"
            | "reprocessing";
        }

        /*[ClientRequest]*/
        export interface GetCompetitionUploaderConfigRequest {
          competitionId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatabundleExternalChildrenRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
          firestorePath: string;
          offset: /*Int32*/ number;
          count: /*Int32*/ number;
          depth: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatabundleExternalColumnsByFirestorePathRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
          firestorePaths: (string)[];
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatabundleExternalColumnsRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
          firestorePath: string;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatabundleExternalRequest {
          verificationInfo: Kaggle.Sdk.Datasets.Models.DatabundleVerificationInfo;
        }

        /*[ClientRequest]*/
        export interface GetDatabundleVersionCreationStatusRequest {
          databundleVersionId: /*Int32*/ number;
        }

        export interface GetDatasetActivityFeedRequest {
          datasetId: /*Int32*/ number;
          isHashLinkRequest: boolean;
          page: /*Int32*/ number;
          pageSize: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatasetActivityRequest {
          datasetId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetDatasetByUrlRequest {
          /*[NotNull]*/
          url: string;
        }

        export interface GetDatasetCollaboratorListRequest {
          datasetId: /*Int32*/ number;
          hashLink: string | null;
        }

        export interface GetDatasetCoreIdsByHashLinkRequest {
          hashLink: string | null;
          accessType: "own" | "see" | "update";
          userId: (/*Int32*/ number) | null;
          versionNumber: (/*Int32*/ number) | null;
        }

        export interface GetDatasetCoreIdsBySlugIgnoreAccessRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
        }

        export interface GetDatasetCoreIdsBySlugRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
          accessType: "own" | "see" | "update";
          userId: (/*Int32*/ number) | null;
          versionNumber: (/*Int32*/ number) | null;
          inFlight: boolean;
        }

        export interface GetDatasetDownloadUrlRequest {
          datasetId: /*Int32*/ number;
          databundleVersionId: /*Int32*/ number;
          datasetHashLink: string | null;
          dataObjectFirestorePath: string | null;
          defaultToZipDownload: boolean;
        }

        export interface GetDatasetEmbedCardRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
        }

        export interface GetDatasetEmbedCardResponse {
          status:
            | ".ctor"
            | "accepted"
            | "alreadyReported"
            | "ambiguous"
            | "badGateway"
            | "badRequest"
            | "conflict"
            | "continue"
            | "created"
            | "earlyHints"
            | "expectationFailed"
            | "failedDependency"
            | "forbidden"
            | "found"
            | "gatewayTimeout"
            | "gone"
            | "httpVersionNotSupported"
            | "iMUsed"
            | "insufficientStorage"
            | "internalServerError"
            | "lengthRequired"
            | "locked"
            | "loopDetected"
            | "methodNotAllowed"
            | "misdirectedRequest"
            | "moved"
            | "movedPermanently"
            | "multipleChoices"
            | "multiStatus"
            | "networkAuthenticationRequired"
            | "noContent"
            | "nonAuthoritativeInformation"
            | "notAcceptable"
            | "notExtended"
            | "notFound"
            | "notImplemented"
            | "notModified"
            | "oK"
            | "partialContent"
            | "paymentRequired"
            | "permanentRedirect"
            | "preconditionFailed"
            | "preconditionRequired"
            | "processing"
            | "proxyAuthenticationRequired"
            | "redirect"
            | "redirectKeepVerb"
            | "redirectMethod"
            | "requestedRangeNotSatisfiable"
            | "requestEntityTooLarge"
            | "requestHeaderFieldsTooLarge"
            | "requestTimeout"
            | "requestUriTooLong"
            | "resetContent"
            | "seeOther"
            | "serviceUnavailable"
            | "switchingProtocols"
            | "temporaryRedirect"
            | "tooManyRequests"
            | "unauthorized"
            | "unavailableForLegalReasons"
            | "unprocessableEntity"
            | "unsupportedMediaType"
            | "unused"
            | "upgradeRequired"
            | "useProxy"
            | "value__"
            | "variantAlsoNegotiates";
          embedCard: Kaggle.Sdk.Datasets.Models.DatasetEmbedCard | null;
        }

        /*[ClientRequest]*/
        export interface GetDatasetHistoryRequest {
          datasetId: /*Int32*/ number;
          count: /*Int32*/ number;
          hashLink: string | null;
        }

        /*[ClientRequest]*/
        export interface GetDatasetLimitsRequest {
          /*[NotNull]*/
          userId: /*Int32*/ number;
          organizationId: (/*Int32*/ number) | null;
          excludeDatasetVersionId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface GetDatasetMetadataRequest {
          datasetVersionId: /*Int32*/ number;
          hashLink: string | null;
        }

        export interface GetDatasetNewsfeedSidebarItemsByIdRequest {
          ids: (/*Int32*/ number)[];
        }

        export interface GetDatasetNewsfeedStoriesByIdRequest {
          storyItems: Record<
            string,
            Kaggle.Sdk.Newsfeed.Protos.NewsfeedStoryInfo
          >;
          type: "dataset" | "datasetVote";
        }

        export interface GetDatasetRequest {
          datasetId: /*Int32*/ number;
          datasetVersionId: /*Int32*/ number;
          isHashLinkRequest: boolean;
          inFlight: boolean;
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Datasets.Models.DatasetDto
          >;
        }

        export interface GetDatasetsBatchForActivityRequest {
          batchSize: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatasetsByIdRequest {
          ids: (/*Int32*/ number)[];
          initialRank: /*Int32*/ number;
          includeDescription: boolean | null;
        }

        export interface GetDatasetsByVersionIdRequest {
          datasetVersionIds: (/*Int32*/ number)[];
        }

        export interface GetDatasetSchemaDiffRequest {
          oldDatabundleVersionId: /*Int32*/ number;
          newDatabundleVersionId: /*Int32*/ number;
          databundleVersionType:
            | "bigQuery"
            | "fileset"
            | "gcsFileSet"
            | "kernelOutputFileSet"
            | "remoteGitRepositoryFileSet"
            | "remoteUrlFileSet";
          datasetDiffType: "realtime" | "unversioned" | "versioned";
        }

        export interface GetDatasetSidebarIdsRequest {
          userId: (/*Int32*/ number) | null;
          isUserQuery: boolean;
          count: /*Int32*/ number;
        }

        export interface GetDatasetSiteMapUrlsRequest {}

        export interface GetDatasetsKernelRedirectRequest {
          requestPath: string | null;
          datasetUserName: string | null;
          datasetSlug: string | null;
          kernelUserName: string | null;
          kernelSlug: string | null;
          scriptVersionId: string | null;
          tab: string | null;
        }

        /*[ClientRequest]*/
        export interface GetDatasetSuggestionsRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
        }

        export interface GetDatasetSummaryDatesRequest {}

        /*[ClientRequest, NotNull]*/
        export interface GetDatasetTasksByIdRequest {
          taskIds: (/*Int32*/ number)[];
          userId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest, NotNull]*/
        export interface GetDatasetTasksRequest {
          datasetId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetDatasetUploaderConfigRequest {
          currentDatasetVersionId: (/*Int32*/ number) | null;
          ownerOrganizationId: (/*Int32*/ number) | null;
        }

        export interface GetDatasetVersionCopyStatusRequest {
          operationId: string | null;
        }

        export interface GetDatasetVersionGcsBucketRequest {
          mountSlug: string | null;
          integrationType: "autoMl" | "tpu";
        }

        export interface GetDataSourcesMappingRequest {
          datasetVersionIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface GetFirestorePathForDatabundleFieldRequest {
          /*[NotNull]*/
          field: string;
          value: (/*Object*/ unknown) | null;
        }

        export interface GetGcsDatasetExternalCopyInfoAdminRequest {
          mountSlug: string | null;
          competitionId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface GetGithubRepositoryInfoRequest {
          ownerSlug: string | null;
          repositorySlug: string | null;
        }

        export interface GetHotNewTasksRequest {
          since: /*DateTime*/ string;
          count: /*Int32*/ number;
          featuredOnly: boolean;
        }

        export interface GetJoinSuggestionsRequest {
          kernelId: /*Int32*/ number;
          count: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetKernelOutputDatasetRequest {
          /*[NotNull]*/
          kernelId: /*Int32*/ number;
        }

        export interface GetKernelOutputKernelReferenceRequest {
          datasetId: /*Int32*/ number;
        }

        export interface GetKernelTaskSubmissionInfosRequest {
          kernelIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface GetLandingPageTopicsRequest {}

        export interface GetOrganizationDatasetsRequest {
          ownerOrganizationId: /*Int32*/ number;
        }

        export interface GetPopularDatasetIdsRequest {
          count: /*Int32*/ number;
          offset: /*Int32*/ number;
          userId: (/*Int32*/ number) | null;
          initialUpdateDate: (/*DateTime*/ string) | null;
          sortBy:
            | "active"
            | "hottest"
            | "lastViewed"
            | "published"
            | "relevance"
            | "updated"
            | "usability"
            | "votes";
          excludedDatasetIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface GetPossibleCompetitionDatasetsRequest {
          competitionId: /*Int32*/ number;
          search: string | null;
          offset: /*Int32*/ number;
          limit: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetPossibleTaskSubmissionsRequest {
          datasetTaskId: /*Int32*/ number;
          submissionType: "dataset" | "notebook";
          search: string | null;
          offset: /*Int32*/ number;
          limit: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetRecentlyViewedDatasetsRequest {
          userId: (/*Int32*/ number) | null;
        }

        export interface GetRecommendedCategoricalDatasetIdsRequest {
          count: /*Int32*/ number;
          offset: /*Int32*/ number;
          categoryId: /*Int32*/ number;
          userId: (/*Int32*/ number) | null;
          initialUpdateDate: (/*DateTime*/ string) | null;
          excludedDatasetIds: (/*Int32*/ number)[];
          sortBy:
            | "active"
            | "hottest"
            | "lastViewed"
            | "published"
            | "relevance"
            | "updated"
            | "usability"
            | "votes";
        }

        /*[ClientRequest, NotNull]*/
        export interface GetRemoteUrlFileInfoRequest {
          url: string;
        }

        /*[ClientRequest]*/
        export interface GetSidebarTasksRequest {}

        /*[ClientRequest]*/
        export interface GetTaskRequest {
          taskId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetTaskSubmissionsRequest {
          taskId: /*Int32*/ number;
          offset: /*Int32*/ number;
          limit: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetTopicalDatasetsRequest {
          /*[NotNull]*/
          topicType:
            | "artsAndEntertainmentDataset"
            | "automobilesAndVehiclesDataset"
            | "biologyDataset"
            | "businessDataset"
            | "cancerDataset"
            | "classificationDataset"
            | "clothingAndAccessoriesDataset"
            | "computerScienceDataset"
            | "covidDataset"
            | "earthAndNatureDataset"
            | "economicsDataset"
            | "educationDataset"
            | "exerciseDataset"
            | "financeDataset"
            | "foodDataset"
            | "gamesDataset"
            | "healthDataset"
            | "imageDataset"
            | "internetDataset"
            | "investingDataset"
            | "lawDataset"
            | "moviesAndTvShowsDataset"
            | "musicDataset"
            | "newsDataset"
            | "nlpDataset"
            | "onlineCommunitiesDataset"
            | "popularDataset"
            | "programmingDataset"
            | "recentlyViewed"
            | "retailAndShoppingDataset"
            | "socialIssuesAndAdvocacyDataset"
            | "socialNetworksDataset"
            | "socialScienceDataset"
            | "softwareDataset"
            | "sportsDataset"
            | "standardizedTestingDataset"
            | "textDataset"
            | "transportationDataset"
            | "travelDataset"
            | "trendingDataset"
            | "trendingTask"
            | "universitiesAndCollegesDataset";
          sortBy:
            | "active"
            | "hottest"
            | "lastViewed"
            | "published"
            | "relevance"
            | "updated"
            | "usability"
            | "votes";
          offset: (/*Int32*/ number) | null;
          count: (/*Int32*/ number) | null;
          initialResponseUpdateTime: (/*DateTime*/ string) | null;
        }

        /*[ClientRequest]*/
        export interface GetTopicalTasksRequest {
          /*[NotNull]*/
          topicType:
            | "artsAndEntertainmentDataset"
            | "automobilesAndVehiclesDataset"
            | "biologyDataset"
            | "businessDataset"
            | "cancerDataset"
            | "classificationDataset"
            | "clothingAndAccessoriesDataset"
            | "computerScienceDataset"
            | "covidDataset"
            | "earthAndNatureDataset"
            | "economicsDataset"
            | "educationDataset"
            | "exerciseDataset"
            | "financeDataset"
            | "foodDataset"
            | "gamesDataset"
            | "healthDataset"
            | "imageDataset"
            | "internetDataset"
            | "investingDataset"
            | "lawDataset"
            | "moviesAndTvShowsDataset"
            | "musicDataset"
            | "newsDataset"
            | "nlpDataset"
            | "onlineCommunitiesDataset"
            | "popularDataset"
            | "programmingDataset"
            | "recentlyViewed"
            | "retailAndShoppingDataset"
            | "socialIssuesAndAdvocacyDataset"
            | "socialNetworksDataset"
            | "socialScienceDataset"
            | "softwareDataset"
            | "sportsDataset"
            | "standardizedTestingDataset"
            | "textDataset"
            | "transportationDataset"
            | "travelDataset"
            | "trendingDataset"
            | "trendingTask"
            | "universitiesAndCollegesDataset";
          offset: (/*Int32*/ number) | null;
          count: (/*Int32*/ number) | null;
          initialResponseUpdateTime: (/*DateTime*/ string) | null;
        }

        export interface GetTrendingDatasetIdsRequest {
          count: /*Int32*/ number;
          offset: /*Int32*/ number;
          userId: (/*Int32*/ number) | null;
          initialUpdateDate: (/*DateTime*/ string) | null;
          sortBy:
            | "active"
            | "hottest"
            | "lastViewed"
            | "published"
            | "relevance"
            | "updated"
            | "usability"
            | "votes";
          excludedDatasetIds: (/*Int32*/ number)[];
        }

        export interface GetTrendingDatasetTaskIdsRequest {
          count: /*Int32*/ number;
          offset: /*Int32*/ number;
          userId: (/*Int32*/ number) | null;
          initialUpdateDate: (/*DateTime*/ string) | null;
        }

        export interface GetUserDatasetCountRequest {
          userId: /*Int32*/ number;
          includeNonPublic: boolean;
        }

        /*[ClientRequest]*/
        export interface GetUserDoiDatasetsRequest {
          /*[NotNull]*/
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetUserSubmissionsRequest {
          userId: /*Int32*/ number;
          acceptedOnly: boolean;
          offset: /*Int32*/ number;
          limit: /*Int32*/ number;
        }

        export interface LinkKernelTaskSubmissionRequest {
          kernelId: /*Int32*/ number;
          taskId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface RefreshRemoteDatasetRequest {
          /*[NotNull]*/
          datasetId: /*Int32*/ number;
          /*[NotNull]*/
          settings: Kaggle.Sdk.Datasets.Models.Creation.DataCreationSettings;
        }

        export interface SearchDatasetDatasourcesRequest {
          search: string | null;
          page: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface SearchDatasetsRequest {
          /*[NotNull]*/
          group:
            | "all"
            | "bookmarked"
            | "featured"
            | "my"
            | "myPrivate"
            | "myPublic"
            | "organization"
            | "public"
            | "unfeatured"
            | "upvoted"
            | "user"
            | "userSharedWithMe";
          /*[NotNull]*/
          size: "all" | "large" | "medium" | "small";
          /*[NotNull]*/
          fileType: "all" | "bigQuery" | "csv" | "json" | "sqlite";
          /*[NotNull]*/
          license: "all" | "cc" | "gpl" | "odb" | "other";
          /*[NotNull]*/
          viewed: "all" | "viewed";
          /*[NotNull]*/
          sortBy:
            | "active"
            | "hottest"
            | "lastViewed"
            | "published"
            | "relevance"
            | "updated"
            | "usability"
            | "votes";
          /*[NotNull]*/
          categoryIds: (/*Int32*/ number)[];
          /*[NotNull]*/
          search: string;
          userId: (/*Int32*/ number) | null;
          organizationId: (/*Int32*/ number) | null;
          maintainerOrganizationId: (/*Int32*/ number) | null;
          minSize: (/*Int64*/ number) | null;
          maxSize: (/*Int64*/ number) | null;
          isUserQuery: boolean;
          page: /*Int32*/ number;
          hasTasks: boolean;
          competitionId: (/*Int32*/ number) | null;
          topicalDataset: Kaggle.Sdk.Datasets.Responses.TopicalDataset | null;
          includeTopicalDatasets: boolean;
        }

        /*[ClientRequest]*/
        export interface SearchTasksRequest {
          query: string | null;
          includeClosed: boolean;
          includeWithAcceptedSubmission: boolean;
          includeOwnTasks: boolean;
          maxResults: /*Int32*/ number;
          offset: /*Int32*/ number;
        }

        export interface SetDatabundleVersionExceptionRequest {
          databundleVersionId: /*Int32*/ number;

          userMessage: string | null;
        }

        /*[ClientRequest, NotNull]*/
        export interface SetDatabundleVersionNotesRequest {
          databundleVersionId: /*Int32*/ number;
          versionNotes: string;
        }

        export interface SetDatabundleVersionStatusRequest {
          databundleVersionId: /*Int32*/ number;
          currentStepName: string | null;
          percentComplete: (/*Double*/ number) | null;
        }

        export interface SetDatabundleVersionStorageRequest {
          databundleVersionId: /*Int32*/ number;
          storageSettings: Kaggle.Sdk.Datasets.Models.DatabundleVersionStorageSettings | null;
        }

        export interface SetDatasetActivityRequest {
          lastAttemptedDate: /*DateTime*/ string;
          datasetActivity: Kaggle.Sdk.Datasets.Models.ActivitySummaryStats | null;
        }

        /*[ClientRequest]*/
        export interface SetDatasetChecklistVisibilityRequest {
          datasetId: /*Int32*/ number;
          visibility: "collapsed" | "dismissed" | "expanded";
        }

        /*[ClientRequest]*/
        export interface SetDatasetCollaboratorListRequest {
          datasetId: /*Int32*/ number;
          /*[NotNull]*/
          collaboratorList: Kaggle.Sdk.Users.Models.CollaboratorList;
        }

        export interface SetDatasetGroupsRequest {
          datasetId: /*Int32*/ number;
          readerGroupId: (/*Int32*/ number) | null;
          writerGroupId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest, NotNull]*/
        export interface SoftDeleteDatasetsForOrgRequest {
          organizationId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface SoftDeleteDatasetsForUserRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface TaskVoteRequest {
          taskId: /*Int32*/ number;
          isUpvote: boolean;
        }

        /*[ClientRequest]*/
        export interface UnacceptTaskSubmissionsRequest {
          taskId: /*Int32*/ number;
        }

        /*[ClientRequest, NotNull]*/
        export interface UndeleteDatasetsForUserRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetCollaboratorsRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetGeneralRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
          title: string | null;
          overview: string | null;
          licenseId: /*Byte*/ number;
          owner: Kaggle.Sdk.Datasets.Models.OwnerDto | null;
          diffType: "realtime" | "unversioned" | "versioned";
          updateFrequency: "daily" | "monthly" | "never" | "weekly" | null;
          blockTaskCreation: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetGeneralSettingsRequest {
          datasetVersionId: /*Int32*/ number;
          /*[NotNull]*/
          title: string;
          /*[NotNull]*/
          subtitle: string;
          /*[NotNull]*/
          owner: Kaggle.Sdk.Datasets.Models.OwnerDto;
          licenseId: /*Byte*/ number;
          diffType: "realtime" | "unversioned" | "versioned";
          updateFrequency: "daily" | "monthly" | "never" | "weekly" | null;
          blockTaskCreation: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetMetadataRequest {
          /*[NotNull]*/
          datasetVersionId: /*Int32*/ number;
          /*[NotNull]*/
          dataCoverageAttribute: Kaggle.Sdk.Datasets.Models.DataCoverageAttribute;
          collectionMethods: string | null;
          /*[NotNull]*/
          datasetVersionAuthors: (Kaggle.Sdk.Datasets.Models.DatasetVersionAuthor)[];
          doi: string | null;
          licenseId: /*Byte*/ number;
          userSpecifiedSources: string | null;
          expectedUpdateFrequency: string | null;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetPrivacyRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
          isPrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateDatasetRequest {
          ownerSlug: string | null;
          datasetSlug: string | null;
          slug: string | null;
          isRemoved: boolean;
          isFeatured: boolean;
          isSuperFeatured: boolean;
          scheduledToBeFeatured: (/*DateTime*/ string) | null;
          scheduledToBeUnFeatured: (/*DateTime*/ string) | null;
          scheduledToBeSuperFeatured: (/*DateTime*/ string) | null;
          scheduledToBeUnSuperFeatured: (/*DateTime*/ string) | null;
          maintainerOrganization: Kaggle.Sdk.Datasets.Models.OwnerDto | null;
        }

        export interface UpdateDatasetUsabilityRatingRequest {
          datasetId: /*Int32*/ number;
          subScoresForUpdate: (
            | "columnDescription"
            | "coverImage"
            | "fileDescription"
            | "fileFormat"
            | "license"
            | "overviewDescription"
            | "publicKernel"
            | "source"
            | "subtitle"
            | "tag"
            | "updateFrequency")[];
        }

        export interface UpdateTaskHotnessRequest {}
      }

      export namespace Responses {
        /*[NotNull]*/
        export interface AddDatasetCategoriesResponse {
          updatedUsabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating;
        }

        export interface AutoTagDatasetResponse {
          autoTagIds: (/*Int32*/ number)[];
        }

        export interface CopyDatasetVersionToKnownGcsBucketResponse {
          destinationBucket: string | null;
          destinationPath: string | null;
        }

        export interface CreateDoiApproverResponse {
          errorMessage: string | null;
        }

        export interface CreateDoiResponse {
          errorMessage: string | null;
          doi: string | null;
        }

        /*[NotNull]*/
        export interface CreateTaskResponse {
          taskId: /*Int32*/ number;
        }

        export interface DatasetTopicContent {
          topicType:
            | "artsAndEntertainmentDataset"
            | "automobilesAndVehiclesDataset"
            | "biologyDataset"
            | "businessDataset"
            | "cancerDataset"
            | "classificationDataset"
            | "clothingAndAccessoriesDataset"
            | "computerScienceDataset"
            | "covidDataset"
            | "earthAndNatureDataset"
            | "economicsDataset"
            | "educationDataset"
            | "exerciseDataset"
            | "financeDataset"
            | "foodDataset"
            | "gamesDataset"
            | "healthDataset"
            | "imageDataset"
            | "internetDataset"
            | "investingDataset"
            | "lawDataset"
            | "moviesAndTvShowsDataset"
            | "musicDataset"
            | "newsDataset"
            | "nlpDataset"
            | "onlineCommunitiesDataset"
            | "popularDataset"
            | "programmingDataset"
            | "recentlyViewed"
            | "retailAndShoppingDataset"
            | "socialIssuesAndAdvocacyDataset"
            | "socialNetworksDataset"
            | "socialScienceDataset"
            | "softwareDataset"
            | "sportsDataset"
            | "standardizedTestingDataset"
            | "textDataset"
            | "transportationDataset"
            | "travelDataset"
            | "trendingDataset"
            | "trendingTask"
            | "universitiesAndCollegesDataset";
          datasets: (Kaggle.Sdk.Datasets.Models.DatasetListItem)[];
          tasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
        }

        /*[NotNull]*/
        export interface DeleteDatasetCategoriesResponse {
          updatedUsabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating;
        }

        export interface EditDatasetDescriptionResponse {
          usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
        }

        export interface GetDatabundleExternalChildrenResponse {
          directories: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Directory)[];
          files: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.File)[];
          tables: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.Table)[];
          tableColumns: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn)[];
        }

        /*[NotNull]*/
        export interface GetDatabundleExternalColumnsByFirestorePathResponse {
          columns: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.TableColumn)[];
        }

        /*[NotNull]*/
        export interface GetDatabundleExternalColumnsResponse {
          columns: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ColumnBaseInfo)[];
        }

        export interface GetDatabundleExternalResponse {
          /*[NotNull]*/
          dataSource: Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DataSource;
        }

        export interface GetDatasetActivityFeedResponse {
          activities: (Kaggle.Sdk.Datasets.Models.DatasetActivityDto)[];
        }

        export interface GetDatasetDownloadUrlResponse {
          url: string | null;
        }

        export interface GetDatasetSuggestionsResponse {
          suggestions: (Kaggle.Sdk.Common.Models.Suggestion)[];
        }

        export interface GetDatasetSummaryDatesResponse {
          downloadSummaryDate: (/*DateTime*/ string) | null;
          viewSummaryDate: (/*DateTime*/ string) | null;
          kernelCreationSummaryDate: (/*DateTime*/ string) | null;
        }

        /*[NotNull]*/
        export interface GetDatasetTasksResponse {
          tasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
        }

        export interface GetGcsDatasetExternalCopyInfoResponse {
          firestorePath: string | null;
          totalCompressedBytes: (/*Int64*/ number) | null;
          totalUncompressedBytes: (/*Int64*/ number) | null;
          externalCopies: (Kaggle.Sdk.Datasets.Databundles.Models.DataProperties.ExternalCopy)[];
        }

        export interface GetHotNewTasksResponse {
          tasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
        }

        export interface GetKernelTaskSubmissionInfosResponse {
          kernelTaskSubmissionInfos: Record<
            string,
            Kaggle.Sdk.Datasets.Models.KernelTaskSubmissionInfo
          >;
        }

        export interface GetLandingPageTopicsResponse {
          topics: (Kaggle.Sdk.Datasets.Responses.DatasetTopicContent)[];
        }

        export interface GetPopularDatasetIdsResponse {
          datasetIds: (/*Int32*/ number)[];
          hasMore: boolean;
          updateDate: (/*DateTime*/ string) | null;
        }

        export interface GetPossibleTaskSubmissionsResponse {
          submissionType: "dataset" | "notebook";
          totalCount: /*Int32*/ number;
          results: (Kaggle.Sdk.Datasets.Models.TaskSubmissionListItem)[];
        }

        export interface GetRecommendedCategoricalDatasetIdsResponse {
          datasetIds: (/*Int32*/ number)[];
          hasMore: boolean;
          updateDate: (/*DateTime*/ string) | null;
        }

        /*[NotNull]*/
        export interface GetSidebarTasksResponse {
          yourTasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
          openTasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
        }

        export interface GetTaskSubmissionsResponse {
          totalCount: /*Int32*/ number;
          taskSubmissions: (Kaggle.Sdk.Datasets.Models.TaskSubmissionListItem)[];
        }

        export interface GetTopicalDatasetsResponse {
          datasets: (Kaggle.Sdk.Datasets.Models.DatasetListItem)[];
          hasMore: boolean;
          initialResponseUpdateTime: (/*DateTime*/ string) | null;
        }

        export interface GetTopicalTasksResponse {
          tasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
          hasMore: boolean;
          initialResponseUpdateTime: (/*DateTime*/ string) | null;
        }

        export interface GetTrendingDatasetIdsResponse {
          datasetIds: (/*Int32*/ number)[];
          hasMore: boolean;
          updateDate: (/*DateTime*/ string) | null;
        }

        export interface GetTrendingDatasetTaskIdsResponse {
          datasetTaskIds: (/*Int32*/ number)[];
          hasMore: boolean;
          updateDate: (/*DateTime*/ string) | null;
        }

        export interface GetUserSubmissionsResponse {
          totalCount: /*Int32*/ number;
          taskSubmissions: (Kaggle.Sdk.Datasets.Models.TaskSubmissionListItem)[];
        }

        export interface SearchDatasetsResponse {
          datasetList: Kaggle.Sdk.Datasets.Models.DatasetList | null;
          hasMore: boolean;
          topicalDataset: Kaggle.Sdk.Datasets.Responses.TopicalDataset | null;
        }

        /*[NotNull]*/
        export interface SearchTasksResponse {
          tasks: (Kaggle.Sdk.Datasets.Models.TaskListItem)[];
          totalResults: /*Int32*/ number;
        }

        export interface TopicalDataset {
          isPopular: boolean;
          isTrending: boolean;
          categoryId: (/*Int32*/ number) | null;
          topicUpdateTime: (/*DateTime*/ string) | null;
        }

        export interface UpdateDatabundleMetadataExternalResponse {
          usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
        }

        export interface UpdateDatasetGeneralSettingsResponse {
          datasetUrl: string | null;
          usabilityRating: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
        }

        export interface UpdateDatasetResponse {
          datasetUrl: string | null;
        }

        export interface UpdateDatasetUsabilityRatingResponse {
          updatedScore: Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating | null;
          errorMessage: string | null;
        }
      }

      export interface DatabundlesClient {}

      export interface DatasetsClient {}

      export interface DatasetsConstants {}
    }

    export namespace Discussions {
      export namespace Models {
        export interface Discussion {
          currentUser: Kaggle.Sdk.Users.Models.User | null;
          siteForums: (Kaggle.Sdk.Discussions.Protos.Forum)[];
          topicSort:
            | "active"
            | "hot"
            | "new"
            | "recent"
            | "relevance"
            | "top"
            | "unspecified";
          tagCommunities: (Kaggle.Sdk.Tags.Protos.Tag)[];
        }

        export interface DiscussionForum
          extends Kaggle.Sdk.Discussions.Models.Discussion {
          forum: Kaggle.Sdk.Discussions.Protos.Forum | null;
        }

        export interface DiscussionParamValues {
          page: /*Int32*/ number;
          search: string | null;
          group:
            | "all"
            | "bookmarked"
            | "custom"
            | "myActivity"
            | "owned"
            | "starred"
            | "unspecified"
            | "upvoted";
          sortBy:
            | "active"
            | "hot"
            | "new"
            | "recent"
            | "relevance"
            | "top"
            | "unspecified";
          category:
            | "all"
            | "competitions"
            | "datasets"
            | "forums"
            | "unspecified";
        }

        export interface DiscussionSettings {
          commentSort:
            | "chronological"
            | "hot"
            | "new"
            | "old"
            | "top"
            | "unspecified";
          topicSort:
            | "active"
            | "hot"
            | "new"
            | "recent"
            | "relevance"
            | "top"
            | "unspecified";
        }

        export interface DiscussionTopic
          extends Kaggle.Sdk.Discussions.Models.Discussion {
          topic: Kaggle.Sdk.Discussions.Protos.ForumTopic | null;
        }

        export interface ForumParamValues
          extends Kaggle.Sdk.Discussions.Models.DiscussionParamValues {
          category:
            | "all"
            | "competitions"
            | "datasets"
            | "forums"
            | "unspecified";
        }

        export interface NewTopicDto {
          allowAttachments: boolean;
          authorRanking: (/*Int32*/ number) | null;
          authorTier:
            | "contributor"
            | "expert"
            | "grandmaster"
            | "master"
            | "novice"
            | "recalc"
            | "staff";
          authorType: "admin" | "comment" | "datasetCreator" | "host" | "topic";
          forumId: /*Int32*/ number;
          parentName: string | null;
          parentUrl: string | null;
        }

        export interface TopicListDto {
          canDownvote: boolean;
          dataUrl: string | null;
          id: (/*Int32*/ number) | null;
          showSubscribeButton: boolean;
          isSubscribed: boolean;
          subscription:
            | "forumNewTopics"
            | "forumNewTopicsAndComments"
            | "invalid"
            | "kernelNewComments"
            | "kernelNewCommentsAndVersions"
            | "subscribeAll"
            | "subscribeSingle"
            | "topicNewComments"
            | "unsubscribe";
          paramValues: Kaggle.Sdk.Discussions.Models.DiscussionParamValues | null;
        }
      }

      export namespace Protos {
        export interface AddToAdminForumTopicGroupingRequest {
          // The ID of the forum topic grouping to add to
          groupingId: number;
          // The IDs of the forum topics to add
          forumTopicIds: number[];
        }

        export interface AddToAdminForumTopicGroupingResponse {}

        export interface AdminStarForumTopicRequest {
          // The ID for the forum topic to star
          forumTopicId: number;
        }

        export interface AdminStarForumTopicResponse {}

        export interface AdminStarForumTopicsRequest {
          // The ID sfor the forum topics to star
          forumTopicIds: number[];
        }

        export interface AdminStarForumTopicsResponse {}

        export interface AdminUnstarForumTopicRequest {
          // The ID for the forum topic to unstar
          forumTopicId: number;
        }

        export interface AdminUnstarForumTopicResponse {}

        export interface AdminUnstarForumTopicsRequest {
          // The IDs for the forum topics to unstar
          forumTopicIds: number[];
        }

        export interface AdminUnstarForumTopicsResponse {}

        export interface BlobCreationInfo {
          // Opaque string token used to reference the new BlobFile.
          token: string;
          // URL to use to start the upload.
          createUrl: string;
        }

        export interface BlobFileInfo {
          // The name of the file, minus any path segments.
          name: string;
          // The content type of the file.
          contentType: string;
          // The total size (bytes) of the file.
          contentLength: number;
          // The date last modified, used to help determine whether the file has been updated since previous uploads.
          lastModifiedDate: /* google.protobuf.Timestamp */ string | null;
        }

        export interface CommentAttachment {
          fileType?: /* google.protobuf.StringValue */ string | null;
          id: number;
          name: string;
          totalBytes: number;
          url?: /* google.protobuf.StringValue */ string | null;
          blobToken?: /* google.protobuf.StringValue */ string | null;
        }

        // This is a version of ForumMessage meant for displaying comments
        export interface CommentForumMessage {
          id: number;
          postDate: /* google.protobuf.Timestamp */ string | null;
          rawMarkdown?: /* google.protobuf.StringValue */ string | null;
          content: string;
          replies: Kaggle.Sdk.Discussions.Protos.CommentForumMessage[];
          attachments: Kaggle.Sdk.Discussions.Protos.CommentAttachment[];
          parent: Kaggle.Sdk.Discussions.Protos.DiscussionItemLink | null;
          author: Kaggle.Sdk.Users.Protos.UserAvatar | null;
          authorType: Kaggle.Sdk.Discussions.Protos.CommentAuthorType;
          votes: Kaggle.Sdk.Discussions.Protos.CommentVoteButton | null;
          // Permissions/Display
          canDelete: boolean;
          isUserAuthor: boolean;
          hasFlags: boolean;
          isDeleted: boolean;
          isAdminDeleted: boolean;
          isFlagged: boolean;
          isSpammed: boolean;
          currentKernelVersion: number;
          isPinned: boolean;
          kernelVersion?: /* google.protobuf.Int32Value */ number | null;
          // Medals/Rankings
          competitionRanking?: /* google.protobuf.Int32Value */ number | null;
          medal: Kaggle.Sdk.Users.Protos.Medal;
          feedbackTrackingData: Kaggle.Sdk.Discussions.Protos.FeedbackTrackingData | null;
        }

        export interface CommentVoteButton {
          totalVotes: number;
          hasAlreadyVotedUp: boolean;
          hasAlreadyVotedDown: boolean;
          canUpvote: boolean;
          canDownvote: boolean;
          voters: Kaggle.Sdk.Users.Protos.UserAvatar[];
          upvoters: Kaggle.Sdk.Users.Protos.UserAvatar[];
        }

        export interface CreateAdminForumTopicGroupingRequest {
          // The name for the forum topic grouping
          name: string;
          // The forum topic IDs to initially seed the grouping with
          forumTopicIds: number[];
        }

        export interface CreateAdminForumTopicGroupingResponse {
          // The ID of the created forum topic grouping
          groupingId: number;
        }

        export interface CreateAttachmentRequest {
          // The info for the blob file being created.
          blobFileInfo: Kaggle.Sdk.Discussions.Protos.BlobFileInfo | null;
        }

        export interface CreateAttachmentResponse {
          // The info used for creating a blob.
          blobCreationInfo: Kaggle.Sdk.Discussions.Protos.BlobCreationInfo;
        }

        export interface CreateKernelMessageRequest {
          // The kernel ID to create the message on.
          kernelId: number;
          // The message content & blobs.
          message: Kaggle.Sdk.Discussions.Protos.Message | null;
        }

        export interface CreateKernelMessageResponse {
          // The created message ID.
          messageId: number;
          // The topic ID associated with the kernel messages.
          topicId: number;
        }

        export interface CreateReplyRequest {
          // The message ID of the parent message being replied to.
          messageId: number;
          // The message content & blobs.
          message: Kaggle.Sdk.Discussions.Protos.Message | null;
        }

        export interface CreateReplyResponse {
          // The created message ID.
          messageId: number;
        }

        export interface CreateTopicRequest {
          // The forum ID of the parent forum for the topic being created.
          forumId: number;
          // The name of the topic being created.
          topicName: string;
          // The message content & blobs.
          message: Kaggle.Sdk.Discussions.Protos.Message | null;
          // Optional tags to add to the forum topic
          tagIds: number[];
        }

        export interface CreateTopicResponse {
          // The created topic ID.
          topicId: number;
          // The created message ID.
          messageId: number;
        }

        export interface DeleteAdminForumTopicGroupingRequest {
          // The ID of the forum topic grouping to delete
          groupingId: number;
        }

        export interface DeleteAdminForumTopicGroupingResponse {}

        export interface DeleteAttachmentRequest {
          // The ForumMessageAttachmentFiles.Id of the file to delete.
          attachmentId: number;
        }

        export interface DeleteMessageRequest {
          messageId: number;
        }

        export interface DeleteTopicRequest {
          topicId: number;
        }

        // Used to store data about a related item which we'll want to link to.
        // Eg a message's topic, or a message's script.
        export interface DiscussionItemLink {
          id: number;
          name?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
        }

        // This is serialized/deserialized to the database using JsonConvert. Ensure
        // backward compatibility with existing data when adding/removing/changing fields.
        export interface FeedbackTrackingData {
          buganizerId?: /* google.protobuf.Int32Value */ number | null;
          followUpStatus: Kaggle.Sdk.Discussions.Protos.FollowUpStatus;
        }

        export interface Forum {
          allowAttachments: boolean;
          currentUserCanDownvote: boolean;
          currentUserTier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          id?: /* google.protobuf.Int32Value */ number | null;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          isPrivate: boolean;
          lastPostDate: /* google.protobuf.Timestamp */ string | null;
          lastPostUrl?: /* google.protobuf.StringValue */ string | null;
          name?: /* google.protobuf.StringValue */ string | null;
          subscriptionState: Kaggle.Sdk.Notifications.Protos.SubscribeState;
          subtitle?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          hasUnreadTopics: boolean;
          recentAuthors: Kaggle.Sdk.Users.Protos.UserAvatar[];
        }

        export interface ForumMessage {
          id: number;
          postDate: /* google.protobuf.Timestamp */ string | null;
          postUserId?: /* google.protobuf.Int32Value */ number | null;
          postUserThumbnailName?: /* google.protobuf.StringValue */
            | string
            | null;
          postUsername?: /* google.protobuf.StringValue */ string | null;
          postUserDisplayName?: /* google.protobuf.StringValue */ string | null;
          topicName?: /* google.protobuf.StringValue */ string | null;
          topicUrl: string;
          scriptId?: /* google.protobuf.Int32Value */ number | null;
          forumName?: /* google.protobuf.StringValue */ string | null;
          message?: /* google.protobuf.StringValue */ string | null;
          messageUrl: string;
          medal: Kaggle.Sdk.Users.Protos.Medal;
          score: number;
          isFirstMessageInTopic: boolean;
          isSpam: boolean;
          isDeleted: boolean;
          isPinned: boolean;
          topicId: number;
          forumId: number;
        }

        export interface ForumTopic {
          allowAttachments: boolean;
          authorId?: /* google.protobuf.Int32Value */ number | null;
          authorThumbnailName?: /* google.protobuf.StringValue */ string | null;
          authorUserDisplayName?: /* google.protobuf.StringValue */
            | string
            | null;
          authorUserName?: /* google.protobuf.StringValue */ string | null;
          canDelete: boolean;
          comments: Kaggle.Sdk.Discussions.Protos.CommentForumMessage[];
          commentSort: Kaggle.Sdk.Discussions.Protos.CommentListSortBy;
          firstMessage: Kaggle.Sdk.Discussions.Protos.CommentForumMessage | null;
          firstMessageId?: /* google.protobuf.Int32Value */ number | null;
          forumId: number;
          forumName: string;
          id: number;
          isAdminStarred: boolean;
          isDeleted: boolean;
          isDeletedLegacy: boolean;
          isFollowed: boolean;
          isLocked: boolean;
          isSpammed: boolean;
          isStickied: boolean;
          name: string;
          parentName?: /* google.protobuf.StringValue */ string | null;
          parentUrl?: /* google.protobuf.StringValue */ string | null;
          postDate: /* google.protobuf.Timestamp */ string | null;
          tags: Kaggle.Sdk.Tags.Protos.Tag[];
          totalVotes: number;
          url: string;
          isBookmarked: boolean;
        }

        export interface ForumTopicGrouping {
          groupingId: number;
          name: string;
        }

        export interface GetAdminForumTopicGroupingsForCurrentUserRequest {}

        export interface GetAdminForumTopicGroupingsForCurrentUserResponse {
          // The forum topic groupings owned by the current user
          forumTopicGroupings: Kaggle.Sdk.Discussions.Protos.ForumTopicGrouping[];
        }

        export interface GetForumMessagesInTopicRequest {
          topicId: number;
          page?: /* google.protobuf.Int32Value */ number | null;
          pageSize?: /* google.protobuf.Int32Value */ number | null;
          newUserSort: Kaggle.Sdk.Discussions.Protos.CommentListSortBy;
          filter: Kaggle.Sdk.Discussions.Protos.CommentListFilter;
          includeFirstForumMessage: boolean;
        }

        export interface GetForumMessagesInTopicResponse {
          comments: Kaggle.Sdk.Discussions.Protos.CommentForumMessage[];
          commentSort: Kaggle.Sdk.Discussions.Protos.CommentListSortBy;
        }

        export interface GetForumRequest {
          forumId?: /* google.protobuf.Int32Value */ number | null;
          forumSlug?: /* google.protobuf.StringValue */ string | null;
          readMask?: google.protobuf.FieldMask | null;
        }

        export interface GetForumResponse {
          forum: Kaggle.Sdk.Discussions.Protos.Forum | null;
          topicSort: Kaggle.Sdk.Discussions.Protos.TopicListSortBy;
        }

        export interface GetForumTopicByIdRequest {
          forumTopicId: number;
          includeComments: boolean;
          readMask: google.protobuf.FieldMask | null;
        }

        export interface GetForumTopicByIdResponse {
          forumTopic: Kaggle.Sdk.Discussions.Protos.ForumTopic | null;
        }

        export interface GetSiteForumsRequest {}

        export interface GetSiteForumsResponse {
          forums: Kaggle.Sdk.Discussions.Protos.Forum[];
        }

        export interface GetTopicListByCategoryIdRequest {
          category: Kaggle.Sdk.Discussions.Protos.TopicListCategory;
          customGroupingIds: number[];
          listingCategoryId?: /* google.protobuf.Int32Value */ number | null;
          group: Kaggle.Sdk.Discussions.Protos.TopicListGroup;
          page: number;
          searchQuery?: /* google.protobuf.StringValue */ string | null;
          sortBy: Kaggle.Sdk.Discussions.Protos.TopicListSortBy;
          recency: Kaggle.Sdk.Discussions.Protos.TopicListRecency;
          myActivity: Kaggle.Sdk.Discussions.Protos.TopicListMyActivity;
          author: Kaggle.Sdk.Discussions.Protos.TopicListAuthor;
          filterCategoryIds: number[];
          tagCommunityFilter: Kaggle.Sdk.Discussions.Protos.TagCommunityFilter;
        }

        export interface GetTopicListByForumIdRequest {
          category: Kaggle.Sdk.Discussions.Protos.TopicListCategory;
          customGroupingIds: number[];
          forumId?: /* google.protobuf.Int32Value */ number | null;
          group: Kaggle.Sdk.Discussions.Protos.TopicListGroup;
          page: number;
          searchQuery?: /* google.protobuf.StringValue */ string | null;
          sortBy: Kaggle.Sdk.Discussions.Protos.TopicListSortBy;
          recency: Kaggle.Sdk.Discussions.Protos.TopicListRecency;
          myActivity: Kaggle.Sdk.Discussions.Protos.TopicListMyActivity;
          author: Kaggle.Sdk.Discussions.Protos.TopicListAuthor;
          filterCategoryIds: number[];
        }

        export interface GetTopicListResponse {
          topics: Kaggle.Sdk.Discussions.Protos.TopicListItem[];
          count: number;
        }

        export interface Message {
          // The markdown of the message.
          markdown: string;
          // The HTML of the message.
          html: string;
          // The blob file tokens of the files attached to the message.
          blobFileTokens: string[];
        }

        export interface PinForumMessageRequest {
          forumMessageId: number;
        }

        export interface RemoveFromAdminForumTopicGroupingRequest {
          // The ID of the forum topic grouping to remove from
          groupingId: number;
          // The IDs of the forum topics to remove
          forumTopicIds: number[];
        }

        export interface RemoveFromAdminForumTopicGroupingResponse {}

        export interface ToggleFlagMessageRequest {
          messageId?: /* google.protobuf.Int32Value */ number | null;
          explanation?: /* google.protobuf.StringValue */ string | null;
          reasonType: Kaggle.Sdk.Discussions.Protos.FlagReason;
          scriptVersionId?: /* google.protobuf.Int32Value */ number | null;
          datasetVersionId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface ToggleSpamMessageRequest {
          messageId: number;
        }

        export interface ToggleSpamMessageResponse {
          messageUrl: string;
        }

        export interface TopicListItem {
          authorUser: Kaggle.Sdk.Users.Protos.UserAvatar | null;
          authorType: Kaggle.Sdk.Discussions.Protos.CommentAuthorType;
          commentCount: number;
          currentUserVote: number;
          canUpvote: boolean;
          canDownvote: boolean;
          firstForumMessageId: number;
          hasAdminResponse: boolean;
          id: number;
          isAdminStarred: boolean;
          isSticky: boolean;
          lastCommenterType: Kaggle.Sdk.Discussions.Protos.CommentAuthorType;
          lastCommenterName: string;
          lastCommenterUrl: string;
          lastCommentPostDate: /* google.protobuf.Timestamp */ string | null;
          lastViewDate: /* google.protobuf.Timestamp */ string | null;
          medal: Kaggle.Sdk.Users.Protos.Medal;
          parentName?: /* google.protobuf.StringValue */ string | null;
          parentUrl?: /* google.protobuf.StringValue */ string | null;
          postDate: /* google.protobuf.Timestamp */ string | null;
          tags: Kaggle.Sdk.Tags.Protos.Tag[];
          title: string;
          topicUrl: string;
          voteResumeUrl: string;
          votes: number;
          isBookmarked: boolean;
          oldestUnreadCommentUrl?: /* google.protobuf.StringValue */
            | string
            | null;
        }

        export interface UnsubscribeWatchesRequest {
          userId: number;
        }

        export interface UpdateFeedbackTrackingDataRequest {
          messageId: number;
          feedbackTrackingData: Kaggle.Sdk.Discussions.Protos.FeedbackTrackingData | null;
        }

        export interface UpdateForumSettingsRequest {
          forumId: number;
          settingToToggle: Kaggle.Sdk.Discussions.Protos.ForumSettings;
        }

        export interface UpdateForumTopicSettingsRequest {
          forumTopicId: number;
          //  Indicates which field should be toggled
          settingToToggle: Kaggle.Sdk.Discussions.Protos.ForumTopicSettings;
        }

        export interface UpdateManyFeedbackTrackingDataRequest {
          messageIds: number[];
          feedbackTrackingData: Kaggle.Sdk.Discussions.Protos.FeedbackTrackingData | null;
        }

        export interface UpdateMessageRequest {
          // The message ID of the message being updated.
          messageId: number;
          // The message content & blobs.
          message: Kaggle.Sdk.Discussions.Protos.Message | null;
        }

        export interface UpdateMessageResponse {}

        export interface UpdateTopicRequest {
          // The topic ID of the topic being updated.
          topicId: number;
          // The updated name of the topic.
          topicName: string;
          // The message content & blobs.
          message: Kaggle.Sdk.Discussions.Protos.Message | null;
          // Optional tags to add to the forum topic
          tagIds: number[];
        }

        export interface UpdateTopicResponse {}

        export interface VoteOnForumMessageRequest {
          forumMessageId: number;
          score: number;
        }

        export interface VoteOnForumMessageResponse {}

        export enum CommentAuthorType {
          ADMIN = "admin", // = 0
          HOST = "host", // = 1
          DATASET_CREATOR = "datasetCreator", // = 2
          TOPIC = "topic", // = 3
          COMMENT = "comment", // = 4
        }
        export enum CommentListFilter {
          ALL = "all", // = 0
          KERNEL_VERSION = "kernelVersion", // = 1
        }
        export enum CommentListSortBy {
          UNSPECIFIED = "unspecified", // = 0
          HOT = "hot", // = 1
          NEW = "new", // = 2
          OLD = "old", // = 3
          TOP = "top", // = 4
          CHRONOLOGICAL = "chronological", // = 5
        }
        export enum FlagReason {
          UNSPECIFIED = "unspecified", // = 0
          OTHER = "other", // = 1
          SPAM = "spam", // = 2
          PLAGIARISM = "plagiarism", // = 3
          VOTE_MANIPULATION = "voteManipulation", // = 4
          ABUSIVE = "abusive", // = 5
          PRIVACY_VIOLATION = "privacyViolation", // = 6
          COPYRIGHT_VIOLATION = "copyrightViolation", // = 7
          UPVOTE_BEGGING = "upvoteBegging", // = 8
        }
        export enum FollowUpStatus {
          NONE = "none", // = 0
          IN_PROGRESS = "inProgress", // = 1
          DONE = "done", // = 2
        }
        export enum ForumSettings {
          IS_READ_ONLY = "isReadOnly", // = 0
        }
        export enum ForumTopicSettings {
          IS_READ_ONLY = "isReadOnly", // = 0
          IS_STICKY = "isSticky", // = 1
        }
        export enum TagCommunityFilter {
          ALL = "all", // = 0
          TAG_TOPICS_ONLY = "tagTopicsOnly", // = 1
        }
        export enum TopicListAuthor {
          UNSPECIFIED = "unspecified", // = 0
          ADMIN = "admin", // = 1
        }
        export enum TopicListCategory {
          UNSPECIFIED = "unspecified", // = 0
          ALL = "all", // = 1
          FORUMS = "forums", // = 2
          COMPETITIONS = "competitions", // = 3
          DATASETS = "datasets", // = 4
        }
        export enum TopicListGroup {
          UNSPECIFIED = "unspecified", // = 0
          ALL = "all", // = 1
          OWNED = "owned", // = 2
          UPVOTED = "upvoted", // = 3
          STARRED = "starred", // = 4
          CUSTOM = "custom", // = 5
          BOOKMARKED = "bookmarked", // = 6
          MY_ACTIVITY = "myActivity", // = 7
        }
        export enum TopicListMyActivity {
          UNSPECIFIED = "unspecified", // = 0
          PUBLISHED = "published", // = 1
          COMMENTED = "commented", // = 2
          VIEWED = "viewed", // = 3
        }
        export enum TopicListRecency {
          UNSPECIFIED = "unspecified", // = 0
          LAST_30_DAYS = "last30Days", // = 1
          LAST_7_DAYS = "last7Days", // = 2
          TODAY = "today", // = 3
        }
        export enum TopicListSortBy {
          UNSPECIFIED = "unspecified", // = 0
          HOT = "hot", // = 1
          TOP = "top", // = 2
          NEW = "new", // = 3
          RECENT = "recent", // = 4
          ACTIVE = "active", // = 5
          RELEVANCE = "relevance", // = 6
        }
      }

      export interface DiscussionsClient {}
    }

    export namespace Education {
      export namespace Models {
        export interface Certificate {
          authorUsername: string | null;
          completionDate: /*DateTime*/ string;
          courseName: string | null;
          fullUsername: string | null;
          gcsAccessImageUrl: string | null;
          isViewingOwnCertificate: boolean;
          trackId: /*Int32*/ number;
          trackUrl: string | null;
          showOldCertificate: boolean;
        }

        export interface LearnExercise {
          id: /*Int32*/ number;
          scriptId: /*Int32*/ number;
          name: string | null;
          url: string | null;
          authorUsername: string | null;
          scriptSlug: string | null;
          progress: (/*Double*/ number) | null;
        }

        export interface LearnExerciseVersion {
          kernelVersionId: /*Int32*/ number;
          questionCount: /*Int32*/ number;
        }

        export interface LearnHome {
          tracks: (Kaggle.Sdk.Education.Protos.LearnTrack)[];
          recentlyProgressedTracks: (Kaggle.Sdk.Education.Protos.LearnTrack)[];
        }

        export interface LearnLesson {
          id: /*Int32*/ number;
          description: string | null;
          learnTutorial: Kaggle.Sdk.Education.Models.LearnTutorial | null;
          learnExercise: Kaggle.Sdk.Education.Models.LearnExercise | null;
          isExtraCredit: boolean;
        }

        export interface LearnNudge {
          courseIndex: /*Int32*/ number;
          courseName: string | null;
          courseSlug: string | null;
          nextItemName: string | null;
          nextItemUrl: string | null;
          nextItemType:
            | "courseCompleteNoBonusLessons"
            | "courseCompleteWithBonusLessons"
            | "courseIncomplete"
            | "doExercise"
            | "doTutorial";
        }

        export interface LearnTutorial {
          id: /*Int32*/ number;
          scriptId: /*Int32*/ number;
          name: string | null;
          url: string | null;
          authorDisplayName: string | null;
          authorUsername: string | null;
          scriptSlug: string | null;
          thumbnailImageUrl: string | null;
          creationDate: (/*DateTime*/ string) | null;
          progress: (/*Double*/ number) | null;
        }

        export interface LessonInfo {
          tracks: (Kaggle.Sdk.Education.Protos.LearnTrack)[];
        }
      }

      export namespace Protos {
        export interface AddLessonsToTrackRequest {
          trackId: number;
          lessonIds: number[];
        }

        export interface Certificate {
          // This is deprecated. Use author_usernames instead.
          authorUsername: string;
          completionDate: /* google.protobuf.Timestamp */ string | null;
          courseName: string;
          fullUsername: string;
          gcsAccessImageUrl: string;
          isViewingOwnCertificate: boolean;
          trackId: number;
          trackUrl: string;
          // Globally disabled on 2020-07-08.  Remove in a few months when all
          // clients are updated.
          showOldCertificate: boolean;
          authorUsernames: string[];
        }

        export interface EditLessonRequest {
          lessonId: number;
          description?: /* google.protobuf.StringValue */ string | null;
          exerciseKernelId?: /* google.protobuf.Int32Value */ number | null;
          exerciseKernelVersionId?: /* google.protobuf.Int32Value */
            | number
            | null;
          questionCount?: /* google.protobuf.Int32Value */ number | null;
          tutorialKernelId?: /* google.protobuf.Int32Value */ number | null;
          isExtraCredit?: /* google.protobuf.BoolValue */ boolean | null;
        }

        export interface GetCertificateUploadUrlRequest {
          contentLength: number;
          trackId: number;
        }

        export interface GetCertificateUploadUrlResponse {
          uploadUrl: string;
        }

        export interface GetExerciseVersionsRequest {
          exerciseId: number;
        }

        export interface GetExerciseVersionsResponse {
          exerciseVersions: Kaggle.Sdk.Education.Protos.LearnExerciseVersion[];
        }

        export interface GetTrackRequest {
          trackSlug: string;
        }

        export interface GetTracksRequest {}

        export interface GetTracksResponse {
          tracks: Kaggle.Sdk.Education.Protos.LearnTrack[];
        }

        export interface LearnExercise {
          id: number;
          scriptId: number;
          name: string;
          url: string;
          authorUsername: string;
          scriptSlug: string;
          progress?: /* google.protobuf.DoubleValue */ number | null;
        }

        export interface LearnExerciseVersion {
          kernelVersionId: number;
          questionCount: number;
        }

        export interface LearnLesson {
          id: number;
          description: string;
          learnTutorial: Kaggle.Sdk.Education.Protos.LearnTutorial | null;
          learnExercise: Kaggle.Sdk.Education.Protos.LearnExercise | null;
          isExtraCredit: boolean;
        }

        export interface LearnNudge {
          courseIndex: number;
          courseName: string;
          courseSlug: string;
          nextItemName: string;
          nextItemUrl: string;
          nextItemType: Kaggle.Sdk.Education.Protos.LearnNudgeType;
        }

        export interface LearnSeriesNavigationData {
          learnCourse: Kaggle.Sdk.Education.Protos.LearnTrack | null;
          learnNudge: Kaggle.Sdk.Education.Protos.LearnNudge | null;
        }

        export interface LearnTrack {
          id: number;
          trackIndex: number;
          name: string;
          description: string;
          hasDailyDelivery: boolean;
          visible: boolean;
          trackSlug: string;
          thumbnailImageUrl: string;
          estimatedTimeHours: number;
          userProgress: number;
          certificateUrl: string;
          lessons: Kaggle.Sdk.Education.Protos.LearnLesson[];
          prerequisites: Kaggle.Sdk.Education.Protos.LearnTrack[];
          dependencyFor: Kaggle.Sdk.Education.Protos.LearnTrack[];
          authors: Kaggle.Sdk.Users.Protos.User[];
          tags: Kaggle.Sdk.Tags.Protos.Tag[];
        }

        export interface LearnTutorial {
          id: number;
          scriptId: number;
          name: string;
          url: string;
          authorDisplayName: string;
          authorUsername: string;
          scriptSlug: string;
          thumbnailImageUrl: string;
          creationDate: /* google.protobuf.Timestamp */ string | null;
          progress?: /* google.protobuf.DoubleValue */ number | null;
        }

        export interface ReorderTracksRequest {
          trackIds: number[];
        }

        export interface ReorderTracksResponse {
          tracks: Kaggle.Sdk.Education.Protos.LearnTrack[];
        }

        export interface RescoreExerciseVersionRequest {
          scriptVersionId: number;
        }

        export interface RescoreResponse {
          affectedUsers: number;
        }

        export interface TrackEducationRequest {
          type: Kaggle.Sdk.Education.Protos.LearnTrackerStatus;
          id: string;
        }

        export interface TrackExerciseInteractionRequest {
          exceptionClass: string;
          failureMessage: string;
          interactionType: Kaggle.Sdk.Education.Protos.LearnExerciseInteractionType;
          learnToolsVersion: string;
          forkParentScriptVersionId: number;
          outcomeType: Kaggle.Sdk.Education.Protos.LearnExerciseOutcomeType;
          questionId: string;
          questionType: Kaggle.Sdk.Education.Protos.LearnExerciseQuestionType;
          trace: string;
          valueTowardsCompletion?: /* google.protobuf.DoubleValue */
            | number
            | null;
        }

        export interface TrackExerciseInteractionResponse {
          nudge: Kaggle.Sdk.Education.Protos.LearnNudge | null;
          showLoginPrompt: boolean;
        }

        export enum LearnExerciseInteractionType {
          UNSPECIFIED = "unspecified", // = 0
          CHECK = "check", // = 1
          HINT = "hint", // = 2
          SOLUTION = "solution", // = 3
        }
        export enum LearnExerciseOutcomeType {
          UNSPECIFIED = "unspecified", // = 0
          PASS = "pass", // = 1
          FAIL = "fail", // = 2
          EXCEPTION = "exception", // = 3
          UNATTEMPTED = "unattempted", // = 4
        }
        export enum LearnExerciseQuestionType {
          UNSPECIFIED = "unspecified", // = 0
          EQUALITY_CHECK_PROBLEM = "equalityCheckProblem", // = 1
          CODING_PROBLEM = "codingProblem", // = 2
          FUNCTION_PROBLEM = "functionProblem", // = 3
          THOUGHT_EXPERIMENT = "thoughtExperiment", // = 4
        }
        export enum LearnNudgeType {
          COURSE_COMPLETE_NO_BONUS_LESSONS = "courseCompleteNoBonusLessons", // = 0
          COURSE_COMPLETE_WITH_BONUS_LESSONS = "courseCompleteWithBonusLessons", // = 1
          COURSE_INCOMPLETE = "courseIncomplete", // = 2
          DO_EXERCISE = "doExercise", // = 3
          DO_TUTORIAL = "doTutorial", // = 4
        }
        export enum LearnTrackerStatus {
          UNSPECIFIED = "unspecified", // = 0
          TRACK_VIEW = "trackView", // = 1
          KERNEL_VIEW = "kernelView", // = 2
          PAGE_VIEW = "pageView", // = 3
          EXERCISE_FORK = "exerciseFork", // = 4
        }
      }

      export interface EducationClient {}
    }

    export namespace Emails {
      export namespace Models {
        export interface KaggleEmail {
          to: string | null;
          toUser: Kaggle.Sdk.Users.Models.User | null;
          dateCreated: /*DateTime*/ string;
          from: string | null;
          replyTo: string | null;
          cC: string | null;
          bcc: string | null;
          subject: string | null;
        }
      }

      export namespace Protos {
        export interface SendEmailResponse {
          wasSent: boolean;
        }

        export interface SendPrivateDatasetSummaryEmailRequest {
          userId: number;
          startDate: /* google.protobuf.Timestamp */ string | null;
          endDate: /* google.protobuf.Timestamp */ string | null;
        }
      }

      export interface EmailClient {}
    }

    export namespace Kernels {
      export namespace Events {
        export interface KernelRunEnded {
          kernelRunId: /*Int32*/ number;
          runInfo: Kaggle.Sdk.Kernels.Models.KernelRunInfo | null;
        }

        export interface KernelRunStarted {
          kernelRunId: /*Int32*/ number;
        }
      }

      export namespace Models {
        export interface AcceleratorQuotaStatistics {
          hasEverRun: boolean;
          minimumTimeAllowed: /*TimeSpan*/ string;
          timeReserved: /*TimeSpan*/ string;
          timeUsed: /*TimeSpan*/ string;
          totalTimeAllowed: /*TimeSpan*/ string;
        }

        export interface AgentEntry {
          submissionId: /*Int32*/ number;
          teamName: string | null;
        }

        export interface BatchAutoTagKernelsResponse {
          endingKernelId: /*Int32*/ number;
          taggedKernelCount: /*Int32*/ number;
        }

        export interface BatchMessageState {
          lastStatusPosition: /*Double*/ number;
          lastStdoutPosition: /*Double*/ number;
          lastStderrPosition: /*Double*/ number;
        }

        export interface CancelKernelRunResponse {}

        export interface ChangeAnonymousKernelOwnerResponse {
          newOwnerName: string | null;
          newSlug: string | null;
        }

        export interface CheckKernelsAccessResponse {
          authorizations: (Kaggle.Sdk.Kernels.Models.KernelAuthorization)[];
        }

        export interface CheckTitleResponse {
          isValid: boolean;
          errorMessage: string | null;
        }

        export interface CommitAndRunResponse {
          message: string | null;
          newUrl: string | null;
          submitRedirectUrl: string | null;
          sequence: (/*Int32*/ number) | null;
          parentKernelVersionId: (/*Int32*/ number) | null;
          diff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
          kernelId: /*Int32*/ number;
          kernelVersionId: /*Int32*/ number;
          kernelRunId: /*Int32*/ number;
          versionNumber: (/*Int32*/ number) | null;
          status:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running";
          blobUploadUrl: string | null;
        }

        export interface CompleteQuickSessionResponse {
          errorMessage: string | null;
        }

        export interface ComputeConstraintState {
          sessionTimeoutSeconds: (/*Int32*/ number) | null;
          maxCpuCores: (/*Int32*/ number) | null;
          maxStorageBytes: (/*Int64*/ number) | null;
          maxMemoryBytes: (/*Int64*/ number) | null;
          disallowInternet: boolean | null;
        }

        export interface ComputeInternetState {
          isEnabled: boolean;
        }

        export interface ComputeKernelDiffResponse {
          diff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
          leftContent: string | null;
          rightContent: string | null;
        }

        export interface ComputeState {
          accelerator: "gpu" | "none" | "tpu_v2_256" | "tpu_v2_32" | "tpu_v3_8";
          internet: Kaggle.Sdk.Kernels.Models.ComputeInternetState | null;
          constraints: Kaggle.Sdk.Kernels.Models.ComputeConstraintState | null;
        }

        export interface CreateKernelResponse {
          id: /*Int32*/ number;
          currentUrlSlug: string | null;
          kernelVersionId: /*Int32*/ number;
        }

        export interface CreateKernelRunResponse {
          id: /*Int32*/ number;
          resources: Kaggle.Sdk.Kernels.Models.KernelRunResources | null;
          error: string | null;
          useNewKernelsBackend: boolean;
          showParentForkSecretWarning: boolean;
        }

        export interface CreateKernelUpvoteResponse {
          voteId: /*Int32*/ number;
          isSelfVote: boolean;
        }

        export interface CreateKernelWithSettingsResponse {
          id: /*Int32*/ number;
          currentUrlSlug: string | null;
        }

        export interface CreateOrphanedCleanupTaskResponse {}

        export interface CreateSnippetResponse {
          id: /*Int32*/ number;
        }

        export interface CreateWorkerCommandResponse {
          message: string | null;
        }

        export interface DataSource
          extends Kaggle.Sdk.Kernels.Models.DataSourceReference {
          name: string | null;
          dataSourceUrl: string | null;
          thumbnailUrl: string | null;
          isPrivate: boolean;
        }

        export interface DataSourceReference {
          sourceType: "competition" | "datasetVersion" | "kernelVersion";
          sourceId: /*Int32*/ number;
          datasetId: (/*Int32*/ number) | null;
          databundleVersionId: (/*Int32*/ number) | null;
          mountSlug: string | null;
        }

        export interface DataSourceVersion {
          id: (/*Int32*/ number) | null;
          number: (/*Int32*/ number) | null;
          slug: string | null;
        }

        export interface DefaultSessionSettings {
          saveQuickVersionOutputFiles: boolean | null;
          batchSessionDefaultAccelerator:
            | "gpu"
            | "none"
            | "tpu_v2_256"
            | "tpu_v2_32"
            | "tpu_v3_8"
            | null;
          defaultUserPlan: "free" | "kagglePro" | null;
        }

        export interface DeleteKernelResponse {}

        export interface DeleteKernelUpvoteResponse {}

        export interface DeleteSnippetResponse {}

        export interface DockerImage {
          name: string | null;
          repoUrl: string | null;
          dockerfileUrl: string | null;
        }

        export interface DockerImageVersionDetails {
          id: (/*Int32*/ number) | null;
          type: "competition" | "latest" | "original";
          disabledReason: "tpuRestriction" | null;
          dateCreated: (/*DateTime*/ string) | null;
        }

        export interface DockerImageVersionDetailsList {
          images: (Kaggle.Sdk.Kernels.Models.DockerImageVersionDetails)[];
          selectedVersionType: "competition" | "latest" | "original";
          selectedVersionId: (/*Int32*/ number) | null;
        }

        export interface ExportKernelRunForCaipResponse {
          signedUrl: string | null;
          warnings: (string)[];
        }

        export interface FetchExternalKernelContentResponse {
          /*[NotNull]*/
          externalContent: string;
        }

        export interface FetchGitHubContentResponse {
          /*[NotNull]*/
          content: string;
        }

        export interface ForkKernelSessionResponse {
          redirectUrl: string | null;
        }

        export interface ForkOrGetExistingKernelResponse {
          redirectUrl: string | null;
        }

        export interface ForkParentInfo {
          isDeleted: boolean;
          isVisible: boolean;
          authorDisplayName: string | null;
          kernelId: /*Int32*/ number;
          kernelUrl: string | null;
        }

        export interface GetAcceleratorQuotaStatisticsResponse {
          quotaRefreshTime: /*DateTime*/ string;
          kernelsMaxSizeInMb: /*Int32*/ number;
          tpuQuota: Kaggle.Sdk.Kernels.Models.AcceleratorQuotaStatistics | null;
          gpuQuota: Kaggle.Sdk.Kernels.Models.AcceleratorQuotaStatistics | null;
        }

        export interface GetDeletedKernelResponse {
          defaultDatasourceImageUrl: string | null;
          defaultUserImageUrl: string | null;
          deletedKernelUrl: string | null;
          topicId: (/*Int32*/ number) | null;
          commentCount: /*Int32*/ number;
          userCanDownvoteComments: boolean;
        }

        export interface GetFirebaseAuthTokenResponse {
          authToken: string | null;
        }

        export interface GetFirebaseConfigResponse {
          apiKey: string | null;
          authDomain: string | null;
          databaseUrl: string | null;
          projectId: string | null;
          storageBucket: string | null;
          messagingSenderId: string | null;
          appId: string | null;
          proxyDomain: string | null;
        }

        export interface GetKernelBlobSourceResponse {
          source: string | null;
        }

        /*[NotNull]*/
        export interface GetKernelCollaboratorListResponse {
          collaboratorList: Kaggle.Sdk.Users.Models.CollaboratorList;
          errorMessage: string;
        }

        export interface GetKernelLandingPageResponse {
          shelves: (Kaggle.Sdk.Kernels.Models.KernelShelf)[];
          totalPublicKernels: /*Int32*/ number;
        }

        export interface GetKernelRunLogResponse {
          log: string | null;
        }

        export interface GetKernelRunSourceForCaipResponse {
          source: string | null;
          warnings: (string)[];
        }

        export interface GetKernelRunSourceResponse {
          source: (/*Stream*/ unknown) | null;
          stringSource: string | null;
        }

        export interface GetKernelSessionDataSourcesResponse {
          dataSources: (Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DataSource)[];
        }

        export interface GetKernelStatusResponse {
          status:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running";
        }

        export interface GetKernelSummaryForDatasetsResponse {
          goodPublicKernelCountsByDataset: /*Int32*/ number;
          goodPublicKernelUniqueAuthorCountsByDataset: /*Int32*/ number;
          publicKernelCountsByDataset: /*Int32*/ number;
          publicKernelUniqueAuthorCountsByDataset: /*Int32*/ number;
          allKernelCountsByDataset: /*Int32*/ number;
          allUniqueAuthorCountsByDataset: /*Int32*/ number;
        }

        export interface GetKernelViewerSessionIdResponse {
          currentSlug: string | null;
          notFound: boolean;
          redirectUrl: string | null;
          sessionId: (/*Int32*/ number) | null;
        }

        export interface GetKernelViewModelResponse {
          redirectUrl: string | null;
          /*[NotNull]*/
          kernel: Kaggle.Sdk.Kernels.Models.Kernel;
          kernelBlob: Kaggle.Sdk.Kernels.Models.KernelBlob | null;
          /*[NotNull]*/
          kernelRun: Kaggle.Sdk.Kernels.Models.KernelRun;
          author: Kaggle.Sdk.Users.Models.User | null;
          baseUrl: string | null;
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
          initialTab: string | null;
          log: string | null;
          outputFiles: (Kaggle.Sdk.Kernels.Models.KernelSessionOutputFile)[];
          ouputFilesOwnerInfo: Kaggle.Sdk.Datasets.Models.DatabundleOwnerInfo | null;
          pageMessages: (Kaggle.Sdk.Common.Models.PageMessage)[];
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          renderableDataSources: (Kaggle.Sdk.Kernels.Models.DataSource)[];
          versions: (Kaggle.Sdk.Kernels.Models.KernelVersionHistory)[];
          categories: Kaggle.Sdk.Tags.Models.TagList | null;
          downloadAllFilesUrl: string | null;
          submission: Kaggle.Sdk.Kernels.Models.KernelSubmission | null;
          menuLinks: (Kaggle.Sdk.Kernels.Models.LinkModel)[];
          rightMenuLinks: (Kaggle.Sdk.Kernels.Models.LinkModel)[];
          callToAction: Kaggle.Sdk.Kernels.Models.LinkModel | null;
          voteButton: Kaggle.Sdk.Common.Protos.VoteButton | null;
          parentName: string | null;
          parentUrl: string | null;
          thumbnailImageUrl: string | null;
          canWrite: boolean;
          canAdminister: boolean;
          currentUserForkParentSessionId: (/*Int32*/ number) | null;
          currentUserHasForked: boolean;
          forkParentIsRedacted: boolean;
          forkDiffLinesChanged: /*Int32*/ number;
          forkDiffLinesDeleted: /*Int32*/ number;
          forkDiffLinesInserted: /*Int32*/ number;
          forkDiffUrl: string | null;
          forkParentAuthorDisplayName: string | null;
          forkParentAuthorUrl: string | null;
          forkParentTitle: string | null;
          forkParentUrl: string | null;
          simplifiedViewer: boolean;
          kernelOutputDataset: Kaggle.Sdk.Datasets.Models.KernelOutputDatasetReference | null;
          disableComments: boolean;
          taskSubmissionInfo: Kaggle.Sdk.Datasets.Models.KernelTaskSubmissionInfo | null;
          learnSeriesNavigationData: Kaggle.Sdk.Education.Protos.LearnSeriesNavigationData | null;
          showSharingControls: boolean;
          showUnchangedCopyWarning: boolean;
        }

        export interface GetMostRecentForkSlugByUserResponse {
          forkParentSessionId: /*Int32*/ number;
          slug: string | null;
          userName: string | null;
        }

        export interface GetOrCreateKernelSessionResponse {
          draft: Kaggle.Sdk.Kernels.Models.KernelDraft | null;
          sessionId: (/*Int32*/ number) | null;
          sessionTimeoutSeconds: /*Int32*/ number;
          sessionCreationFailureMessage: string | null;
          unusedAcceleratorRemoved:
            | "gpu"
            | "none"
            | "tpu_v2_256"
            | "tpu_v2_32"
            | "tpu_v3_8"
            | null;
          hasMoreRecentCollaboratorVersion: boolean;
          kernelForkedFromPaidTierWarning: boolean;
          sessionStatus:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running"
            | null;
        }

        export interface GetSourceIndexDataResponse {
          referent: string | null;
          continuationToken: string | null;
          definition: Kaggle.Sdk.Kernels.Models.Reference | null;
          references: (Kaggle.Sdk.Kernels.Models.Reference)[];
        }

        export interface GetUserKernelAchievementsResponse {
          totalUpvotes: /*Int32*/ number;
          totalKernels: /*Int32*/ number;
          totalForks: /*Int32*/ number;
        }

        export interface GithubBranchInfo {
          /*[NotNull]*/
          name: string;
        }

        export interface GithubFileInfo {
          /*[NotNull]*/
          owner: string;
          /*[NotNull]*/
          repo: string;
          /*[NotNull]*/
          path: string;
          /*[NotNull]*/
          ref: string;
          /*[NotNull]*/
          rawUrl: string;
        }

        export interface GithubRepositoryInfo {
          /*[NotNull]*/
          owner: string;
          /*[NotNull]*/
          name: string;
          /*[NotNull]*/
          defaultBranch: string;
        }

        export interface HasAcceptedKernelCompetitionRulesResponse {
          competitionsRequiringAcceptance: (Kaggle.Sdk.Kernels.Models.KernelCompetition)[];
        }

        export interface IndexAllSnippetsResponse {
          numberOfSnippetsToIndex: /*Int32*/ number;
          searchIndexResult: Kaggle.Sdk.Search.Protos.IndexSnippetResponse | null;
        }

        export interface InteractiveMessageState {
          lastStatusPosition: /*Double*/ number;
          lastChangesPosition: /*Int32*/ number;
          lastHeartbeatValue: (/*Double*/ number) | null;
        }

        export interface Kernel {
          id: /*Int32*/ number;
          title: string | null;
          forkParent: Kaggle.Sdk.Kernels.Models.KernelForkInfo | null;
          currentRunId: (/*Int32*/ number) | null;
          mostRecentRunId: (/*Int32*/ number) | null;
          url: string | null;
          tags: (Kaggle.Sdk.Kernels.Models.Tag)[];
          commentCount: /*Int32*/ number;
          upvoteCount: /*Int32*/ number;
          viewCount: /*Int32*/ number;
          forkCount: /*Int32*/ number;
          bestPublicScore: (/*Double*/ number) | null;
          author: Kaggle.Sdk.Users.Models.User | null;
          isPrivate: boolean;
          updatedTime: /*DateTime*/ string;
          selfLink: string | null;
          pinnedDockerImageVersionId: (/*Int32*/ number) | null;
          dockerImagePinningType: "latest" | "original";
          originalDockerImageId: (/*Int32*/ number) | null;
          isLanguageTemplate: boolean;
          medal: "bronze" | "gold" | "silver" | "unspecified" | null;
          topicId: (/*Int32*/ number) | null;
          readGroupId: (/*Int32*/ number) | null;
          writeGroupId: (/*Int32*/ number) | null;
          slug: string | null;
          hasUsedAccelerator: boolean | null;
          pinnedSessionId: (/*Int32*/ number) | null;
          disableComments: boolean;
          hasLinkedSubmission: boolean;
          currentUserHasBookmarked: boolean;
        }

        export interface KernelAuthorization {
          kernelId: /*Int32*/ number;
          isAuthorized: boolean;
        }

        export interface KernelBlob {
          id: /*Int32*/ number;
          settings: Kaggle.Sdk.Kernels.Models.KernelBlobSettings | null;
          source: string | null;
          dateCreated: /*DateTime*/ string;
        }

        export interface KernelBlobSettings {
          dockerImageVersionId: (/*Int32*/ number) | null;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          sourceType: "notebook" | "script";
          language: "julia" | "python" | "r" | "rmarkdown" | "sqlite";
          accelerator: "gpu" | "none" | "tpu_v2_256" | "tpu_v2_32" | "tpu_v3_8";
          isInternetEnabled: boolean;
        }

        export interface KernelCategoryIdList {
          totalCount: (/*Int32*/ number) | null;
          categoryIds: (/*Int32*/ number)[];
        }

        export interface KernelCompetition {
          competitionId: /*Int32*/ number;
          /*[NotNull]*/
          title: string;
          /*[NotNull]*/
          rulesUrl: string;
        }

        export interface KernelDataSourceListItemDto {
          kernelId: /*Int32*/ number;
          sourceType: "competition" | "dataset" | "kernel";
          sourceId: /*Int32*/ number;
          description: string | null;
          siteName: string | null;
          thumbnailUrl: string | null;
          title: string | null;
          isPrivate: boolean;
        }

        export interface KernelDiff {
          linesInserted: /*Int32*/ number;
          linesDeleted: /*Int32*/ number;
          linesChanged: /*Int32*/ number;
          linesUnchanged: /*Int32*/ number;
          newTotalLines: /*Int32*/ number;
        }

        export interface KernelDraft {
          sequence: /*Int32*/ number;
          parentKernelVersionId: (/*Int32*/ number) | null;
          blob: Kaggle.Sdk.Kernels.Models.KernelBlob | null;
          hasMoreRecentCollaboratorVersion: boolean;
        }

        export interface KernelForkInfo {
          kernelId: /*Int32*/ number;
          runId: /*Int32*/ number;
          /*[NotNull]*/
          url: string;
          title: string | null;
          author: Kaggle.Sdk.Users.Models.User | null;
          diff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
          isRedacted: boolean;
          dateCreated: (/*DateTime*/ string) | null;
          workerStatus:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running";
          isolatorResults: string | null;
          languageId: (/*Int32*/ number) | null;
          versionType: "batch" | "interactive" | "quick";
          isPrivate: boolean;
          isFork: boolean;
        }

        export interface KernelList {
          totalCount: (/*Int32*/ number) | null;
          kernels: (Kaggle.Sdk.Kernels.Models.KernelListItem)[];
        }

        export interface KernelListItem {
          author: Kaggle.Sdk.Users.Models.User | null;
          currentUserHasVotedForThisScript: boolean;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSource)[];
          forkDiffLinesChanged: /*Int32*/ number;
          forkDiffLinesDeleted: /*Int32*/ number;
          forkDiffLinesInserted: /*Int32*/ number;
          forkDiffUrl: string | null;
          hasCollaborators: boolean;
          id: /*Int32*/ number;
          scriptVersionId: (/*Int32*/ number) | null;
          isFork: boolean;
          isPrivate: boolean;
          languageName: string | null;
          aceLanguageName: string | null;
          isNotebook: boolean;
          versionNumber: (/*Int32*/ number) | null;
          isGpuEnabled: boolean;
          bestPublicScore: (/*Double*/ number) | null;
          forumTopicId: (/*Int32*/ number) | null;
          lastRunTime: /*DateTime*/ string;
          lastRunExecutionTimeSeconds: (/*Int32*/ number) | null;
          medal: "bronze" | "gold" | "silver" | "unspecified" | null;
          outputTypes: (Kaggle.Sdk.Kernels.Models.KernelOutputType)[];
          categories: (Kaggle.Sdk.Common.Models.Category)[];
          scriptUrl: string | null;
          scriptCommentsUrl: string | null;
          scriptInputUrl: string | null;
          scriptEditUrl: string | null;
          title: string | null;
          totalComments: /*Int32*/ number;
          totalForks: /*Int32*/ number;
          totalScripts: /*Int32*/ number;
          totalViews: /*Int32*/ number;
          totalVotes: /*Int32*/ number;
          totalLines: /*Int32*/ number;
          currentUserHasBookmarked: boolean;
          isRunning: boolean;
          isDeleted: boolean;
          isMyUncommittedDraft: boolean;
          currentUrlSlug: string | null;
          scriptVersionDateCreated: (/*DateTime*/ string) | null;
          dateEvaluated: (/*DateTime*/ string) | null;
          outputFiles: (Kaggle.Sdk.Kernels.Models.KernelSessionOutputFile)[];
          canCurrentUserDeleteKernel: boolean;
          canCurrentUserEditKernel: boolean;
          hasLinkedSubmission: boolean;
          disableComments: boolean;
          taskSubmissionInfo: Kaggle.Sdk.Datasets.Models.KernelTaskSubmissionInfo | null;
          forkParentInfo: Kaggle.Sdk.Kernels.Models.ForkParentInfo | null;
        }

        export interface KernelOutputType {
          count: /*Int32*/ number;
          extension: string | null;
        }

        export interface KernelRun {
          id: /*Int32*/ number;
          kernelId: /*Int32*/ number;
          status:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running";
          kernelVersionType: "batch" | "interactive" | "quick";
          sourceType: "notebook" | "script";
          language: "julia" | "python" | "r" | "rmarkdown" | "sqlite";
          title: string | null;
          dateCreated: (/*DateTime*/ string) | null;
          dateEvaluated: (/*DateTime*/ string) | null;
          dateCancelled: (/*DateTime*/ string) | null;
          workerContainerPort: (/*Int32*/ number) | null;
          workerUptimeSeconds: (/*Int32*/ number) | null;
          workerIPAddress: string | null;
          workerIPAddressExternal: string | null;
          scriptLanguageId: /*Int32*/ number;
          scriptLanguageName: string | null;
          renderedOutputUrl: string | null;
          commit: Kaggle.Sdk.Kernels.Models.KernelBlob | null;
          resources: Kaggle.Sdk.Kernels.Models.KernelRunResources | null;
          isolatorResults: string | null;
          runInfo: Kaggle.Sdk.Kernels.Models.KernelRunInfo | null;
          dockerImageVersionId: (/*Int32*/ number) | null;
          usedCustomDockerImage: boolean;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          useNewKernelsBackend: boolean | null;
          isGpuEnabled: boolean;
          isTpuEnabled: boolean;
          acceleratorType:
            | "gpu"
            | "none"
            | "tpu_v2_256"
            | "tpu_v2_32"
            | "tpu_v3_8";
          isInternetEnabled: boolean;
          userPlan: "free" | "kagglePro";
        }

        export interface KernelRunInfo {
          dockerfileUrl: string | null;
          dockerHubUrl: string | null;
          dockerImageDigest: string | null;
          dockerImageId: string | null;
          dockerImageName: string | null;
          diskKbFree: /*Int32*/ number;
          failureMessage: string | null;
          exitCode: /*Int32*/ number;
          queuedSeconds: /*Int32*/ number;
          outputSizeBytes: /*Int64*/ number;
          runTimeSeconds: /*Decimal*/ number;
          usedAllSpace: boolean;
          timeoutExceeded: boolean;
          isValidStatus: boolean;
          wasGpuEnabled: boolean;
          wasInternetEnabled: boolean;
          outOfMemory: boolean;
          invalidPathErrors: boolean;
          succeeded: boolean;
          wasKilled: boolean;
        }

        export interface KernelRunLog {
          lineNumber: /*Int32*/ number;
          elapsedSeconds: /*Double*/ number;
          content: string | null;
          streamName: "stderr" | "stdout";
        }

        export interface KernelRunResources {
          storageBytes: /*Int64*/ number;
          memoryBytes: /*Int64*/ number;
          cpuCores: /*Int32*/ number;
          sessionTimeoutSeconds: /*Int32*/ number;
          idleTimeoutSeconds: /*Int32*/ number;
          network: string | null;
        }

        /*[NotNull]*/
        export interface KernelSession {
          kernelId: /*Int32*/ number;
          kernelRunId: /*Int32*/ number;
          type: "batch" | "interactive" | "quick";
          sourceType: "notebook" | "script";
          title: string;
          dateCreated: /*DateTime*/ string;
          languageName: string;
          accelerator: "gpu" | "none" | "tpu_v2_256" | "tpu_v2_32" | "tpu_v3_8";
          isInternetEnabled: boolean;
          versionNumber: (/*Int32*/ number) | null;
          versionName: string;
        }

        /*[NotNull]*/
        export interface KernelSessionList {
          totalCount: /*Int32*/ number;
          quotaLimits: Kaggle.Sdk.Kernels.Models.KernelSessionQuotaLimits;
          sessions: (Kaggle.Sdk.Kernels.Models.KernelSession)[];
        }

        export interface KernelSessionOutputFile {
          kernelSessionOutputFileId: /*Int32*/ number;
          kernelSessionId: /*Int32*/ number;
          kernelId: /*Int32*/ number;
          name: string | null;
          contentLength: /*Int64*/ number;
          fullPath: string | null;
          downloadUrl: string | null;
          fileType: string | null;
        }

        /*[NotNull]*/
        export interface KernelSessionQuotaLimits {
          gpuInteractive: /*Int32*/ number;
          gpuBatch: /*Int32*/ number;
          cpuInteractive: /*Int32*/ number;
          cpuBatch: /*Int32*/ number;
          tpuInteractive: /*Int32*/ number;
          tpuBatch: /*Int32*/ number;
        }

        export interface KernelSessionUnit {
          kernelRunId: /*Int32*/ number;
          dateCreated: (/*DateTime*/ string) | null;
          workerIpAddress: string | null;
          workerIpAddressExternal: string | null;
          workerZone: string | null;
        }

        export interface KernelShelf {
          kernels: (Kaggle.Sdk.Kernels.Models.KernelListItem)[];
          label: string | null;
          totalKernels: /*Int32*/ number;
          moreKernelsRequest: Kaggle.Sdk.Kernels.Requests.ListKernelIdsRequest | null;
        }

        export interface KernelSubmission {
          date: /*DateTime*/ string;
          privateScore: string | null;
          publicScore: string | null;
          submissionId: /*Int32*/ number;
          teamName: string | null;
          status: /*Int32*/ number;
        }

        export interface KernelVersion {
          id: /*Int32*/ number;
          versionNumber: /*Int32*/ number;
          linesTotal: /*Int32*/ number;
          linesInserted: /*Int32*/ number;
          linesDeleted: /*Int32*/ number;
          pinningType: "pinned" | "unpinned";
          versionName: string | null;
          versionType: "batch" | "interactive" | "quick";
          userPlan: "free" | "kagglePro";
        }

        export interface KernelVersionAndRun {
          author: Kaggle.Sdk.Users.Models.User | null;
          version: Kaggle.Sdk.Kernels.Models.KernelVersion | null;
          run: Kaggle.Sdk.Kernels.Models.KernelRun | null;
          blob: Kaggle.Sdk.Kernels.Models.KernelBlob | null;
          isForkParent: boolean;
          currentUrlSlug: string | null;
          kernelAuthorUserName: string | null;
          viewerUrl: string | null;
        }

        export interface KernelVersionCommitSettings {
          versionNumber: /*Int32*/ number;
          linesTotal: /*Int32*/ number;
          linesInserted: /*Int32*/ number;
          linesDeleted: /*Int32*/ number;
        }

        export interface KernelVersionDraftSettings {
          parentKernelVersionId: (/*Int32*/ number) | null;
          dateCheckpointed: /*DateTime*/ string;
        }

        export interface KernelVersionHistory {
          id: /*Int32*/ number;
          isForkParent: boolean;
          isNotebook: boolean;
          languageName: string | null;
          lastRunTime: (/*DateTime*/ string) | null;
          linesChangedFromPrevious: /*Int32*/ number;
          linesDeletedFromPrevious: /*Int32*/ number;
          linesInsertedFromPrevious: /*Int32*/ number;
          outputFilesTotalSizeBytes: /*Int64*/ number;
          runInfo: Kaggle.Sdk.Kernels.Models.KernelVersionRunInfo | null;
          status:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running";
          title: string | null;
          /*[NotNull]*/
          url: string;
          versionNumber: /*Int32*/ number;
          hasVersionNumber: boolean;
          isRedacted: boolean;
          versionAuthor: Kaggle.Sdk.Users.Models.User | null;
          versionType: "batch" | "interactive" | "quick";
          userPlan: "free" | "kagglePro";
        }

        export interface KernelVersionList {
          items: (Kaggle.Sdk.Kernels.Models.KernelVersionAndRun)[];
        }

        export interface KernelVersionRunInfo {
          dockerfileUrl: string | null;
          dockerHubUrl: string | null;
          dockerImageId: string | null;
          dockerImageName: string | null;
          exitCode: /*Int32*/ number;
          failureMessage: string | null;
          isValidStatus: boolean;
          runTimeSeconds: (/*Double*/ number) | null;
          succeeded: boolean;
          timeoutExceeded: boolean;
          usedAllSpace: boolean | null;
        }

        export interface LinkModel {
          count: (/*Int32*/ number) | null;
          href: string | null;
          reportEventCategory: string | null;
          reportEventType: string | null;
          showZeroCountExplicitly: boolean;
          showOnMobile: boolean;
          tab: string | null;
          text: string | null;
          title: string | null;
        }

        export interface ListGithubRepositoriesResponse {
          repositories: (Kaggle.Sdk.Kernels.Models.GithubRepositoryInfo)[];
        }

        export interface ListGithubRepositoryBranchesResponse {
          branches: (Kaggle.Sdk.Kernels.Models.GithubBranchInfo)[];
        }

        export interface ListGithubRepositoryFilesResponse {
          files: (Kaggle.Sdk.Kernels.Models.GithubFileInfo)[];
        }

        export interface ListKernelRunOutputResponse {
          items: (Kaggle.Sdk.Kernels.Models.KernelSessionOutputFile)[];
          nextPageToken: string | null;
        }

        export interface ListKernelUpvotesResponse {
          upvoterUserIds: (/*Int32*/ number)[];
          currentUserUpvoted: boolean;
        }

        export interface ListSnippetsResponse {
          snippets: (Kaggle.Sdk.Kernels.Models.Snippet)[];
        }

        export interface NewKernelResponse {
          type: "notFound" | "redirect";
        }

        export interface ParentKernelVersionData {
          kernelVersionId: /*Int32*/ number;
          copyAndEditUrl: string | null;
          title: string | null;
          viewUrl: string | null;
        }

        export interface PromoteKernelDraftResponse {
          versionNumber: /*Int32*/ number;
          diff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
          forkParentDiff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
        }

        export interface Reference {
          kernelId: /*Int32*/ number;
          kernelRunId: /*Int32*/ number;
          authorDisplayName: string | null;
          authorProfileUrl: string | null;
          authorThumbnailUrl: string | null;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSource)[];
          dateEvaluated: /*DateTime*/ string;
          title: string | null;
          totalVotes: /*Int32*/ number;
          url: string | null;
          definitions: (Kaggle.Sdk.Kernels.Models.SnippetReference)[];
          snippets: (Kaggle.Sdk.Kernels.Models.SnippetReference)[];
          totalSnippetCount: /*Int32*/ number;
        }

        export interface RunInfo {
          succeeded: boolean;
          exitCode: /*Int32*/ number;
          dockerImage: Kaggle.Sdk.Kernels.Models.DockerImage | null;
          timeoutExceeded: boolean;
          failureMessage: string | null;
          runTime: /*Int32*/ number;
          queueTime: /*Int32*/ number;
          outputSize: /*Int32*/ number;
          usedAllSpace: boolean;
        }

        export interface SearchKernelDataSourcesResponse {
          results: (Kaggle.Sdk.Kernels.Models.KernelDataSourceListItemDto)[];
        }

        export interface Snippet {
          id: /*Int32*/ number;
          title: string | null;
          authorUserId: /*Int32*/ number;
          tags: string | null;
          content: string | null;
          languageName: string | null;
          isPrivate: boolean | null;
        }

        export interface SnippetReference {
          snippetText: string | null;
          lineNumber: /*Int32*/ number;
        }

        export interface Tag {
          name: string | null;
          slug: string | null;
          url: string | null;
        }

        export interface UpdateDataSourceResult {
          /*[NotNull]*/
          reference: Kaggle.Sdk.Kernels.Models.DataSourceReference;
          /*[NotNull]*/
          mountedVersion: Kaggle.Sdk.Kernels.Models.DataSourceVersion;
          newVersion: Kaggle.Sdk.Kernels.Models.DataSourceVersion | null;
        }

        export interface UpdateDockerImageVersionResponse {}

        export interface UpdateDockerPinningTypeResponse {}

        export interface UpdateKernelCollaboratorsResponse {
          privateDataSources: (Kaggle.Sdk.Kernels.Models.DataSource)[];
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
        }

        export interface UpdateKernelDraftResponse {
          sequence: /*Int32*/ number;
          kernelVersionId: /*Int32*/ number;
          computedParent: Kaggle.Sdk.Kernels.Models.ParentKernelVersionData | null;
        }

        export interface UpdateKernelPrivacyResponse {}

        export interface UpdateKernelRunDataSourcesResponse {
          results: (Kaggle.Sdk.Kernels.Models.UpdateDataSourceResult)[];
          anyChanges: boolean;
        }

        export interface UpdateKernelRunResponse {
          errorMessage: string | null;
          restartRequired: boolean;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
        }

        export interface UpdateKernelSessionEndResponse {}

        export interface UpdateKernelSessionKeepaliveResponse {}

        export interface UpdateKernelTitleResponse {
          errorMessage: string | null;
          username: string | null;
          slug: string | null;
          newUrl: string | null;
        }

        export interface UpdateKernelVersionNameResponse {}

        export interface UpdatePinnedKernelSessionResponse {}

        export interface UpdateSnippetResponse {}

        export interface UpdateUserKernelFirestoreAuthResponse {
          sessionId: string | null;
        }
      }

      export namespace Protos {
        export interface GetKernelEmbedResponse {
          ipynbContent?: /* google.protobuf.StringValue */ string | null;
          renderedOutputUrl?: /* google.protobuf.StringValue */ string | null;
          viewerUrl: string;
        }

        export enum KernelsListSortType {
          HOTNESS = "hotness", // = 0
          COMMENT_COUNT = "commentCount", // = 1
          DATE_CREATED = "dateCreated", // = 2
          DATE_RUN = "dateRun", // = 3
          RELEVANCE = "relevance", // = 4
          SCORE_ASCENDING = "scoreAscending", // = 5
          SCORE_DESCENDING = "scoreDescending", // = 6
          VIEW_COUNT = "viewCount", // = 7
          VOTE_COUNT = "voteCount", // = 8
        }
        export enum KernelsListViewType {
          UNSPECIFIED = "unspecified", // = 0
          PROFILE = "profile", // = 1
          UPVOTED = "upvoted", // = 2
          EVERYONE = "everyone", // = 3
          COLLABORATION = "collaboration", // = 4
          FORK = "fork", // = 5
          BOOKMARKED = "bookmarked", // = 6
          RECENTLY_VIEWED = "recentlyViewed", // = 7
        }
        export enum KernelWorkerStatus {
          QUEUED = "queued", // = 0
          RUNNING = "running", // = 1
          COMPLETE = "complete", // = 2
          ERROR = "error", // = 3
          CANCEL_REQUESTED = "cancelRequested", // = 4
          CANCEL_ACKNOWLEDGED = "cancelAcknowledged", // = 5
          NEW_SCRIPT = "newScript", // = 6
        }
      }

      export namespace Queries {}

      export namespace Requests {
        /*[ClientRequest]*/
        export interface AcceptKernelCompetitionRulesRequest {
          kernelSessionId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface AddKernelCategoryRequest {
          kernelId: /*Int32*/ number;
          categoryId: /*Int32*/ number;
        }

        export interface AdjustGpuQuotaRequest {
          newWeeklyQuota: /*TimeSpan*/ string;
        }

        /*[ClientRequest]*/
        export interface AutoSaveRequest {
          kernelId: /*Int32*/ number;
          sequence: /*Int32*/ number;
          parentKernelVersionId: (/*Int32*/ number) | null;
          settings: Kaggle.Sdk.Kernels.Models.KernelBlobSettings | null;
          source: string | null;
          externalSourceUrl: string | null;
        }

        /*[ClientRequest]*/
        export interface BatchAutoTagKernelsRequest {
          batchSize: /*Int32*/ number;
          startingKernelId: /*Int32*/ number;
        }

        export interface BatchUpdateKernelCollaboratorsRequest {
          kernelIds: (/*Int32*/ number)[];
          additionalReadUserIds: (/*Int32*/ number)[];
          additionalWriteUserIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface CancelKernelRunRequest {
          kernelRunId: /*Int32*/ number;
        }

        export interface CancelKernelRunsForBlockedUserRequest {
          userId: /*Int32*/ number;
        }

        export interface ChangeAnonymousKernelOwnerRequest {
          kernelSlug: string | null;
        }

        export interface CheckKernelAccessRequest {
          kernelId: /*Int32*/ number;
          accessType: "administrative" | "comment" | "read" | "write";
        }

        export interface CheckKernelsAccessRequest {
          kernelIds: (/*Int32*/ number)[];
          accessType: "administrative" | "comment" | "read" | "write";
        }

        export interface CheckKernelSessionAccessRequest {
          kernelSessionId: /*Int32*/ number;
          accessType: "administrative" | "comment" | "read" | "write";
        }

        export interface CheckTitleRequest {
          title: string | null;
          slug: string | null;
          kernelId: (/*Int32*/ number) | null;
          datasetId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface CommitAndRunRequest {
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          forkParentScriptVersionId: (/*Int32*/ number) | null;
          isLanguageTemplate: boolean | null;
          newText: string | null;
          newTitle: string | null;
          scriptId: /*Int32*/ number;
          scriptLanguageName: string | null;
          dockerImageVersionId: (/*Int32*/ number) | null;
          isPrivate: boolean;
          editorType: "notebook" | "script" | null;
          dockerImageTag: string | null;
          workerPoolName: string | null;
          sequence: (/*Int32*/ number) | null;
          compute: Kaggle.Sdk.Kernels.Models.ComputeState | null;
          kernelVersionId: (/*Int32*/ number) | null;
          versionName: string | null;
          versionType: "batch" | "interactive" | "quick";
          userPlanOverride: "free" | "kagglePro" | null;
        }

        /*[ClientRequest]*/
        export interface CompleteQuickSessionRequest {
          kernelSessionId: /*Int32*/ number;
          workerPoolName: string | null;
        }

        /*[ClientRequest]*/
        export interface ComputeKernelDiffRequest {
          leftSessionId: /*Int32*/ number;
          rightSessionId: /*Int32*/ number;
          includeContents: boolean;
        }

        /*[ClientRequest]*/
        export interface CreateKernelRequest
          extends Kaggle.Sdk.Kernels.Requests.CreateKernelRunRequestBase {
          dockerImagePinningType: "latest" | "original" | null;
          forkedFromRunId: (/*Int32*/ number) | null;
          isPrivate: boolean;
          pinnedDockerImageVersionId: (/*Int32*/ number) | null;
          sourceType: "notebook" | "script";
          source: string | null;
          externalSourceUrl: string | null;
          startInteractiveSession: boolean;
        }

        /*[ClientRequest]*/
        export interface CreateKernelRunRequest
          extends Kaggle.Sdk.Kernels.Requests.CreateKernelRunRequestBase {
          kernelId: /*Int32*/ number;
          versionType: "batch" | "interactive" | "quick";
          dockerImageTag: string | null;
          workerPoolName: string | null;
          userPlanOverride: "free" | "kagglePro" | null;
          immediatelyCancelSession: boolean;
          kernelVersionId: (/*Int32*/ number) | null;
          diff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
          forkParentDiff: Kaggle.Sdk.Kernels.Models.KernelDiff | null;
        }

        export interface CreateKernelRunRequestBase {
          title: string | null;
          languageId: /*Int32*/ number;
          dockerImageVersionId: (/*Int32*/ number) | null;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          compute: Kaggle.Sdk.Kernels.Models.ComputeState | null;
          useGivenDataSourceVersionIds: boolean;
        }

        /*[ClientRequest]*/
        export interface CreateKernelUpvoteRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface CreateKernelWithSettingsRequest {
          kernelLanguageId: /*Int32*/ number;
          sourceType: "notebook" | "script";
          accelerator: "gpu" | "none" | "tpu_v2_256" | "tpu_v2_32" | "tpu_v3_8";
          sourceUrl: string | null;
          enableInternet: boolean | null;
          enableBigQuery: boolean | null;
          forkParentScriptVersionId: (/*Int32*/ number) | null;
          competitionId: (/*Int32*/ number) | null;
          datasetVersionId: (/*Int32*/ number) | null;
          datasetTaskId: (/*Int32*/ number) | null;
          kernelOutputVersionId: (/*Int32*/ number) | null;
          bigQuerySecretId: (/*Int32*/ number) | null;
          dockerImagePinningType: "latest" | "original";
        }

        export interface CreateNlpKernelAutoTagsRequest {
          kernelSessionId: /*Int32*/ number;
        }

        export interface CreateOrphanedCleanupTaskRequest {}

        /*[ClientRequest]*/
        export interface CreateSnippetRequest {
          data: Kaggle.Sdk.Kernels.Requests.SnippetData | null;
        }

        export interface CreateWorkerCommandRequest {
          workerPattern: string | null;
          flushDatasetVersion: Kaggle.Sdk.Kernels.Requests.FlushDatasetVersion | null;
          flushCompetitionDataset: Kaggle.Sdk.Kernels.Requests.FlushCompetitionDataset | null;
          flushDataSource: Kaggle.Sdk.Kernels.Requests.FlushDataSource | null;
          genericCommand: string | null;
        }

        /*[ClientRequest]*/
        export interface DeleteKernelRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteKernelUpvoteRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteSnippetRequest {
          id: /*Int32*/ number;
        }

        export interface DeleteUserKernelsRequest {
          userId: /*Int32*/ number;
        }

        export interface DeleteUserKernelVotesRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ExportKernelRunForCaipRequest {
          kernelSessionId: /*Int32*/ number;
          useDraft: boolean;
        }

        /*[ClientRequest]*/
        export interface FetchExternalKernelContentRequest {
          sourceUrl: string | null;
        }

        /*[ClientRequest]*/
        export interface FetchGitHubContentRequest {
          owner: string | null;
          repo: string | null;
          path: string | null;
          ref: string | null;
        }

        export interface FlushCompetitionDataset {
          competitionId: /*Int32*/ number;
        }

        export interface FlushDatasetVersion {
          datasetId: /*Int32*/ number;
          datasetVersionId: /*Int32*/ number;
        }

        export interface FlushDataSource {
          sourceUrl: string | null;
        }

        export interface ForkKernelSessionRequest {
          kernelSessionId: /*Int32*/ number;
        }

        export interface ForkOrGetExistingKernelRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetAcceleratorQuotaStatisticsRequest {}

        /*[ClientRequest]*/
        export interface GetActiveInteractiveKernelRunRequest {
          kernelId: /*Int32*/ number;
          includeCancelledSessions: boolean;
          firebaseIdToken: string | null;
        }

        /*[ClientRequest]*/
        export interface GetDefaultSessionSettingsRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetDeletedKernelRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetFirebaseAuthTokenRequest {}

        /*[ClientRequest]*/
        export interface GetFirebaseConfigRequest {}

        export interface GetKernelBlobSourceRequest {
          blobId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetKernelCategoryIdsRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetKernelCollaboratorListRequest {
          kernelId: /*Int32*/ number;
          alwaysIncludeReadGroup: boolean;
        }

        /*[ClientRequest]*/
        export interface GetKernelDraftRequest {
          kernelId: /*Int32*/ number;
        }

        export interface GetKernelIdByUsernameAndSlugRequest {
          username: string | null;
          slug: string | null;
        }

        /*[ClientRequest]*/
        export interface GetKernelLandingPageRequest {}

        /*[ClientRequest]*/
        export interface GetKernelListDetailsRequest {
          kernelIds: (/*Int32*/ number)[];
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Kernels.Models.KernelListItem
          >;
          excludeResultsFilesOutputs: boolean;
          wantOutputFiles: boolean;
          unauthorizedAccessBehavior: "returnNothing" | "returnShellEntry";
          deletedAccessBehavior: "returnNothing" | "returnShellEntry";
          outputFileTypes: (string)[];
          maxOutputFilesPerKernel: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface GetKernelRequest {
          kernelId: (/*Int32*/ number) | null;
          username: string | null;
          slug: string | null;
        }

        export interface GetKernelRunLogRequest {
          kernelRunId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetKernelRunRequest {
          kernelRunId: /*Int32*/ number;
        }

        export interface GetKernelRunSourceForCaipRequest {
          kernelSessionId: (/*Int32*/ number) | null;
          useDraft: boolean;
        }

        /*[ClientRequest]*/
        export interface GetKernelRunSourceRequest {
          kernelRunId: /*Int32*/ number;
          includeOutputIfAvailable: boolean;
          serializeToString: boolean;
        }

        /*[ClientRequest]*/
        export interface GetKernelSessionDataSourcesRequest {
          kernelSessionId: /*Int32*/ number;
          includeOutputFiles: boolean;
        }

        /*[ClientRequest]*/
        export interface GetKernelSessionUnitRequest {
          kernelRunId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetKernelStatusRequest {
          kernelRunId: /*Int32*/ number;
          existingStatus:
            | "cancelAcknowledged"
            | "cancelRequested"
            | "complete"
            | "error"
            | "newScript"
            | "queued"
            | "running"
            | null;
        }

        export interface GetKernelSummaryForDatasetsRequest {
          creationStartDate: /*DateTime*/ string;
          creationEndDate: /*DateTime*/ string;
          datasetIdRange: (/*Range*/ unknown) | null;
        }

        export interface GetKernelViewerSessionIdRequest {
          sessionId: (/*Int32*/ number) | null;
          slug: string | null;
          userName: string | null;
          validateWithoutRedirect: boolean;
        }

        export interface GetKernelViewModelRequest {
          authorUserName: string | null;
          kernelSlug: string | null;
          kernelVersionId: /*Int32*/ number;
          tab: string | null;
          renderMaterial: boolean;
        }

        export interface GetMostRecentForkSlugByUserRequest {
          parentKernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetOrCreateKernelSessionRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GetSourceIndexDataRequest {
          continuationToken: string | null;
          maxReferencesToReturn: /*Int32*/ number;
          maxSnippetsPerReference: /*Int32*/ number;
          referent: string | null;
        }

        /*[ClientRequest]*/
        export interface GetUserKernelAchievementsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface HasAcceptedKernelCompetitionRulesRequest {
          kernelSessionId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface IndexAllSnippetsRequest {}

        export interface KernelBlobSyncFeederRequest {
          highwaterBlobId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListDockerImagesRequest {
          kernelSessionId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListGithubRepositoriesRequest {
          query: string | null;
          page: (/*Int32*/ number) | null;
          perPage: (/*Int32*/ number) | null;
          includePrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface ListGithubRepositoryBranchesRequest {
          owner: string | null;
          name: string | null;
          includePrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface ListGithubRepositoryFilesRequest {
          owner: string | null;
          name: string | null;
          branch: string | null;
          fileExtensionFilter: (string)[];
          includePrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface ListKernelIdsRequest {
          after: (/*Int32*/ number) | null;
          competitionId: (/*Int32*/ number) | null;
          datasetId: (/*Int32*/ number) | null;
          datasourceType: string | null;
          forkParentScriptId: (/*Int32*/ number) | null;
          group:
            | "bookmarked"
            | "collaboration"
            | "everyone"
            | "fork"
            | "profile"
            | "recentlyViewed"
            | "unspecified"
            | "upvoted";
          kernelType: string | null;
          language: string | null;
          outputType: string | null;
          excludeResultsFilesOutputs: boolean;
          page: /*Int32*/ number;
          pageSize: /*Int32*/ number;
          sortBy:
            | "commentCount"
            | "dateCreated"
            | "dateRun"
            | "hotness"
            | "relevance"
            | "scoreAscending"
            | "scoreDescending"
            | "viewCount"
            | "voteCount";
          userId: (/*Int32*/ number) | null;
          tagIds: string | null;
          wantOutputFiles: boolean;
          hasGpuRun: boolean | null;
          privacy: string | null;
          startRow: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListKernelRunLogsRequest {
          kernelRunId: /*Int32*/ number;
        }

        export interface ListKernelRunLogsResponse {
          logs: (Kaggle.Sdk.Kernels.Models.KernelRunLog)[];
        }

        /*[ClientRequest]*/
        export interface ListKernelRunOutputRequest {
          kernelRunId: /*Int32*/ number;
          pageSize: (/*Int32*/ number) | null;
          pageToken: string | null;
        }

        /*[ClientRequest]*/
        export interface ListKernelSessionsRequest {}

        /*[ClientRequest]*/
        export interface ListKernelsRequest {
          kernelFilterCriteria: Kaggle.Sdk.Kernels.Requests.SearchKernelIdsRequest | null;
          detailFilterCriteria: Kaggle.Sdk.Kernels.Requests.GetKernelListDetailsRequest | null;
        }

        export interface ListKernelUpvotesRequest {
          kernelId: /*Int32*/ number;
          pageSize: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListKernelVersionsRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListSnippetsRequest {
          query: string | null;
          languageName: string | null;
        }

        export interface NewKernelRequest {
          forkParentScriptVersionId: (/*Int32*/ number) | null;
          datasetVersionId: (/*Int32*/ number) | null;
          competitionId: (/*Int32*/ number) | null;
          scriptVersionId: (/*Int32*/ number) | null;
          sourceKernelContentUrl: string | null;
          editorType: "notebook" | "script";
          languageId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface PromoteKernelDraftRequest {
          kernelId: /*Int32*/ number;
          kernelVersionId: /*Int32*/ number;
          newSourceType: "notebook" | "script";
          newSource: string | null;
          versionName: string | null;
          versionType: "batch" | "interactive" | "quick";
        }

        /*[ClientRequest]*/
        export interface RemoveKernelCategoryRequest {
          kernelId: /*Int32*/ number;
          categoryId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface RunEpisodeRequest {
          competitionId: /*Int32*/ number;
          episodeId: /*Int32*/ number;
          environment: string | null;
          episodeType:
            | "exhibition"
            | "private"
            | "public"
            | "unspecified"
            | "validation";
          agents: (Kaggle.Sdk.Kernels.Models.AgentEntry)[];
          configuration: string | null;
          renderType: "html" | "json" | "liveVideo" | "unspecified" | "video";
          dockerImageNameOverride: string | null;
          poolNameOverride: string | null;
        }

        export interface SearchKernelDataSourcesRequest {
          page: /*Int32*/ number;
          search: string | null;
        }

        /*[ClientRequest]*/
        export interface SearchKernelIdsRequest
          extends Kaggle.Sdk.Kernels.Requests.ListKernelIdsRequest {
          search: string | null;
        }

        export interface SetKernelGroupsRequest {
          kernelId: /*Int32*/ number;
          readerGroupId: (/*Int32*/ number) | null;
          writerGroupId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface SnippetData {
          title: string | null;
          tags: string | null;
          content: string | null;
          languageName: string | null;
          isPrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateDefaultSessionSettingsRequest {
          kernelId: /*Int32*/ number;
          settings: Kaggle.Sdk.Kernels.Models.DefaultSessionSettings | null;
        }

        /*[ClientRequest]*/
        export interface UpdateDockerImageVersionRequest {
          scriptId: /*Int32*/ number;
          dockerImageVersionId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface UpdateDockerPinningTypeRequest {
          kernelId: /*Int32*/ number;
          dockerImagePinningType: "latest" | "original";
        }

        /*[ClientRequest]*/
        export interface UpdateKernelCollaboratorsRequest {
          kernelId: /*Int32*/ number;
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelPrivacyRequest {
          kernelId: /*Int32*/ number;
          disableComments: boolean | null;
          isPrivate: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelRunDataSourcesRequest {
          sessionId: /*Int32*/ number;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
          dryRun: boolean;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelRunRequest {
          kernelRunId: /*Int32*/ number;
          isInternetEnabled: boolean;
          dataSources: (Kaggle.Sdk.Kernels.Models.DataSourceReference)[];
        }

        export interface UpdateKernelSessionEndRequest {
          canceled: boolean;
          containerRunInfo: (/*JObject*/ unknown) | null;
          evaluationDurationMilliseconds: /*Double*/ number;
          scriptSource: string | null;
          outputFilesAddress: string | null;
          context: Record<string, /*Object*/ unknown>;
          kernelSessionId: /*Int32*/ number;
          acceleratorUsed: boolean;
          status: string | null;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelSessionKeepaliveRequest {
          kernelSessionId: /*Int32*/ number;
        }

        export interface UpdateKernelSessionStartRequest {
          kernelSessionId: /*Int32*/ number;
          dateEvaluated: /*DateTime*/ string;
          workerIpAddress: string | null;
          workerIpAddressExternal: string | null;
          workerVmInstance: string | null;
          workerVmInstanceName: string | null;
          workerContainerPort: (/*Int32*/ number) | null;
          workerUptimeSeconds: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelTitleRequest {
          newTitle: string | null;
          scriptVersionId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface UpdateKernelVersionNameRequest {
          versionId: /*Int32*/ number;
          newName: string | null;
        }

        /*[ClientRequest]*/
        export interface UpdatePinnedKernelSessionRequest {
          sessionId: /*Int32*/ number;
          pinningType: "pinned" | "unpinned";
        }

        /*[ClientRequest]*/
        export interface UpdateSnippetRequest {
          id: /*Int32*/ number;
          data: Kaggle.Sdk.Kernels.Requests.SnippetData | null;
        }

        /*[ClientRequest]*/
        export interface UpdateUserKernelFirestoreAuthRequest {
          kernelRunId: /*Int32*/ number;
          firebaseIdToken: string | null;
        }

        /*[ClientRequest]*/
        export interface UploadKernelSessionOutputRequest {
          interactiveSessionId: /*Int32*/ number;
          batchSessionId: /*Int32*/ number;
        }

        export interface ValidateKernelJweRequest {
          token: string | null;
          callerAddress: string | null;
        }
      }

      export interface KernelsClient {}

      export interface KernelsConstants {}

      export interface NotebookCell {
        cell_type: string | null;
        execution_count: (/*Int32*/ number) | null;
        outputs: (/*Object*/ unknown) | null;
        source: (/*Object*/ unknown) | null;
        sourceString: string | null;
      }

      export interface NotebookIpynb {
        cells: (Kaggle.Sdk.Kernels.NotebookCell)[];
        metadata: Kaggle.Sdk.Kernels.NotebookMetadata | null;
        nbformat: /*Int32*/ number;
        nbformat_minor: /*Int32*/ number;
      }

      export interface NotebookJson {}

      export interface NotebookMetadata {
        language_info: (/*Object*/ unknown) | null;
        kernelspec: (/*Object*/ unknown) | null;
      }
    }

    export namespace Monitoring {
      export interface RecordPageLoadMetricsRequest {
        pageUrl: string | null;
        isFullPageRefresh: boolean;
        pageRequestStartEpochMs: /*Int64*/ number;
        pageRequestEndEpochMs: /*Int64*/ number;
        pageLoadStartEpochMs: /*Int64*/ number;
        pageLoadEndEpochMs: /*Int64*/ number;
      }

      export interface UserAgentInfo {
        device: "bot" | "desktop" | "mobile" | "tablet" | "unknown";
        operatingSystemName: string | null;
        operatingSystemVersion: string | null;
        browserName: string | null;
        browserVersion: string | null;
      }
    }

    export namespace Newsfeed {
      export namespace Protos {
        export interface GetDismissableBannerRequest {}

        export interface GetDismissableBannerResponse {
          showBanner: boolean;
        }

        export interface GetItemsRequest {}

        export interface GetNewsfeedSidebarContentRequest {}

        export interface GetStoriesRequest {
          page: number;
        }

        export interface GetStoriesResponse {
          stories: Kaggle.Sdk.Newsfeed.Protos.NewsfeedStory[];
        }

        export interface NewsfeedBlog {
          imageUrl: string;
          summary: string;
          title: string;
          url: string;
        }

        export interface NewsfeedCompetition {
          coverImageUrl: string;
          currentUserRank?: /* google.protobuf.Int32Value */ number | null;
          deadline: /* google.protobuf.Timestamp */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          imageUrl: string;
          briefDescription: string;
          overview: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetitionOverview | null;
          resultsAreFinal?: /* google.protobuf.BoolValue */ boolean | null;
          rewardQuantity?: /* google.protobuf.DoubleValue */ number | null;
          rewardType?: /* google.protobuf.StringValue */ string | null;
          teams: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetitionTeam[];
          totalEnteredTeams?: /* google.protobuf.Int32Value */ number | null;
          url?: /* google.protobuf.StringValue */ string | null;
          winningSubmissionUrl?: /* google.protobuf.StringValue */
            | string
            | null;
        }

        export interface NewsfeedCompetitionOverview {
          content: string;
          type: string;
        }

        export interface NewsfeedCompetitionTeam {
          name: string;
          rank?: /* google.protobuf.Int32Value */ number | null;
          team: Kaggle.Sdk.Competitions.Protos.Team | null;
          users: Kaggle.Sdk.Users.Protos.User[];
        }

        export interface NewsfeedDataset {
          commonFileType: Kaggle.Sdk.Datasets.Models.DatasetFileType.Enum;
          databundleVersionId?: /* google.protobuf.Int32Value */ number | null;
          datasetIsDeleted: boolean;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          licenseName: string;
          overview: string;
          title?: /* google.protobuf.StringValue */ string | null;
          totalSize?: /* google.protobuf.Int64Value */ number | null;
          totalFiles?: /* google.protobuf.Int32Value */ number | null;
          totalKernels?: /* google.protobuf.Int32Value */ number | null;
          totalTopics?: /* google.protobuf.Int32Value */ number | null;
          totalViews?: /* google.protobuf.Int32Value */ number | null;
          url?: /* google.protobuf.StringValue */ string | null;
          versionNotes: string;
          datasetId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface NewsfeedDiscussion {
          forumName: string;
          forumUrl?: /* google.protobuf.StringValue */ string | null;
          messageId?: /* google.protobuf.Int32Value */ number | null;
          messageRawHtml: string;
          messageRawMarkdown?: /* google.protobuf.StringValue */ string | null;
          messageUrl: string;
          topicDate: /* google.protobuf.Timestamp */ string | null;
          topicId?: /* google.protobuf.Int32Value */ number | null;
          topicName: string;
          topicRawHtml: string;
          topicRawMarkdown?: /* google.protobuf.StringValue */ string | null;
          topicUrl: string;
        }

        export interface NewsfeedKernel {
          commentCount: number;
          dataUrl: string;
          disableComments: boolean;
          fileOutputCount?: /* google.protobuf.Int32Value */ number | null;
          hasMultipleDataSources: boolean;
          kernelId?: /* google.protobuf.Int32Value */ number | null;
          kernelType: Kaggle.Sdk.Newsfeed.Protos.EditorType;
          language: string;
          lineCount?: /* google.protobuf.Int32Value */ number | null;
          name: string;
          runTimeSeconds?: /* google.protobuf.DoubleValue */ number | null;
          url: string;
          views?: /* google.protobuf.Int32Value */ number | null;
          visualizationUrls: string[];
        }

        export interface NewsfeedSidebarContent {
          userName?: /* google.protobuf.StringValue */ string | null;
          avatarUrl?: /* google.protobuf.StringValue */ string | null;
          userUrl?: /* google.protobuf.StringValue */ string | null;
          userTier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          userJoinDate: /* google.protobuf.Timestamp */ string | null;
          progression: Kaggle.Sdk.Users.Protos.GetCurrentUserProgressionResponse | null;
          competitionSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
          datasetSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
          kernelSidebarList: Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarItem[];
        }

        export interface NewsfeedSidebarItem {
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          title?: /* google.protobuf.StringValue */ string | null;
          linkUrl?: /* google.protobuf.StringValue */ string | null;
          icon?: /* google.protobuf.StringValue */ string | null;
          iconTitle?: /* google.protobuf.StringValue */ string | null;
          iconRight?: /* google.protobuf.StringValue */ string | null;
          iconRightTitle?: /* google.protobuf.StringValue */ string | null;
          dateCreated: /* google.protobuf.Timestamp */ string | null;
        }

        export interface NewsfeedStory {
          // Only users can do actions on the newsfeed, such as upvoting and commenting
          actionUser: Kaggle.Sdk.Users.Protos.User | null;
          blog: Kaggle.Sdk.Newsfeed.Protos.NewsfeedBlog | null;
          competition: Kaggle.Sdk.Newsfeed.Protos.NewsfeedCompetition | null;
          dataset: Kaggle.Sdk.Newsfeed.Protos.NewsfeedDataset | null;
          date: /* google.protobuf.Timestamp */ string | null;
          discussion: Kaggle.Sdk.Newsfeed.Protos.NewsfeedDiscussion | null;
          isFollowingItem?: /* google.protobuf.BoolValue */ boolean | null;
          isFollowingUser?: /* google.protobuf.BoolValue */ boolean | null;
          kernel: Kaggle.Sdk.Newsfeed.Protos.NewsfeedKernel | null;
          // Owners can be either a user or an organization
          ownerOrganization: Kaggle.Sdk.Newsfeed.Protos.Organization | null;
          ownerUser: Kaggle.Sdk.Users.Protos.User | null;
          storyInfo: Kaggle.Sdk.Newsfeed.Protos.NewsfeedStoryInfo | null;
          vote: Kaggle.Sdk.Newsfeed.Protos.NewsfeedVote | null;
        }

        export interface NewsfeedStoryInfo {
          experimentId: string;
          id: number;
          sortId: number;
          storyType: Kaggle.Sdk.Newsfeed.Protos.ItemType;
        }

        export interface NewsfeedVote {
          canDownvote?: /* google.protobuf.BoolValue */ boolean | null;
          canUpvote?: /* google.protobuf.BoolValue */ boolean | null;
          downvoteUrl: string;
          hasAlreadyDownvoted?: /* google.protobuf.BoolValue */ boolean | null;
          hasAlreadyUpvoted?: /* google.protobuf.BoolValue */ boolean | null;
          upvoteUrl?: /* google.protobuf.StringValue */ string | null;
          voteCount?: /* google.protobuf.Int32Value */ number | null;
          kernelId?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface Organization {
          id: number;
          creationDate: /* google.protobuf.Timestamp */ string | null;
          name: string;
          creatorUser: Kaggle.Sdk.Users.Protos.User | null;
          url: string;
          thumbnailUrl: string;
          joinDate: /* google.protobuf.Timestamp */ string | null;
          location: string;
          datasetCount: number;
          competitionCount: number;
          memberCount: number;
        }

        export interface SetDismissableBannerRequest {
          showBanner: boolean;
        }

        export enum EditorType {
          UNSPECIFIED = "unspecified", // = 0
          SCRIPT = "script", // = 1
          NOTEBOOK = "notebook", // = 2
        }
        // The ItemType enum defines all the possible newsfeed items that the front
        // end knows how to render.
        export enum ItemType {
          UNSPECIFIED = "unspecified", // = 0
          RAN_KERNEL = "ranKernel", // = 1
          PUBLISHED_KERNEL = "publishedKernel", // = 2
          COMMENTED_ON_KERNEL = "commentedOnKernel", // = 3
          UPVOTED_KERNEL = "upvotedKernel", // = 4
          DATASET_TRENDING = "datasetTrending", // = 5
          POSTED_DATASET = "postedDataset", // = 6
          DATASET_FEATURED = "datasetFeatured", // = 7
          UPVOTED_DATASET = "upvotedDataset", // = 8
          BLOG_POST = "blogPost", // = 9
          CREATED_TOPIC = "createdTopic", // = 10
          REPLIED_TO_TOPIC = "repliedToTopic", // = 11
          UPVOTED_TOPIC = "upvotedTopic", // = 12
          COMPETITION_LAUNCH = "competitionLaunch", // = 13
          COMPETITION_END = "competitionEnd", // = 14
          COMPETITION_FINAL = "competitionFinal", // = 15
          LEARN_CHALLENGE = "learnChallenge", // = 16
        }
      }

      export interface NewsfeedClient {}
    }

    export namespace Notifications {
      export namespace Models {
        export interface SendNotificationEmailsResponse {
          timeTaken: (Kaggle.Sdk.Notifications.Models.TimeTaken)[];
          numberProcessed: /*Int32*/ number;
        }

        export interface TimeTaken {
          notificationId: /*Int32*/ number;
          queryTimeMilliseconds: (/*Int64*/ number) | null;
          markTimeMilliseconds: (/*Int64*/ number) | null;
          loadTimeMilliseconds: (/*Int64*/ number) | null;
          processTimeMilliseconds: (/*Int64*/ number) | null;
          sendTimeMilliseconds: (/*Int64*/ number) | null;
          logTimeMilliseconds: (/*Int64*/ number) | null;
          totalTimeMilliseconds: /*Int64*/ number;
        }

        export interface UserNotificationSettings {
          enabled: boolean | null;
          atMentions: "all" | "following" | "none" | null;
          defaultDeliverySetting: "both" | "email" | "none" | "web" | null;
          aggregation: "daily" | "noAggregation" | "weekly" | null;
          datasetSummaryEmail: "both" | "email" | "none" | "web" | null;
          privateDatasetSummaryEmail: "both" | "email" | "none" | "web" | null;
          datasetTrendingSummaryEmail: "both" | "email" | "none" | "web" | null;
          datasetTaskEmail: "both" | "email" | "none" | "web" | null;
          userCollaborationMessages: "both" | "email" | "none" | "web" | null;
          isSubscribedToMailingList: boolean | null;
          atMentionFollowedUser: "both" | "email" | "none" | "web" | null;
          atMentionRegularUser: "both" | "email" | "none" | "web" | null;
          competitionAnnouncements: "both" | "email" | "none" | "web" | null;
          competitionTeamUpdates: "both" | "email" | "none" | "web" | null;
          datasetAlerts: "both" | "email" | "none" | "web" | null;
          notebookAlerts: "both" | "email" | "none" | "web" | null;
          engagedTopicComment: "both" | "email" | "none" | "web" | null;
          notificationTypeDeliverySettings: Record<
            string,
            "both" | "email" | "none" | "web"
          >;
          subscriptions: (Kaggle.Sdk.Notifications.Models.UserSubscription)[];
        }

        export interface UserSubscription {
          id: /*Int32*/ number;
          subscriptionStateId: /*Int32*/ number;
          subscriptionType: string | null;
          name: string | null;
          kernelName: string | null;
          notificationCount: /*Int32*/ number;
          lastNotificationCreatedDate: (/*DateTime*/ string) | null;
          link: string | null;
        }
      }

      export namespace Protos {
        export interface AddTestNotificationRequest {
          // What notification type do you want for the notification to be added?
          // Not all notification types are currently supported
          notificationTypeId: number;
          // for the notification type specified, there are pre-made notifications - which one of those do you want?
          // Not all types have variants - simply specify 0 for them
          // the invoking user must have permission to the any objects (dataset/comp/etc) mentioned in the variant
          variant: number;
          // By default the notification will be sent to the invoking user as a web notification,
          // when send_email is true, it will also be sent as an email to the invoking user.
          sendEmail: boolean;
        }

        export interface AddTestNotificationResponse {
          // id of the notification that was created
          notificationId: number;
          // the number of emails that we attempted to send - does not always succeed.
          emailsProcessedCount: number;
        }

        export interface GetMySubscribeStateRequest {
          id: number;
          type: Kaggle.Sdk.Notifications.Protos.SubscriptionType;
        }

        export interface GetSubscribeStateResponse {
          state: Kaggle.Sdk.Notifications.Protos.SubscribeState;
        }

        export interface GetUserNotificationsRequest {
          afterNotificationId?: /* google.protobuf.Int32Value */ number | null;
          pageSize: number;
        }

        export interface GetUserNotificationsResponse {
          containsMore: boolean;
          enabled: boolean;
          countUnviewed: number;
          notifications: Kaggle.Sdk.Notifications.Protos.Notification[];
          newestNotificationId: number;
        }

        export interface MarkAllNotificationsRequest {
          newestNotificationId: number;
          commandMark: Kaggle.Sdk.Notifications.Protos.CommandMark;
        }

        export interface MarkNotificationsRequest {
          // when you want to change a single notification's status, set this field
          singleNotificationId?: number;
          // setting this field will mark all notification ids <= this id
          newestNotificationId?: number;
          // set to true when you want the DatedViewed set on the notification
          markViewed: boolean;
          // set to true when you want the DateRead set on the notification
          markRead: boolean;
        }

        export interface MessageObject {
          key?: /* google.protobuf.StringValue */ string | null;
          text?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
        }

        export interface Notification {
          id: number;
          subscriptionType: Kaggle.Sdk.Notifications.Protos.SubscriptionType;
          relatedItemId: number;
          relatedItemType: Kaggle.Sdk.Notifications.Protos.NotificationRelatedItemType;
          isRead: boolean;
          isViewed: boolean;
          createdDate: /* google.protobuf.Timestamp */ string | null;
          imageUrl?: /* google.protobuf.StringValue */ string | null;
          imageHref?: /* google.protobuf.StringValue */ string | null;
          messageFormat?: /* google.protobuf.StringValue */ string | null;
          messageObjects: Kaggle.Sdk.Notifications.Protos.MessageObject[];
          title?: /* google.protobuf.StringValue */ string | null;
          message?: /* google.protobuf.StringValue */ string | null;
          // if non-null, this indicates that the notification represents a bundle of notifications
          // the count is the number of notifications in the bundle. Value will never be 0 or 1.
          bundleCount?: /* google.protobuf.Int32Value */ number | null;
          // The following fields are only defined for emails or summary/full views
          messagePreview?: /* google.protobuf.StringValue */ string | null;
          actionUrl?: /* google.protobuf.StringValue */ string | null;
          upvoteUrl?: /* google.protobuf.StringValue */ string | null;
          downvoteUrl?: /* google.protobuf.StringValue */ string | null;
          voteCount?: /* google.protobuf.Int32Value */ number | null;
          medalUrl?: /* google.protobuf.StringValue */ string | null;
        }

        export interface SubscribeToRequest {
          subscribe: Kaggle.Sdk.Notifications.Protos.SubscribeState;
          // Is the user being subscribed implictly (e.g. as a result of commenting) or explicitly (as a result of them clicking follow)
          // Implicit subscription never overwrites explicit unsubscribing
          isImplicit: boolean;
          id?: /* google.protobuf.Int32Value */ number | null;
          type: Kaggle.Sdk.Notifications.Protos.SubscriptionType;
          parentType: Kaggle.Sdk.Notifications.Protos.NotificationRelatedItemType;
          parentId?: /* google.protobuf.Int32Value */ number | null;
        }

        export enum CommandMark {
          READ = "read", // = 0
          VIEWED = "viewed", // = 1
        }
        export enum NotificationRelatedItemType {
          UNSPECIFIED = "unspecified", // = 0
          FORUM_MESSAGE = "forumMessage", // = 1
          KERNEL = "kernel", // = 2
          KERNEL_RUN = "kernelRun", // = 3
          USER_TIER_LOG = "userTierLog", // = 4
          USER_MEDAL = "userMedal", // = 5
          COMPETITION = "competition", // = 6
          DATASET = "dataset", // = 7
          TEAM = "team", // = 8
          DATASET_TASK = "datasetTask", // = 9
          DATASET_TASK_SOLUTION = "datasetTaskSolution", // = 10
        }
        export enum SubscribeState {
          INVALID = "invalid", // = 0
          UNSUBSCRIBE = "unsubscribe", // = 1
          // out of date, do not use except for back compat
          SUBSCRIBE_SINGLE = "subscribeSingle", // = 2
          SUBSCRIBE_ALL = "subscribeAll", // = 3
          // Forums
          FORUM_NEW_TOPICS = "forumNewTopics", // = 10
          FORUM_NEW_TOPICS_AND_COMMENTS = "forumNewTopicsAndComments", // = 11
          // Topic
          TOPIC_NEW_COMMENTS = "topicNewComments", // = 20
          // Kernels
          KERNEL_NEW_COMMENTS = "kernelNewComments", // = 30
          KERNEL_NEW_COMMENTS_AND_VERSIONS = "kernelNewCommentsAndVersions", // = 31
        }
        export enum SubscriptionType {
          NOT_APPLICABLE = "notApplicable", // = 0
          FORUM_TOPIC = "forumTopic", // = 1
          FORUM = "forum", // = 2
          KERNEL = "kernel", // = 3
        }
      }

      export namespace Requests {
        export interface AggregateNotificationEmailsRequest {
          aggregationType: "daily" | "noAggregation" | "weekly";
          maxToProcess: /*Int32*/ number;
          now: /*DateTime*/ string;
          daysOfWeekToSend:
            | ".ctor"
            | "friday"
            | "monday"
            | "saturday"
            | "sunday"
            | "thursday"
            | "tuesday"
            | "value__"
            | "wednesday"[];
        }

        export interface CleanupNotificationsRequest {
          lastRun: /*DateTime*/ string;
          totalRunTimeMs: /*Int64*/ number;
        }

        export interface CompetitionMilestonesDetectionRequest {}

        export interface ProcessMedalsRequest {
          lastProcessedMedalId: /*Int32*/ number;
        }

        export interface ProcessTierChangesRequest {
          lastProcessedMedalId: /*Int32*/ number;
        }

        export interface SendNotificationEmailsRequest {
          now: /*DateTime*/ string;
        }

        /*[ClientRequest]*/
        export interface SetUserNotificationSettingsRequest {
          userId: /*Int32*/ number;
          settings: Kaggle.Sdk.Notifications.Models.UserNotificationSettings | null;
        }

        /*[ClientRequest]*/
        export interface UserNotificationSettingsRequest {}
      }

      export interface NotificationsClient {}
    }

    export namespace ScheduledTasks {
      export namespace Requests {
        export interface AnonymizationZamboniRequest {}

        export interface BlockKernelsAbuseRequest {}

        export interface CleanActiveEvents {}

        export interface CleanPhoneReputationsRequest {}

        export interface CleanScriptQueueRequest {}

        export interface CleanupCompetitionKernelRerunsRequest {}

        export interface DeleteAccountsRequest {}

        export interface DeleteOldRecentlyViewedItemsConstants {}

        export interface DeleteOldRecentlyViewedItemsRequest {}

        export interface MigrateTermsAcceptancesRequest {}

        export interface RefreshRemoteDatasetUrlsRequest {}

        export interface SyncKernelBlobsRequest {}

        export interface UpdateDatasetEmailsRequest {}

        export interface UpdateDatasetScriptCountsRequest {}

        export interface UpdateDatasetUsabilityRatingsDailyRequest {}

        export interface UpdateDatasetUsabilityRatingsForKernelRunsRequest {}

        export interface UpdateKernelsHotnessRequest {}

        export interface UpdateSearchAggregatesRequest {}

        export interface UpdateSearchTrendsRequest {}
      }

      export namespace States {
        export interface BatchIndexSnippetsState {
          lastIndexedRowVersion: string | null;
          lastRunTime: /*DateTime*/ string;
          numberOfSnippetsToIndex: (/*Int32*/ number) | null;
          searchIndexResult: Kaggle.Sdk.Search.Protos.IndexSnippetResponse | null;
        }

        export interface CheckErroringSimulationAgentsState {
          erroringSubmissionIds: /*Int32*/ number;
        }

        export interface CheckServiceBrownoutsRequest {}

        export interface CheckSubmissionsHealthState {
          previousSubmissionRequestedTime: /*DateTime*/ string;
          workersUnresponsiveOnLastCheck: boolean;
          previousLongEstimatedWaitTimeSeverity: /*Double*/ number;
          previousWarnedSubmissionIds: (/*Int32*/ number)[];
        }

        export interface CountPlanCacheLog {
          dateTime: /*DateTime*/ string;
          count: /*Int32*/ number;
        }

        export interface CountPlanCacheState {
          dailyEntries: (Kaggle.Sdk.ScheduledTasks.States.CountPlanCacheLog)[];
          taskEntries: (Kaggle.Sdk.ScheduledTasks.States.CountPlanCacheLog)[];
        }

        export interface DeleteAnonymousKernelsConstants {}

        export interface DeleteAnonymousKernelsState {
          numberOfKernelsDeleted: /*Int32*/ number;
          lastRunTime: /*DateTime*/ string;
        }

        export interface DeleteOrphanedKernelBlobsState {
          blobsDeleted: /*Int32*/ number;
          blobsFailed: /*Int32*/ number;
          lastExpiryTime: /*DateTime*/ string;
        }

        export interface FeatureDatasetsState {
          lastEndDate: (/*DateTime*/ string) | null;
          processedRequestIds: (/*Int32*/ number)[];
        }

        export interface GenerateEpisodesState {
          totalEpisodes: /*Int32*/ number;
        }

        export interface SendNotificationEmailsState {
          startTime: /*DateTime*/ string;
          endTime: /*DateTime*/ string;
          numberProcessed: /*Int32*/ number;
          queryTimeMilliseconds: (/*Double*/ number) | null;
          markTimeMilliseconds: (/*Double*/ number) | null;
          loadTimeMilliseconds: (/*Double*/ number) | null;
          processTimeMilliseconds: (/*Double*/ number) | null;
          sendTimeMilliseconds: (/*Double*/ number) | null;
          logTimeMilliseconds: (/*Double*/ number) | null;
          slowNotifications: (Kaggle.Sdk.Notifications.Models.TimeTaken)[];
        }

        export interface TimeoutDatabundleVersionState {
          databundleVersionsScanned: /*Int32*/ number;
          databundleVersionsTimedOut: /*Int32*/ number;
          elapsedTimeMs: /*Int64*/ number;
        }

        export interface UpdateCompetitionCountsState {
          lastRunDate: /*DateTime*/ string;
          lastRunDuration: /*TimeSpan*/ string;
          lastRowVersion: string | null;
        }

        export interface UpdateKernelsBestPublicScoreState {
          lastRunTime: /*DateTime*/ string;
        }

        export interface UpdateTagFullPathState {
          lastEndDate: (/*DateTime*/ string) | null;
          totalTagsProcessed: /*Int32*/ number;
        }

        export interface ValidateSearchRankingsState {
          correctPercent: /*Double*/ number;
        }

        export interface WipeoutDatasetsState {
          lastEndDate: (/*DateTime*/ string) | null;
          processedIds: (/*Int32*/ number)[];
        }

        export interface WipeoutKernelsConstants {}

        export interface WipeoutKernelsState {
          successfullyProcessedKernels: /*Int32*/ number;
          unsuccessfullyProcessedKernels: /*Int32*/ number;
          lastRunTime: /*DateTime*/ string;
        }
      }

      export interface ScheduledTasksClient {}
    }

    export namespace Search {
      export namespace Models {
        export namespace Elastic {
          export interface BlogDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            blogTitle: string | null;
            blogSummary: string | null;
            blogUrl: string | null;
            blogImageUrl: string | null;
          }

          export interface CommentDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            commentForum: string | null;
            commentForumId: (/*Int64*/ number) | null;
            commentForumSlug: string | null;
            commentTopic: string | null;
            commentTopicId: (/*Int64*/ number) | null;
            commentContent: string | null;
            commentAuthor: string | null;
            commentAuthorUserId: (/*Int64*/ number) | null;
            commentAuthorThumbnail: string | null;
            commentTotalScore: /*Int64*/ number;
            commentDataSourceId: (/*Int64*/ number) | null;
            commentDataSourceType: string | null;
            commentDataSourceSlug: string | null;
            commentDataSourceOwnerSlug: string | null;
            commentDataset: string | null;
            commentCompetition: string | null;
            commentKernelIsDeleted: boolean | null;
          }

          export interface CompetitionDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            competitionSlug: string | null;
            competitionTitle: string | null;
            competitionDescription: string | null;
            competitionDeadline: /*DateTime*/ string;
            competitionIsKernelsOnly: boolean;
            competitionPrizeValue: (/*Decimal*/ number) | null;
            competitionTeamsCount: /*Int32*/ number;
            competitionHostSegment: string | null;
            competitionHostSegmentId: /*Int32*/ number;
            competitionEvaluationAlgorithm: string | null;
            competitionEvaluationAlgorithmId: (/*Int32*/ number) | null;
            competitionIsActive: boolean;
            competitionLongDescription: string | null;
            competitionRules: string | null;
            competitionEvaluation: string | null;
            competitionDataDescriptions: string | null;
            competitionPrizes: string | null;
            competitionCategories: (string)[];
            competitionAllCategories: (string)[];
            competitionCategoryFullPaths: (string)[];
            competitionCategoriesJson: string | null;
            competitionAllCategoriesJson: string | null;
            competitionCategoryFullPathsJson: string | null;
          }

          export interface CourseDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            courseHasDailyDelivery: boolean | null;
            courseLessonCount: /*Int64*/ number;
            courseDescription: string | null;
            courseName: string | null;
            courseAuthorIds: (/*Int64*/ number)[];
            courseAuthorUserNames: (string)[];
            courseAuthorDisplayNames: (string)[];
            coursePrerequisiteIds: (/*Int64*/ number)[];
            coursePrerequisiteForIds: (/*Int64*/ number)[];
            courseEstimatedTimeHours: /*Int64*/ number;
            courseAuthorIdsJson: string | null;
            courseAuthorUserNamesJson: string | null;
            courseAuthorDisplayNamesJson: string | null;
            coursePrerequisiteIdsJson: string | null;
            coursePrerequisiteForIdsJson: string | null;
          }

          export interface DatasetDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            datasetName: string | null;
            datasetOverview: string | null;
            datasetDescription: string | null;
            datasetSlug: string | null;
            datasetCreationDate: /*DateTime*/ string;
            datasetFeatureDate: (/*DateTime*/ string) | null;
            datasetSuperFeatureDate: (/*DateTime*/ string) | null;
            datasetThumbnail: string | null;
            datasetOwnerSlug: string | null;
            datasetTotalVotes: /*Int64*/ number;
            datasetLastActivityDate: /*DateTime*/ string;
            datasetLicenseId: /*Int32*/ number;
            datasetLicenseGroupIntId: /*Int32*/ number;
            datasetSize: (/*Int64*/ number) | null;
            datasetSizeGroup: string | null;
            datasetType: /*Int32*/ number;
            datasetFileCount: /*Int32*/ number;
            datasetFileNames: (string)[];
            datasetCategories: (string)[];
            datasetAllCategories: (string)[];
            datasetCategoryFullPaths: (string)[];
            datasetFileTypes: (string)[];
            datasetIsPublished: boolean;
            datasetFeatured: boolean;
            datasetIsSuperFeatured: boolean;
            datasetSegment: /*Int32*/ number;
            datasetUsabilityRating: (/*Double*/ number) | null;
            datasetTotalScripts: /*Int32*/ number;
            datasetFirestorePath: string | null;
            datasetMaintainerOrganizationId: (/*Int32*/ number) | null;
            datasetHotness: (/*Double*/ number) | null;
            datasetColumnNames: (string)[];
            datasetColumnTypes: (string)[];
            datasetColumnDescriptions: (string)[];
            datasetFileDescriptions: (string)[];
            datasetCreatorUserSlug: string | null;
            datasetDownloads: /*Int32*/ number;
            hasTasks: boolean;
            totalTasks: /*Int32*/ number;
            datasetFileNamesJson: string | null;
            datasetCategoriesJson: string | null;
            datasetAllCategoriesJson: string | null;
            datasetCategoryFullPathsJson: string | null;
            datasetFileTypesJson: string | null;
            datasetColumnNamesJson: string | null;
            datasetColumnTypesJson: string | null;
            datasetColumnDescriptionsJson: string | null;
            datasetFileDescriptionsJson: string | null;
          }

          export interface NotebookDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            kernelVersionId: /*Int32*/ number;
            kernelBlobId: (/*Int32*/ number) | null;
            kernelTitle: string | null;
            kernelContent: string | null;
            kernelAuthorUserId: /*Int64*/ number;
            kernelSearchableAuthorUserId: /*Int64*/ number;
            kernelAuthorThumbnail: string | null;
            kernelAuthorUserName: string | null;
            kernelVotes: /*Int64*/ number;
            kernelViews: /*Int64*/ number;
            kernelSlug: string | null;
            kernelDate: (/*DateTime*/ string) | null;
            kernelSecondsToRun: (/*Int32*/ number) | null;
            kernelIsFork: boolean;
            kernelIsNotebook: boolean;
            kernelLanguage: string | null;
            kernelLanguageGroup: string | null;
            kernelDataSourceType: string | null;
            kernelDataSourceName: string | null;
            kernelDataSourceSlug: string | null;
            kernelDataSourceOwnerSlug: string | null;
            kernelOutputFileTypeList: (string)[];
            kernelOutputFileGroupList: (string)[];
            kernelCategories: (string)[];
            kernelAllCategories: (string)[];
            kernelCategoryFullPaths: (string)[];
            totalComments: /*Int64*/ number;
            dateEvaluated: (/*DateTime*/ string) | null;
            kernelForkCount: /*Int64*/ number;
            kernelOutputFileTypeListJson: string | null;
            kernelOutputFileGroupListJson: string | null;
            kernelCategoriesJson: string | null;
            kernelAllCategoriesJson: string | null;
            kernelCategoryFullPathsJson: string | null;
          }

          export interface OrganizationDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            organizationName: string | null;
            organizationSlug: string | null;
            organizationImageUrl: string | null;
            organizationLocation: string | null;
            organizationDatasetCount: /*Int32*/ number;
            organizationCompetitionCount: /*Int32*/ number;
            organizationMemberCount: /*Int32*/ number;
          }

          export interface SearchDocument {
            id: string | null;
            contentType: string | null;
            dbId: /*Int32*/ number;
            title: string | null;
            subtitle: string | null;
            url: string | null;
            imageUrl: string | null;
            date: (/*DateTime*/ string) | null;
            authorUserId: (/*Int64*/ number) | null;
            authorUserName: string | null;
            authorDisplayName: string | null;
            searchHotness: /*Int64*/ number;
            votes: /*Int32*/ number;
            views: /*Int32*/ number;
            tag: (string)[];
            autoTag: (string)[];
            tagLeaves: (string)[];
            tagNodes: (string)[];
            autoTagNodes: (string)[];
            tagPaths: (string)[];
            ownerUserId: (/*Int64*/ number) | null;
            ownerOrganizationId: (/*Int64*/ number) | null;
            competitionIds: (/*Int64*/ number)[];
            datasetIds: (/*Int64*/ number)[];
            readGroupId: (/*Int64*/ number) | null;
            writeGroupId: (/*Int64*/ number) | null;
            isPrivate: boolean;
            isDeleted: boolean;
            rowVersion: (/*Byte*/ number)[];
            highWatermarkValue: string | null;
            tagJson: string | null;
            autoTagJson: string | null;
            tagLeavesJson: string | null;
            tagNodesJson: string | null;
            autoTagNodesJson: string | null;
            tagPathsJson: string | null;
            competitionIdsJson: string | null;
            datasetIdsJson: string | null;
          }

          export interface TopicDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            topicForum: string | null;
            topicForumId: /*Int32*/ number;
            topicForumSlug: string | null;
            topicName: string | null;
            topicMessage: string | null;
            topicAuthor: string | null;
            topicAuthorUserId: (/*Int64*/ number) | null;
            topicAuthorThumbnail: string | null;
            topicDate: /*DateTime*/ string;
            topicTotalComments: /*Int64*/ number;
            topicTotalViews: /*Int64*/ number;
            topicTotalScore: /*Int64*/ number;
            topicDataSourceType: string | null;
            topicDataSourceSlug: string | null;
            topicDataSourceOwnerSlug: string | null;
            topicDataset: string | null;
            topicCompetition: string | null;
            topicIsKernel: boolean;
          }

          export interface TutorialDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            tutorialCourseName: string | null;
            tutorialCourseDescription: string | null;
            tutorialExerciseId: (/*Int64*/ number) | null;
            tutorialExerciseTitle: string | null;
            tutorialExerciseSubtitle: string | null;
            tutorialExerciseUrl: string | null;
            tutorialExerciseImageUrl: string | null;
            tutorialExerciseDate: (/*DateTime*/ string) | null;
            tutorialExerciseAuthorUserId: (/*Int64*/ number) | null;
            tutorialExerciseAuthorUserName: string | null;
            tutorialExerciseAuthorDisplayName: string | null;
            tutorialExerciseVotes: (/*Int64*/ number) | null;
            tutorialExerciseViews: (/*Int64*/ number) | null;
          }

          export interface UserDocument
            extends Kaggle.Sdk.Search.Models.Elastic.SearchDocument {
            userName: string | null;
            userDisplay: string | null;
            userEmail: string | null;
            userImage: string | null;
            userPerformanceTier: /*Int32*/ number;
            userDescription: string | null;
            userLocation: string | null;
            userFollowerCount: /*Int32*/ number;
            userFollowingCount: /*Int32*/ number;
          }
        }

        export interface BlogPost {
          authorDisplayName: string | null;
          authorName: string | null;
          publishDate: /*DateTime*/ string;
          id: /*Int32*/ number;
          title: string | null;
          url: string | null;
        }

        export interface Constants {}

        export interface Filter {
          name:
            | "authorUserName"
            | "by"
            | "competitionEvaluationAlgorithm"
            | "datasetFileTypes"
            | "datasetLicense"
            | "datasetSize"
            | "datasetSizeGroup"
            | "date"
            | "in"
            | "kernelLanguage"
            | "sortBy"
            | "tag"
            | "viewedByYou";
          nestField: string | null;
          nestType: "date" | "integer" | "text";
          renderType: "checkbox" | "radio" | "text";

          values: (string)[];
          indexes: (string)[];
          categories: (
            | "blog"
            | "comment"
            | "competition"
            | "course"
            | "dataset"
            | "kernel"
            | "organization"
            | "topic"
            | "tutorial"
            | "unspecified"
            | "user")[];
        }

        export interface ParsedQuery {}
      }

      export namespace Protos {
        export interface CategoryFilter {
          name: Kaggle.Sdk.Search.Protos.DocumentType;
          count: number;
        }

        export interface CommentItemInfo {
          forumName: string;
          forumType: string;
          matchingText: string;
        }

        export interface CompetitionItemInfo {
          teamsCount: number;
          deadlineDate: /* google.protobuf.Timestamp */ string | null;
          prizeValue: number;
          hasEntered: boolean;
          type: Kaggle.Sdk.Competitions.Protos.HostSegment;
          isKernelsOnly: boolean;
        }

        export interface CompetitionsSearchRequest {}

        export interface CompetitionsSearchResponse {}

        export interface DatasetItemInfo {
          size: number;
          fileTypes: string[];
          kernelsCount: number;
          filesCount: number;
          maintainedByKaggle: boolean;
        }

        export interface DatasetsSearchRequest {}

        export interface DatasetsSearchResponse {}

        export interface FilterOption {
          name: string;
          count: number;
        }

        export interface FullSearchRequest {}

        export interface FullSearchResponse {}

        export interface FullSearchResponse {
          documents: Kaggle.Sdk.Search.Protos.SearchItem[];
          count: number;
          filters: Kaggle.Sdk.Search.Protos.SearchFilter[];
          categories: Kaggle.Sdk.Search.Protos.CategoryFilter[];
        }

        export interface GetAutoCompleteSuggestionsRequest {
          prefix: string;
        }

        export interface GetAutoCompleteSuggestionsResponse {
          autoCompleteSuggestions: string[];
        }

        export interface GetPopularTagsRequest {}

        export interface GetPopularTagsResponse {
          popularTags: Kaggle.Sdk.Search.Protos.FilterOption[];
        }

        export interface GetRecentSearchesRequest {
          userId?: /* google.protobuf.Int32Value */ number | null;
          // If empty, will not filter out any query histories based
          // on search indices.
          // List of specific search indices to limit the result to only
          // search queries made from these indices.
          specificSearchIndices: Kaggle.Sdk.Search.Protos.SearchIndex[];
        }

        export interface GetRecentSearchesResponse {
          recentSearches: string[];
        }

        export interface GetTrendingSearchesRequest {}

        export interface GetTrendingSearchesResponse {
          trendingSearches: string[];
        }

        export interface IndexSnippetRequest {}

        export interface IndexSnippetResponse {}

        export interface KernelItemInfo {
          languageGroup: string;
          secondsToRun: number;
          dataSource: string;
          forksCount: number;
        }

        export interface KernelsSearchRequest {}

        export interface KernelsSearchResponse {}

        export interface LogSearchRequest {
          index: string;
          isQuick: boolean;
          query: string;
          rank?: /* google.protobuf.Int32Value */ number | null;
          id?: /* google.protobuf.StringValue */ string | null;
          url?: /* google.protobuf.StringValue */ string | null;
          secondsSpentSearching: number;
          token?: /* google.protobuf.StringValue */ string | null;
          isPrivate?: /* google.protobuf.BoolValue */ boolean | null;
        }

        export interface OrganizationItemInfo {
          location: string;
          datasetCount: number;
          competitionCount: number;
          memberCount: number;
        }

        export interface QuickSearchRequest {}

        export interface QuickSearchResponse {}

        export interface SearchFilter {
          name: Kaggle.Sdk.Search.Protos.FilterName;
          type: Kaggle.Sdk.Search.Protos.FilterType;
          options: Kaggle.Sdk.Search.Protos.FilterOption[];
          categories: Kaggle.Sdk.Search.Protos.DocumentType[];
        }

        export interface SearchItem {
          id: string;
          documentType: Kaggle.Sdk.Search.Protos.DocumentType;
          databaseId: number;
          title: string;
          url: string;
          thumbnailImageUrl: string;
          rank: number;
          score: number;
          isPrivate: boolean;
          votes: number;
          date: /* google.protobuf.Timestamp */ string | null;
          authorSlug: string;
          authorDisplayName: string;
          commentInfo?: Kaggle.Sdk.Search.Protos.CommentItemInfo | null;
          competitionInfo?: Kaggle.Sdk.Search.Protos.CompetitionItemInfo | null;
          datasetInfo?: Kaggle.Sdk.Search.Protos.DatasetItemInfo | null;
          kernelInfo?: Kaggle.Sdk.Search.Protos.KernelItemInfo | null;
          topicInfo?: Kaggle.Sdk.Search.Protos.TopicItemInfo | null;
          userInfo?: Kaggle.Sdk.Search.Protos.UserItemInfo | null;
          organizationInfo?: Kaggle.Sdk.Search.Protos.OrganizationItemInfo | null;
          matchedText: string;
          isCreatedByCurrentUser: boolean;
        }

        export interface SearchResultGroup {
          documents: Kaggle.Sdk.Search.Protos.SearchItem[];
          type: Kaggle.Sdk.Search.Protos.DocumentType;
          count: number;
        }

        export interface SnippetsSearchRequest {}

        export interface SuggestedSearchRequest {}

        export interface SuggestedSearchResponse {}

        export interface SuggestedSearchResponse {
          groups: Kaggle.Sdk.Search.Protos.SearchResultGroup[];
        }

        export interface TimeSpentOnClickedResultRequest {
          seconds: number;
          resultToken: string;
        }

        export interface TopicItemInfo {
          creationDate: /* google.protobuf.Timestamp */ string | null;
          forumName: string;
          forumType: string;
          matchingText: string;
        }

        export interface TopicsSearchRequest {}

        export interface TopicsSearchResponse {}

        export interface UserItemInfo {
          kernelsCount: number;
          topicsCount: number;
          description: string;
          lastSeenDate: /* google.protobuf.Timestamp */ string | null;
          performanceTier: number;
          location: string;
        }

        export enum DocumentType {
          UNSPECIFIED = "unspecified", // = 0
          BLOG = "blog", // = 1
          COMPETITION = "competition", // = 2
          DATASET = "dataset", // = 3
          KERNEL = "kernel", // = 5
          COMMENT = "comment", // = 6
          ORGANIZATION = "organization", // = 7
          TOPIC = "topic", // = 8
          USER = "user", // = 9
          COURSE = "course", // = 10
          TUTORIAL = "tutorial", // = 11
        }
        export enum FilterName {
          DATE = "date", // = 0
          IN = "in", // = 1
          BY = "by", // = 2
          TAG = "tag", // = 3
          AUTHOR_USER_NAME = "authorUserName", // = 4
          SORT_BY = "sortBy", // = 6
          COMPETITION_EVALUATION_ALGORITHM = "competitionEvaluationAlgorithm", // = 7
          DATASET_LICENSE = "datasetLicense", // = 8
          DATASET_SIZE = "datasetSize", // = 9
          DATASET_SIZE_GROUP = "datasetSizeGroup", // = 10
          DATASET_FILE_TYPES = "datasetFileTypes", // = 11
          KERNEL_LANGUAGE = "kernelLanguage", // = 12
          VIEWED_BY_YOU = "viewedByYou", // = 13
        }
        export enum FilterType {
          RADIO = "radio", // = 0
          CHECKBOX = "checkbox", // = 1
          TEXT = "text", // = 2
        }
        // Specific search index name used to get/set in recent search
        // history results.
        export enum SearchIndex {
          UNSPECIFIED = "unspecified", // = 0
          COMPETITIONS = "competitions", // = 1
          DATASETS = "datasets", // = 2
          GLOBAL = "global", // = 3
          KERNELS = "kernels", // = 5
          TOPICS = "topics", // = 6
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface FullSearchWebRequest {
          query: string | null;
          page: /*Int32*/ number;
          resultsPerPage: /*Int32*/ number;
          showPrivate: boolean;
        }

        export interface ParseAndExtractQueryRequest {
          query: string | null;
        }

        /*[ClientRequest]*/
        export interface SuggestedSearchWebRequest {
          query: string | null;
        }
      }

      export interface SearchClient {}
    }

    export namespace Tags {
      export namespace Models {
        export interface NewTagTopic {
          currentUser: Kaggle.Sdk.Users.Protos.UserAvatar | null;
          currentUserIsAdmin: boolean;
          currentUserIsAnonymous: boolean;
          tag: Kaggle.Sdk.Tags.Protos.Tag | null;
        }

        export interface TagDetail {
          filter: "all" | "tagTopicsOnly";
          followerCount: /*Int32*/ number;
          isFollowing: boolean;
          relatedCommunities: (Kaggle.Sdk.Tags.Protos.Tag)[];
          tag: Kaggle.Sdk.Tags.Protos.Tag | null;
          tagFollowers: (Kaggle.Sdk.Users.Protos.UserAvatar)[];
          topContributors: (Kaggle.Sdk.Users.Protos.UserAvatar)[];
          topicSort:
            | "active"
            | "hot"
            | "new"
            | "recent"
            | "relevance"
            | "top"
            | "unspecified";
        }

        export interface TagList {
          type:
            | "competition"
            | "dataset"
            | "notebook"
            | "searchResult"
            | "task";
          tags: (Kaggle.Sdk.Tags.Protos.Tag)[];
        }
      }

      export namespace Protos {
        export interface CreateCompetitionTagsRequest {
          // The competition to tag
          competitionId: number;
          // The tags to apply
          tagIds: number[];
        }

        export interface CreateCompetitionTagsResponse {}

        export interface CreateLearnTrackTagsRequest {
          // The learn track to tag
          learnTrackId: number;
          // The tags to apply
          tagIds: number[];
        }

        export interface CreateLearnTrackTagsResponse {}

        export interface DeleteCompetitionTagsRequest {
          // The competition to untag
          competitionId: number;
          // The tags to remove
          tagIds: number[];
        }

        export interface DeleteCompetitionTagsResponse {}

        export interface DeleteLearnTrackTagsRequest {
          // The learn track to untag
          learnTrackId: number;
          // The tags to remove
          tagIds: number[];
        }

        export interface DeleteLearnTrackTagsResponse {}

        export interface GetTagHierarchyRequest {}

        export interface GetTagHierarchyResponse {
          // The roots of various tag linked lists
          roots: Kaggle.Sdk.Tags.Protos.TagNode[];
        }

        export interface ListTagsResponse {
          featuredTags: Kaggle.Sdk.Tags.Protos.Tag[];
          hotTags: Kaggle.Sdk.Tags.Protos.Tag[];
          tagsCount: number;
          pageSize: number;
        }

        export interface SearchTagsLegacyRequest {
          search?: /* google.protobuf.StringValue */ string | null;
          page: number;
        }

        export interface SearchTagsLegacyResponse {
          tags: Kaggle.Sdk.Tags.Protos.Tag[];
        }

        export interface Tag {
          // The unique identifier for a tag
          id: number;
          // The name of a tag
          name: string;
          // The complete path for a tag, showing its ancestors, separated by >
          fullPath: string;
          // The URL to link to an appropriate listing for the tag, e.g. datasets listing filtered by tag
          listingUrl: string;
          // The description for a given tag
          description?: /* google.protobuf.StringValue */ string | null;
          // The count of datasets tagged with a given tag
          datasetCount: number;
          // The count of competitions tagged with a given tag
          competitionCount: number;
          // The count of notebooks tagged with a given tag
          notebookCount: number;
          // The URL to link directly to a given tag
          tagUrl: string;
          // The display name for a given tag
          displayName: string;
          // Font Awesome icon used in some legacy spots for tags
          fontAwesomeIcon: string;
        }

        export interface TagDatasetTaskRequest {
          taskId: number;
          tagId: number;
        }

        export interface TagNode {
          // The current node's tag
          tag: Kaggle.Sdk.Tags.Protos.Tag | null;
          // Child nodes of the current node
          children: Kaggle.Sdk.Tags.Protos.TagNode[];
        }

        export interface UntagDatasetTaskRequest {
          taskId: number;
          tagIds: number[];
          rereview: boolean;
        }

        export interface UpdateForumTopicTagsRequest {
          // The forum topic to tag
          forumTopicId: number;
          // The set of tags to apply to the forum topic, any existing tags not in the set are removed
          tagIds: number[];
        }

        export interface UpdateForumTopicTagsResponse {}

        export interface UpdateTagFollowRequest {
          // The ID of the tag for which to toggle following state
          tagId: number;
        }

        export interface UpdateTagFollowResponse {
          // Boolean value indicating whether current user is following the tag
          isFollowing: boolean;
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface GetTagsByIdRequest {
          tagIds: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface GetTagsRequest {
          /*[NotNull]*/
          type:
            | "competition"
            | "dataset"
            | "notebook"
            | "searchResult"
            | "task";
          competitionId: (/*Int32*/ number) | null;
          datasetId: (/*Int32*/ number) | null;
          notebookId: (/*Int32*/ number) | null;
          /*[NotNull]*/
          showSystemTags: boolean;
          /*[NotNull]*/
          skip: /*Int32*/ number;
          /*[NotNull]*/
          take: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface SearchTagsRequest {
          /*[NotNull]*/
          searchType:
            | "competition"
            | "dataset"
            | "notebook"
            | "searchResult"
            | "task";
          searchQuery: string | null;
          showSystemTags: boolean;
          skip: /*Int32*/ number;
          take: /*Int32*/ number;
        }
      }

      export namespace Responses {
        export interface CategorizationResponse {
          status: "error" | "ok";
          message: string | null;
        }
      }

      export interface TagConstants {}

      export interface TagsClient {}
    }

    export namespace Users {
      export namespace Models {
        export interface Attribute {
          type:
            | "addressCity"
            | "addressCountry"
            | "addressRegion"
            | "bio"
            | "bookmarksCompetitionsMigrated"
            | "bookmarksDatasetsMigrated"
            | "bookmarksForumTopicsMigrated"
            | "bookmarksKernelsMigrated"
            | "dataScienceAndMachineLearningSurvey2020Interaction"
            | "discussionSettings"
            | "dismissableBannerNewsfeed"
            | "emailNudgesDisabled"
            | "employerNudgesDisabled"
            | "githubUserName"
            | "googleMlSummit2021Interaction"
            | "hatsLastClickDate"
            | "hatsLastDismissalDate"
            | "kernelEditorNotebooksDarkMode"
            | "kernelEditorScriptsDarkMode"
            | "linkedinUrl"
            | "notificationsAggregationType"
            | "notificationsAtMentionsSetting"
            | "notificationsBlockAllUserContactEmails"
            | "notificationsBlockCollaborationEmails"
            | "notificationsCompetitionAnnouncements"
            | "notificationsCompetitionTeamUpdates"
            | "notificationsDatasetAlerts"
            | "notificationsDefaultDeliverySetting"
            | "notificationsEnabled"
            | "notificationsEngagedTopicComment"
            | "notificationsNotebookAlerts"
            | "notificationsNotificationsAtMentionFollowedUser"
            | "notificationsNotificationsAtMentionRegularUser"
            | "notificationsSubscribeToKaggleNewsletter"
            | "notificationsUnsubscribedFromDatasetSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTaskEmail"
            | "notificationsUnsubscribedFromDatasetTaskSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTrendingSummaryEmail"
            | "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail"
            | "occupation"
            | "organization"
            | "registrationNewsEmailSignupWasOptOut"
            | "registrationReturnUrl"
            | "tagCommunityFilter"
            | "twitterUserName"
            | "unspecified"
            | "website";
          value: string | null;
        }

        export interface AttributeExtensions {}

        export interface Collaborator {
          userId: (/*Int32*/ number) | null;
          groupId: (/*Int32*/ number) | null;
          groupMemberCount: (/*Int32*/ number) | null;
          /*[NotNull]*/
          profileUrl: string;
          /*[NotNull]*/
          thumbnailUrl: string;
          /*[NotNull]*/
          name: string;
          /*[NotNull]*/
          slug: string;
          userTier: (/*Int32*/ number) | null;
          joinDate: (/*DateTime*/ string) | null;
          /*[NotNull]*/
          type: "owner" | "reader" | "unspecified" | "writer";
          isUser: boolean;
          isGroup: boolean;
        }

        export interface CollaboratorList {
          /*[NotNull]*/
          owner: Kaggle.Sdk.Users.Models.Collaborator;
          collaborators: (Kaggle.Sdk.Users.Models.Collaborator)[];
        }

        export interface ExtractedItem {
          id: (/*Int32*/ number) | null;
          newType:
            | "competition"
            | "dataset"
            | "forum"
            | "forumTopic"
            | "kernel"
            | "learnTrack"
            | null;
        }

        export interface Group {
          id: /*Int32*/ number;
          name: string | null;
          groupTypeId: /*Int32*/ number;
          groupTypeName: string | null;
          ownerCompetitionId: (/*Int32*/ number) | null;
          ownerDatsetId: (/*Int32*/ number) | null;
        }

        export interface GroupMember {
          userId: (/*Int32*/ number) | null;
          groupId: (/*Int32*/ number) | null;
          profileUrl: string | null;
          thumbnailUrl: string | null;
          name: string | null;
          slug: string | null;
          userTier: (/*Int32*/ number) | null;
          joinDate: (/*DateTime*/ string) | null;
          isUser: boolean;
          isGroup: boolean;
        }

        export interface IRecentlyViewedItemsReporter {}

        export interface ITracked {
          itemType:
            | "competition"
            | "dataset"
            | "forum"
            | "forumTopic"
            | "kernel"
            | "learnTrack";
        }

        export interface KaggleClaimTypes {}

        export interface KaggleProData {
          procurementAccountId: string | null;
        }

        export interface KernelAbuseMassBlockAccountsResponse {
          summary: (string)[];
        }

        export interface Organization {
          id: /*Int32*/ number;
          creationDate: /*DateTime*/ string;
          name: string | null;
          creatorUser: Kaggle.Sdk.Users.Models.User | null;
          url: string | null;
          thumbnailUrl: string | null;
          joinDate: /*DateTime*/ string;
          location: string | null;
          datasetCount: /*Int32*/ number;
          competitionCount: /*Int32*/ number;
          memberCount: /*Int32*/ number;
        }

        export interface Place {
          displayLocation: string | null;
          normalizedLocation: string | null;
        }

        export interface RecentlyViewedTrackedItems {
          actions: Record<string, Kaggle.Sdk.Users.Models.TrackedAction>;
          requests: Record<string, Kaggle.Sdk.Users.Models.TrackedRequest>;
        }

        export interface SimpleUserDto {
          avatarThumbnailUrl: string | null;
          displayName: string | null;
          profileUrl: string | null;
          tier: string | null;
          tierInt: /*Int32*/ number;
          userId: /*Int32*/ number;
          userName: string | null;
        }

        export interface Tokens {
          antiForgeryToken: string | null;
          kernelsInjectionToken: string | null;
        }

        export interface TrackedAction
          extends Kaggle.Sdk.Users.Models.ITracked {
          controller: string | null;
          action: string | null;
          itemType:
            | "competition"
            | "dataset"
            | "forum"
            | "forumTopic"
            | "kernel"
            | "learnTrack";
          slugPattern: string | null;
        }

        export interface TrackedRequest
          extends Kaggle.Sdk.Users.Models.ITracked {
          itemType:
            | "competition"
            | "dataset"
            | "forum"
            | "forumTopic"
            | "kernel"
            | "learnTrack";
          requestType: (/*Type*/ unknown) | null;
        }

        export interface User {
          id: (/*Int32*/ number) | null;
          displayName: string | null;
          email: string | null;
          editedEmail: string | null;
          editedEmailCode: (/*Guid*/ string) | null;
          userName: string | null;
          thumbnailUrl: string | null;
          profileUrl: string | null;
          registerDate: /*DateTime*/ string;
          lastVisitDate: /*DateTime*/ string;
          statusId: /*Byte*/ number;
          performanceTier: /*Int32*/ number;
          grandfatheredCompetitionTier: (/*Int32*/ number) | null;
          userLogins: (Kaggle.Sdk.Users.Models.UserLogin)[] | null;
          groupIds: (/*Int32*/ number)[] | null;
          duplicateUsers: (Kaggle.Sdk.Users.Models.User)[] | null;
          hasPhoneVerifications: boolean;
          failedNerdchas: /*Int32*/ number;
          hasPendingNerdcha: boolean;
          deleteRequests: (string)[] | null;
          isAdmin: boolean;
          isKaggleBot: boolean;
          isAnonymous: boolean;
          canAct: boolean;
          canBeSeen: boolean;
          thumbnailName: string | null;
          isPhoneVerified: boolean;
        }

        export interface UserAvatar {
          displayName: string | null;
          id: /*Int32*/ number;
          thumbnailUrl: string | null;
          tier:
            | "contributor"
            | "expert"
            | "grandmaster"
            | "master"
            | "novice"
            | "recalc"
            | "staff";
          userUrl: string | null;
        }

        export interface UserId {}

        export interface UserLogin {
          name: string | null;
          email: string | null;
          isDisabled: boolean;
          linkedDate: /*DateTime*/ string;
        }

        export interface UserPlanEventAccount {
          id: string | null;
          updateTime: /*DateTime*/ string;
        }

        export interface UserPlanEventEntitlement {
          id: string | null;
          updateTime: /*DateTime*/ string;
        }

        export interface UserSiteAcceptance {
          userName: string | null;
          acceptanceDate: /*DateTime*/ string;
          isPrivacyChecked: boolean;
          isTermsChecked: boolean;
        }

        export interface UserStatusLog {
          userId: /*Int32*/ number;
          statusId: /*Int32*/ number;
          logDate: /*DateTime*/ string;
          reason: string | null;
        }

        export interface UserSuggestion {
          id: /*Int32*/ number;
          userName: string | null;
          displayName: string | null;
          thumbnailUrl: string | null;
          profileUrl: string | null;
        }
      }

      export namespace Protos {
        export namespace GetUserOrganizationsResponse {
          export interface OrganizationCard {
            // Name of the organization
            name: string;
            // Link to the organization's page on kaggle
            url: string;
            // URL of the organization's profile image
            imageUrl: string;
          }
        }

        export interface AchievementTypeRanking {
          // The progression type for the ranking
          type: Kaggle.Sdk.Users.Protos.UserAchievementType;
          // The ranking for this user for the corresponding progression type
          ranking: number;
        }

        export interface ActivateMarketplaceUserRequest {
          // Id of that user in the external billing system.
          procurementAccountId: string;
        }

        export interface ActivateMarketplaceUserResponse {}

        export interface ActivityCalendar {
          // This name cannot be changed as react-calendar-heatmap relies on the name of this property being "date"
          date: /* google.protobuf.Timestamp */ string | null;
          totalSubmissionsCount: number;
          totalScriptsCount: number;
          totalDiscussionsCount: number;
          totalDatasetsCount: number;
        }

        export interface Bookmark {
          // The content type for a given Bookmark
          bookmarkType: Kaggle.Sdk.Users.Protos.BookmarkType;
          // The ID for the underlying entity, of content type bookmark_type
          bookmarkedEntityId: number;
        }

        export interface CancelMarketplaceActivationRequest {
          // Id of that user in the external billing system.
          procurementAccountId: string;
        }

        export interface CancelMarketplaceActivationResponse {}

        export interface CheckForNudgeRequest {}

        export interface CheckForNudgeResponse {
          potentialNudges: Kaggle.Sdk.Users.Protos.PotentialNudge[];
        }

        export interface ContactSupportRequest {
          name: string;
          email: string;
          responses: { [key: string]: string };
          question?: /* google.protobuf.StringValue */ string | null;
          requireCaptcha: boolean;
          captchaResponse?: /* google.protobuf.StringValue */ string | null;
        }

        export interface ConvertLegacyFavoritesRequest {
          // The content type to convert to Bookmarks
          bookmarkType: Kaggle.Sdk.Users.Protos.BookmarkType;
          // Enum indicating which conversion method to use, disposal or migration
          conversionMethod: Kaggle.Sdk.Users.Protos.ConversionMethod;
        }

        export interface ConvertLegacyFavoritesResponse {}

        export interface CreateBookmarkRequest {
          // A Bookmark message describing what Bookmark to create for the current user
          bookmark: Kaggle.Sdk.Users.Protos.Bookmark | null;
        }

        export interface CreateBookmarkResponse {}

        export interface CreatePhoneVerificationCodeRequest {
          // The phone number to send the code to
          phoneNumber: string;
          // The captcha response from the phone verification page
          captchaResponse: string;
          // The URL to return the user to after completing verification
          returnUrl: string;
        }

        export interface CreatePhoneVerificationCodeResponse {
          // Whether a code was successfully sent
          isSuccessful: boolean;
          // Whether the user is already phone verified
          isPhoneVerified: boolean;
          // The response message for the user
          message: string;
          // Whether the user is in India, requiring a different verification path
          isIndia: boolean;
        }

        export interface DeleteBookmarkRequest {
          // A Bookmark message describing what Bookmark to delete for the current user
          bookmark: Kaggle.Sdk.Users.Protos.Bookmark | null;
        }

        export interface DeleteBookmarkResponse {}

        export interface DeleteRecentlyViewedItemsRequest {
          userId: number;
        }

        export interface DeleteRecentlyViewedItemsResponse {}

        export interface DiscussionCounts {
          totalDiscussionsCount: number;
          totalTopicsCount: number;
          totalRepliesCount: number;
          totalUpvotesCount: number;
        }

        export interface DiscussionItem {
          id: number;
          totalScore: number;
          postTime: /* google.protobuf.Timestamp */ string | null;
          message: string;
          medal: Kaggle.Sdk.Users.Protos.Medal;
          attachments: Kaggle.Sdk.Discussions.Protos.CommentAttachment[];
          type: Kaggle.Sdk.Users.Protos.DiscussionType;
          script: Kaggle.Sdk.Discussions.Protos.DiscussionItemLink | null;
          forum: Kaggle.Sdk.Discussions.Protos.DiscussionItemLink | null;
          forumTopic: Kaggle.Sdk.Discussions.Protos.DiscussionItemLink | null;
          vote: Kaggle.Sdk.Discussions.Protos.CommentVoteButton | null;
        }

        export interface DismissHatsRequest {
          location: Kaggle.Sdk.Users.Protos.HatsLocation;
          userClickedLink: boolean;
        }

        export interface DismissHatsResponse {}

        export interface DismissSurveyRequest {
          location: Kaggle.Sdk.Users.Protos.HatsLocation;
          userClickedSurvey: boolean;
          surveyType: Kaggle.Sdk.Users.Protos.SurveyType;
        }

        export interface DismissSurveyResponse {}

        export interface ExpireApiTokensRequest {
          // Username of the user whose api tokens will be expired/invalidated.
          userName: string;
          // Why are we expiring api tokens of the user.
          reason: string;
        }

        export interface FollowUserRequest {
          // The username of the user to follow
          userName: string;
        }

        export interface FollowUserResponse {}

        export interface GenerateApiTokenRequest {}

        export interface GenerateApiTokenResponse {
          userName: string;
          apiToken: string;
        }

        export interface GetBookmarkMigrationStatusRequest {
          // The content type to fetch bookmark status for
          bookmarkType: Kaggle.Sdk.Users.Protos.BookmarkType;
        }

        export interface GetBookmarkMigrationStatusResponse {
          // Remaining legacy favorites to migrate to bookmarks
          remainingCount: number;
        }

        export interface GetCaptchaConfigRequest {
          // The ReCaptcha version. Valid values are `v2` or `v3`.
          version: string;
        }

        export interface GetCaptchaConfigResponse {
          // The ReCaptcha site key.
          siteKey: string;
          // Whether captcha verification is enabled.
          enabled: boolean;
        }

        export interface GetContactUserInfoRequest {}

        export interface GetContactUserInfoResponse {
          canSend: boolean;
          emailsRemaining: number;
          error: Kaggle.Sdk.Users.Protos.ContactUserInfoError;
        }

        export interface GetCurrentUserProgressionRequest {}

        export interface GetCurrentUserProgressionResponse {
          // Sets of requirements for each progression type for the user. A group consists of all requirements
          // for a given type (Competitions, Kernels, etc.) and tier (Expert, Master, etc.). A group can have
          // multiple requirements, where a single requirement may be "3 Gold Competition Medals".
          tierRequirementGroups: Kaggle.Sdk.Users.Protos.TierRequirementGroup[];
          // The user's ranking for each progression type
          achievementTypeRankings: Kaggle.Sdk.Users.Protos.AchievementTypeRanking[];
        }

        export interface GetNerdChallengeRequest {
          challengeIdToken?: string;
          userId?: number;
          createNewIfNoActiveChallenge: boolean;
          forceNewChallenge: boolean;
          newChallengeReason: string;
        }

        export interface GetNerdChallengeResponse {
          challengeIdToken: string;
          question: string;
        }

        export interface GetOrganizationsRequest {
          filter?: /* google.protobuf.StringValue */ string | null;
        }

        export interface GetOrganizationsResponse {
          organizations: Kaggle.Sdk.Users.Protos.OrganizationCard[];
        }

        export interface GetProfilePreviewRequest {
          // The user ID for whom to return a profile preview
          userId?: number;
          // The user name for whom to return a profile preview
          userName?: string;
        }

        export interface GetProfilePreviewResponse {
          // The requested user's user name
          userName: string;
          // The requested user's display name
          displayName: string;
          // The URL for the requested user's profile
          profileUrl: string;
          // The URL For the requested user's avatar
          thumbnailUrl: string;
          // The requested user's tier
          performanceTier: number;
          // The requested user's country
          country: string;
          // The requested user's region
          region: string;
          // The requested user's city
          city: string;
          // The requested user's occupation
          occupation: string;
          // Boolean indicating whether or not the current user is following the requested user
          isFollowing: boolean;
        }

        export interface GetRecentlyViewedItemsRequest {
          userId: number;
          itemCount: number;
        }

        export interface GetRecentlyViewedItemsResponse {
          recentlyViewedItems: Kaggle.Sdk.Users.Protos.RecentlyViewedItem[];
        }

        export interface GetUserActivityRequest {
          userName: string;
        }

        export interface GetUserActivityResponse {
          activities: Kaggle.Sdk.Users.Protos.ActivityCalendar[];
        }

        export interface GetUserDiscussionCountsRequest {
          userName: string;
        }

        export interface GetUserDiscussionMessagesRequest {
          userName: string;
          sortBy: Kaggle.Sdk.Users.Protos.DiscussionSortBy;
          group: Kaggle.Sdk.Users.Protos.DiscussionSelectionGroup;
          page: number;
        }

        export interface GetUserDiscussionMessagesResponse {
          messages: Kaggle.Sdk.Users.Protos.DiscussionItem[];
        }

        export interface GetUserHatsStatusRequest {
          location: Kaggle.Sdk.Users.Protos.HatsLocation;
        }

        export interface GetUserHatsStatusResponse {
          // Deprecated: use survey_type enum instead
          showPrompt: boolean;
          // Deprecated: used to show the 2020 diversity study
          showDiversityStudyPrompt: boolean;
          // What type of survey to show
          surveyType: Kaggle.Sdk.Users.Protos.SurveyType;
        }

        export interface GetUserOrganizationsRequest {
          // The id of the user to retrieve organizations for
          userId: number;
          // Which page to display (for pagination)
          page: number;
        }

        export interface GetUserOrganizationsResponse {
          // All the organizations for that user on the current page
          organizations: Kaggle.Sdk.Users.Protos.GetUserOrganizationsResponse.OrganizationCard[];
        }

        export interface GetUserPlanLogRequest {
          // Id of the user to change the history for. This request is admin-only.
          userId: number;
        }

        export interface GetUserPlanLogResponse {
          // History of plans for the requested user. If empty, it means the user is on the FREE plan by default.
          log: Kaggle.Sdk.Users.Protos.UserPlanLog[];
        }

        export interface GetUserPlanRequest {
          // Id of the user to get the info for (since the "free" / "pro" status should be public knowledge, other users
          // should be able to query that (not just for your own user) e.g. when viewing profile pages.
          userId: number;
        }

        export interface GetUserPlanResponse {
          // Enum reflecting the plan the requested user is currently on.
          currentPlan: Kaggle.Sdk.Users.Protos.UserPlan;
          // Optionally whether this plan expires at some future date. In most cases, this will be null.
          expiryDate: /* google.protobuf.Timestamp */ string | null;
          // When did the current plan come into effect.
          signupDate: /* google.protobuf.Timestamp */ string | null;
        }

        export interface GetUserRankingsRequest {
          group: Kaggle.Sdk.Users.Protos.AchievementSummaryType;
          page: number;
        }

        export interface LeaderboardCounts {
          tier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          count: number;
        }

        export interface LeaderboardsListItem {
          currentRanking?: /* google.protobuf.Int32Value */ number | null;
          displayName?: /* google.protobuf.StringValue */ string | null;
          thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
          userId: number;
          userUrl?: /* google.protobuf.StringValue */ string | null;
          tier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          points: number;
          joinTime: /* google.protobuf.Timestamp */ string | null;
          totalGoldMedals: number;
          totalSilverMedals: number;
          totalBronzeMedals: number;
        }

        export interface NewEmailRegistrationUserRequest {
          // The display name for the new user
          displayName: string;
          // The username for the new user
          userName: string;
          // The email for the new user
          email: string;
          // The password for the new user
          password: string;
          // The captcha response from the registration page
          captchaResponse: string;
          // Whether the new user wants to subscribe to receiving Kaggle news
          iWishToSubscribeToYourNewsletter: boolean;
          // The URL to redirect the user to after successful registration
          returnUrl: string;
          // Whether opt-out logic was used for the email signup
          newsEmailSignupWasOptOut: boolean;
        }

        export interface NewEmailRegistrationUserResponse {
          // The registration errors for each field on the form
          errors: Kaggle.Sdk.Users.Protos.RegistrationError[];
          // The user ID that was created for the user
          createdUserId: number;
        }

        export interface OrganizationCard {
          name: string;
          id: number;
          thumbnailImageUrl: string;
        }

        export interface PerformMedalCeremonyRequest {}

        export interface PotentialNudge {
          // What kind of nudge to show (or NO_NUDGE)
          type: Kaggle.Sdk.Users.Protos.NudgeType;
          // the pages that this nudge is allowed to show on
          page: Kaggle.Sdk.Users.Protos.NudgePage;
          // what priority value to use when evaluating which nudge to show to user. Higher priority value == more important
          priority: number;
          // What variant this nudge is. Variants are different versons of the same nudge
          // Currently no display differences between variants, it's only for selecting different groups of users
          variant?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface ReactToNudgeRequest {
          // Which nudge to dismiss
          nudgeId: number;
          // Whether the user acted upon the nudge (clicked the call to action) or just dismissed it
          reaction: Kaggle.Sdk.Users.Protos.NudgeReactions;
          // Whether the user wants these messages to never show for them again
          dontShowAgain: boolean;
        }

        export interface ReactToNudgeResponse {}

        export interface RecentlyViewedItem {
          title: string;
          url: string;
          itemType: Kaggle.Sdk.Users.Protos.RecentlyViewedItemType;
          authorSlug: string;
          mostRecentView: /* google.protobuf.Timestamp */ string | null;
          thumbnailUrl: string;
        }

        export interface RegistrationError {
          // The field on the registration form
          field: Kaggle.Sdk.Users.Protos.RegistrationInfoFields;
          // The ID of the message to display to the user
          messageId: Kaggle.Sdk.Users.Protos.LoginMessageId;
        }

        export interface RegistrationValidationRequest {
          // The display name for the new user
          displayName: string;
          // The username for the new user
          userName: string;
          // The email for the new user
          email: string;
          // The password for the new user
          password: string;
          // The captcha response from the registration page
          captcha: string;
        }

        export interface RegistrationValidationResponse {
          // The registration errors for each field on the form
          errors: Kaggle.Sdk.Users.Protos.RegistrationError[];
        }

        export interface SetCancelPlanReasonRequest {
          reason: Kaggle.Sdk.Users.Protos.CancelPlanReason;
        }

        export interface SetCancelPlanReasonResponse {}

        export interface ShowingNudgeRequest {
          // type of the nudge that the user will see
          type: Kaggle.Sdk.Users.Protos.NudgeType;
          // What variant the user will see
          variant?: /* google.protobuf.Int32Value */ number | null;
        }

        export interface ShowingNudgeResponse {
          // Unique Id to identify the nudge, used to dismiss
          // If value is 0 then this is a duplicate and the nudge should not be shown to the user
          userNudgeId: number;
        }

        export interface TierRequirement {
          // The copy shown to the user for the requirement
          label: string;
          // The call-to-action URL for the requirement
          url: string;
          // The total number required to satisfy the requirement
          numberRequired: number;
          // The current number of the requirement completed by the user
          numberMet: number;
        }

        export interface TierRequirementGroup {
          // The progression tier for the set of requirements
          tier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          // The progression type for the set of requirements
          type: Kaggle.Sdk.Users.Protos.UserAchievementType;
          // Whether the full set of requirements is complete
          isComplete: boolean;
          // Whether this progression type/tier is the current in-progress tier
          isInProgress: boolean;
          // The set of requirements for the type/tier
          requirements: Kaggle.Sdk.Users.Protos.TierRequirement[];
        }

        export interface UnfollowUserRequest {
          // The username of the user to unfollow
          userName: string;
        }

        export interface UnfollowUserResponse {}

        export interface UpdateBioRequest {
          // The new bio to be saved.
          bio: string;
          // The user this bio is for, usually the current user.
          userId: number;
        }

        export interface UpdateBioResponse {}

        export interface UpdateProfileRequest {
          // The Id of the user being updated
          userId?: number;
          // The username of the user being updated
          userName?: string;
          // The user's display name
          displayName?: /* google.protobuf.StringValue */ string | null;
          // The user's username in github
          gitHubUserName?: /* google.protobuf.StringValue */ string | null;
          // The user's username on twitter
          twitterUserName?: /* google.protobuf.StringValue */ string | null;
          // A url corresponding to the user's linked in page
          linkedInUrl?: /* google.protobuf.StringValue */ string | null;
          // City the user lives in
          city?: /* google.protobuf.StringValue */ string | null;
          // Region the user lives in (state, province etc)
          region?: /* google.protobuf.StringValue */ string | null;
          // Country the user lives in
          country?: /* google.protobuf.StringValue */ string | null;
          // User's current occupation
          occupation?: /* google.protobuf.StringValue */ string | null;
          // Organization user currently works for
          organization?: /* google.protobuf.StringValue */ string | null;
          // A link to the user's website
          website?: /* google.protobuf.StringValue */ string | null;
        }

        export interface UpdateProfileResponse {
          wasSuccessful: boolean;
          errorMessage?: /* google.protobuf.StringValue */ string | null;
          parsedTwitterUserName?: /* google.protobuf.StringValue */
            | string
            | null;
          parsedGitHubUserName?: /* google.protobuf.StringValue */
            | string
            | null;
          parsedLinkedInUrl?: /* google.protobuf.StringValue */ string | null;
          parsedWebsite?: /* google.protobuf.StringValue */ string | null;
          displayName?: /* google.protobuf.StringValue */ string | null;
        }

        export interface UpdateUserPlanRequest {
          // Id of the user to change the plan for. These requests will be only executed by a background service (which needs
          // to do this for arbitrary users).
          userId: number;
          // Enum reflecting the new plan.
          newPlan: Kaggle.Sdk.Users.Protos.UserPlan;
          // Optionally an effective date for the new plan. If this is null, the new plan is effective immediately.
          effectiveDate: /* google.protobuf.Timestamp */ string | null;
          // Optionally an end date for the new plan. If this is null, this plan won't expire unless a new plan is set.
          endDate: /* google.protobuf.Timestamp */ string | null;
          // Id of that user in the external billing system. Required for all paid plans, optional if new_plan is FREE.
          procurementAccountId: string;
        }

        export interface UpdateUserPlanResponse {}

        export interface User {
          id?: /* google.protobuf.Int32Value */ number | null;
          displayName?: /* google.protobuf.StringValue */ string | null;
          email: string;
          editedEmail?: /* google.protobuf.StringValue */ string | null;
          editedEmailCode?: /* google.protobuf.StringValue */ string | null;
          userName: string;
          thumbnailUrl: string;
          profileUrl: string;
          registerDate: /* google.protobuf.Timestamp */ string | null;
          lastVisitDate: /* google.protobuf.Timestamp */ string | null;
          statusId: number;
          performanceTier: number;
          userLogins: Kaggle.Sdk.Users.Protos.UserLogin[];
          groupIds: number[];
          duplicateUsers: Kaggle.Sdk.Users.Protos.User[];
          hasPhoneVerifications: boolean;
          failedNerdchas: number;
          hasPendingNerdcha: boolean;
          deleteRequests: string[];
          isAdmin: boolean;
          isKaggleBot: boolean;
          isAnonymous: boolean;
          canAct: boolean;
          canBeSeen: boolean;
          thumbnailName: string;
          isPhoneVerified: boolean;
        }

        export interface UserAvatar {
          // Display name for the given user
          displayName?: /* google.protobuf.StringValue */ string | null;
          // Thumbnail URL for the given user
          thumbnailUrl?: /* google.protobuf.StringValue */ string | null;
          // Profile URL for the given user
          url?: /* google.protobuf.StringValue */ string | null;
          // User name for the given user
          userName?: /* google.protobuf.StringValue */ string | null;
          // Tier for the given user
          tier: Kaggle.Sdk.Users.Protos.UserAchievementTier;
          // ID for the given user
          id: number;
        }

        export interface UserLogin {
          name: string;
          email: string;
          isDisabled: boolean;
          linkedDate: /* google.protobuf.Timestamp */ string | null;
        }

        export interface UserPlanLog {
          // The plan that was active between start_date and end_date
          plan: Kaggle.Sdk.Users.Protos.UserPlan;
          // When did the plan become active
          startDate: /* google.protobuf.Timestamp */ string | null;
          // Optionally an end date for the plan. If this is null, this plan is active and won't expire unless a new plan is set.
          endDate: /* google.protobuf.Timestamp */ string | null;
        }

        export interface UserRankings {
          group: Kaggle.Sdk.Users.Protos.AchievementSummaryType;
          userRanking: Kaggle.Sdk.Users.Protos.LeaderboardsListItem | null;
          totalUsers: number;
          counts: Kaggle.Sdk.Users.Protos.LeaderboardCounts[];
          list: Kaggle.Sdk.Users.Protos.LeaderboardsListItem[];
        }

        export interface VerifyAccountEmailRequest {
          // Codes either typed in by the user or clicked in new emails
          verificationCode: string;
          // The user to be verified
          userId: number;
          // Their return URL, used in case the email needs to be resent
          returnUrl: string;
        }

        export interface VerifyAccountEmailResponse {
          // The ID of the message to display to the user.
          messageId: Kaggle.Sdk.Users.Protos.LoginMessageId;
          // The user ID matching the provided verification code
          foundUserId: number;
          // The outcome of the verification
          outcome: Kaggle.Sdk.Users.Protos.VerifyOutcome;
        }

        export interface VerifyCaptchaRequest {
          // The ReCaptcha response token.
          token: string;
        }

        export interface VerifyCaptchaResponse {}

        export interface VerifyNerdChallengeAnswerRequest {
          challengeIdToken: string;
          answer: string;
          comment: string;
        }

        export interface VerifyNerdChallengeAnswerResponse {
          success: boolean;
          error: string;
          challengeIdToken: string;
          question: string;
          overrideUrl: string;
        }

        export interface VerifyPhoneVerificationCodeRequest {
          // The verification code entered by the user
          verificationCode: string;
          // Whether this phone number is being reassigned to a different account
          reassignPhoneNumber: boolean;
        }

        export interface VerifyPhoneVerificationCodeResponse {
          // Whether a code was successfully sent
          isSuccessful: boolean;
          // Whether the user is already phone verified
          isPhoneVerified: boolean;
          // The response message for the user
          message: string;
          // Whether this phone number can be reassigned to a different account
          canReassign: boolean;
          // Whether this phone number is a duplicate from another account
          isDuplicate: boolean;
        }

        // Used via WithErrorInfo
        export enum AccountError {
          UNSPECIFIED = "unspecified", // = 0
          // User needs to verify their phone number.
          PHONE_VERIFICATION_REQUIRED = "phoneVerificationRequired", // = 1
        }
        export enum AchievementSummaryType {
          UNSPECIFIED = "unspecified", // = 0
          COMPETITIONS = "competitions", // = 1
          NOTEBOOKS = "notebooks", // = 2
          DISCUSSION = "discussion", // = 3
          DATASETS = "datasets", // = 4
        }
        export enum BookmarkType {
          UNSPECIFIED = "unspecified", // = 0
          COMPETITION = "competition", // = 1
          DATASET = "dataset", // = 2
          FORUM_TOPIC = "forumTopic", // = 3
          KERNEL = "kernel", // = 4
        }
        export enum CancelPlanReason {
          OTHER = "other", // = 0
          TOO_EXPENSIVE = "tooExpensive", // = 1
          TEMPORARILY_LEAVING = "temporarilyLeaving", // = 2
          INSUFFICIENT_COMPUTE = "insufficientCompute", // = 3
        }
        export enum CollaboratorType {
          UNSPECIFIED = "unspecified", // = 0
          READER = "reader", // = 1
          WRITER = "writer", // = 2
          OWNER = "owner", // = 3
        }
        export enum ContactUserInfoError {
          UNSPECIFIED = "unspecified", // = 0
          CONTACT_USER_INFO_NOVICE_USER = "contactUserInfoNoviceUser", // = 1
          CONTACT_USER_INFO_QUOTA_REACHED = "contactUserInfoQuotaReached", // = 2
        }
        export enum ConversionMethod {
          UNSPECIFIED = "unspecified", // = 0
          MIGRATE = "migrate", // = 1
          DISPOSE = "dispose", // = 2
        }
        export enum DiscussionSelectionGroup {
          UNSPECIFIED = "unspecified", // = 0
          COMMENTS_AND_TOPICS = "commentsAndTopics", // = 1
          COMMENTS = "comments", // = 2
          TOPICS = "topics", // = 3
          UPVOTED = "upvoted", // = 4
        }
        export enum DiscussionSortBy {
          UNSPECIFIED = "unspecified", // = 0
          LATEST_POST = "latestPost", // = 1
          MOST_VOTES = "mostVotes", // = 2
        }
        export enum DiscussionType {
          UNSPECIFIED = "unspecified", // = 0
          SCRIPT_COMMENT = "scriptComment", // = 1
          FORUM_TOPIC = "forumTopic", // = 2
          FORUM_MESSAGE = "forumMessage", // = 3
        }
        export enum HatsLocation {
          UNSPECIFIED = "unspecified", // = 0
          HOMEPAGE = "homepage", // = 1
          COMPETITIONS = "competitions", // = 2
          DATASETS = "datasets", // = 3
          NOTEBOOKS = "notebooks", // = 4
          COURSES = "courses", // = 5
          DISCUSSIONS = "discussions", // = 6
        }
        // These aren't fully qualified because the transpilier is including the prefix
        // on the enum value for some reason
        export enum LoginMessageId {
          UNSPECIFIED = "unspecified", // = 0
          UNKNOWN = "unknown", // = 1
          LOCKED_OUT = "lockedOut", // = 2
          INVALID_LOGIN = "invalidLogin", // = 3
          INVALID_GOOGLE_SSO = "invalidGoogleSso", // = 4
          MISSING_LOGIN = "missingLogin", // = 5
          DISABLED_LOGIN = "disabledLogin", // = 6
          INTERNAL_ERROR = "internalError", // = 7
          BANNED_LOGIN = "bannedLogin", // = 8
          ALREADY_CONFIRMED = "alreadyConfirmed", // = 9
          EXPIRED_CODE = "expiredCode", // = 10
          GOOGLE_SSO_EMAIL_MISSING = "googleSsoEmailMissing", // = 11
          GOOGLE_LINK_SUCCESS = "googleLinkSuccess", // = 12
          GOOGLE_SSO_INACTIVE = "googleSsoInactive", // = 13
          ADMINS_USE_GOOGLE = "adminsUseGoogle", // = 14
          ADMINS_USE_GOOGLE_EMAIL = "adminsUseGoogleEmail", // = 15
          DATASETS_WELCOME = "datasetsWelcome", // = 16
          CAPTCHA_MISSING = "captchaMissing", // = 17
          USERNAME_TAKEN = "usernameTaken", // = 18
          USERNAME_NUMBER = "usernameNumber", // = 19
          USERNAME_ALPHANUMERIC = "usernameAlphanumeric", // = 20
          USERNAME_MIN_LENGTH = "usernameMinLength", // = 21
          USERNAME_MAX_LENGTH = "usernameMaxLength", // = 22
          FULL_NAME_LENGTH = "fullNameLength", // = 23
          EMAIL_EXISTS = "emailExists", // = 24
          EMAIL_LENGTH = "emailLength", // = 25
          INVALID_EMAIL = "invalidEmail", // = 26
          PASSWORD_TOO_SHORT = "passwordTooShort", // = 27
          DATASETS_LOGIN = "datasetsLogin", // = 28
          TOPIC_LOGIN = "topicLogin", // = 29
          VOTE_LOGIN = "voteLogin", // = 30
          CONTACT_USERS = "contactUsers", // = 31
          USE_GOOGLE_SSO = "useGoogleSso", // = 32
          MISSING_EMAIL = "missingEmail", // = 33
          MISSING_USER_NAME = "missingUserName", // = 34
          MISSING_DISPLAY_NAME = "missingDisplayName", // = 35
          MISSING_PASSWORD = "missingPassword", // = 36
          BOOKMARK_LOGIN = "bookmarkLogin", // = 37
        }
        export enum Medal {
          UNSPECIFIED = "unspecified", // = 0
          GOLD = "gold", // = 1
          SILVER = "silver", // = 2
          BRONZE = "bronze", // = 3
        }
        export enum NudgePage {
          ANY = "any", // = 0
          COMPETITIONS = "competitions", // = 1
          PROFILE = "profile", // = 2
          LANDING = "landing", // = 3
        }
        export enum NudgeReactions {
          REASON_UNSPECIFIED = "reasonUnspecified", // = 0
          USER_DISMISSED = "userDismissed", // = 1
          ACCEPTED = "accepted", // = 2
          AUTO_DISMISSED = "autoDismissed", // = 3
        }
        // These values should match Ids of Nudge table
        export enum NudgeType {
          UNSPECIFIED = "unspecified", // = 0
          INTRODUCE_YOURSELF = "introduceYourself", // = 1
          GETTING_NOTICED = "gettingNoticed", // = 2
          PROMOTED = "promoted", // = 3
          STILL_WORK_AT = "stillWorkAt", // = 4
          COMPETITION_EMAIL = "competitionEmail", // = 5
          BRAND_NEW = "brandNew", // = 6
          DATASET_GRAB_AND_GO = "datasetGrabAndGo", // = 7
          NEWLY_RETURNED = "newlyReturned", // = 8
        }
        export enum RecentlyViewedItemType {
          UNSPECIFIED = "unspecified", // = 0
          COMPETITION = "competition", // = 1
          DATASET = "dataset", // = 2
          KERNEL = "kernel", // = 4
          TOPIC = "topic", // = 5
          COURSE = "course", // = 6
        }
        export enum RegistrationInfoFields {
          UNSPECIFIED = "unspecified", // = 0
          USER_NAME = "userName", // = 1
          DISPLAY_NAME = "displayName", // = 2
          EMAIL = "email", // = 3
          PASSWORD = "password", // = 4
          CAPTCHA = "captcha", // = 5
        }
        export enum SurveyType {
          UNSPECIFIED = "unspecified", // = 0
          HATS = "hats", // = 1
          DATA_SCIENCE_AND_MACHINE_LEARNING_SURVEY_2020 = "dataScienceAndMachineLearningSurvey2020", // = 2
          GOOGLE_CLOUD_ML_SUMMIT_2021 = "googleCloudMlSummit2021", // = 3
        }
        export enum UserAchievementTier {
          NOVICE = "novice", // = 0
          CONTRIBUTOR = "contributor", // = 1
          EXPERT = "expert", // = 2
          MASTER = "master", // = 3
          GRANDMASTER = "grandmaster", // = 4
          // Kaggle admins
          STAFF = "staff", // = 5
          // Flag user for tier recalculation
          RECALC = "recalc", // = 21
        }
        export enum UserAchievementType {
          UNSPECIFIED = "unspecified", // = 0
          COMPETITIONS = "competitions", // = 1
          NOTEBOOKS = "notebooks", // = 2
          DISCUSSION = "discussion", // = 3
          DATASETS = "datasets", // = 4
        }
        export enum UserPlan {
          FREE = "free", // = 0
          KAGGLE_PRO = "kagglePro", // = 1
        }
        export enum VerifyOutcome {
          UNSPECIFIED = "unspecified", // = 0
          INVALID = "invalid", // = 1
          SUCCESS = "success", // = 2
          RETRY_ERROR = "retryError", // = 3
          NERDCHA = "nerdcha", // = 4
          ALREADY_VERIFIED = "alreadyVerified", // = 5
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface AcceptCookiesRequest {}

        /*[ClientRequest]*/
        export interface ActivateAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
          verificationCode: string | null;
        }

        export interface AddMemberToDatasetGroupRequest {
          datasetId: /*Int32*/ number;
          userId: /*Int32*/ number;
          isReader: boolean;
          isWriter: boolean;
          currentReaderGroupId: (/*Int32*/ number) | null;
          currentWriterGroupId: (/*Int32*/ number) | null;
        }

        export interface BlockAccountAndIssueNerdChallengeRequest {
          userId: /*Int32*/ number;
          reason: string | null;
          forumMessageId: (/*Int32*/ number) | null;
        }

        export interface CallbackFromSSOLinkRequest {
          loginIdentifier: string | null;
          userLoginProviderId: /*Int32*/ number;
          providerName: string | null;
          email: string | null;
          friendlyIdentifierForDisplay: string | null;
          userId: (/*Int32*/ number) | null;
          code: string | null;
          returnUrl: string | null;
        }

        export interface CanCurrentUserDownvoteRequest {}

        export interface CanDownvoteRequest {
          userId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface CanSeeFeatureRequest {
          feature: string | null;
        }

        /*[ClientRequest]*/
        export interface CheatBlockAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
        }

        export interface CheckInvalidLoginAttemptsAndLockOutRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface CreateKaggleAccountRequest {
          userId: /*Int32*/ number;
          password: string | null;
        }

        /*[ClientRequest]*/
        export interface DeleteOrganizationMembershipsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteOrganizationRequest {
          organizationId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeletePhoneVerificationsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteUserContentBlobsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteUserLoginsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface FailNerdchaRequest {
          userId: /*Int32*/ number;
        }

        export interface ForbiddenPrefixesContainsRequest {
          prefixToCheck: string | null;
        }

        export interface GetAdminCurrentUserRequest {
          exceptionMessage: string | null;
        }

        export interface GetAuthenticatedCurrentUserIdRequest {
          exceptionMessage: string | null;
        }

        export interface GetAuthenticatedCurrentUserRequest {
          exceptionMessage: string | null;
          includeGroups: boolean | null;
        }

        export interface GetCollaboratorListRequest {
          ownerId: /*Int32*/ number;
          isOrganization: boolean;
          readerGroupId: (/*Int32*/ number) | null;
          writerGroupId: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface GetCurrentUserClaimsRequest {}

        /*[ClientRequest]*/
        export interface GetCurrentUserIdRequest {}

        export interface GetCurrentUserLooksSuspiciousRequest {
          currentUser: Kaggle.Sdk.Users.Models.User | null;
        }

        /*[ClientRequest]*/
        export interface GetCurrentUserRequest {
          includeGroups: boolean | null;
        }

        /*[ClientRequest]*/
        export interface GetDuplicateUsersRequest {
          userId: /*Int32*/ number;
        }

        export interface GetGroupMembersRequest {
          groupId: /*Int32*/ number;
        }

        export interface GetGroupRequest {
          groupId: /*Int32*/ number;
        }

        export interface GetGroupsByUserRequest {
          userId: /*Int32*/ number;
          groupTypes: (/*Int32*/ number)[];
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Users.Models.Group
          >;
        }

        /*[ClientRequest]*/
        export interface GetMyAttributesRequest {
          attributes: (
            | "addressCity"
            | "addressCountry"
            | "addressRegion"
            | "bio"
            | "bookmarksCompetitionsMigrated"
            | "bookmarksDatasetsMigrated"
            | "bookmarksForumTopicsMigrated"
            | "bookmarksKernelsMigrated"
            | "dataScienceAndMachineLearningSurvey2020Interaction"
            | "discussionSettings"
            | "dismissableBannerNewsfeed"
            | "emailNudgesDisabled"
            | "employerNudgesDisabled"
            | "githubUserName"
            | "googleMlSummit2021Interaction"
            | "hatsLastClickDate"
            | "hatsLastDismissalDate"
            | "kernelEditorNotebooksDarkMode"
            | "kernelEditorScriptsDarkMode"
            | "linkedinUrl"
            | "notificationsAggregationType"
            | "notificationsAtMentionsSetting"
            | "notificationsBlockAllUserContactEmails"
            | "notificationsBlockCollaborationEmails"
            | "notificationsCompetitionAnnouncements"
            | "notificationsCompetitionTeamUpdates"
            | "notificationsDatasetAlerts"
            | "notificationsDefaultDeliverySetting"
            | "notificationsEnabled"
            | "notificationsEngagedTopicComment"
            | "notificationsNotebookAlerts"
            | "notificationsNotificationsAtMentionFollowedUser"
            | "notificationsNotificationsAtMentionRegularUser"
            | "notificationsSubscribeToKaggleNewsletter"
            | "notificationsUnsubscribedFromDatasetSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTaskEmail"
            | "notificationsUnsubscribedFromDatasetTaskSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTrendingSummaryEmail"
            | "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail"
            | "occupation"
            | "organization"
            | "registrationNewsEmailSignupWasOptOut"
            | "registrationReturnUrl"
            | "tagCommunityFilter"
            | "twitterUserName"
            | "unspecified"
            | "website")[];
        }

        /*[ClientRequest]*/
        export interface GetNewPasswordRequest {}

        export interface GetOrgIdsByUserRequest {
          userId: /*Int32*/ number;
        }

        export interface GetUserAttributeRequest {
          userId: (/*Int32*/ number) | null;
          attribute:
            | "addressCity"
            | "addressCountry"
            | "addressRegion"
            | "bio"
            | "bookmarksCompetitionsMigrated"
            | "bookmarksDatasetsMigrated"
            | "bookmarksForumTopicsMigrated"
            | "bookmarksKernelsMigrated"
            | "dataScienceAndMachineLearningSurvey2020Interaction"
            | "discussionSettings"
            | "dismissableBannerNewsfeed"
            | "emailNudgesDisabled"
            | "employerNudgesDisabled"
            | "githubUserName"
            | "googleMlSummit2021Interaction"
            | "hatsLastClickDate"
            | "hatsLastDismissalDate"
            | "kernelEditorNotebooksDarkMode"
            | "kernelEditorScriptsDarkMode"
            | "linkedinUrl"
            | "notificationsAggregationType"
            | "notificationsAtMentionsSetting"
            | "notificationsBlockAllUserContactEmails"
            | "notificationsBlockCollaborationEmails"
            | "notificationsCompetitionAnnouncements"
            | "notificationsCompetitionTeamUpdates"
            | "notificationsDatasetAlerts"
            | "notificationsDefaultDeliverySetting"
            | "notificationsEnabled"
            | "notificationsEngagedTopicComment"
            | "notificationsNotebookAlerts"
            | "notificationsNotificationsAtMentionFollowedUser"
            | "notificationsNotificationsAtMentionRegularUser"
            | "notificationsSubscribeToKaggleNewsletter"
            | "notificationsUnsubscribedFromDatasetSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTaskEmail"
            | "notificationsUnsubscribedFromDatasetTaskSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTrendingSummaryEmail"
            | "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail"
            | "occupation"
            | "organization"
            | "registrationNewsEmailSignupWasOptOut"
            | "registrationReturnUrl"
            | "tagCommunityFilter"
            | "twitterUserName"
            | "unspecified"
            | "website";
        }

        /*[ClientRequest]*/
        export interface GetUserCountRequest {}

        export interface GetUserIdByLoginlessTokenRequest {
          loginlessToken: /*Guid*/ string;
        }

        /*[ClientRequest]*/
        export interface GetUserRequest {
          userId: (/*Int32*/ number) | null;
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Users.Models.User
          >;
        }

        export interface GetUserSiteMapUrlsRequest {}

        /*[ClientRequest]*/
        export interface GetUserStatusLogsRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface GrantSiteAdminRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface HardDeleteAccountRequest {
          userId: /*Int32*/ number;
        }

        export interface HardDeleteReadyAccountsRequest {}

        export interface IsAdminRequest {
          userId: (/*Int32*/ number) | null;
        }

        export interface IsCurrentUserAdminRequest {}

        export interface IsUserCreatorOfOrgRequest {
          userId: (/*Int32*/ number) | null;
          organizationId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface KernelAbuseBlockAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
        }

        /*[ClientRequest]*/
        export interface KernelAbuseMassBlockAccountsRequest {
          userIds: (/*Int32*/ number)[];
          reason: string | null;
        }

        /*[ClientRequest]*/
        export interface LockOutAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
        }

        export interface LogUserPlanSummaryRequest {}

        /*[ClientRequest]*/
        export interface MigrateTermsAcceptancesRequest {
          date: /*DateTime*/ string;
          pageSize: /*Int32*/ number;
          pagesToRetrievePerRun: /*Int32*/ number;
        }

        export interface QueueTrackedActionRequest {
          actionName: string | null;
          controllerName: string | null;
          httpStatusCode: /*Int32*/ number;
          requestedPathAndQuery: string | null;
          userId: (/*Int32*/ number) | null;
        }

        export interface QueueTrackedRequestRequest {
          request: (/*Object*/ unknown) | null;
          userId: (/*Int32*/ number) | null;
        }

        export interface RecordRecentlyViewedItemRequest {
          itemId: (/*Int32*/ number) | null;
          itemType:
            | "competition"
            | "dataset"
            | "forum"
            | "forumTopic"
            | "kernel"
            | "learnTrack";
          userId: /*Int32*/ number;
          visitTime: /*DateTime*/ string;
        }

        export interface RemoveAllMembersRequest {
          groupId: /*Int32*/ number;
        }

        export interface RemoveGroupRequest {
          groupId: /*Int32*/ number;
        }

        export interface RemoveMemberRequest {
          groupId: /*Int32*/ number;
          userId: /*Int32*/ number;
        }

        export interface RequireAdminUserRequest {
          exceptionMessage: string | null;
        }

        export interface RequireAuthenticationRequest {
          exceptionMessage: string | null;
        }

        /*[ClientRequest]*/
        export interface ResendVerificationEmailRequest {
          email: string | null;
          userId: (/*Int32*/ number) | null;
          returnUrl: string | null;
        }

        /*[ClientRequest]*/
        export interface ResetPasswordRequest {
          userId: /*Int32*/ number;
          resetPasswordCode: string | null;
          password: string | null;
        }

        export interface ResumeActionRequest {
          action: "vote";
          queryString: (/*NameValueCollection*/ unknown) | null;
        }

        /*[ClientRequest]*/
        export interface RevokeSiteAdminRequest {
          userId: /*Int32*/ number;
        }

        export interface SearchOrganizationsRequest {
          ids: (/*Int32*/ number)[];
        }

        /*[ClientRequest]*/
        export interface SearchPlacesRequest {
          input: string | null;
        }

        export interface SearchUsersRequest {
          userIds: (/*Int32*/ number)[];
          usernames: (string)[];
          page: (/*Int32*/ number) | null;
          pageSize: /*Int32*/ number;
          selection: Kaggle.Framework.Service.Selection<
            Kaggle.Sdk.Users.Models.User
          >;
          teammateOf: (/*Int32*/ number) | null;
        }

        /*[ClientRequest]*/
        export interface SearchUsersSuggestionsRequest {
          pageSize: /*Int32*/ number;
          query: string | null;
          topicId: (/*Int32*/ number) | null;
        }

        export interface SetCollaboratorsRequest {
          parentEntityDescription: string | null;
          parentEntityId: /*Int32*/ number;
          collaborators: Kaggle.Sdk.Users.Models.CollaboratorList | null;
          currentReaderGroupId: (/*Int32*/ number) | null;
          currentWriterGroupId: (/*Int32*/ number) | null;
          readerGroupTypeId: /*Int32*/ number;
          writerGroupTypeId: /*Int32*/ number;
        }

        export interface SetDatasetCollaboratorsRequest
          extends Kaggle.Sdk.Users.Requests.SetCollaboratorsRequest {
          parentEntityDescription: string | null;
          readerGroupTypeId: /*Int32*/ number;
          writerGroupTypeId: /*Int32*/ number;
        }

        export interface SetKernelCollaboratorsRequest
          extends Kaggle.Sdk.Users.Requests.SetCollaboratorsRequest {
          parentEntityDescription: string | null;
          readerGroupTypeId: /*Int32*/ number;
          writerGroupTypeId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface SetMyAttributesRequest {
          attributes: Record<string, string>;
        }

        export interface SetUserAttributeRequest {
          userId: /*Int32*/ number;
          attributeId:
            | "addressCity"
            | "addressCountry"
            | "addressRegion"
            | "bio"
            | "bookmarksCompetitionsMigrated"
            | "bookmarksDatasetsMigrated"
            | "bookmarksForumTopicsMigrated"
            | "bookmarksKernelsMigrated"
            | "dataScienceAndMachineLearningSurvey2020Interaction"
            | "discussionSettings"
            | "dismissableBannerNewsfeed"
            | "emailNudgesDisabled"
            | "employerNudgesDisabled"
            | "githubUserName"
            | "googleMlSummit2021Interaction"
            | "hatsLastClickDate"
            | "hatsLastDismissalDate"
            | "kernelEditorNotebooksDarkMode"
            | "kernelEditorScriptsDarkMode"
            | "linkedinUrl"
            | "notificationsAggregationType"
            | "notificationsAtMentionsSetting"
            | "notificationsBlockAllUserContactEmails"
            | "notificationsBlockCollaborationEmails"
            | "notificationsCompetitionAnnouncements"
            | "notificationsCompetitionTeamUpdates"
            | "notificationsDatasetAlerts"
            | "notificationsDefaultDeliverySetting"
            | "notificationsEnabled"
            | "notificationsEngagedTopicComment"
            | "notificationsNotebookAlerts"
            | "notificationsNotificationsAtMentionFollowedUser"
            | "notificationsNotificationsAtMentionRegularUser"
            | "notificationsSubscribeToKaggleNewsletter"
            | "notificationsUnsubscribedFromDatasetSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTaskEmail"
            | "notificationsUnsubscribedFromDatasetTaskSummaryEmail"
            | "notificationsUnsubscribedFromDatasetTrendingSummaryEmail"
            | "notificationsUnsubscribedFromPrivateDatasetTaskSummaryEmail"
            | "occupation"
            | "organization"
            | "registrationNewsEmailSignupWasOptOut"
            | "registrationReturnUrl"
            | "tagCommunityFilter"
            | "twitterUserName"
            | "unspecified"
            | "website";
          value: string | null;
        }

        export interface SetUserAttributesRequest {
          userId: /*Int32*/ number;
          attributes: Record<string, string>;
        }

        /*[ClientRequest]*/
        export interface SoftDeleteAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
        }

        /*[ClientRequest]*/
        export interface SpamBlockAccountRequest {
          userId: /*Int32*/ number;
          reason: string | null;
        }

        /*[ClientRequest]*/
        export interface SpamBlockMultipleAccountRequest {
          userIdList: string | null;
          reason: string | null;
        }

        /*[ClientRequest]*/
        export interface StartMigrateSsoRequest {
          email: string | null;
          returnUrl: string | null;
        }

        /*[ClientRequest]*/
        export interface StartResetPasswordRequest {
          email: string | null;
          returnUrl: string | null;
        }

        export interface SyncNudgeCandidatesRequest {}

        /*[ClientRequest]*/
        export interface UnsubscribeNewsletterRequest {
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface UnverifyPhoneRequest {
          userId: /*Int32*/ number;
        }

        export interface UploadProfileImageRequest {
          imageUpload: /*IFormFile*/ unknown;
          userId: /*Int32*/ number;
          imageLeft: /*Double*/ number;
          imageTop: /*Double*/ number;
          imageWidth: /*Double*/ number;
          imageHeight: /*Double*/ number;
        }

        export interface UserPlanEventRequest {
          eventId: string | null;
          eventType: string | null;
          account: Kaggle.Sdk.Users.Models.UserPlanEventAccount | null;
          entitlement: Kaggle.Sdk.Users.Models.UserPlanEventEntitlement | null;
        }

        /*[ClientRequest]*/
        export interface ValidateResetPasswordCodeRequest {
          userId: /*Int32*/ number;
          resetPasswordCode: string | null;
          resendIfExpired: boolean;
          returnUrl: string | null;
        }

        /*[ClientRequest]*/
        export interface VerifyPasswordRequest {
          userLoginId: /*Int32*/ number;
          password: string | null;
        }

        /*[ClientRequest]*/
        export interface VerifyPhoneRequest {
          userId: /*Int32*/ number;
          phoneNumber: string | null;
          forceVerify: boolean;
        }
      }

      export namespace Responses {
        export interface CallbackFromSSOLinkResponse {
          message: string | null;
          outcome: "error" | "info" | "notAuthorized" | "success";
          userLoginToLoginAs: (/*Int32*/ number) | null;
          redirectUrl: string | null;
        }

        export interface DatasetForReview {
          url: string | null;
          name: string | null;
          datasetId: /*Int32*/ number;
        }

        export interface ForbiddenPrefixesContainsResponse {
          found: boolean;
        }

        export interface GetUserIdByLoginlessTokenResponse {
          userId: /*Int32*/ number;
        }

        export interface ResendVerificationEmailResponse {}

        export interface ResetPasswordResponse {
          userLoginId: (/*Int32*/ number) | null;
        }

        export interface ResumeActionResponse {
          redirectToUrl: string | null;
          pageMessage: string | null;
          pageMessageLevel: "error" | "success";
        }

        export interface SoftDeleteAccountResponse {
          isUserSoftDeleted: boolean;
        }

        export interface SpamBlockMultipleAccountResponse {
          blockedUserIds: (/*Int32*/ number)[];
          blockedCount: /*Int32*/ number;
          failedBlockUserIds: (/*Int32*/ number)[];
          failedBlockCount: /*Int32*/ number;
          elapsedTimeMillis: /*Int64*/ number;
        }

        export interface StartMigrateSsoResponse {
          outcome: "createPassword" | "emailLoginExists" | "googleSsoExists";
          userId: (/*Int32*/ number) | null;
        }

        export interface StartResetPasswordResponse {
          outcome: "noSuchUser" | "success" | "userBlocked";
          userId: /*Int32*/ number;
        }

        export interface UploadProfileImageResponse {
          imageUrl: string | null;
          thumbnailUrl: string | null;
        }

        export interface VerifyPasswordResponse {
          validPassword: boolean;
        }
      }

      export interface UserClient {}
    }

    export namespace UserSecrets {
      export namespace Models {
        export interface AccessToken {
          token: string | null;
          expiresInSeconds: /*Int64*/ number;
        }

        export interface DeleteUserSecretResponse {
          wasAttached: boolean;
          secretId: /*Int32*/ number;
        }

        export interface GetGitHubAccessInfoResponse {
          login: string | null;
        }

        export interface GetUserSecretResponse {
          secretId: /*Int32*/ number;
          secret: string | null;
          expiresInSeconds: /*Int64*/ number;
          secretType: "accessToken" | "custom" | "refreshToken";
          secretProvider: "gitHub" | "google" | "user";
        }

        export interface KnownGcsBucketExtensions {}

        export interface OAuthFlowResponse {
          oAuthFlowStartUrl: string | null;
          scopes: string[];
          clientId: string | null;
          state: string | null;
        }

        export interface UserSecretKernelAttachmentMetadata {
          attachmentId: /*Int32*/ number;
          secretId: /*Int32*/ number;
          secretType: "accessToken" | "custom" | "refreshToken";
          secretProvider: "gitHub" | "google" | "user";
          secretTargets: ("autoMl" | "bigQuery" | "cloudAI" | "gcs")[];
        }

        export interface UserSecretMetadata {
          secretId: /*Int32*/ number;
          secretLabel: string | null;
          secretType: "accessToken" | "custom" | "refreshToken";
          secretProvider: "gitHub" | "google" | "user";
          secretTargets: ("autoMl" | "bigQuery" | "cloudAI" | "gcs")[];
          openIdConnectSubject: string | null;
          userDisplayName: string | null;
          userProfileImage: string | null;
          userEmail: string | null;
        }

        export interface UserSecretQueryFields {
          kernelId: /*Int32*/ number;
          type: "accessToken" | "custom" | "refreshToken";
          provider: "gitHub" | "google" | "user";
          label: string | null;
        }
      }

      export namespace Requests {
        /*[ClientRequest]*/
        export interface AddSecretKernelAttachmentRequest {
          secretId: /*Int32*/ number;
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteSecretKernelAttachmentRequest {
          attachmentId: /*Int32*/ number;
        }

        export interface DeleteSecretKernelAttachmentsRequest {
          kernelId: /*Int32*/ number;
          userId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface DeleteUserSecretRequest {
          secretId: /*Int32*/ number;
        }

        export interface DeleteUserSecretsRequest {
          userId: /*Int32*/ number;
        }

        export interface ExchangeAuthorizationCodeRequest {
          secretProvider: "gitHub" | "google" | "user";
          secretType: "accessToken" | "custom" | "refreshToken";
          authorizationCode: string | null;
          state: string | null;
          redirectUrl: string | null;
          scopes: string[];
        }

        /*[ClientRequest]*/
        export interface ExchangeGcloudAuthorizationCodeRequest {
          authorizationCode: string | null;
        }

        /*[ClientRequest]*/
        export interface GetGitHubAccessInfoRequest {}

        export interface GetOAuthFlowRequest {
          secretProvider: "gitHub" | "google" | "user";
          scopes: string[];
          redirectUrl: string | null;
          targetTypes: "autoMl" | "bigQuery" | "cloudAI" | "gcs"[];
          openIdConnectSubject: string | null;
        }

        /*[ClientRequest]*/
        export interface GetUserSecretByLabelRequest {
          label: string | null;
          jWE: string | null;
        }

        /*[ClientRequest]*/
        export interface GetUserSecretByProviderRequest {
          secretType: "accessToken" | "custom" | "refreshToken";
          secretProvider: "gitHub" | "google" | "user";
        }

        export interface GetUserSecretMetadataRequest {
          userSecretId: (/*Int32*/ number) | null;
          queryFields: Kaggle.Sdk.UserSecrets.Models.UserSecretQueryFields | null;
          includeProfileFields: boolean;
        }

        export interface GetUserSecretRequest {
          target: "autoMl" | "bigQuery" | "cloudAI" | "gcs";
          jWE: string | null;
        }

        /*[ClientRequest]*/
        export interface ListKernelSecretsMetadataRequest {
          kernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListKernelsWithSecretRequest {
          secretId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListParentKernelSecretsMetadataRequest {
          forkedKernelId: /*Int32*/ number;
        }

        /*[ClientRequest]*/
        export interface ListUserSecretsMetadataRequest {
          target: "autoMl" | "bigQuery" | "cloudAI" | "gcs" | null;
          provider: "gitHub" | "google" | "user" | null;
        }

        /*[ClientRequest]*/
        export interface UpsertCustomUserSecretRequest {
          secret: string | null;
          secretLabel: string | null;
        }

        export interface UpsertUserSecretRequest {
          secretType: "accessToken" | "custom" | "refreshToken";
          secretProvider: "gitHub" | "google" | "user";
          secretTargets: "autoMl" | "bigQuery" | "cloudAI" | "gcs"[];
          secret: string | null;
          secretLabel: string | null;
          openIdConnectSubject: string | null;
        }
      }

      export interface UserSecretsClient {}
    }

    export interface SdkConfiguration {}
  }

  export interface AlwaysPopulatePropertiesWhenSerializingAttribute {}

  export interface JsonCreationConverter {
    canWrite: boolean;
  }

  export interface JsonDto {}

  export interface ProtobufByteStringConverter {
    canWrite: boolean;
  }

  export interface ProtobufTimestampConverter {}
}
/**
 * This is template content for sdk.ts fetch bindings.
 * Top section contains bits that read as errors until combined with types.
 */

/** The type of a command handler request. */
type IRequest = Kaggle.Framework.Service.IRequest;

/** Are we currently running in a development environment. */
const IS_DEV = process.env.NODE_ENV === "development";
const IS_JEST = (global as any).__JEST__;

/** Dev escape hatch for overriding the base URL. */
const BASE_URL = (window as any).__BASE_URL__ || "";

// todo(b/129357862): Deprecate this after .NET core go-live.
/** The legacy header name used for sending the CSRF form token. */
const LEGACY_XSRF_HEADER_TOKEN_NAME = "__RequestVerificationToken";
// todo(b/129357862): Make this only load from Webpack DefinePlugin.
// todo(b/129357862): Change names for this to "X-XSRF-TOKEN" back end.
/** The header name used for sending the CSRF form token. */
const XSRF_HEADER_TOKEN_NAME =
  (window as any).__XSRF_HEADER_TOKEN_NAME__ || "X-XSRF-TOKEN";

/** The JS readable XSRF-TOKEN that should be sent as X-XSRF-TOKEN header. */
const XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";

import * as fetch from "isomorphic-fetch";
import * as invariant from "invariant";
import * as Cookies from "js-cookie";

/** End error section. */

declare let MiniProfiler: any;

type ResponseType = "arrayBuffer" | "blob" | "json" | "text";

interface RouteConstraint {
  [key: string]: any;
}

type ResultConstraint = (ArrayBuffer | Blob | any | string | null) &
  GeneralResponse<any>;

type RequestHttpMethod = "GET" | "POST" | "PUT" | "OPTIONS" | "DELETE";
type RequestContentType = "application/json" | "multipart/form-data";
type RequestAccept = "application/json";

export enum LoggingFlag {
  None = "none",
  Log = "log",
  Debug = "debug",
}

export enum EnvironmentFlag {
  Browser = "browser",
  Node = "node",
}

type ApiFlagsCondensed = (LoggingFlag | EnvironmentFlag)[]; // [LoggingFlag | undefined, EnvironmentFlag | undefined];

interface ApiFlagsExpanded {
  logging: LoggingFlag;
  environment: EnvironmentFlag;
}

type ActionLogger = (message: any, ...args: any[]) => void;

type RequestInitCondensed = [
  RequestHttpMethod,
  RequestContentType | null | undefined,
  RequestAccept | null | undefined
];

// minimize repeated configuration
type ApiOptsCondensed = [
  RequestInitCondensed,
  ApiFlagsCondensed,
  // routeTemplate
  string,
  // routeKeys
  string[],
  // queryKeys
  string[],
  // bodyKeys
  string[] | null | undefined,
  // responseType
  ResponseType,
  Middleware[],
  MockRequest<unknown, unknown> | undefined
];

type MiddlewareType = "request" | "response";

interface Middleware {
  readonly type: MiddlewareType;
}

export class RequestMiddleware implements Middleware {
  readonly type: MiddlewareType = "request";
  readonly next: Mapper<RequestInit, RequestInit>;

  constructor(next: Mapper<RequestInit, RequestInit>) {
    this.next = next;
  }
}

export class ResponseMiddleware implements Middleware {
  readonly type: MiddlewareType = "response";
  readonly next: Mapper<Response, Response>;

  constructor(next: Mapper<Response, Response>) {
    this.next = next;
  }
}

interface ApiOptsExpanded {
  init: RequestInit;
  flags: ApiFlagsExpanded;
  routeTemplate: string;
  routeKeys: ReadonlyArray<string>;
  queryKeys: ReadonlyArray<string>;
  bodyKeys: ReadonlyArray<string> | null | undefined;
  responseType: ResponseType;
  middlewares: Set<Middleware>;
  mockRequest: MockRequest<unknown, unknown> | undefined;
  debug: ActionLogger | null | undefined;
  log: ActionLogger | null | undefined;
}

type Disposer = () => void;

type RequestAction<TBody, TResult extends ResultConstraint> = (
  body: TBody
) => StreamablePromise<TResult>;

type Mapper<Input, Output> = (input: Input) => Output;

export enum FetchStatus {
  Pending = "pending",
  Complete = "complete",
}

export interface RequestResult<TResult> {
  status: FetchStatus;
  result: TResult;
}

export interface Observer<T> {
  onNext: (value: T) => void;
  onError: (error: Error) => void;
  onCompleted: () => void;
}

export interface Observable<T> {
  subscribe: Subscribe<T>;
}

type Subscribe<T> = (observer: Observer<T>) => Disposer;
type RequestObserver<TResult extends ResultConstraint> = Observer<
  RequestResult<TResult>
>;
type RequestResultObservable<TResult extends ResultConstraint> = Observable<
  RequestResult<TResult>
>;
type RequestObservable<TBody, TResult extends ResultConstraint> = RequestAction<
  TBody,
  TResult
> &
  RequestResultObservable<TResult>;

interface Streamable<TResult extends ResultConstraint> {
  stream: SubscribeStream<TResult>;
}

interface StreamablePromise<TResult extends ResultConstraint>
  extends Promise<TResult>,
    Streamable<TResult> {}

interface RequestMembers {
  routeTemplate: string;
  validateRoute: (route: string) => void;
  validateUrl: (url: string) => void;
  getLocation: (route: RequestRoute) => Location;
  getUrl: (route: RequestRoute) => string;
}

type RequestExport<TBody, TResult extends ResultConstraint> = RequestAction<
  TBody,
  TResult
> &
  RequestObservable<TBody, TResult> &
  RequestMembers &
  Streamable<TResult>;

interface DirectChainableRequest<TBody, TResult extends ResultConstraint> {
  /** Register a request middleware. */
  with: (middleware: RequestMiddleware) => ChainableRequest<TBody, TResult>;
  /** Register a response middleware. */
  when: (
    responseMiddleware: ResponseMiddleware
  ) => ChainableRequest<TBody, TResult>;
  /** Clear all request middlewares. */
  clearWith: () => ChainableRequest<TBody, TResult>;
  /** Clear all response middlewares. */
  clearWhen: () => ChainableRequest<TBody, TResult>;
  /** Clear all request, response, and result middlewares. */
  clear: () => ChainableRequest<TBody, TResult>;
  /** Manually set headers. */
  withHeaders: (headers: {
    [key: string]: string;
  }) => ChainableRequest<TBody, TResult>;
  /** Manually set a header. */
  withHeader: (name: string, value: string) => ChainableRequest<TBody, TResult>;
  mock: (
    mockRequest: MockRequest<TBody, TResult>
  ) => ChainableRequest<TBody, TResult>;
}

type ChainableRequest<
  TBody,
  TResult extends ResultConstraint
> = DirectChainableRequest<TBody, TResult> & RequestExport<TBody, TResult>;

class ResponseCode {
  static Redirects = [202, 301, 302];
}

/** Fetches tokens if they don't exist, otherwise stores them in a cache and returns immediately. */
export function getAntiForgeryToken(): string {
  const antiForgeryToken = Cookies.get(XSRF_TOKEN_COOKIE_NAME);
  if (!antiForgeryToken) {
    throw new Error("An anti-forgery token could not be found.");
  }
  return antiForgeryToken;
}

/**
 * Static utility functions for working with Roslyn Api.
 */
export class Utils {
  /** Validate a Location seems valid. */
  static validateLocation(location: Location) {
    const { pathname, search, hash } = location;
    if (pathname.length && !pathname.startsWith("/")) {
      throw new Error(
        `Api.Utils.createLocation Error: pathname must begin with a '/' or be empty. Location: ${location}`
      );
    }
    if (search.length && !search.startsWith("?")) {
      throw new Error(
        `Api.Utils.createLocation Error: search must begin with a '?' or be empty. Location: ${location}`
      );
    }
    if (hash.length && !hash.startsWith("#")) {
      throw new Error(
        `Api.Utils.createLocation Error: hash must begin with a '#' or be empty. Location: ${location}`
      );
    }
  }

  /** Create a new Location object (defaults localhost fields) */
  static createLocation(partialLocation: Partial<Location> = {}): Location {
    const protocol =
      partialLocation.protocol || window.location.protocol || "http:";
    const hostname =
      partialLocation.hostname || window.location.hostname || "localhost";
    const port = partialLocation.port || window.location.port || "80";
    const host = partialLocation.host || `${hostname}:${port}`;
    const origin =
      partialLocation.origin ||
      window.location.origin ||
      `${protocol}//${host}`;
    const pathname = partialLocation.pathname || "/";
    const search = partialLocation.search || "";
    const hash = partialLocation.hash || "";
    const href = `${origin}${pathname}${search}${hash}`;
    const location = {
      protocol,
      host,
      hostname,
      port,
      origin,
      pathname,
      search,
      hash,
      href,
      // hack(cochamberlain): TS requires this but we don't use it anywhere.
      ancestorOrigins: {} as any,
      assign() {
        throw new Error("SyntheticLocation does not implement methods.");
      },
      reload() {
        throw new Error("SyntheticLocation does not implement methods.");
      },
      replace() {
        throw new Error("SyntheticLocation does not implement methods.");
      },
      toString() {
        return this.href;
      },
    };
    Utils.validateLocation(location);
    return location;
  }
  /** Create a new Location object for a specified string URL */
  static parseLocation(url: string): Location {
    const parser = document.createElement("a");
    parser.href = url;
    return Utils.createLocation(parser);
  }
  static localhost: Location = Utils.parseLocation("http://localhost");
  /** Compact Roslyn Api init options. */
  static condenseInit(init: RequestInit): RequestInitCondensed {
    // hack(cochamberlain): TS 2.7 has a bug in type definition
    const headers = init.headers as any;
    return [
      init.method as RequestHttpMethod,
      headers.get("Content-Type") as RequestContentType,
      headers.get("Accept") as RequestAccept,
    ];
  }
  /** Expand Roslyn Api init options. */
  static expandInit(initCondensed: RequestInitCondensed): RequestInit {
    const [method, contentType, accept] = initCondensed;
    const headers = new Headers();
    if (contentType) {
      headers.append("Content-Type", contentType);
    }
    if (accept) {
      headers.append("Accept", accept);
    }
    return {
      method,
      headers,
    };
  }
}

/**
 * Request middlewares that may be chained into Roslyn Api via `Api.Datasets.getDataset.with((url: string, init: RequestInit, next: RequestHandler) => next(url, init))({ id: 10 })`
 *
 * Used for transforming the raw url and init fetch request parameters.
 */
export class RequestMiddlewares {
  /** Add a non-automatic header onto the request. */
  static withHeader = (name: string, value: string) =>
    new RequestMiddleware(init => {
      const headers = new Headers(init.headers);
      headers.set(name, value);
      return { ...init, headers };
    });
  /** Add non-automatic headers onto the request. */
  static withHeaders = (
    headers: {
      [key: string]: string;
    } /* Todo(b/129357862): WHEN BROWSERS CATCH UP... Headers */
  ) =>
    new RequestMiddleware(init => {
      const _headers = new Headers(init.headers);
      for (const [key, value] of (Object as any).entries(headers)) {
        _headers.set(key, value);
      }
      return { ...init, headers: _headers };
    });
  /** Set the Content-Type header to "application/json". */
  static withJSON = RequestMiddlewares.withHeaders({
    "Content-Type": "application/json",
    Accept: "application/json",
  });
  /** Set the `credentials: RequestCredentials` option of the Fetch init argument. */
  static withCredentials = (credentials: RequestCredentials) =>
    new RequestMiddleware(init => ({
      ...init,
      credentials,
    }));
  /** Set the `redirect: RequestRedirect` option of the Fetch init argument. */
  static withRedirect = (redirect: RequestRedirect) =>
    new RequestMiddleware(init => ({
      ...init,
      redirect,
    }));
  /** Default `RequestMiddleware[]` used by Roslyn Api in the browser. */
  static browserDefaults: RequestMiddleware[] = [
    RequestMiddlewares.withCredentials(IS_DEV ? "include" : "same-origin"),
    RequestMiddlewares.withRedirect("follow"),
  ].filter(x => x !== null) as RequestMiddleware[];
  /** Default `RequestMiddleware[]` used by Roslyn Api in Node.js. */
  static nodeDefaults: RequestMiddleware[] = [
    RequestMiddlewares.withCredentials("include"),
    RequestMiddlewares.withRedirect("follow"),
  ];
}

/**
 * Response middlewares that may be chained into Roslyn Api via `Api.Datasets.getDataset.when((response: Response, next: ResponseHandler) => next(response))({ id: 10 })`
 *
 * Used for transforming the raw fetch response.
 */
export class ResponseMiddlewares {
  /** Forces hard redirects via `window.location` if the response has a redirect status code or Location header. */
  static redirect = new ResponseMiddleware(res => {
    const isRedirect =
      (ResponseCode.Redirects as any).includes(res.status) &&
      res.headers.has("Location");
    if (!isRedirect) {
      return res;
    }
    const location = res.headers.get("Location");
    if (location === null) {
      throw new Error("Location redirect can not be null.");
    }
    window.location.assign(location);
    return res;
  });
  /** Enforces specific status codes on the response or throws an error. */
  static enforceStatuses = (...statuses: number[]) =>
    new ResponseMiddleware(res => {
      if (!(statuses as any).includes(res.status)) {
        throw new Error(
          `[ResponseMiddlewares.enforceStatuses] response had a disallowed status | ${res.status}: ${res.statusText}`
        );
      }
      return res;
    });
  /** Enforces an ok response or throws an error. */
  static enforceOk = new ResponseMiddleware(res => {
    if (!res.ok) {
      throw new Error(
        `[ResponseMiddlewares.enforceOk] response was not ok | ${res.status}: ${res.statusText}`
      );
    }
    return res;
  });
  /** Default `ResponseMiddleware[]` used by Roslyn Api in all environments. */
  static defaults: ResponseMiddleware[] = [
    ResponseMiddlewares.redirect,
    ResponseMiddlewares.enforceOk,
  ];
}

interface ApiFlagsParams {
  logging: LoggingFlag;
  environment: EnvironmentFlag;
}

class ApiFlags implements ApiFlagsExpanded {
  logging: LoggingFlag;
  environment: EnvironmentFlag;

  constructor(params: ApiFlagsParams) {
    this.logging = params.logging;
    this.environment = params.environment;
  }

  static expand = (flagsCondensed: ApiFlagsCondensed): ApiFlags => {
    const loggingDefault = IS_DEV ? LoggingFlag.Log : LoggingFlag.None;
    const environmentDefault =
      typeof window !== "object" || IS_JEST
        ? EnvironmentFlag.Node
        : EnvironmentFlag.Browser;
    const [logging = loggingDefault, environment = environmentDefault] =
      flagsCondensed || [];
    return new ApiFlags({ logging, environment } as ApiFlagsParams);
  };

  condense = (): ApiFlagsCondensed => [this.logging, this.environment];
}

/**
 * Options that are used when creating a fetch wrapped Roslyn endpoint. (Internal use for now).
 */
class ApiOpts implements ApiOptsExpanded {
  init: RequestInit;
  flags: ApiFlags;
  routeTemplate: string;
  routeKeys: ReadonlyArray<string>;
  queryKeys: ReadonlyArray<string>;
  bodyKeys: ReadonlyArray<string>;
  responseType: ResponseType;
  middlewares: Set<Middleware>;
  mockRequest: MockRequest<unknown, unknown> | undefined;
  debug: ActionLogger | null | undefined;
  log: ActionLogger | null | undefined;

  constructor(optsCondensed: ApiOptsCondensed) {
    const [
      initCondensed,
      flagsCondensed,
      routeTemplate,
      routeKeys,
      queryKeys,
      bodyKeys,
      responseType,
      middlewares,
      mockRequest,
    ] = optsCondensed;
    const { headers, ...init } = Utils.expandInit(initCondensed);
    // hack(cochamberlain): TS 2.7 has a bug with headers definition
    this.init = Object.freeze({
      ...init,
      headers: Object.freeze(headers) as Headers,
    });
    this.flags = Object.freeze(ApiFlags.expand(flagsCondensed));
    this.routeTemplate = Object.freeze(routeTemplate);
    this.routeKeys = Object.freeze(routeKeys);
    this.queryKeys = Object.freeze(queryKeys);
    this.bodyKeys = Object.freeze(bodyKeys || []);
    this.responseType = Object.freeze(responseType);
    this.middlewares = new Set(
      middlewares ||
        RequestMiddlewares.browserDefaults.concat(ResponseMiddlewares.defaults)
    );
    this.mockRequest = mockRequest;
  }

  /** Create a new instance with additional headers. */
  readonly withHeaders = (requestHeaders: {
    [key: string]: string;
  }): ApiOpts => {
    const headers = { ...this.init.headers, ...requestHeaders };
    const init = { ...this.init, headers };
    return this.partialClone({ init });
  };

  private readonly appendMiddleware = (middleware: Middleware) => {
    const middlewares = new Set(Array.from(this.middlewares));
    middlewares.add(middleware);
    return this.partialClone({ middlewares });
  };

  /** Apply a middleware to the command request. */
  readonly with = (middleware: RequestMiddleware) =>
    this.appendMiddleware(middleware);

  /** Apply a middleware to the raw command response stream (pre-deserialization). */
  readonly when = (middleware: ResponseMiddleware) =>
    this.appendMiddleware(middleware);

  /** Clear all request middlewares for this instance. */
  readonly clearWith = () =>
    this.partialClone({
      middlewares: new Set(
        Array.from(this.middlewares).filter(({ type }) => type !== "request")
      ),
    });

  /** Clear all response middlewares for this instance. */
  readonly clearWhen = () =>
    this.partialClone({
      middlewares: new Set(
        Array.from(this.middlewares).filter(({ type }) => type !== "response")
      ),
    });

  /** Clear all middlewares for this instance. */
  readonly clear = () => this.partialClone({ middlewares: new Set() });

  readonly mock = <TBody, TResult>(
    mockRequest: MockRequest<TBody, TResult>
  ) => {
    return this.partialClone({ mockRequest });
  };

  /** Condense all attributes of this client to a serializable for cloning. */
  readonly condense = (opts: ApiOpts = this): ApiOptsCondensed => [
    Utils.condenseInit(opts.init),
    opts.flags.condense(),
    opts.routeTemplate,
    opts.routeKeys as string[],
    opts.queryKeys as string[],
    opts.bodyKeys as string[] | null | undefined,
    opts.responseType,
    Array.from(opts.middlewares || []),
    opts.mockRequest,
  ];

  /** Clone this instance with partial differences. */
  private partialClone = (opts: Partial<ApiOpts> = {}): ApiOpts => {
    if (!opts.init) {
      opts.init = this.init;
    }
    if (!opts.flags) {
      opts.flags = this.flags;
    }
    if (!opts.routeTemplate) {
      opts.routeTemplate = this.routeTemplate;
    }
    if (!opts.routeKeys) {
      opts.routeKeys = this.routeKeys;
    }
    if (!opts.queryKeys) {
      opts.queryKeys = this.queryKeys;
    }
    if (!opts.responseType) {
      opts.responseType = this.responseType;
    }
    if (!opts.middlewares) {
      opts.middlewares = this.middlewares;
    }
    if (!opts.mockRequest) {
      opts.mockRequest = this.mockRequest;
    }
    return new ApiOpts(this.condense(opts as ApiOpts));
  };
}

/** Class for assisting in parsing routes to detect incorrect formatting. */
class RouteReverser<TRoute extends RouteConstraint> {
  private opts: ApiOpts;

  private routeStripper: RegExp;

  constructor(opts: ApiOpts) {
    this.opts = opts;

    const routePattern = this.opts.routeKeys.reduce((pattern, _key, i) => {
      return pattern.replace(`{${i}}`, "([^/$]+)");
    }, this.opts.routeTemplate);
    this.routeStripper = new RegExp(routePattern);
  }

  /** Reverses route and query parameters from a serialized url */
  reverse = (url: string): { route: TRoute; query: { [key: string]: any } } => {
    const { routeTemplate, routeKeys } = this.opts;
    const [pathAndQueryMaybe] = url.includes("#")
      ? url.split("#")
      : [url, null];
    const pathAndQuery = pathAndQueryMaybe ? pathAndQueryMaybe : url;
    const [pathMaybe] = pathAndQuery.includes("?")
      ? pathAndQuery.split("?")
      : [pathAndQuery, null];
    const path = pathMaybe ? pathMaybe : pathAndQuery;

    const routeStripperArray = this.routeStripper.exec(path);
    if (routeStripperArray === null) {
      throw new Error(`Route could not be stripped for url: ${url}`);
    }
    const [, ...routeValues] = routeStripperArray;
    if (this.opts.routeKeys.length !== routeValues.length) {
      throw new Error(
        `Route does not match.\n\trouteTemplate: ${routeTemplate}\n\turl: ${url}\n\trouteKeys: ${JSON.stringify(
          routeKeys
        )}\n\trouteValues: ${JSON.stringify(routeValues)}`
      );
    }
    const route = routeKeys.reduce((route, key, i) => {
      const value = routeValues[i];
      if (value === "null" || value === "undefined") {
        throw new Error(
          `Received url with null or undefined values.\n\trouteTemplate: ${routeTemplate}\n\turl: ${url}\n\trouteKeys: ${JSON.stringify(
            routeKeys
          )}\n\trouteValues: ${JSON.stringify(
            routeValues
          )}\n\tFailed on [${key}]: ${value}`
        );
      }
      return { ...route, [key]: value };
    }, {}) as TRoute;

    const query = {};
    return { route, query };
  };
}

interface RegexDictionary {
  [key: string]: RegExp;
}

const REGEX: RegexDictionary = {
  VALID_URL: /[^{}]/,
};

const UNSERIALIZABLE_OBJECT_STRING = {}.toString();

const cache = {
  requests: new Map<string, Promise<any>>(),
  streamListeners: new Map<string, StreamListener<any>[]>(),
};

function streamCounts(): Readonly<{ [fingerprint: string]: number }> {
  const fingerprints = Array.from(cache.streamListeners.keys());
  const counts = fingerprints.reduce((_, fingerprint) => {
    const streamListener = cache.streamListeners.get(fingerprint);
    return {
      ..._,
      [fingerprint]: streamListener ? streamListener.length : 0,
    };
  }, {});
  return Object.freeze(counts);
}

function serializePrimitive(value: unknown): string {
  switch (typeof value) {
    case "string":
      return value as string;
    case "number":
      return (value as number).toString();
    case "boolean":
      return (value as boolean).toString();
    case "undefined":
      throw new Error(
        "Roslyn API: serializePrimitive should not be called on an undefined value!"
      );
    case "object":
      invariant(
        value !== null,
        "Roslyn API: serializePrimitive should not be called on a null value!"
      );
      const stringValue = (value as {}).toString();
      if (stringValue === UNSERIALIZABLE_OBJECT_STRING) {
        throw new Error(
          `Roslyn API: serializePrimitive should not be called on a non-primitive object! Received: ${JSON.stringify(
            value
          )}`
        );
      }
      return stringValue;
    case "function":
    case "symbol":
    default:
      throw new Error(
        `Roslyn API: serializePrimitive should not be used for typeof ${typeof value}: ${(value as any).toString()}!`
      );
  }
}

interface RequestRoute {
  [key: string]: unknown;
  typeName: string;
}

/**
 * Extensible basis for building observable, chainable fetch requests
 */
export class RequestBuilder<TBody, TResult extends ResultConstraint> {
  opts: ApiOpts;
  route: RequestRoute;
  private reverser: RouteReverser<RequestRoute> | undefined;

  constructor(opts: ApiOptsCondensed, typeName: string) {
    this.opts = new ApiOpts(opts);
    this.route = { typeName };
    if (this.opts.debug) {
      this.reverser = new RouteReverser<RequestRoute>(this.opts);
      this.opts.debug(`Action: ${this.opts.routeTemplate}`);
    }
  }

  private readonly getMembers = (): RequestMembers => {
    const routeTemplate = this.opts.routeTemplate;
    const validateRoute = this.validateRoute;
    const validateUrl = this.validateUrl;
    const getLocation = this.getLocation;
    const getUrl = this.getUrl;
    return {
      routeTemplate,
      validateRoute,
      validateUrl,
      getLocation,
      getUrl,
    };
  };

  /** Validates that a string route fits the routeTemplate. */
  readonly validateRoute = (route: string) => {
    if (!this.reverser) {
      return;
    }
    // debug heavy in dev mode and go fast in prod
    const routeInfo = this.reverser.reverse(route);
    if (this.opts.debug) {
      this.opts.debug(
        `reversed route\n\turl: ${route}\n\trouteInfo:${JSON.stringify(
          routeInfo
        )}`
      );
    }
  };

  /** Validates that a string url seems valid (slugs, etc.). */
  readonly validateUrl = (url: string) => {
    if (!REGEX.VALID_URL.test(url)) {
      throw new Error(
        `${this.toString()}: Route was invalid | routeTemplate: '${
          this.opts.routeTemplate
        }' => '${url}'`
      );
    }
  };

  /** Gets a Location for a given set of route. */
  readonly getLocation = (route: RequestRoute): Location => {
    const url = this.getUrl(route);
    return Utils.parseLocation(url);
  };

  /** Interpolates and validates route and query params or string url and returns the full URL. */
  readonly getUrl = (route: RequestRoute): string => {
    // if route is a string, route should be parsed and validated to make sure it matches route and is well formatted (no null / undefined values)
    if (typeof route === "string") {
      const url = route;
      if (this.opts.debug) {
        this.validateRoute(url);
      }
      this.validateUrl(url);
      return url;
    }

    const allKeys = Object.keys(route);
    const routeKeys = allKeys.filter(x =>
      (this.opts.routeKeys as any).includes(x)
    );
    const queryKeys = allKeys.filter(x =>
      (this.opts.queryKeys as any).includes(x)
    );

    const getRouteValue = (routeKey: string): string => {
      try {
        return serializePrimitive(route[routeKey]);
      } catch (error) {
        throw new Error(
          `Roslyn API: Unsupported route value received for route key "${routeKey}" of route template "${this.opts.routeTemplate}"!\n${error.message}`
        );
      }
    };

    const formatRoute = (): string => {
      return routeKeys.reduce(
        (route, routeKey, i) =>
          route.replace(`{${i}}`, getRouteValue(routeKey)),
        this.opts.routeTemplate
      );
    };

    const formatQuery = (): string => {
      return queryKeys.length > 0
        ? `?${queryKeys
            .map(queryKey => `${queryKey}=${route[queryKey]}`)
            .join("&")}`
        : "";
    };

    const url = `${BASE_URL}${formatRoute()}${formatQuery()}`;
    this.validateUrl(url);
    return url;
  };

  private readonly filterMiddlewares = <T extends Middleware>(
    _type: MiddlewareType
  ) =>
    Array.from(this.opts.middlewares).filter(
      middleware => middleware.type
    ) as T[];

  private applyRequestMiddleware = (
    init: RequestInit,
    ...middlewares: RequestMiddleware[]
  ): RequestInit => {
    const requestMiddlewares = middlewares.concat(
      this.filterMiddlewares<RequestMiddleware>("request")
    );
    return requestMiddlewares.reduce((_init, middleware) => {
      return middleware.next(_init);
    }, init);
  };

  private applyResponseMiddleware = (response: Response): Response => {
    const responseMiddlewares = this.filterMiddlewares<ResponseMiddleware>(
      "response"
    );
    return responseMiddlewares.reduce((_response, middleware) => {
      return middleware.next(_response);
    }, response);
  };

  private handleResponse = (response: Response): Promise<ResultConstraint> => {
    const _response = this.applyResponseMiddleware(response);
    if (_response === null) {
      throw new Error(
        "Null response received after SDK middleware transformation."
      );
    }
    // jSON deserialization happens here.
    return response[this.opts.responseType]();
  };

  private createFetchArgs = (
    url: string,
    ...middlewares: RequestMiddleware[]
  ): [string, RequestInit] => {
    const init = this.applyRequestMiddleware(this.opts.init, ...middlewares);
    return [url, init];
  };

  readonly toString = () => {
    return `ApiOpts: ${this.opts.routeTemplate}`;
  };

  readonly fetch = (body: TBody): StreamablePromise<TResult> => {
    if (this.opts.mockRequest) {
      return this.opts.mockRequest(body) as StreamablePromise<TResult>;
    }

    let lastResult: TResult | null = null;
    let listenersNotified = false;

    const url = this.getUrl(this.route);
    const fingerprint = this.createFingerprint(this.route);
    const stream = createStream<TResult>(fingerprint);

    // ensure we have the anti-forgery token before executing the request.
    const antiForgeryToken = getAntiForgeryToken();

    // send the anti-forgery header in a header.
    const csrfMiddleware = RequestMiddlewares.withHeaders({
      [LEGACY_XSRF_HEADER_TOKEN_NAME]: antiForgeryToken,
      [XSRF_HEADER_TOKEN_NAME]: antiForgeryToken,
    });

    const [requestInfo, init] = this.createFetchArgs(url, csrfMiddleware);
    if (body !== undefined) {
      init.body = this.createBody(body);
    }

    const promise = fetch(requestInfo, {
      ...init,
      credentials: IS_DEV ? "include" : "same-origin",
    }).then((response: Response) => {
      const responsePromise = this.handleResponse(response) as Promise<TResult>;

      const miniprofilerHeaders = response.headers.get("X-MiniProfiler-Ids");
      if (
        typeof MiniProfiler !== "undefined" &&
        miniprofilerHeaders &&
        miniprofilerHeaders.length
      ) {
        MiniProfiler.fetchResults(JSON.parse(miniprofilerHeaders));
      }

      return responsePromise
        .then(result => {
          lastResult = result;
          const listeners = cache.streamListeners.get(fingerprint);
          if (IS_DEV) {
            if (!listeners) {
              console.warn(
                "promise resolved: no listeners found to notify (maybe this is just a regular promise.then()).",
                fingerprint,
                { lastResult, listenersNotified }
              );
            }
          }
          if (listeners) {
            for (const listener of listeners) {
              listener(result);
            }
          }
          listenersNotified = true;
          return result;
        })
        .then((result: unknown) => {
          // unwrap command handler envelope.
          const generalResponse = result as GeneralResponse<TResult>;
          if (generalResponse.wasSuccessful) {
            return generalResponse.result === undefined
              ? {}
              : generalResponse.result;
          } else if (generalResponse.wasSuccessful === false) {
            const errors = generalResponse.errors;
            const errorCode =
              generalResponse.error && generalResponse.error.code !== undefined
                ? generalResponse.error.code
                : CanonicalErrorCode.INTERNAL;
            const errorMessage =
              (generalResponse.error && generalResponse.error.message) ||
              errors[0] ||
              (errorCode === CanonicalErrorCode.OK ? "" : "Internal");

            const errorDetails =
              generalResponse.error && generalResponse.error.details;
            throw new CanonicalError(errorMessage, errorCode, errorDetails);
          }
          throw new Error(
            `Command handler response had unexpected shape: ${JSON.stringify(
              Object.keys(result as any)
            )}`
          );
        });
    });

    const enhancedPromise: StreamablePromise<TResult> = Object.defineProperties(
      promise,
      {
        stream: {
          value: stream,
          configurable: false,
          writable: false,
          enumerable: true,
        },
        info: {
          get() {
            return {
              fingerprint,
              streamCounts: streamCounts(),
              lastResult,
              listenersNotified,
            };
          },
          configurable: false,
          enumerable: true,
        },
      }
    );
    return enhancedPromise;
  };
  private readonly createFingerprint = (route: RequestRoute): string => {
    const url = this.getUrl(route);
    const { method } = this.opts.init;
    return `${method}|${url}`;
  };
  private readonly pascalCase = (bodyParam: {
    [key: string]: any;
  }): { [key: string]: any } => {
    if (bodyParam === null || bodyParam === undefined) {
      return bodyParam;
    }
    if (typeof bodyParam !== "object") {
      return bodyParam;
    }
    if (Array.isArray(bodyParam)) {
      return bodyParam;
    }
    const keys = Object.keys(bodyParam);
    if (keys.length === 0) {
      return bodyParam;
    }
    return keys.reduce(
      (_, x) => ({
        ..._,
        [x.charAt(0).toUpperCase() + x.substr(1)]: this.pascalCase(
          bodyParam[x]
        ),
      }),
      {}
    );
  };
  private readonly createBody = (bodyParams: TBody | string | Blob): any => {
    const { init } = this.opts;
    // hack(cochamberlain): TS 2.7 bug with headers definition
    const headers = init.headers as any;
    const contentType = headers.get("Content-Type");
    if (contentType === null) {
      return bodyParams;
    }
    const bodyParamsType = typeof bodyParams;
    if (bodyParamsType === "string") {
      return JSON.stringify(bodyParams);
    }
    if (bodyParamsType === "number") {
      return `"${bodyParams}"`;
    }
    if (contentType.includes("application/json")) {
      return typeof bodyParams === "object" ? JSON.stringify(bodyParams) : {};
    }
    if (contentType.includes("application/octet-stream")) {
      const isBlob = bodyParams instanceof Blob;
      if (!isBlob) {
        throw new Error(
          `Expected body type of "Blob", received "${
            typeof bodyParams === "object"
              ? JSON.stringify(bodyParams)
              : bodyParams
          }"`
        );
      }
      return bodyParams;
    }
    if (contentType.includes("multipart/form-data")) {
      const isFormData = bodyParams instanceof FormData;
      if (!isFormData) {
        throw new Error(
          `Expected body type of "FormData", received "${
            typeof bodyParams === "object"
              ? JSON.stringify(bodyParams)
              : bodyParams
          }"`
        );
      }
      return bodyParams;
    }
    throw new Error(
      `Fetch init contains an unimplemented "Content-Type" header: "${contentType}"`
    );
  };

  readonly export = () => {
    const observable = createRequestObservable(this.fetch);
    const members: RequestMembers = this.getMembers();
    const properties = Object.keys(members).reduce((_, key) => {
      const value = (members as any)[key];
      return {
        ..._,
        [key]: {
          value,
          enumerable: true,
          writable: false,
          configurable: false,
        },
      };
    }, {});
    const fetchExport: RequestExport<TBody, TResult> = Object.defineProperties(
      observable,
      properties
    );
    return fetchExport;
  };
}

/** Extends a fetch action with a subscribe property (Observable) */
function createRequestObservable<TBody, TResult extends ResultConstraint>(
  requestAction: RequestAction<TBody, TResult>
): RequestObservable<TBody, TResult> {
  let _observer: RequestObserver<TResult | null> | null = null;
  const subscribe: Subscribe<RequestResult<TResult>> = (
    observer: RequestObserver<TResult | null>
  ) => {
    _observer = observer;
    return () => {
      _observer = null;
    };
  };
  const observableAction = (body: TBody) => {
    _observer &&
      _observer.onNext &&
      _observer.onNext({ status: FetchStatus.Pending, result: null });
    const promise = requestAction(body);
    // const enhancedPromise = Object.defineProperty(promise, "stream", { value: promise.stream, configurable: false, writable: false, enumerable: true });
    promise
      .then(result => {
        _observer &&
          _observer.onNext &&
          _observer.onNext({ status: FetchStatus.Complete, result });
        _observer && _observer.onCompleted && _observer.onCompleted();
      })
      .catch(error => {
        if (_observer && _observer.onError) {
          _observer.onError(error);
        } else {
          throw error;
        }
      });
    return promise;
  };
  const fetchObservable: RequestObservable<
    TBody,
    TResult
  > = Object.defineProperty(observableAction, "subscribe", {
    value: subscribe,
    enumerable: true,
    configurable: true,
  });
  return fetchObservable;
}

type MockRequest<TBody, TResult> = (body: TBody) => Promise<TResult>;

/**
 * Creates a strongly typed fetch function for requests.
 * @param opts options to use on the request.
 */
export function createRequest<TBody, TResult extends ResultConstraint>(
  opts: ApiOptsCondensed,
  typeName: string
): ChainableRequest<TBody, TResult> {
  const builder = new RequestBuilder<TBody, TResult>(opts, typeName);
  const observable = builder.export();

  const chainables: DirectChainableRequest<TBody, TResult> = {
    with: (requestMiddleware: RequestMiddleware) =>
      createRequest<TBody, TResult>(
        builder.opts.with(requestMiddleware).condense(),
        typeName
      ),
    when: (responseMiddleware: ResponseMiddleware) =>
      createRequest<TBody, TResult>(
        builder.opts.when(responseMiddleware).condense(),
        typeName
      ),
    clearWith: () =>
      createRequest<TBody, TResult>(
        builder.opts.clearWith().condense(),
        typeName
      ),
    clearWhen: () =>
      createRequest<TBody, TResult>(
        builder.opts.clearWhen().condense(),
        typeName
      ),
    clear: () =>
      createRequest<TBody, TResult>(builder.opts.clear().condense(), typeName),
    withHeaders: (headers: { [key: string]: string }) =>
      createRequest<TBody, TResult>(
        builder.opts.with(RequestMiddlewares.withHeaders(headers)).condense(),
        typeName
      ),
    withHeader: (name: string, value: string) =>
      createRequest<TBody, TResult>(
        builder.opts
          .with(RequestMiddlewares.withHeader(name, value))
          .condense(),
        typeName
      ),
    mock: (mockRequest: MockRequest<TBody, TResult>) =>
      createRequest<TBody, TResult>(
        builder.opts.mock(mockRequest).condense(),
        typeName
      ),
  };

  const properties = Object.keys(chainables).reduce(
    (_, name) => ({
      ..._,
      [name]: {
        value: (chainables as any)[name],
        enumerable: true,
        writable: false,
        configurable: false,
      },
    }),
    {}
  );

  const chainable: ChainableRequest<TBody, TResult> = Object.defineProperties(
    observable,
    properties
  );
  return chainable;
}

type SubscribeStream<TResult> = (next: StreamListener<TResult>) => Disposer;

type StreamListener<TResult> = (next: TResult) => void;

// function createStream<TRoute, TResult>(observable: FetchObservable<TRoute, undefined, TResult>): SubscribeStreamCore<TResult> {
function createStream<TResult>(fingerprint: string): SubscribeStream<TResult> {
  if (!cache.streamListeners.has(fingerprint)) {
    cache.streamListeners.set(fingerprint, []);
  }
  function stream(next: StreamListener<TResult>): Disposer {
    const listeners = cache.streamListeners.get(fingerprint);

    if (listeners === undefined) {
      throw new Error("Stream listeners cannot be undefined.");
    }

    listeners.push(next);

    if (listeners.length > 100) {
      console.warn("Possible stream leak detected.", streamCounts());
    }

    return function dispose() {
      listeners.splice(listeners.indexOf(next), 1);
    };
  }
  return stream;
}

// Hardcoding these since they don't change and we transpile the values as camelCase strings for historical reasons
// but still need the enum number in some spots.
export declare const enum CanonicalErrorCode {
  OK = 0,
  CANCELLED = 1,
  UNKNOWN = 2,
  INVALID_ARGUMENT = 3,
  DEADLINE_EXCEEDED = 4,
  NOT_FOUND = 5,
  ALREADY_EXISTS = 6,
  PERMISSION_DENIED = 7,
  RESOURCE_EXHAUSTED = 8,
  FAILED_PRECONDITION = 9,
  ABORTED = 10,
  OUT_OF_RANGE = 11,
  UNIMPLEMENTED = 12,
  INTERNAL = 13,
  UNAVAILABLE = 14,
  DATA_LOSS = 15,
  UNAUTHENTICATED = 16,
}

function getCanonicalErrorFromCode(code: number): google.rpc.Code {
  switch (code) {
    case CanonicalErrorCode.OK:
      return google.rpc.Code.OK;
    case CanonicalErrorCode.CANCELLED:
      return google.rpc.Code.CANCELLED;
    case CanonicalErrorCode.UNKNOWN:
      return google.rpc.Code.UNKNOWN;
    case CanonicalErrorCode.INVALID_ARGUMENT:
      return google.rpc.Code.INVALID_ARGUMENT;
    case CanonicalErrorCode.DEADLINE_EXCEEDED:
      return google.rpc.Code.DEADLINE_EXCEEDED;
    case CanonicalErrorCode.NOT_FOUND:
      return google.rpc.Code.NOT_FOUND;
    case CanonicalErrorCode.ALREADY_EXISTS:
      return google.rpc.Code.ALREADY_EXISTS;
    case CanonicalErrorCode.PERMISSION_DENIED:
      return google.rpc.Code.PERMISSION_DENIED;
    case CanonicalErrorCode.RESOURCE_EXHAUSTED:
      return google.rpc.Code.RESOURCE_EXHAUSTED;
    case CanonicalErrorCode.FAILED_PRECONDITION:
      return google.rpc.Code.FAILED_PRECONDITION;
    case CanonicalErrorCode.ABORTED:
      return google.rpc.Code.ABORTED;
    case CanonicalErrorCode.OUT_OF_RANGE:
      return google.rpc.Code.OUT_OF_RANGE;
    case CanonicalErrorCode.UNIMPLEMENTED:
      return google.rpc.Code.UNIMPLEMENTED;
    case CanonicalErrorCode.INTERNAL:
      return google.rpc.Code.INTERNAL;
    case CanonicalErrorCode.UNAVAILABLE:
      return google.rpc.Code.UNAVAILABLE;
    case CanonicalErrorCode.DATA_LOSS:
      return google.rpc.Code.DATA_LOSS;
    case CanonicalErrorCode.UNAUTHENTICATED:
      return google.rpc.Code.UNAUTHENTICATED;
    default:
      return google.rpc.Code.INTERNAL;
  }
}

export class CanonicalError extends Error {
  readonly code: CanonicalErrorCode;
  readonly status: string;
  readonly details: any[] | null | undefined;

  constructor(
    message: string,
    code: number,
    details: any[] | null | undefined = undefined
  ) {
    super(message);
    this.code = code;
    this.status = getCanonicalErrorFromCode(code);
    this.details = details;
  }

  getErrorInfo(): ErrorInfo | undefined {
    if (!this.details) {
      return undefined;
    }

    for (const errorDetail of this.details) {
      if (!errorDetail) {
        continue;
      }

      if (
        errorDetail &&
        "@type" in errorDetail &&
        errorDetail["@type"] === "type.googleapis.com/google.rpc.ErrorInfo"
      ) {
        return new ErrorInfo(
          errorDetail.reason || "",
          errorDetail.domain || "",
          errorDetail.metadata || {}
        );
      }
    }

    return undefined;
  }
}

export class ErrorInfo {
  readonly reason: string;
  readonly domain: string;
  readonly metadata: { [key: string]: string };

  constructor(
    reason: string,
    domain: string,
    metadata: { [key: string]: string }
  ) {
    this.reason = reason;
    this.domain = domain;
    this.metadata = metadata;
  }
}

interface ErrorResponse {
  wasSuccessful: false;
  errors: string[];
  // todo(b/140209162): remove Partial when mediatorController is passing all info
  error?: Partial<google.rpc.ErrorResponse.Status>;
}
interface SuccessResponse<TResponse> {
  wasSuccessful: true;
  result: TResponse;
}
type GeneralResponse<TResponse> = SuccessResponse<TResponse> | ErrorResponse;
function createRequestClient<TRequest extends IRequest, TResponse>(
  typeName: string
) {
  return createRequest<TRequest, TResponse>(
    [
      ["POST", "application/json", "application/json"],
      [],
      "/requests/{0}",
      ["typeName"],
      ["request"],
      null,
      "json",
      [],
      undefined,
    ],
    typeName
  ) as (request: TRequest) => Promise<TResponse>;
}

export type SdkFetch<
  TBody,
  TResult extends ResultConstraint
> = ChainableRequest<TBody, TResult>;
export type AnySdkFetch = SdkFetch<any, any>;

/** Pass a handler to this to get access to `mock` and other calls (boxed as a simple promise). */
export function unboxSdk<TRequest, TResult extends ResultConstraint>(
  boxed: (request: TRequest) => Promise<TResult>
) {
  return boxed as SdkFetch<TRequest, TResult>;
}

/**
 * Pause an async function for a set amount of time.
 */
export function delay(milliseconds: number) {
  return new Promise(function delayResolver(resolve) {
    window.setTimeout(resolve, milliseconds);
  });
}

/** Competitions client fetch bindings. */
export const competitionsClient = {
  getTeamsForUser: createRequestClient<
    Kaggle.Sdk.Competitions.Requests.GetTeamsForUserRequest,
    (Kaggle.Sdk.Competitions.Protos.Team)[]
  >("GetTeamsForUserRequest"),
  searchCompetitions: createRequestClient<
    Kaggle.Sdk.Competitions.Requests.SearchCompetitionsRequest,
    (Kaggle.Sdk.Competitions.Protos.Competition)[]
  >("SearchCompetitionsRequest"),
  userService: {
    // Logs that the Current User has accepted the rules for the given
    // Competition.
    acceptRules: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.AcceptRulesRequest,
      google.protobuf.Empty
    >("UserService/AcceptRules"),
    // Returns whether the Current User has accepted the rules for the given
    // Competition. Returns true if the Competition does not require rules
    // acceptance.
    hasAcceptedRules: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.HasAcceptedRulesRequest,
      Kaggle.Sdk.Competitions.Protos.HasAcceptedRulesResponse
    >("UserService/HasAcceptedRules"),
    // Returns all User Configs linked to the Current User with optional key
    // filters.
    listConfigs: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListConfigsRequest,
      Kaggle.Sdk.Competitions.Protos.ListConfigsResponse
    >("UserService/ListConfigs"),
    // Inserts or updates a User Config row.  For updates, name and competition_id
    // comprise the key, and value will be updated to whatever was provided.
    upsertConfig: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.UpsertConfigRequest,
      Kaggle.Sdk.Competitions.Protos.CompetitionUserConfig
    >("UserService/UpsertConfig"),
    // Returns information about the calling User in the context of the given
    // Competition.
    getUser: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetUserRequest,
      Kaggle.Sdk.Competitions.Protos.GetUserResponse
    >("UserService/GetUser"),
  },
  // Contains methods related to competition leaderboards.
  leaderboardService: {
    // Gets the leaderboard for the specified competition.
    getLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetLeaderboardRequest,
      Kaggle.Sdk.Competitions.Protos.GetLeaderboardResponse
    >("LeaderboardService/GetLeaderboard"),
    // Given a Competition and set of UserIds, returns each User's Team's Rank.
    //
    // Uses the current main Leaderboard:  Public LB if comp is in Weak LB mode
    // (~= comp is ongoing), Private LB if comp is in Strong LB mode (and comp
    // has Private LB).  See LeaderboardMode enum below.
    getRanksForUsers: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetRanksForUsersRequest,
      Kaggle.Sdk.Competitions.Protos.GetRanksForUsersResponse
    >("LeaderboardService/GetRanksForUsers"),
    // Admin-only RPC which recalculates cached LB data stored on Teams rows.
    // Can either recalculate only Weak LB fields, or both Weak and Strong.
    //
    // NOTE: This is the only way for the Strong LB fields, such as Ranks, to be
    // written.
    // It is not intended for frequent usage; the Weak LB should be kept up-to-
    // date synchronously as the competition progresses.
    recalculateLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.RecalculateLeaderboardRequest,
      Kaggle.Sdk.Competitions.Protos.RecalculateLeaderboardResponse
    >("LeaderboardService/RecalculateLeaderboard"),
    // Admin-only RPC that uses the legacy recalculate version of the above RPC.
    // NOTE: This RPC should be removed once the newer one is fully live.
    legacyRecalculateLeaderboard: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.LegacyRecalculateLeaderboardRequest,
      Kaggle.Sdk.Competitions.Protos.LegacyRecalculateLeaderboardResponse
    >("LeaderboardService/LegacyRecalculateLeaderboard"),
  },
  episodeService: {
    // For each active Sims Comp, kick off some new Episodes.  Intended for use
    // by the GenerateEpisodesScheduledTask.
    generateEpisodes: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GenerateEpisodesRequest,
      Kaggle.Sdk.Competitions.Protos.GenerateEpisodesResponse
    >("EpisodeService/GenerateEpisodes"),
    getEpisodeReplay: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetEpisodeReplayRequest,
      Kaggle.Sdk.Competitions.Protos.GetEpisodeReplayResponse
    >("EpisodeService/GetEpisodeReplay"),
    invalidateErroringSimulationsSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.InvalidateErroringSimulationsSubmissionsRequest,
      Kaggle.Sdk.Competitions.Protos.InvalidateErroringSimulationsSubmissionsResponse
    >("EpisodeService/InvalidateErroringSimulationsSubmissions"),
    // Lists Episodes of type Completed for a given filter. Currently top 1000 only, by most recent EndTime.
    listEpisodes: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListEpisodesRequest,
      Kaggle.Sdk.Competitions.Protos.ListEpisodesResponse
    >("EpisodeService/ListEpisodes"),
    setEpisodeErrored: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.SetEpisodeErroredRequest,
      google.protobuf.Empty
    >("EpisodeService/SetEpisodeErrored"),
  },
  // Loosely based on https://github.com/googleapis/googleapis/blob/master/google/longrunning/operations.proto
  // Prefixed with "Background" to avoid conflict with that one.
  // Has historically only been used by Competitions but could eventually be made into an official (non-Legacy) service.
  legacyCompetitionBackgroundService: {
    waitBackgroundOperation: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.WaitBackgroundOperationRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionBackgroundService/WaitBackgroundOperation"),
    getBackgroundOperation: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetBackgroundOperationRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionBackgroundService/GetBackgroundOperation"),
  },
  // Contains methods related to competitions.
  competitionService: {
    // Gets information about the requested competition.
    // (-- KAGGLE_INTERNAL This RPC does check the user's read access. --)
    getCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetCompetitionRequest,
      Kaggle.Sdk.Competitions.Protos.Competition
    >("CompetitionService/GetCompetition"),
    // Lists the competitions according the query and sorting parameters
    // specified. Also includes information about the current user's team for each
    // competition.
    // (-- KAGGLE_INTERNAL This RPC does check the user's read access. --)
    listCompetitions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListCompetitionsRequest,
      Kaggle.Sdk.Competitions.Protos.ListCompetitionsResponse
    >("CompetitionService/ListCompetitions"),
    archiveCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ArchiveCompetitionRequest,
      google.protobuf.Empty
    >("CompetitionService/ArchiveCompetition"),
    // Emails participants in a competition that match criteria.
    // Requestor must be Admin.
    emailParticipants: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.EmailParticipantsRequest,
      Kaggle.Sdk.Competitions.Protos.CompetitionEmail
    >("CompetitionService/EmailParticipants"),
    // Sets the competition deadline to now (ending the competition immediately).
    // Requestor must be Admin.
    setCompetitionDeadlineNow: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.SetCompetitionDeadlineNowRequest,
      Kaggle.Sdk.Competitions.Protos.SetCompetitionDeadlineNowResponse
    >("CompetitionService/SetCompetitionDeadlineNow"),
    createCompetitionSampleSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreateCompetitionSampleSubmissionRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateCompetitionSampleSubmission"),
    createCompetitionSolution: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreateCompetitionSolutionRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateCompetitionSolution"),
    createEnvironmentMetric: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreateEnvironmentMetricRequest,
      google.protobuf.Empty
    >("CompetitionService/CreateEnvironmentMetric"),
    waitForCompetitionAdminEvaluationEvent: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.WaitForCompetitionAdminEvaluationEventRequest,
      Kaggle.Sdk.Competitions.Protos.WaitForCompetitionAdminEvaluationEventResponse
    >("CompetitionService/WaitForCompetitionAdminEvaluationEvent"),
    // Returns data used to create the "Competitions Summary" on a user profile's Competitions tab
    getProfileUserStats: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetProfileUserStatsRequest,
      Kaggle.Sdk.Competitions.Protos.GetProfileUserStatsResponse
    >("CompetitionService/GetProfileUserStats"),
  },
  // Contains methods related to hosting competitions.
  competitionHostService: {
    // "Privacy" tab:
    getPrivacySettings: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetPrivacySettingsRequest,
      Kaggle.Sdk.Competitions.Protos.PrivacySettings
    >("CompetitionHostService/GetPrivacySettings"),
    updatePrivacySettings: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.UpdatePrivacySettingsRequest,
      Kaggle.Sdk.Competitions.Protos.PrivacySettings
    >("CompetitionHostService/UpdatePrivacySettings"),
    // This keeps existing UI behavior, but it could be refactored into the
    // UpdatePrivacySettings RPC above with a convention like setting it to "regenerate"
    // would cause it to be regenerated.
    regenerateShareToken: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.RegenerateShareTokenRequest,
      Kaggle.Sdk.Competitions.Protos.PrivacySettings
    >("CompetitionHostService/RegenerateShareToken"),
  },
  rerunService: {
    // Bulk Reruns
    cancelBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CancelBulkRerunRequest,
      google.protobuf.Empty
    >("RerunService/CancelBulkRerun"),
    initiateBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.InitiateBulkRerunRequest,
      Kaggle.Sdk.Competitions.Protos.InitiateBulkRerunResponse
    >("RerunService/InitiateBulkRerun"),
    listBulkReruns: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListBulkRerunsRequest,
      Kaggle.Sdk.Competitions.Protos.ListBulkRerunsResponse
    >("RerunService/ListBulkReruns"),
    publishBulkRerun: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.PublishBulkRerunRequest,
      google.protobuf.Empty
    >("RerunService/PublishBulkRerun"),
  },
  legacySubmissionService: {
    // Gets the status of the current user's most recent submission.
    getMostRecentSubmissionStatus: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetMostRecentSubmissionStatusRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.LegacySubmissionExtended
    >("LegacySubmissionService/GetMostRecentSubmissionStatus"),
    listSandboxSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.ListSandboxSubmissionsRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.ListSandboxSubmissionsResponse
    >("LegacySubmissionService/ListSandboxSubmissions"),
  },
  submissionService: {
    canSubmit: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CanSubmitRequest,
      Kaggle.Sdk.Competitions.Protos.CanSubmitResponse
    >("SubmissionService/CanSubmit"),
    createSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreateSubmissionRequest,
      Kaggle.Sdk.Competitions.Protos.Submission
    >("SubmissionService/CreateSubmission"),
    listSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListSubmissionsRequest,
      Kaggle.Sdk.Competitions.Protos.ListSubmissionsResponse
    >("SubmissionService/ListSubmissions"),
    // Used to bulk-invalidate particular submission ids.
    invalidateSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.InvalidateSubmissionsRequest,
      google.protobuf.Empty
    >("SubmissionService/InvalidateSubmissions"),
    // Returns submissions for the user. Sorts by most recent first.
    // TODO: This is only used by the Genie page and should be replaced by PLX.
    listSubmissionsForUser: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListSubmissionsForUserRequest,
      Kaggle.Sdk.Competitions.Protos.ListSubmissionsForUserResponse
    >("SubmissionService/ListSubmissionsForUser"),
    updateSubmissionSelection: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.UpdateSubmissionSelectionRequest,
      Kaggle.Sdk.Competitions.Protos.UpdateSubmissionSelectionResponse
    >("SubmissionService/UpdateSubmissionSelection"),
  },
  teamService: {
    acceptTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.AcceptTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/AcceptTeamMerge"),
    createTeams: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreateTeamsRequest,
      Kaggle.Sdk.Competitions.Protos.CreateTeamsResponse
    >("TeamService/CreateTeams"),
    listTeamMergeRequests: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListTeamMergeRequestsRequest,
      Kaggle.Sdk.Competitions.Protos.ListTeamMergeRequestsResponse
    >("TeamService/ListTeamMergeRequests"),
    listTeams: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListTeamsRequest,
      Kaggle.Sdk.Competitions.Protos.ListTeamsResponse
    >("TeamService/ListTeams"),
    listTeamsByUser: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.ListTeamsByUserRequest,
      Kaggle.Sdk.Competitions.Protos.ListTeamsByUserResponse
    >("TeamService/ListTeamsByUser"),
    rejectTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.RejectTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/RejectTeamMerge"),
    requestTeamMerge: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.RequestTeamMergeRequest,
      google.protobuf.Empty
    >("TeamService/RequestTeamMerge"),
    // Searches TeamName by a prefix, and returns up to 100 matching teams ordered by length.
    searchTeams: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.SearchTeamsRequest,
      Kaggle.Sdk.Competitions.Protos.SearchTeamsResponse
    >("TeamService/SearchTeams"),
    updateTeam: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.UpdateTeamRequest,
      Kaggle.Sdk.Competitions.Protos.Team
    >("TeamService/UpdateTeam"),
  },
  pageService: {
    getPage: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.GetPageRequest,
      Kaggle.Sdk.Competitions.Protos.Page
    >("PageService/GetPage"),
    createPage: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.CreatePageRequest,
      Kaggle.Sdk.Competitions.Protos.Page
    >("PageService/CreatePage"),
    updatePage: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.UpdatePageRequest,
      Kaggle.Sdk.Competitions.Protos.Page
    >("PageService/UpdatePage"),
    deletePage: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.DeletePageRequest,
      google.protobuf.Empty
    >("PageService/DeletePage"),
  },
  legacyCompetitionHostService: {
    // Creates a new (unlaunched) competition.
    // (-- aip.dev/not-precedent: Not returning a Competition message yet to keep it simple.
    //     Can refactor after moving out of Legacy.)
    createCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.CreateCompetitionRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.CreateCompetitionResponse
    >("LegacyCompetitionHostService/CreateCompetition"),
    // Gets claims/permissions that inform the host what they can do (and adjust the UI appropriately).
    getHostClaims: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetHostClaimsRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.CompetitionHostClaims
    >("LegacyCompetitionHostService/GetHostClaims"),
    // Saves the data on the "Settings" page.
    // (-- aip.dev/not-precedent: Not returning anything on Update to match legacy API.)
    updateCompetitionSettings: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.UpdateCompetitionSettingsRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/UpdateCompetitionSettings"),
    // Adds a user to the competition's admin group.
    addHostUser: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.AddHostUserRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.AddHostUserResponse
    >("LegacyCompetitionHostService/AddHostUser"),
    // Removes a user from the competition's admin group.
    removeHostUser: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.RemoveHostUserRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/RemoveHostUser"),
    // Lists all of the users that are members of the competition's admin group.
    listHostUsers: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.ListHostUsersRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.ListHostUsersResponse
    >("LegacyCompetitionHostService/ListHostUsers"),
    // Searches for users that could be added as a host to a competition's admin group.
    searchHostUsers: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.SearchHostUsersRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.SearchHostUsersResponse
    >("LegacyCompetitionHostService/SearchHostUsers"),
    getHostEvaluationInfo: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetHostEvaluationInfoRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.HostEvaluationInfo
    >("LegacyCompetitionHostService/GetHostEvaluationInfo"),
    obliterateEvaluationFromStep: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.ObliterateEvaluationFromStepRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/ObliterateEvaluationFromStep"),
    getEvaluationMetric: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetEvaluationMetricRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.EvaluationMetric
    >("LegacyCompetitionHostService/GetEvaluationMetric"),
    setEvaluationMetric: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.SetEvaluationMetricRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetEvaluationMetric"),
    setEvaluationMetricParameters: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.SetEvaluationMetricParametersRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetEvaluationMetricParameters"),
    // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly yet to preserve existing client behavior of
    //     expecting a null value if not set.)
    getSolutionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetSolutionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.GetSolutionColumnMappingResponse
    >("LegacyCompetitionHostService/GetSolutionColumnMapping"),
    // (-- aip.dev/not-precedent: Not returning a ColumnMapping message directly yet to preserve existing client behavior of
    //     expecting a null value if not set.)
    getSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.GetSubmissionColumnMappingResponse
    >("LegacyCompetitionHostService/GetSubmissionColumnMapping"),
    // Note that this name is somewhat overloaded in that it checks if there is a mapping OR if it's a simulations competition.
    // It should likely be refactored to clean this up.
    getCompetitionHasSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetCompetitionHasSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.GetCompetitionHasSubmissionColumnMappingResponse
    >("LegacyCompetitionHostService/GetCompetitionHasSubmissionColumnMapping"),
    updateSubmissionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.UpdateSubmissionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateSubmissionColumnMapping"),
    updateSolutionColumnMapping: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.UpdateSolutionColumnMappingRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateSolutionColumnMapping"),
    getSolutionInfo: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetSolutionInfoRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.SolutionInfo
    >("LegacyCompetitionHostService/GetSolutionInfo"),
    toggleBenchmarkSubmission: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.ToggleBenchmarkSubmissionRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/ToggleBenchmarkSubmission"),
    setBenchmarkSubmissionName: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.SetBenchmarkSubmissionNameRequest,
      google.protobuf.Empty
    >("LegacyCompetitionHostService/SetBenchmarkSubmissionName"),
    // Gets details to render the host checklist page.
    getHostChecklist: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.GetHostChecklistRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.HostChecklist
    >("LegacyCompetitionHostService/GetHostChecklist"),
    // Launch the competition (or set it to be launched in the future) so that it becomes visible to participants.
    launchCompetition: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.LaunchCompetitionRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.LaunchCompetitionResponse
    >("LegacyCompetitionHostService/LaunchCompetition"),
    // Rescores the specified submissions.
    rescoreSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.RescoreSubmissionsRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/RescoreSubmissions"),
    invalidateSubmissions: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.InvalidateSubmissionsRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/InvalidateSubmissions"),
    updateTeamVisibility: createRequestClient<
      Kaggle.Sdk.Competitions.Protos.Legacy.UpdateTeamVisibilityRequest,
      Kaggle.Sdk.Competitions.Protos.Legacy.BackgroundOperation
    >("LegacyCompetitionHostService/UpdateTeamVisibility"),
  },
};
/** Datasets client fetch bindings. */
export const datasetsClient = {
  acceptTaskSubmission: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.AcceptTaskSubmissionRequest,
    void
  >("AcceptTaskSubmissionRequest"),
  addDatasetCategories: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.AddDatasetCategoriesRequest,
    Kaggle.Sdk.Datasets.Responses.AddDatasetCategoriesResponse
  >("AddDatasetCategoriesRequest"),
  attachCompetitionDataset: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.AttachCompetitionDatasetRequest,
    void
  >("AttachCompetitionDatasetRequest"),
  createCompetitionDataRequestV2: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateCompetitionDataRequestV2,
    Kaggle.Sdk.Datasets.Models.Creation.DataCreationResponse
  >("CreateCompetitionDataRequestV2"),
  createDatasetHashLink: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateDatasetHashLinkRequest,
    string
  >("CreateDatasetHashLinkRequest"),
  createDatasetRequestV2: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateDatasetRequestV2,
    Kaggle.Sdk.Datasets.Models.Creation.DatasetCreationResponse
  >("CreateDatasetRequestV2"),
  createDatasetVersionRequestV2: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateDatasetVersionRequestV2,
    Kaggle.Sdk.Datasets.Models.Creation.DatasetCreationResponse
  >("CreateDatasetVersionRequestV2"),
  createDoiApprover: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateDoiApproverRequest,
    Kaggle.Sdk.Datasets.Responses.CreateDoiApproverResponse
  >("CreateDoiApproverRequest"),
  createDoi: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateDoiRequest,
    Kaggle.Sdk.Datasets.Responses.CreateDoiResponse
  >("CreateDoiRequest"),
  createRequestV2: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateRequestV2,
    void
  >("CreateRequestV2"),
  createTask: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateTaskRequest,
    Kaggle.Sdk.Datasets.Responses.CreateTaskResponse
  >("CreateTaskRequest"),
  createTaskSubmission: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.CreateTaskSubmissionRequest,
    void
  >("CreateTaskSubmissionRequest"),
  deleteDatasetBySlug: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteDatasetBySlugRequest,
    void
  >("DeleteDatasetBySlugRequest"),
  deleteDatasetCategories: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteDatasetCategoriesRequest,
    Kaggle.Sdk.Datasets.Responses.DeleteDatasetCategoriesResponse
  >("DeleteDatasetCategoriesRequest"),
  deleteDatasetHashLink: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteDatasetHashLinkRequest,
    void
  >("DeleteDatasetHashLinkRequest"),
  deleteTask: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteTaskRequest,
    void
  >("DeleteTaskRequest"),
  deleteTaskSubmission: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteTaskSubmissionRequest,
    void
  >("DeleteTaskSubmissionRequest"),
  deleteUserTasks: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DeleteUserTasksRequest,
    void
  >("DeleteUserTasksRequest"),
  detectDuplicate: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.DetectDuplicateRequest,
    Kaggle.Sdk.Datasets.Models.Creation.DuplicationReference
  >("DetectDuplicateRequest"),
  editDatasetDescription: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.EditDatasetDescriptionRequest,
    Kaggle.Sdk.Datasets.Responses.EditDatasetDescriptionResponse
  >("EditDatasetDescriptionRequest"),
  editTask: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.EditTaskRequest,
    void
  >("EditTaskRequest"),
  getCompetitionUploaderConfig: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetCompetitionUploaderConfigRequest,
    Kaggle.Sdk.Datasets.Models.Creation.CompetitionUploaderConfig
  >("GetCompetitionUploaderConfigRequest"),
  getDataViewExternal: createRequestClient<
    Kaggle.Sdk.Datasets.DataViewer.Requests.GetDataViewExternalRequest,
    Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponse
  >("GetDataViewExternalRequest"),
  getDatabundleExternalChildren: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatabundleExternalChildrenRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatabundleExternalChildrenResponse
  >("GetDatabundleExternalChildrenRequest"),
  getDatabundleExternalColumnsByFirestorePath: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatabundleExternalColumnsByFirestorePathRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatabundleExternalColumnsByFirestorePathResponse
  >("GetDatabundleExternalColumnsByFirestorePathRequest"),
  getDatabundleExternalColumns: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatabundleExternalColumnsRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatabundleExternalColumnsResponse
  >("GetDatabundleExternalColumnsRequest"),
  getDatabundleExternal: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatabundleExternalRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatabundleExternalResponse
  >("GetDatabundleExternalRequest"),
  getDatabundleVersionCreationStatus: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatabundleVersionCreationStatusRequest,
    Kaggle.Sdk.Datasets.Models.DatabundleVersionCreationStatus
  >("GetDatabundleVersionCreationStatusRequest"),
  getDatabundleVersionsForDatasetVersionIds: createRequestClient<
    Kaggle.Sdk.Datasets.Databundles.Requests.GetDatabundleVersionsForDatasetVersionIdsRequest,
    Kaggle.Sdk.Datasets.Databundles.Models.DataObjects.DatabundleVersionList
  >("GetDatabundleVersionsForDatasetVersionIdsRequest"),
  getDatasetActivity: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetActivityRequest,
    Kaggle.Sdk.Datasets.Models.ActivityPage
  >("GetDatasetActivityRequest"),
  getDatasetByUrl: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetByUrlRequest,
    Kaggle.Sdk.Datasets.Models.DatasetListItem
  >("GetDatasetByUrlRequest"),
  getDatasetHistory: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetHistoryRequest,
    Kaggle.Sdk.Datasets.Models.DatasetHistory
  >("GetDatasetHistoryRequest"),
  getDatasetLimits: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetLimitsRequest,
    Kaggle.Sdk.Datasets.Models.DatasetLimits
  >("GetDatasetLimitsRequest"),
  getDatasetMetadata: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetMetadataRequest,
    Kaggle.Sdk.Datasets.Models.DatasetMetadata
  >("GetDatasetMetadataRequest"),
  getDatasetSuggestions: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetSuggestionsRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatasetSuggestionsResponse
  >("GetDatasetSuggestionsRequest"),
  getDatasetTasksById: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetTasksByIdRequest,
    (Kaggle.Sdk.Datasets.Models.TaskListItem)[]
  >("GetDatasetTasksByIdRequest"),
  getDatasetTasks: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetTasksRequest,
    Kaggle.Sdk.Datasets.Responses.GetDatasetTasksResponse
  >("GetDatasetTasksRequest"),
  getDatasetUploaderConfig: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetUploaderConfigRequest,
    Kaggle.Sdk.Datasets.Models.Creation.DatasetUploaderConfig
  >("GetDatasetUploaderConfigRequest"),
  getDatasetsById: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetDatasetsByIdRequest,
    Kaggle.Sdk.Datasets.Models.DatasetList
  >("GetDatasetsByIdRequest"),
  getExistingUploadFiles: createRequestClient<
    Kaggle.Sdk.Datasets.Databundles.Requests.GetExistingUploadFilesRequest,
    Kaggle.Sdk.Datasets.Databundles.Responses.GetExistingUploadFilesResponse
  >("GetExistingUploadFilesRequest"),
  getFirestorePathForDatabundleField: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetFirestorePathForDatabundleFieldRequest,
    (string)[]
  >("GetFirestorePathForDatabundleFieldRequest"),
  getGithubRepositoryInfo: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetGithubRepositoryInfoRequest,
    (Kaggle.Sdk.Datasets.Models.Creation.GithubRepositoryContent)[]
  >("GetGithubRepositoryInfoRequest"),
  getKernelOutputDataViewExternal: createRequestClient<
    Kaggle.Sdk.Datasets.DataViewer.Requests.GetKernelOutputDataViewExternalRequest,
    Kaggle.Sdk.Datasets.DataViewer.Protos.GetDataViewResponse
  >("GetKernelOutputDataViewExternalRequest"),
  getKernelOutputDataset: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetKernelOutputDatasetRequest,
    Kaggle.Sdk.Datasets.Models.KernelOutputDatasetReference
  >("GetKernelOutputDatasetRequest"),
  getLandingPageTopics: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetLandingPageTopicsRequest,
    Kaggle.Sdk.Datasets.Responses.GetLandingPageTopicsResponse
  >("GetLandingPageTopicsRequest"),
  getPossibleCompetitionDatasets: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetPossibleCompetitionDatasetsRequest,
    Kaggle.Sdk.Datasets.Models.DatasetList
  >("GetPossibleCompetitionDatasetsRequest"),
  getPossibleTaskSubmissions: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetPossibleTaskSubmissionsRequest,
    Kaggle.Sdk.Datasets.Responses.GetPossibleTaskSubmissionsResponse
  >("GetPossibleTaskSubmissionsRequest"),
  getRecentlyViewedDatasets: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetRecentlyViewedDatasetsRequest,
    Kaggle.Sdk.Datasets.Models.DatasetList
  >("GetRecentlyViewedDatasetsRequest"),
  getRemoteUrlFileInfo: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetRemoteUrlFileInfoRequest,
    Kaggle.Sdk.Datasets.Models.RemoteUrlUploadFile
  >("GetRemoteUrlFileInfoRequest"),
  getSidebarTasks: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetSidebarTasksRequest,
    Kaggle.Sdk.Datasets.Responses.GetSidebarTasksResponse
  >("GetSidebarTasksRequest"),
  getTask: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetTaskRequest,
    Kaggle.Sdk.Datasets.Models.TaskModel
  >("GetTaskRequest"),
  getTaskSubmissions: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetTaskSubmissionsRequest,
    Kaggle.Sdk.Datasets.Responses.GetTaskSubmissionsResponse
  >("GetTaskSubmissionsRequest"),
  getTopicalDatasets: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetTopicalDatasetsRequest,
    Kaggle.Sdk.Datasets.Responses.GetTopicalDatasetsResponse
  >("GetTopicalDatasetsRequest"),
  getTopicalTasks: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetTopicalTasksRequest,
    Kaggle.Sdk.Datasets.Responses.GetTopicalTasksResponse
  >("GetTopicalTasksRequest"),
  getUserDoiDatasets: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetUserDoiDatasetsRequest,
    (/*Int32*/ number)[]
  >("GetUserDoiDatasetsRequest"),
  getUserSubmissions: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.GetUserSubmissionsRequest,
    Kaggle.Sdk.Datasets.Responses.GetUserSubmissionsResponse
  >("GetUserSubmissionsRequest"),
  refreshRemoteDataset: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.RefreshRemoteDatasetRequest,
    Kaggle.Sdk.Datasets.Models.Creation.DatasetCreationResponse
  >("RefreshRemoteDatasetRequest"),
  searchDatasets: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SearchDatasetsRequest,
    Kaggle.Sdk.Datasets.Responses.SearchDatasetsResponse
  >("SearchDatasetsRequest"),
  searchTasks: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SearchTasksRequest,
    Kaggle.Sdk.Datasets.Responses.SearchTasksResponse
  >("SearchTasksRequest"),
  setDatabundleVersionNotes: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SetDatabundleVersionNotesRequest,
    void
  >("SetDatabundleVersionNotesRequest"),
  setDatasetChecklistVisibility: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SetDatasetChecklistVisibilityRequest,
    void
  >("SetDatasetChecklistVisibilityRequest"),
  setDatasetCollaboratorList: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SetDatasetCollaboratorListRequest,
    void
  >("SetDatasetCollaboratorListRequest"),
  softDeleteDatasetsForOrg: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SoftDeleteDatasetsForOrgRequest,
    void
  >("SoftDeleteDatasetsForOrgRequest"),
  softDeleteDatasetsForUser: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.SoftDeleteDatasetsForUserRequest,
    void
  >("SoftDeleteDatasetsForUserRequest"),
  taskVote: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.TaskVoteRequest,
    void
  >("TaskVoteRequest"),
  testApi: createRequestClient<
    Kaggle.Sdk.Datasets.DataViewer.Protos.TestApiRequest,
    Kaggle.Sdk.Datasets.DataViewer.Protos.TestApiResponse
  >("TestApiRequest"),
  unacceptTaskSubmissions: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UnacceptTaskSubmissionsRequest,
    void
  >("UnacceptTaskSubmissionsRequest"),
  undeleteDatasetsForUser: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UndeleteDatasetsForUserRequest,
    void
  >("UndeleteDatasetsForUserRequest"),
  updateDatabundleColumns: createRequestClient<
    Kaggle.Sdk.Datasets.Databundles.Requests.UpdateDatabundleColumnsRequest,
    Kaggle.Sdk.Datasets.Databundles.Responses.UpdateDatabundleResponse
  >("UpdateDatabundleColumnsRequest"),
  updateDatabundleMetadataExternal: createRequestClient<
    Kaggle.Sdk.Datasets.Databundles.Requests.UpdateDatabundleMetadataExternalRequest,
    Kaggle.Sdk.Datasets.Responses.UpdateDatabundleMetadataExternalResponse
  >("UpdateDatabundleMetadataExternalRequest"),
  updateDatabundleObject: createRequestClient<
    Kaggle.Sdk.Datasets.Databundles.Requests.UpdateDatabundleObjectRequest,
    Kaggle.Sdk.Datasets.Databundles.Responses.UpdateDatabundleResponse
  >("UpdateDatabundleObjectRequest"),
  updateDatasetCollaborators: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetCollaboratorsRequest,
    void
  >("UpdateDatasetCollaboratorsRequest"),
  updateDatasetGeneral: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetGeneralRequest,
    Kaggle.Sdk.Datasets.Responses.UpdateDatasetGeneralSettingsResponse
  >("UpdateDatasetGeneralRequest"),
  updateDatasetGeneralSettings: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetGeneralSettingsRequest,
    Kaggle.Sdk.Datasets.Responses.UpdateDatasetGeneralSettingsResponse
  >("UpdateDatasetGeneralSettingsRequest"),
  updateDatasetMetadata: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetMetadataRequest,
    Kaggle.Sdk.Datasets.Models.DatasetUsabilityRating
  >("UpdateDatasetMetadataRequest"),
  updateDatasetPrivacy: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetPrivacyRequest,
    void
  >("UpdateDatasetPrivacyRequest"),
  updateDataset: createRequestClient<
    Kaggle.Sdk.Datasets.Requests.UpdateDatasetRequest,
    Kaggle.Sdk.Datasets.Responses.UpdateDatasetResponse
  >("UpdateDatasetRequest"),
  datasetService: {
    // retrieve counts of the content that the user has created. This is used for display on the User Profile > Dataset tab
    getProfileDatasetStats: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.GetProfileDatasetStatsRequest,
      Kaggle.Sdk.Datasets.Protos.GetProfileDatasetStatsResponse
    >("DatasetService/GetProfileDatasetStats"),
    // Sometime the databundle zipper would fail, this give moderator/host to recreate the databundle zip file
    recreateDatasetArchive: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.RecreateDatasetArchiveRequest,
      Kaggle.Sdk.Datasets.Protos.RecreateDatasetArchiveResponse
    >("DatasetService/RecreateDatasetArchive"),
  },
  datasetDetailService: {
    getDatasetBasics: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.GetDatasetBasicsRequest,
      Kaggle.Sdk.Datasets.Protos.DatasetBasics
    >("DatasetDetailService/GetDatasetBasics"),
    getDatasetSettings: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.GetDatasetSettingsRequest,
      Kaggle.Sdk.Datasets.Protos.DatasetSettings
    >("DatasetDetailService/GetDatasetSettings"),
    setDatasetSettings: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.SetDatasetSettingsRequest,
      google.protobuf.Empty
    >("DatasetDetailService/SetDatasetSettings"),
    getDatasetUsabilityRating: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.GetDatasetUsabilityRatingRequest,
      Kaggle.Sdk.Datasets.Protos.GetDatasetUsabilityRatingResponse
    >("DatasetDetailService/GetDatasetUsabilityRating"),
    getDatasetImageInfo: createRequestClient<
      Kaggle.Sdk.Datasets.Protos.GetDatasetImageInfoRequest,
      Kaggle.Sdk.Datasets.Protos.GetDatasetImageInfoResponse
    >("DatasetDetailService/GetDatasetImageInfo"),
  },
};
/** Kernels client fetch bindings. */
export const kernelsClient = {
  acceptKernelCompetitionRules: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.AcceptKernelCompetitionRulesRequest,
    void
  >("AcceptKernelCompetitionRulesRequest"),
  addKernelCategory: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.AddKernelCategoryRequest,
    Kaggle.Sdk.Tags.Responses.CategorizationResponse
  >("AddKernelCategoryRequest"),
  autoSave: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.AutoSaveRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelDraftResponse
  >("AutoSaveRequest"),
  batchAutoTagKernels: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.BatchAutoTagKernelsRequest,
    Kaggle.Sdk.Kernels.Models.BatchAutoTagKernelsResponse
  >("BatchAutoTagKernelsRequest"),
  cancelKernelRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CancelKernelRunRequest,
    Kaggle.Sdk.Kernels.Models.CancelKernelRunResponse
  >("CancelKernelRunRequest"),
  commitAndRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CommitAndRunRequest,
    Kaggle.Sdk.Kernels.Models.CommitAndRunResponse
  >("CommitAndRunRequest"),
  completeQuickSession: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CompleteQuickSessionRequest,
    Kaggle.Sdk.Kernels.Models.CompleteQuickSessionResponse
  >("CompleteQuickSessionRequest"),
  computeKernelDiff: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ComputeKernelDiffRequest,
    Kaggle.Sdk.Kernels.Models.ComputeKernelDiffResponse
  >("ComputeKernelDiffRequest"),
  createKernel: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CreateKernelRequest,
    Kaggle.Sdk.Kernels.Models.CreateKernelResponse
  >("CreateKernelRequest"),
  createKernelRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CreateKernelRunRequest,
    Kaggle.Sdk.Kernels.Models.CreateKernelRunResponse
  >("CreateKernelRunRequest"),
  createKernelUpvote: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CreateKernelUpvoteRequest,
    Kaggle.Sdk.Kernels.Models.CreateKernelUpvoteResponse
  >("CreateKernelUpvoteRequest"),
  createKernelWithSettings: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CreateKernelWithSettingsRequest,
    Kaggle.Sdk.Kernels.Models.CreateKernelWithSettingsResponse
  >("CreateKernelWithSettingsRequest"),
  createSnippet: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.CreateSnippetRequest,
    Kaggle.Sdk.Kernels.Models.CreateSnippetResponse
  >("CreateSnippetRequest"),
  deleteKernel: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.DeleteKernelRequest,
    Kaggle.Sdk.Kernels.Models.DeleteKernelResponse
  >("DeleteKernelRequest"),
  deleteKernelUpvote: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.DeleteKernelUpvoteRequest,
    Kaggle.Sdk.Kernels.Models.DeleteKernelUpvoteResponse
  >("DeleteKernelUpvoteRequest"),
  deleteSnippet: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.DeleteSnippetRequest,
    Kaggle.Sdk.Kernels.Models.DeleteSnippetResponse
  >("DeleteSnippetRequest"),
  exportKernelRunForCaip: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ExportKernelRunForCaipRequest,
    Kaggle.Sdk.Kernels.Models.ExportKernelRunForCaipResponse
  >("ExportKernelRunForCaipRequest"),
  fetchExternalKernelContent: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.FetchExternalKernelContentRequest,
    Kaggle.Sdk.Kernels.Models.FetchExternalKernelContentResponse
  >("FetchExternalKernelContentRequest"),
  fetchGitHubContent: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.FetchGitHubContentRequest,
    Kaggle.Sdk.Kernels.Models.FetchGitHubContentResponse
  >("FetchGitHubContentRequest"),
  getAcceleratorQuotaStatistics: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetAcceleratorQuotaStatisticsRequest,
    Kaggle.Sdk.Kernels.Models.GetAcceleratorQuotaStatisticsResponse
  >("GetAcceleratorQuotaStatisticsRequest"),
  getActiveInteractiveKernelRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetActiveInteractiveKernelRunRequest,
    Kaggle.Sdk.Kernels.Models.KernelRun
  >("GetActiveInteractiveKernelRunRequest"),
  getDefaultSessionSettings: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetDefaultSessionSettingsRequest,
    Kaggle.Sdk.Kernels.Models.DefaultSessionSettings
  >("GetDefaultSessionSettingsRequest"),
  getDeletedKernel: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetDeletedKernelRequest,
    Kaggle.Sdk.Kernels.Models.GetDeletedKernelResponse
  >("GetDeletedKernelRequest"),
  getFirebaseAuthToken: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetFirebaseAuthTokenRequest,
    Kaggle.Sdk.Kernels.Models.GetFirebaseAuthTokenResponse
  >("GetFirebaseAuthTokenRequest"),
  getFirebaseConfig: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetFirebaseConfigRequest,
    Kaggle.Sdk.Kernels.Models.GetFirebaseConfigResponse
  >("GetFirebaseConfigRequest"),
  getKernelCategoryIds: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelCategoryIdsRequest,
    Kaggle.Sdk.Kernels.Models.KernelCategoryIdList
  >("GetKernelCategoryIdsRequest"),
  getKernelCollaboratorList: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelCollaboratorListRequest,
    Kaggle.Sdk.Kernels.Models.GetKernelCollaboratorListResponse
  >("GetKernelCollaboratorListRequest"),
  getKernelDraft: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelDraftRequest,
    Kaggle.Sdk.Kernels.Models.KernelDraft
  >("GetKernelDraftRequest"),
  getKernelLandingPage: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelLandingPageRequest,
    Kaggle.Sdk.Kernels.Models.GetKernelLandingPageResponse
  >("GetKernelLandingPageRequest"),
  getKernelListDetails: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelListDetailsRequest,
    Kaggle.Sdk.Kernels.Models.KernelList
  >("GetKernelListDetailsRequest"),
  getKernel: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelRequest,
    Kaggle.Sdk.Kernels.Models.Kernel
  >("GetKernelRequest"),
  getKernelRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelRunRequest,
    Kaggle.Sdk.Kernels.Models.KernelRun
  >("GetKernelRunRequest"),
  getKernelRunSource: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelRunSourceRequest,
    Kaggle.Sdk.Kernels.Models.GetKernelRunSourceResponse
  >("GetKernelRunSourceRequest"),
  getKernelSessionDataSources: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelSessionDataSourcesRequest,
    Kaggle.Sdk.Kernels.Models.GetKernelSessionDataSourcesResponse
  >("GetKernelSessionDataSourcesRequest"),
  getKernelSessionUnit: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelSessionUnitRequest,
    Kaggle.Sdk.Kernels.Models.KernelSessionUnit
  >("GetKernelSessionUnitRequest"),
  getKernelStatus: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetKernelStatusRequest,
    Kaggle.Sdk.Kernels.Models.GetKernelStatusResponse
  >("GetKernelStatusRequest"),
  getOrCreateKernelSession: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetOrCreateKernelSessionRequest,
    Kaggle.Sdk.Kernels.Models.GetOrCreateKernelSessionResponse
  >("GetOrCreateKernelSessionRequest"),
  getSourceIndexData: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetSourceIndexDataRequest,
    Kaggle.Sdk.Kernels.Models.GetSourceIndexDataResponse
  >("GetSourceIndexDataRequest"),
  getUserKernelAchievements: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.GetUserKernelAchievementsRequest,
    Kaggle.Sdk.Kernels.Models.GetUserKernelAchievementsResponse
  >("GetUserKernelAchievementsRequest"),
  hasAcceptedKernelCompetitionRules: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.HasAcceptedKernelCompetitionRulesRequest,
    Kaggle.Sdk.Kernels.Models.HasAcceptedKernelCompetitionRulesResponse
  >("HasAcceptedKernelCompetitionRulesRequest"),
  indexAllSnippets: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.IndexAllSnippetsRequest,
    Kaggle.Sdk.Kernels.Models.IndexAllSnippetsResponse
  >("IndexAllSnippetsRequest"),
  listDockerImages: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListDockerImagesRequest,
    Kaggle.Sdk.Kernels.Models.DockerImageVersionDetailsList
  >("ListDockerImagesRequest"),
  listGithubRepositories: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListGithubRepositoriesRequest,
    Kaggle.Sdk.Kernels.Models.ListGithubRepositoriesResponse
  >("ListGithubRepositoriesRequest"),
  listGithubRepositoryBranches: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListGithubRepositoryBranchesRequest,
    Kaggle.Sdk.Kernels.Models.ListGithubRepositoryBranchesResponse
  >("ListGithubRepositoryBranchesRequest"),
  listGithubRepositoryFiles: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListGithubRepositoryFilesRequest,
    Kaggle.Sdk.Kernels.Models.ListGithubRepositoryFilesResponse
  >("ListGithubRepositoryFilesRequest"),
  listKernelIds: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelIdsRequest,
    (/*Int32*/ number)[]
  >("ListKernelIdsRequest"),
  listKernelRunLogs: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelRunLogsRequest,
    Kaggle.Sdk.Kernels.Requests.ListKernelRunLogsResponse
  >("ListKernelRunLogsRequest"),
  listKernelRunOutput: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelRunOutputRequest,
    Kaggle.Sdk.Kernels.Models.ListKernelRunOutputResponse
  >("ListKernelRunOutputRequest"),
  listKernelSessions: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelSessionsRequest,
    Kaggle.Sdk.Kernels.Models.KernelSessionList
  >("ListKernelSessionsRequest"),
  listKernelVersions: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelVersionsRequest,
    Kaggle.Sdk.Kernels.Models.KernelVersionList
  >("ListKernelVersionsRequest"),
  listKernels: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListKernelsRequest,
    Kaggle.Sdk.Kernels.Models.KernelList
  >("ListKernelsRequest"),
  listSnippets: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.ListSnippetsRequest,
    Kaggle.Sdk.Kernels.Models.ListSnippetsResponse
  >("ListSnippetsRequest"),
  promoteKernelDraft: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.PromoteKernelDraftRequest,
    Kaggle.Sdk.Kernels.Models.PromoteKernelDraftResponse
  >("PromoteKernelDraftRequest"),
  removeKernelCategory: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.RemoveKernelCategoryRequest,
    Kaggle.Sdk.Tags.Responses.CategorizationResponse
  >("RemoveKernelCategoryRequest"),
  runEpisode: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.RunEpisodeRequest,
    string
  >("RunEpisodeRequest"),
  searchKernelIds: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.SearchKernelIdsRequest,
    void
  >("SearchKernelIdsRequest"),
  snippetData: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.SnippetData,
    void
  >("SnippetData"),
  updateDefaultSessionSettings: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateDefaultSessionSettingsRequest,
    void
  >("UpdateDefaultSessionSettingsRequest"),
  updateDockerImageVersion: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateDockerImageVersionRequest,
    Kaggle.Sdk.Kernels.Models.UpdateDockerImageVersionResponse
  >("UpdateDockerImageVersionRequest"),
  updateDockerPinningType: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateDockerPinningTypeRequest,
    Kaggle.Sdk.Kernels.Models.UpdateDockerPinningTypeResponse
  >("UpdateDockerPinningTypeRequest"),
  updateKernelCollaborators: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelCollaboratorsRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelCollaboratorsResponse
  >("UpdateKernelCollaboratorsRequest"),
  updateKernelPrivacy: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelPrivacyRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelPrivacyResponse
  >("UpdateKernelPrivacyRequest"),
  updateKernelRunDataSources: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelRunDataSourcesRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelRunDataSourcesResponse
  >("UpdateKernelRunDataSourcesRequest"),
  updateKernelRun: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelRunRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelRunResponse
  >("UpdateKernelRunRequest"),
  updateKernelSessionKeepalive: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelSessionKeepaliveRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelSessionKeepaliveResponse
  >("UpdateKernelSessionKeepaliveRequest"),
  updateKernelTitle: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelTitleRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelTitleResponse
  >("UpdateKernelTitleRequest"),
  updateKernelVersionName: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateKernelVersionNameRequest,
    Kaggle.Sdk.Kernels.Models.UpdateKernelVersionNameResponse
  >("UpdateKernelVersionNameRequest"),
  updatePinnedKernelSession: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdatePinnedKernelSessionRequest,
    Kaggle.Sdk.Kernels.Models.UpdatePinnedKernelSessionResponse
  >("UpdatePinnedKernelSessionRequest"),
  updateSnippet: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateSnippetRequest,
    Kaggle.Sdk.Kernels.Models.UpdateSnippetResponse
  >("UpdateSnippetRequest"),
  updateUserKernelFirestoreAuth: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UpdateUserKernelFirestoreAuthRequest,
    Kaggle.Sdk.Kernels.Models.UpdateUserKernelFirestoreAuthResponse
  >("UpdateUserKernelFirestoreAuthRequest"),
  uploadKernelSessionOutput: createRequestClient<
    Kaggle.Sdk.Kernels.Requests.UploadKernelSessionOutputRequest,
    void
  >("UploadKernelSessionOutputRequest"),
};
/** Notifications client fetch bindings. */
export const notificationsClient = {
  setUserNotificationSettings: createRequestClient<
    Kaggle.Sdk.Notifications.Requests.SetUserNotificationSettingsRequest,
    void
  >("SetUserNotificationSettingsRequest"),
  userNotificationSettings: createRequestClient<
    Kaggle.Sdk.Notifications.Requests.UserNotificationSettingsRequest,
    Kaggle.Sdk.Notifications.Models.UserNotificationSettings
  >("UserNotificationSettingsRequest"),
  notificationsService: {
    // Set the read or viewed status on a single notification or many notifications.
    markNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.MarkNotificationsRequest,
      google.protobuf.Empty
    >("NotificationsService/MarkNotifications"),
    // Get the list of notifications for the current user.
    getUserNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.GetUserNotificationsRequest,
      Kaggle.Sdk.Notifications.Protos.GetUserNotificationsResponse
    >("NotificationsService/GetUserNotifications"),
    // directly creates a new notification in the notification table and sends email.
    addTestNotification: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.AddTestNotificationRequest,
      Kaggle.Sdk.Notifications.Protos.AddTestNotificationResponse
    >("NotificationsService/AddTestNotification"),
    // Mark all notification as (read|viewed) for a user
    markAllNotifications: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.MarkAllNotificationsRequest,
      google.protobuf.Empty
    >("NotificationsService/MarkAllNotifications"),
  },
  subscriptionService: {
    getMySubscribeState: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.GetMySubscribeStateRequest,
      Kaggle.Sdk.Notifications.Protos.GetSubscribeStateResponse
    >("SubscriptionService/GetMySubscribeState"),
    subscribeTo: createRequestClient<
      Kaggle.Sdk.Notifications.Protos.SubscribeToRequest,
      google.protobuf.Empty
    >("SubscriptionService/SubscribeTo"),
  },
};
/** Search client fetch bindings. */
export const searchClient = {
  fullSearchWeb: createRequestClient<
    Kaggle.Sdk.Search.Requests.FullSearchWebRequest,
    Kaggle.Sdk.Search.Protos.FullSearchResponse
  >("FullSearchWebRequest"),
  suggestedSearchWeb: createRequestClient<
    Kaggle.Sdk.Search.Requests.SuggestedSearchWebRequest,
    Kaggle.Sdk.Search.Protos.SuggestedSearchResponse
  >("SuggestedSearchWebRequest"),
  // Search is structured such that some handlers live on a service-host container and a proxied by web pods, while some
  // handlers live on the actual web monolith. Because a ProtoServiceRegistration requires all RPCs to have mapped
  // handlers, it's thus necessary to divide these two services so that web pods can have their own RPCs while not
  // defining handlers for the proxied requests.
  searchWebService: {
    getAutoCompleteSuggestions: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsRequest,
      Kaggle.Sdk.Search.Protos.GetAutoCompleteSuggestionsResponse
    >("SearchWebService/GetAutoCompleteSuggestions"),
    getPopularTags: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetPopularTagsRequest,
      Kaggle.Sdk.Search.Protos.GetPopularTagsResponse
    >("SearchWebService/GetPopularTags"),
    getRecentSearches: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetRecentSearchesRequest,
      Kaggle.Sdk.Search.Protos.GetRecentSearchesResponse
    >("SearchWebService/GetRecentSearches"),
    getTrendingSearches: createRequestClient<
      Kaggle.Sdk.Search.Protos.GetTrendingSearchesRequest,
      Kaggle.Sdk.Search.Protos.GetTrendingSearchesResponse
    >("SearchWebService/GetTrendingSearches"),
    timeSpentOnClickedResult: createRequestClient<
      Kaggle.Sdk.Search.Protos.TimeSpentOnClickedResultRequest,
      google.protobuf.Empty
    >("SearchWebService/TimeSpentOnClickedResult"),
    logSearch: createRequestClient<
      Kaggle.Sdk.Search.Protos.LogSearchRequest,
      google.protobuf.Empty
    >("SearchWebService/LogSearch"),
  },
};
/** Tags client fetch bindings. */
export const tagsClient = {
  getTagsById: createRequestClient<
    Kaggle.Sdk.Tags.Requests.GetTagsByIdRequest,
    Kaggle.Sdk.Tags.Models.TagList
  >("GetTagsByIdRequest"),
  getTags: createRequestClient<
    Kaggle.Sdk.Tags.Requests.GetTagsRequest,
    Kaggle.Sdk.Tags.Models.TagList
  >("GetTagsRequest"),
  searchTags: createRequestClient<
    Kaggle.Sdk.Tags.Requests.SearchTagsRequest,
    Kaggle.Sdk.Tags.Models.TagList
  >("SearchTagsRequest"),
  tagService: {
    // Tag a given forum topic with one or many tags, removing any tags not specified in the request
    updateForumTopicTags: createRequestClient<
      Kaggle.Sdk.Tags.Protos.UpdateForumTopicTagsRequest,
      Kaggle.Sdk.Tags.Protos.UpdateForumTopicTagsResponse
    >("TagService/UpdateForumTopicTags"),
    // Tag a given learn track with one or many tags
    createLearnTrackTags: createRequestClient<
      Kaggle.Sdk.Tags.Protos.CreateLearnTrackTagsRequest,
      Kaggle.Sdk.Tags.Protos.CreateLearnTrackTagsResponse
    >("TagService/CreateLearnTrackTags"),
    // Untag a given learn track, removing one or many tags
    deleteLearnTrackTags: createRequestClient<
      Kaggle.Sdk.Tags.Protos.DeleteLearnTrackTagsRequest,
      Kaggle.Sdk.Tags.Protos.DeleteLearnTrackTagsResponse
    >("TagService/DeleteLearnTrackTags"),
    // Toggle the state of a follow for the current user on a given tag
    updateTagFollow: createRequestClient<
      Kaggle.Sdk.Tags.Protos.UpdateTagFollowRequest,
      Kaggle.Sdk.Tags.Protos.UpdateTagFollowResponse
    >("TagService/UpdateTagFollow"),
    // Tag a given competition with one or many tags
    createCompetitionTags: createRequestClient<
      Kaggle.Sdk.Tags.Protos.CreateCompetitionTagsRequest,
      Kaggle.Sdk.Tags.Protos.CreateCompetitionTagsResponse
    >("TagService/CreateCompetitionTags"),
    // Untag a given competition, removing one or many tags
    deleteCompetitionTags: createRequestClient<
      Kaggle.Sdk.Tags.Protos.DeleteCompetitionTagsRequest,
      Kaggle.Sdk.Tags.Protos.DeleteCompetitionTagsResponse
    >("TagService/DeleteCompetitionTags"),
    // Fetch the hierarchical structure of all tags
    getTagHierarchy: createRequestClient<
      Kaggle.Sdk.Tags.Protos.GetTagHierarchyRequest,
      Kaggle.Sdk.Tags.Protos.GetTagHierarchyResponse
    >("TagService/GetTagHierarchy"),
    tagDatasetTask: createRequestClient<
      Kaggle.Sdk.Tags.Protos.TagDatasetTaskRequest,
      google.protobuf.Empty
    >("TagService/TagDatasetTask"),
    untagDatasetTask: createRequestClient<
      Kaggle.Sdk.Tags.Protos.UntagDatasetTaskRequest,
      google.protobuf.Empty
    >("TagService/UntagDatasetTask"),
    searchTagsLegacy: createRequestClient<
      Kaggle.Sdk.Tags.Protos.SearchTagsLegacyRequest,
      Kaggle.Sdk.Tags.Protos.SearchTagsLegacyResponse
    >("TagService/SearchTagsLegacy"),
  },
};
/** UserSecrets client fetch bindings. */
export const userSecretsClient = {
  addSecretKernelAttachment: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.AddSecretKernelAttachmentRequest,
    Kaggle.Sdk.UserSecrets.Models.UserSecretKernelAttachmentMetadata
  >("AddSecretKernelAttachmentRequest"),
  deleteSecretKernelAttachment: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.DeleteSecretKernelAttachmentRequest,
    /*Empty*/ unknown
  >("DeleteSecretKernelAttachmentRequest"),
  deleteUserSecret: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.DeleteUserSecretRequest,
    Kaggle.Sdk.UserSecrets.Models.DeleteUserSecretResponse
  >("DeleteUserSecretRequest"),
  exchangeGcloudAuthorizationCode: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.ExchangeGcloudAuthorizationCodeRequest,
    Kaggle.Sdk.UserSecrets.Models.UserSecretMetadata
  >("ExchangeGcloudAuthorizationCodeRequest"),
  getGitHubAccessInfo: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.GetGitHubAccessInfoRequest,
    Kaggle.Sdk.UserSecrets.Models.GetGitHubAccessInfoResponse
  >("GetGitHubAccessInfoRequest"),
  getUserSecretByLabel: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.GetUserSecretByLabelRequest,
    Kaggle.Sdk.UserSecrets.Models.GetUserSecretResponse
  >("GetUserSecretByLabelRequest"),
  getUserSecretByProvider: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.GetUserSecretByProviderRequest,
    Kaggle.Sdk.UserSecrets.Models.GetUserSecretResponse
  >("GetUserSecretByProviderRequest"),
  listKernelSecretsMetadata: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.ListKernelSecretsMetadataRequest,
    (Kaggle.Sdk.UserSecrets.Models.UserSecretKernelAttachmentMetadata)[]
  >("ListKernelSecretsMetadataRequest"),
  listKernelsWithSecret: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.ListKernelsWithSecretRequest,
    (/*Int32*/ number)[]
  >("ListKernelsWithSecretRequest"),
  listParentKernelSecretsMetadata: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.ListParentKernelSecretsMetadataRequest,
    (Kaggle.Sdk.UserSecrets.Models.UserSecretKernelAttachmentMetadata)[]
  >("ListParentKernelSecretsMetadataRequest"),
  listUserSecretsMetadata: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.ListUserSecretsMetadataRequest,
    (Kaggle.Sdk.UserSecrets.Models.UserSecretMetadata)[]
  >("ListUserSecretsMetadataRequest"),
  upsertCustomUserSecret: createRequestClient<
    Kaggle.Sdk.UserSecrets.Requests.UpsertCustomUserSecretRequest,
    Kaggle.Sdk.UserSecrets.Models.UserSecretMetadata
  >("UpsertCustomUserSecretRequest"),
};
/** Users client fetch bindings. */
export const usersClient = {
  acceptCookies: createRequestClient<
    Kaggle.Sdk.Users.Requests.AcceptCookiesRequest,
    void
  >("AcceptCookiesRequest"),
  activateAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.ActivateAccountRequest,
    void
  >("ActivateAccountRequest"),
  canSeeFeature: createRequestClient<
    Kaggle.Sdk.Users.Requests.CanSeeFeatureRequest,
    boolean
  >("CanSeeFeatureRequest"),
  cheatBlockAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.CheatBlockAccountRequest,
    void
  >("CheatBlockAccountRequest"),
  createKaggleAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.CreateKaggleAccountRequest,
    void
  >("CreateKaggleAccountRequest"),
  deleteOrganizationMemberships: createRequestClient<
    Kaggle.Sdk.Users.Requests.DeleteOrganizationMembershipsRequest,
    void
  >("DeleteOrganizationMembershipsRequest"),
  deleteOrganization: createRequestClient<
    Kaggle.Sdk.Users.Requests.DeleteOrganizationRequest,
    void
  >("DeleteOrganizationRequest"),
  deletePhoneVerifications: createRequestClient<
    Kaggle.Sdk.Users.Requests.DeletePhoneVerificationsRequest,
    void
  >("DeletePhoneVerificationsRequest"),
  deleteUserContentBlobs: createRequestClient<
    Kaggle.Sdk.Users.Requests.DeleteUserContentBlobsRequest,
    void
  >("DeleteUserContentBlobsRequest"),
  deleteUserLogins: createRequestClient<
    Kaggle.Sdk.Users.Requests.DeleteUserLoginsRequest,
    void
  >("DeleteUserLoginsRequest"),
  failNerdcha: createRequestClient<
    Kaggle.Sdk.Users.Requests.FailNerdchaRequest,
    void
  >("FailNerdchaRequest"),
  getCurrentUserClaims: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetCurrentUserClaimsRequest,
    Record<string, string>
  >("GetCurrentUserClaimsRequest"),
  getCurrentUserId: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetCurrentUserIdRequest,
    /*Int32*/ number
  >("GetCurrentUserIdRequest"),
  getCurrentUser: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetCurrentUserRequest,
    Kaggle.Sdk.Users.Models.User
  >("GetCurrentUserRequest"),
  getDuplicateUsers: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetDuplicateUsersRequest,
    (Kaggle.Sdk.Users.Models.User)[]
  >("GetDuplicateUsersRequest"),
  getMyAttributes: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetMyAttributesRequest,
    (string)[]
  >("GetMyAttributesRequest"),
  getNewPassword: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetNewPasswordRequest,
    string
  >("GetNewPasswordRequest"),
  getUserCount: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetUserCountRequest,
    /*Int32*/ number
  >("GetUserCountRequest"),
  getUser: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetUserRequest,
    Kaggle.Sdk.Users.Models.User
  >("GetUserRequest"),
  getUserStatusLogs: createRequestClient<
    Kaggle.Sdk.Users.Requests.GetUserStatusLogsRequest,
    (Kaggle.Sdk.Users.Models.UserStatusLog)[]
  >("GetUserStatusLogsRequest"),
  grantSiteAdmin: createRequestClient<
    Kaggle.Sdk.Users.Requests.GrantSiteAdminRequest,
    void
  >("GrantSiteAdminRequest"),
  hardDeleteAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.HardDeleteAccountRequest,
    void
  >("HardDeleteAccountRequest"),
  kernelAbuseBlockAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.KernelAbuseBlockAccountRequest,
    void
  >("KernelAbuseBlockAccountRequest"),
  kernelAbuseMassBlockAccounts: createRequestClient<
    Kaggle.Sdk.Users.Requests.KernelAbuseMassBlockAccountsRequest,
    Kaggle.Sdk.Users.Models.KernelAbuseMassBlockAccountsResponse
  >("KernelAbuseMassBlockAccountsRequest"),
  lockOutAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.LockOutAccountRequest,
    void
  >("LockOutAccountRequest"),
  migrateTermsAcceptances: createRequestClient<
    Kaggle.Sdk.Users.Requests.MigrateTermsAcceptancesRequest,
    /*Int32*/ number
  >("MigrateTermsAcceptancesRequest"),
  resendVerificationEmail: createRequestClient<
    Kaggle.Sdk.Users.Requests.ResendVerificationEmailRequest,
    Kaggle.Sdk.Users.Responses.ResendVerificationEmailResponse
  >("ResendVerificationEmailRequest"),
  resetPassword: createRequestClient<
    Kaggle.Sdk.Users.Requests.ResetPasswordRequest,
    Kaggle.Sdk.Users.Responses.ResetPasswordResponse
  >("ResetPasswordRequest"),
  revokeSiteAdmin: createRequestClient<
    Kaggle.Sdk.Users.Requests.RevokeSiteAdminRequest,
    void
  >("RevokeSiteAdminRequest"),
  searchPlaces: createRequestClient<
    Kaggle.Sdk.Users.Requests.SearchPlacesRequest,
    (Kaggle.Sdk.Users.Models.Place)[]
  >("SearchPlacesRequest"),
  searchUsersSuggestions: createRequestClient<
    Kaggle.Sdk.Users.Requests.SearchUsersSuggestionsRequest,
    (Kaggle.Sdk.Users.Models.UserSuggestion)[]
  >("SearchUsersSuggestionsRequest"),
  setMyAttributes: createRequestClient<
    Kaggle.Sdk.Users.Requests.SetMyAttributesRequest,
    void
  >("SetMyAttributesRequest"),
  softDeleteAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.SoftDeleteAccountRequest,
    Kaggle.Sdk.Users.Responses.SoftDeleteAccountResponse
  >("SoftDeleteAccountRequest"),
  spamBlockAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.SpamBlockAccountRequest,
    void
  >("SpamBlockAccountRequest"),
  spamBlockMultipleAccount: createRequestClient<
    Kaggle.Sdk.Users.Requests.SpamBlockMultipleAccountRequest,
    Kaggle.Sdk.Users.Responses.SpamBlockMultipleAccountResponse
  >("SpamBlockMultipleAccountRequest"),
  startMigrateSso: createRequestClient<
    Kaggle.Sdk.Users.Requests.StartMigrateSsoRequest,
    Kaggle.Sdk.Users.Responses.StartMigrateSsoResponse
  >("StartMigrateSsoRequest"),
  startResetPassword: createRequestClient<
    Kaggle.Sdk.Users.Requests.StartResetPasswordRequest,
    Kaggle.Sdk.Users.Responses.StartResetPasswordResponse
  >("StartResetPasswordRequest"),
  unsubscribeNewsletter: createRequestClient<
    Kaggle.Sdk.Users.Requests.UnsubscribeNewsletterRequest,
    void
  >("UnsubscribeNewsletterRequest"),
  unverifyPhone: createRequestClient<
    Kaggle.Sdk.Users.Requests.UnverifyPhoneRequest,
    void
  >("UnverifyPhoneRequest"),
  validateResetPasswordCode: createRequestClient<
    Kaggle.Sdk.Users.Requests.ValidateResetPasswordCodeRequest,
    | "invalidCode"
    | "noSuchUser"
    | "success"
    | "successUserHasGoogleLogin"
    | "userBlocked"
  >("ValidateResetPasswordCodeRequest"),
  verifyPassword: createRequestClient<
    Kaggle.Sdk.Users.Requests.VerifyPasswordRequest,
    Kaggle.Sdk.Users.Responses.VerifyPasswordResponse
  >("VerifyPasswordRequest"),
  verifyPhone: createRequestClient<
    Kaggle.Sdk.Users.Requests.VerifyPhoneRequest,
    void
  >("VerifyPhoneRequest"),
  progressionService: {
    // Gets the progression tiers and current rankings for the current user
    getCurrentUserProgression: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetCurrentUserProgressionRequest,
      Kaggle.Sdk.Users.Protos.GetCurrentUserProgressionResponse
    >("ProgressionService/GetCurrentUserProgression"),
    getUserRankings: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserRankingsRequest,
      Kaggle.Sdk.Users.Protos.UserRankings
    >("ProgressionService/GetUserRankings"),
  },
  profileService: {
    // Updates a user bio, which is a short message about the user.
    updateBio: createRequestClient<
      Kaggle.Sdk.Users.Protos.UpdateBioRequest,
      Kaggle.Sdk.Users.Protos.UpdateBioResponse
    >("ProfileService/UpdateBio"),
    // Updates various personal information/links about a user
    updateProfile: createRequestClient<
      Kaggle.Sdk.Users.Protos.UpdateProfileRequest,
      Kaggle.Sdk.Users.Protos.UpdateProfileResponse
    >("ProfileService/UpdateProfile"),
    // Fetches information used for populating the profile preview feature.
    getProfilePreview: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetProfilePreviewRequest,
      Kaggle.Sdk.Users.Protos.GetProfilePreviewResponse
    >("ProfileService/GetProfilePreview"),
    // Gets all organizations a user is a member of (paginated)
    getUserOrganizations: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserOrganizationsRequest,
      Kaggle.Sdk.Users.Protos.GetUserOrganizationsResponse
    >("ProfileService/GetUserOrganizations"),
    // Get information about whether the current user can use the contact user feature
    getContactUserInfo: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetContactUserInfoRequest,
      Kaggle.Sdk.Users.Protos.GetContactUserInfoResponse
    >("ProfileService/GetContactUserInfo"),
    // Returns activity information for each day to populate a user's activity graph
    getUserActivity: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserActivityRequest,
      Kaggle.Sdk.Users.Protos.GetUserActivityResponse
    >("ProfileService/GetUserActivity"),
    // Fetch discussion messages to display on a user's profile on the discussions tab
    getUserDiscussionMessages: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserDiscussionMessagesRequest,
      Kaggle.Sdk.Users.Protos.GetUserDiscussionMessagesResponse
    >("ProfileService/GetUserDiscussionMessages"),
    // Returns total counts of different user discussions engagement, e.g. created topics, replies, etc.
    getUserDiscussionCounts: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserDiscussionCountsRequest,
      Kaggle.Sdk.Users.Protos.DiscussionCounts
    >("ProfileService/GetUserDiscussionCounts"),
  },
  bookmarkService: {
    // Create bookmark of a given type from an entity ID for the current user
    createBookmark: createRequestClient<
      Kaggle.Sdk.Users.Protos.CreateBookmarkRequest,
      Kaggle.Sdk.Users.Protos.CreateBookmarkResponse
    >("BookmarkService/CreateBookmark"),
    // Delete bookmark using bookmark_id, referring to the Bookmark entity for current user
    deleteBookmark: createRequestClient<
      Kaggle.Sdk.Users.Protos.DeleteBookmarkRequest,
      Kaggle.Sdk.Users.Protos.DeleteBookmarkResponse
    >("BookmarkService/DeleteBookmark"),
    // Create bookmark entities of a given type from the current user's historical Favorites
    convertLegacyFavorites: createRequestClient<
      Kaggle.Sdk.Users.Protos.ConvertLegacyFavoritesRequest,
      Kaggle.Sdk.Users.Protos.ConvertLegacyFavoritesResponse
    >("BookmarkService/ConvertLegacyFavorites"),
    // Create bookmark entities of a given type from the current user's historical Favorites
    getBookmarkMigrationStatus: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetBookmarkMigrationStatusRequest,
      Kaggle.Sdk.Users.Protos.GetBookmarkMigrationStatusResponse
    >("BookmarkService/GetBookmarkMigrationStatus"),
  },
  planService: {
    // Get the current billing plan of a user (free / Kaggle Pro)
    getUserPlan: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserPlanRequest,
      Kaggle.Sdk.Users.Protos.GetUserPlanResponse
    >("PlanService/GetUserPlan"),
    // Update the current billing plan of a user (free / Kaggle Pro)
    updateUserPlan: createRequestClient<
      Kaggle.Sdk.Users.Protos.UpdateUserPlanRequest,
      Kaggle.Sdk.Users.Protos.UpdateUserPlanResponse
    >("PlanService/UpdateUserPlan"),
    // Get the history of user plans for a given user Id (or admins only).
    getUserPlanLog: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserPlanLogRequest,
      Kaggle.Sdk.Users.Protos.GetUserPlanLogResponse
    >("PlanService/GetUserPlanLog"),
    // Activate an account for Cloud Marketplace (user confirms link).
    activateMarketplaceUser: createRequestClient<
      Kaggle.Sdk.Users.Protos.ActivateMarketplaceUserRequest,
      Kaggle.Sdk.Users.Protos.ActivateMarketplaceUserResponse
    >("PlanService/ActivateMarketplaceUser"),
    // Cancel an account activation for Cloud Marketplace (user cancels linking in progress).
    cancelMarketplaceActivation: createRequestClient<
      Kaggle.Sdk.Users.Protos.CancelMarketplaceActivationRequest,
      Kaggle.Sdk.Users.Protos.CancelMarketplaceActivationResponse
    >("PlanService/CancelMarketplaceActivation"),
    // Before users are about to quit (on marketplace), allow them to give a reason why
    setCancelPlanReason: createRequestClient<
      Kaggle.Sdk.Users.Protos.SetCancelPlanReasonRequest,
      Kaggle.Sdk.Users.Protos.SetCancelPlanReasonResponse
    >("PlanService/SetCancelPlanReason"),
  },
  nerdchaService: {
    getNerdChallenge: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetNerdChallengeRequest,
      Kaggle.Sdk.Users.Protos.GetNerdChallengeResponse
    >("NerdchaService/GetNerdChallenge"),
    verifyNerdChallengeAnswer: createRequestClient<
      Kaggle.Sdk.Users.Protos.VerifyNerdChallengeAnswerRequest,
      Kaggle.Sdk.Users.Protos.VerifyNerdChallengeAnswerResponse
    >("NerdchaService/VerifyNerdChallengeAnswer"),
  },
  captchaService: {
    getCaptchaConfig: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetCaptchaConfigRequest,
      Kaggle.Sdk.Users.Protos.GetCaptchaConfigResponse
    >("CaptchaService/GetCaptchaConfig"),
    verifyCaptcha: createRequestClient<
      Kaggle.Sdk.Users.Protos.VerifyCaptchaRequest,
      Kaggle.Sdk.Users.Protos.VerifyCaptchaResponse
    >("CaptchaService/VerifyCaptcha"),
  },
  accountService: {
    // Attempt to verify an account from an emailed verification code
    verifyAccountEmail: createRequestClient<
      Kaggle.Sdk.Users.Protos.VerifyAccountEmailRequest,
      Kaggle.Sdk.Users.Protos.VerifyAccountEmailResponse
    >("AccountService/VerifyAccountEmail"),
    // Registers the user via email
    newEmailRegistrationUser: createRequestClient<
      Kaggle.Sdk.Users.Protos.NewEmailRegistrationUserRequest,
      Kaggle.Sdk.Users.Protos.NewEmailRegistrationUserResponse
    >("AccountService/NewEmailRegistrationUser"),
    // Validates registration values and returns any applicable errors
    registrationValidation: createRequestClient<
      Kaggle.Sdk.Users.Protos.RegistrationValidationRequest,
      Kaggle.Sdk.Users.Protos.RegistrationValidationResponse
    >("AccountService/RegistrationValidation"),
    // Creates and sends a phone verification code to the provided number
    createPhoneVerificationCode: createRequestClient<
      Kaggle.Sdk.Users.Protos.CreatePhoneVerificationCodeRequest,
      Kaggle.Sdk.Users.Protos.CreatePhoneVerificationCodeResponse
    >("AccountService/CreatePhoneVerificationCode"),
    // Verifies that the provided code matches the code for the current user
    verifyPhoneVerificationCode: createRequestClient<
      Kaggle.Sdk.Users.Protos.VerifyPhoneVerificationCodeRequest,
      Kaggle.Sdk.Users.Protos.VerifyPhoneVerificationCodeResponse
    >("AccountService/VerifyPhoneVerificationCode"),
    contactSupport: createRequestClient<
      Kaggle.Sdk.Users.Protos.ContactSupportRequest,
      google.protobuf.Empty
    >("AccountService/ContactSupport"),
    generateApiToken: createRequestClient<
      Kaggle.Sdk.Users.Protos.GenerateApiTokenRequest,
      Kaggle.Sdk.Users.Protos.GenerateApiTokenResponse
    >("AccountService/GenerateApiToken"),
    expireApiTokens: createRequestClient<
      Kaggle.Sdk.Users.Protos.ExpireApiTokensRequest,
      google.protobuf.Empty
    >("AccountService/ExpireApiTokens"),
  },
  hatsService: {
    getUserHatsStatus: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetUserHatsStatusRequest,
      Kaggle.Sdk.Users.Protos.GetUserHatsStatusResponse
    >("HatsService/GetUserHatsStatus"),
    dismissHats: createRequestClient<
      Kaggle.Sdk.Users.Protos.DismissHatsRequest,
      Kaggle.Sdk.Users.Protos.DismissHatsResponse
    >("HatsService/DismissHats"),
    dismissSurvey: createRequestClient<
      Kaggle.Sdk.Users.Protos.DismissSurveyRequest,
      Kaggle.Sdk.Users.Protos.DismissSurveyResponse
    >("HatsService/DismissSurvey"),
  },
  legacyOrganizationsService: {
    // Fetches organizations for the current user
    getOrganizations: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetOrganizationsRequest,
      Kaggle.Sdk.Users.Protos.GetOrganizationsResponse
    >("LegacyOrganizationsService/GetOrganizations"),
  },
  usersService: {
    // Current user follows the requested user by username
    followUser: createRequestClient<
      Kaggle.Sdk.Users.Protos.FollowUserRequest,
      Kaggle.Sdk.Users.Protos.FollowUserResponse
    >("UsersService/FollowUser"),
    // Current user unfollows the requested user by username
    unfollowUser: createRequestClient<
      Kaggle.Sdk.Users.Protos.UnfollowUserRequest,
      Kaggle.Sdk.Users.Protos.UnfollowUserResponse
    >("UsersService/UnfollowUser"),
  },
  // Service for nudges (pop-up dismissible prompts to the user)
  // Currently only used for Employer/Organization Info nudges, but extensible to others
  nudgeService: {
    // Check if a user has any available nudges to show
    checkForNudge: createRequestClient<
      Kaggle.Sdk.Users.Protos.CheckForNudgeRequest,
      Kaggle.Sdk.Users.Protos.CheckForNudgeResponse
    >("NudgeService/CheckForNudge"),
    // Log what a user did with the nudge (ie did they ignore? accept?)
    reactToNudge: createRequestClient<
      Kaggle.Sdk.Users.Protos.ReactToNudgeRequest,
      Kaggle.Sdk.Users.Protos.ReactToNudgeResponse
    >("NudgeService/ReactToNudge"),
    // Report that a user is seeing a particular nudge
    // This should only be called once by the frontend for a particular user/nudge pair
    showingNudge: createRequestClient<
      Kaggle.Sdk.Users.Protos.ShowingNudgeRequest,
      Kaggle.Sdk.Users.Protos.ShowingNudgeResponse
    >("NudgeService/ShowingNudge"),
  },
  recentlyViewedService: {
    getRecentlyViewedItems: createRequestClient<
      Kaggle.Sdk.Users.Protos.GetRecentlyViewedItemsRequest,
      Kaggle.Sdk.Users.Protos.GetRecentlyViewedItemsResponse
    >("RecentlyViewedService/GetRecentlyViewedItems"),
    deleteRecentlyViewedItems: createRequestClient<
      Kaggle.Sdk.Users.Protos.DeleteRecentlyViewedItemsRequest,
      Kaggle.Sdk.Users.Protos.DeleteRecentlyViewedItemsResponse
    >("RecentlyViewedService/DeleteRecentlyViewedItems"),
  },
};
export namespace google {
  export namespace protobuf {
    export interface Any {
      typeUrl: string;
      value: any;
    }

    export interface BoolValue {
      value: boolean;
    }

    export interface DoubleValue {
      value: number;
    }

    export interface Empty {}

    export interface FieldMask {
      paths: string[];
    }

    export interface Int32Value {
      value: number;
    }

    export interface Int64Value {
      value: number;
    }

    export interface StringValue {
      value: string;
    }

    export interface Timestamp {
      seconds: number;
      nanos: number;
    }
  }

  export namespace rpc {
    export namespace ErrorResponse {
      // This message has the same semantics as `google.rpc.Status`. It has an extra
      // field `status` for backward compatibility with Google API Client Library.
      export interface Status {
        // This corresponds to `google.rpc.Status.code`.
        code: number;
        // This corresponds to `google.rpc.Status.message`.
        message: string;
        // This is the enum version for `google.rpc.Status.code`.
        status: google.rpc.Code;
        // This corresponds to `google.rpc.Status.details`.
        details: google.protobuf.Any[];
      }
    }

    // The error schema for Google REST APIs. NOTE: this schema is not used for
    // other wire protocols.
    export interface ErrorResponse {
      // The actual error payload. The nested message structure is for backward
      // compatibility with Google API client libraries. It also makes the error
      // more readable to developers.
      error: google.rpc.ErrorResponse.Status | null;
    }

    // The canonical error codes for Google APIs.
    //
    //
    // Sometimes multiple error codes may apply.  Services should return
    // the most specific error code that applies.  For example, prefer
    // `OUT_OF_RANGE` over `FAILED_PRECONDITION` if both codes apply.
    // Similarly prefer `NOT_FOUND` or `ALREADY_EXISTS` over `FAILED_PRECONDITION`.
    export enum Code {
      // Not an error; returned on success
      //
      // HTTP Mapping: 200 OK
      OK = "ok", // = 0
      // The operation was cancelled, typically by the caller.
      //
      // HTTP Mapping: 499 Client Closed Request
      CANCELLED = "cancelled", // = 1
      // Unknown error.  For example, this error may be returned when
      // a `Status` value received from another address space belongs to
      // an error space that is not known in this address space.  Also
      // errors raised by APIs that do not return enough error information
      // may be converted to this error.
      //
      // HTTP Mapping: 500 Internal Server Error
      UNKNOWN = "unknown", // = 2
      // The client specified an invalid argument.  Note that this differs
      // from `FAILED_PRECONDITION`.  `INVALID_ARGUMENT` indicates arguments
      // that are problematic regardless of the state of the system
      // (e.g., a malformed file name).
      //
      // HTTP Mapping: 400 Bad Request
      INVALID_ARGUMENT = "invalidArgument", // = 3
      // The deadline expired before the operation could complete. For operations
      // that change the state of the system, this error may be returned
      // even if the operation has completed successfully.  For example, a
      // successful response from a server could have been delayed long
      // enough for the deadline to expire.
      //
      // HTTP Mapping: 504 Gateway Timeout
      DEADLINE_EXCEEDED = "deadlineExceeded", // = 4
      // Some requested entity (e.g., file or directory) was not found.
      //
      // Note to server developers: if a request is denied for an entire class
      // of users, such as gradual feature rollout or undocumented allowlist,
      // `NOT_FOUND` may be used. If a request is denied for some users within
      // a class of users, such as user-based access control, `PERMISSION_DENIED`
      // must be used.
      //
      // HTTP Mapping: 404 Not Found
      NOT_FOUND = "notFound", // = 5
      // The entity that a client attempted to create (e.g., file or directory)
      // already exists.
      //
      // HTTP Mapping: 409 Conflict
      ALREADY_EXISTS = "alreadyExists", // = 6
      // The caller does not have permission to execute the specified
      // operation. `PERMISSION_DENIED` must not be used for rejections
      // caused by exhausting some resource (use `RESOURCE_EXHAUSTED`
      // instead for those errors). `PERMISSION_DENIED` must not be
      // used if the caller can not be identified (use `UNAUTHENTICATED`
      // instead for those errors). This error code does not imply the
      // request is valid or the requested entity exists or satisfies
      // other pre-conditions.
      //
      // HTTP Mapping: 403 Forbidden
      PERMISSION_DENIED = "permissionDenied", // = 7
      // The request does not have valid authentication credentials for the
      // operation.
      //
      // HTTP Mapping: 401 Unauthorized
      UNAUTHENTICATED = "unauthenticated", // = 16
      // Some resource has been exhausted, perhaps a per-user quota, or
      // perhaps the entire file system is out of space.
      //
      // HTTP Mapping: 429 Too Many Requests
      RESOURCE_EXHAUSTED = "resourceExhausted", // = 8
      // The operation was rejected because the system is not in a state
      // required for the operation's execution.  For example, the directory
      // to be deleted is non-empty, an rmdir operation is applied to
      // a non-directory, etc.
      //
      // Service implementors can use the following guidelines to decide
      // between `FAILED_PRECONDITION`, `ABORTED`, and `UNAVAILABLE`:
      //  (a) Use `UNAVAILABLE` if the client can retry just the failing call.
      //  (b) Use `ABORTED` if the client should retry at a higher level
      //      (e.g., when a client-specified test-and-set fails, indicating the
      //      client should restart a read-modify-write sequence).
      //  (c) Use `FAILED_PRECONDITION` if the client should not retry until
      //      the system state has been explicitly fixed.  E.g., if an "rmdir"
      //      fails because the directory is non-empty, `FAILED_PRECONDITION`
      //      should be returned since the client should not retry unless
      //      the files are deleted from the directory.
      //
      // HTTP Mapping: 400 Bad Request
      FAILED_PRECONDITION = "failedPrecondition", // = 9
      // The operation was aborted, typically due to a concurrency issue such as
      // a sequencer check failure or transaction abort.
      //
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      //
      // HTTP Mapping: 409 Conflict
      ABORTED = "aborted", // = 10
      // The operation was attempted past the valid range.  E.g., seeking or
      // reading past end-of-file.
      //
      // Unlike `INVALID_ARGUMENT`, this error indicates a problem that may
      // be fixed if the system state changes. For example, a 32-bit file
      // system will generate `INVALID_ARGUMENT` if asked to read at an
      // offset that is not in the range [0,2^32-1], but it will generate
      // `OUT_OF_RANGE` if asked to read from an offset past the current
      // file size.
      //
      // There is a fair bit of overlap between `FAILED_PRECONDITION` and
      // `OUT_OF_RANGE`.  We recommend using `OUT_OF_RANGE` (the more specific
      // error) when it applies so that callers who are iterating through
      // a space can easily look for an `OUT_OF_RANGE` error to detect when
      // they are done.
      //
      // HTTP Mapping: 400 Bad Request
      OUT_OF_RANGE = "outOfRange", // = 11
      // The operation is not implemented or is not supported/enabled in this
      // service.
      //
      // HTTP Mapping: 501 Not Implemented
      UNIMPLEMENTED = "unimplemented", // = 12
      // Internal errors.  This means that some invariants expected by the
      // underlying system have been broken.  This error code is reserved
      // for serious errors.
      //
      // HTTP Mapping: 500 Internal Server Error
      INTERNAL = "internal", // = 13
      // The service is currently unavailable.  This is most likely a
      // transient condition, which can be corrected by retrying with
      // a backoff.
      //
      // See the guidelines above for deciding between `FAILED_PRECONDITION`,
      // `ABORTED`, and `UNAVAILABLE`.
      //
      // HTTP Mapping: 503 Service Unavailable
      UNAVAILABLE = "unavailable", // = 14
      // Unrecoverable data loss or corruption.
      //
      // HTTP Mapping: 500 Internal Server Error
      DATA_LOSS = "dataLoss", // = 15
    }
  }
}
export const discussionsClient = {
  discussionsService: {
    // Creates a comment on a kernel and returns the newly created message ID.
    createKernelMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.CreateKernelMessageRequest,
      Kaggle.Sdk.Discussions.Protos.CreateKernelMessageResponse
    >("DiscussionsService/CreateKernelMessage"),
    // Creates a reply to a message and returns the newly created message ID.
    createReply: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.CreateReplyRequest,
      Kaggle.Sdk.Discussions.Protos.CreateReplyResponse
    >("DiscussionsService/CreateReply"),
    // Creates a topic on a forum and returns the newly created topic ID and message ID.
    createTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.CreateTopicRequest,
      Kaggle.Sdk.Discussions.Protos.CreateTopicResponse
    >("DiscussionsService/CreateTopic"),
    getForum: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetForumRequest,
      Kaggle.Sdk.Discussions.Protos.GetForumResponse
    >("DiscussionsService/GetForum"),
    // Updates a message's content.
    updateMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateMessageRequest,
      Kaggle.Sdk.Discussions.Protos.UpdateMessageResponse
    >("DiscussionsService/UpdateMessage"),
    // Updates a topic's name and message content.
    updateTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateTopicRequest,
      Kaggle.Sdk.Discussions.Protos.UpdateTopicResponse
    >("DiscussionsService/UpdateTopic"),
    // Creates a token & URL for use to upload a discussions attachment to blob storage.
    createAttachment: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.CreateAttachmentRequest,
      Kaggle.Sdk.Discussions.Protos.CreateAttachmentResponse
    >("DiscussionsService/CreateAttachment"),
    // Deletes an attachment from a discussion post and blob storage.
    deleteAttachment: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.DeleteAttachmentRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteAttachment"),
    deleteMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.DeleteMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteMessage"),
    deleteTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.DeleteTopicRequest,
      google.protobuf.Empty
    >("DiscussionsService/DeleteTopic"),
    getSiteForums: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetSiteForumsRequest,
      Kaggle.Sdk.Discussions.Protos.GetSiteForumsResponse
    >("DiscussionsService/GetSiteForums"),
    getTopicListByCategoryId: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetTopicListByCategoryIdRequest,
      Kaggle.Sdk.Discussions.Protos.GetTopicListResponse
    >("DiscussionsService/GetTopicListByCategoryId"),
    getTopicListByForumId: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetTopicListByForumIdRequest,
      Kaggle.Sdk.Discussions.Protos.GetTopicListResponse
    >("DiscussionsService/GetTopicListByForumId"),
    toggleFlagMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.ToggleFlagMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/ToggleFlagMessage"),
    toggleSpamMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.ToggleSpamMessageRequest,
      Kaggle.Sdk.Discussions.Protos.ToggleSpamMessageResponse
    >("DiscussionsService/ToggleSpamMessage"),
    unsubscribeWatches: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UnsubscribeWatchesRequest,
      google.protobuf.Empty
    >("DiscussionsService/UnsubscribeWatches"),
    updateForumSettings: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateForumSettingsRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateForumSettings"),
    updateForumTopicSettings: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateForumTopicSettingsRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateForumTopicSettings"),
    pinForumMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.PinForumMessageRequest,
      google.protobuf.Empty
    >("DiscussionsService/PinForumMessage"),
    voteOnForumMessage: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.VoteOnForumMessageRequest,
      Kaggle.Sdk.Discussions.Protos.VoteOnForumMessageResponse
    >("DiscussionsService/VoteOnForumMessage"),
    getForumMessagesInTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetForumMessagesInTopicRequest,
      Kaggle.Sdk.Discussions.Protos.GetForumMessagesInTopicResponse
    >("DiscussionsService/GetForumMessagesInTopic"),
    updateFeedbackTrackingData: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateFeedbackTrackingDataRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateFeedbackTrackingData"),
    updateManyFeedbackTrackingData: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.UpdateManyFeedbackTrackingDataRequest,
      google.protobuf.Empty
    >("DiscussionsService/UpdateManyFeedbackTrackingData"),
    getForumTopicById: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetForumTopicByIdRequest,
      Kaggle.Sdk.Discussions.Protos.GetForumTopicByIdResponse
    >("DiscussionsService/GetForumTopicById"),
  },
  issuesService: {
    // Star a forum topic on the product feedback forum
    adminStarForumTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.AdminStarForumTopicRequest,
      Kaggle.Sdk.Discussions.Protos.AdminStarForumTopicResponse
    >("IssuesService/AdminStarForumTopic"),
    // Star many forum topics on the product feedback forum
    adminStarForumTopics: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.AdminStarForumTopicsRequest,
      Kaggle.Sdk.Discussions.Protos.AdminStarForumTopicsResponse
    >("IssuesService/AdminStarForumTopics"),
    // Unstar a forum topic on the product feedback forum
    adminUnstarForumTopic: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.AdminUnstarForumTopicRequest,
      Kaggle.Sdk.Discussions.Protos.AdminUnstarForumTopicResponse
    >("IssuesService/AdminUnstarForumTopic"),
    // Unstar many forum topics on the product feedback forum
    adminUnstarForumTopics: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.AdminUnstarForumTopicsRequest,
      Kaggle.Sdk.Discussions.Protos.AdminUnstarForumTopicsResponse
    >("IssuesService/AdminUnstarForumTopics"),
    // Create a custom group of forum topics on the product feedback forum
    createAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.CreateAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.Protos.CreateAdminForumTopicGroupingResponse
    >("IssuesService/CreateAdminForumTopicGrouping"),
    // Delete a previously created custom forum topic group
    deleteAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.DeleteAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.Protos.DeleteAdminForumTopicGroupingResponse
    >("IssuesService/DeleteAdminForumTopicGrouping"),
    // Add to a previously created custom forum topic group
    addToAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.AddToAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.Protos.AddToAdminForumTopicGroupingResponse
    >("IssuesService/AddToAdminForumTopicGrouping"),
    // Remove from a previously created custom forum topic group
    removeFromAdminForumTopicGrouping: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.RemoveFromAdminForumTopicGroupingRequest,
      Kaggle.Sdk.Discussions.Protos.RemoveFromAdminForumTopicGroupingResponse
    >("IssuesService/RemoveFromAdminForumTopicGrouping"),
    // Return all forum topic groupings owned by the current user
    getAdminForumTopicGroupingsForCurrentUser: createRequestClient<
      Kaggle.Sdk.Discussions.Protos.GetAdminForumTopicGroupingsForCurrentUserRequest,
      Kaggle.Sdk.Discussions.Protos.GetAdminForumTopicGroupingsForCurrentUserResponse
    >("IssuesService/GetAdminForumTopicGroupingsForCurrentUser"),
  },
};
export const cmsClient = {
  // CMS = Content Management System
  legacyCmsService: {
    // Lists all of the documentation pages (used by the outline sidebar).
    listDocs: createRequestClient<
      Kaggle.Sdk.Cms.Protos.ListDocsRequest,
      Kaggle.Sdk.Cms.Protos.ListDocsResponse
    >("LegacyCmsService/ListDocs"),
    // Lists all pages (documentation and regular CMS pages).
    listPages: createRequestClient<
      Kaggle.Sdk.Cms.Protos.ListPagesRequest,
      Kaggle.Sdk.Cms.Protos.ListPagesResponse
    >("LegacyCmsService/ListPages"),
    // Allows an admin to specify where on the documentation main page a doc
    // page should appear.
    updateDocPageOrder: createRequestClient<
      Kaggle.Sdk.Cms.Protos.UpdateDocPageOrderRequest,
      google.protobuf.Empty
    >("LegacyCmsService/UpdateDocPageOrder"),
    // Updates the metadata and content of a CMS/doc page.
    updatePage: createRequestClient<
      Kaggle.Sdk.Cms.Protos.UpdatePageRequest,
      Kaggle.Sdk.Cms.Protos.UpdatePageResponse
    >("LegacyCmsService/UpdatePage"),
  },
};
export const chimeClient = {
  chimeService: {
    // Used by admins to test an SMS send.
    testSms: createRequestClient<
      Kaggle.Sdk.Chime.Protos.TestSmsRequest,
      Kaggle.Sdk.Chime.Protos.SendSmsResponse
    >("ChimeService/TestSms"),
  },
};
export const activeEventsClient = {
  activeEventService: {
    // DeleteActiveEvent deletes the specified ActiveEvent from firestore under the current user.
    deleteActiveEvent: createRequestClient<
      Kaggle.Sdk.ActiveEvents.Protos.DeleteActiveEventRequest,
      google.protobuf.Empty
    >("ActiveEventService/DeleteActiveEvent"),
    getActiveEventsFirebaseConfig: createRequestClient<
      Kaggle.Sdk.ActiveEvents.Protos.GetActiveEventsFirebaseConfigRequest,
      Kaggle.Sdk.ActiveEvents.Protos.GetActiveEventsFirebaseConfigResponse
    >("ActiveEventService/GetActiveEventsFirebaseConfig"),
  },
};
export const newsfeedClient = {
  newsfeedWebService: {
    getDismissableBanner: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetDismissableBannerRequest,
      Kaggle.Sdk.Newsfeed.Protos.GetDismissableBannerResponse
    >("NewsfeedWebService/GetDismissableBanner"),
    getStories: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetStoriesRequest,
      Kaggle.Sdk.Newsfeed.Protos.GetStoriesResponse
    >("NewsfeedWebService/GetStories"),
    setDismissableBanner: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.SetDismissableBannerRequest,
      google.protobuf.Empty
    >("NewsfeedWebService/SetDismissableBanner"),
    getNewsfeedSidebarContent: createRequestClient<
      Kaggle.Sdk.Newsfeed.Protos.GetNewsfeedSidebarContentRequest,
      Kaggle.Sdk.Newsfeed.Protos.NewsfeedSidebarContent
    >("NewsfeedWebService/GetNewsfeedSidebarContent"),
  },
};
export const adminClient = {
  // File drop/pickup functionality.
  inboxFileService: {
    // Creates (aka "drops") a new file into the inbox.
    createInboxFile: createRequestClient<
      Kaggle.Sdk.Admin.Protos.CreateInboxFileRequest,
      Kaggle.Sdk.Admin.Protos.CreateInboxFileResponse
    >("InboxFileService/CreateInboxFile"),
    // Lists all available inbox files (optionally filtering to just a specific directory)
    listInboxFiles: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ListInboxFilesRequest,
      Kaggle.Sdk.Admin.Protos.ListInboxFilesResponse
    >("InboxFileService/ListInboxFiles"),
    // Deletes an existing inbox file.
    deleteInboxFile: createRequestClient<
      Kaggle.Sdk.Admin.Protos.DeleteInboxFileRequest,
      google.protobuf.Empty
    >("InboxFileService/DeleteInboxFile"),
  },
  organizationsService: {
    // Create a new organization given some seed input
    createOrganization: createRequestClient<
      Kaggle.Sdk.Admin.Protos.CreateOrganizationRequest,
      Kaggle.Sdk.Admin.Protos.CreateOrganizationResponse
    >("OrganizationsService/CreateOrganization"),
  },
  adminService: {
    addSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.Protos.AddSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/AddSiteConfig"),
    deleteSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.Protos.DeleteSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/DeleteSiteConfig"),
    getAdminUser: createRequestClient<
      Kaggle.Sdk.Admin.Protos.GetAdminUserRequest,
      Kaggle.Sdk.Admin.Protos.AdminUser
    >("AdminService/GetAdminUser"),
    getDatabaseSize: createRequestClient<
      Kaggle.Sdk.Admin.Protos.GetDatabaseSizeRequest,
      Kaggle.Sdk.Admin.Protos.GetDatabaseSizeResponse
    >("AdminService/GetDatabaseSize"),
    getLoggingConfig: createRequestClient<
      Kaggle.Sdk.Admin.Protos.GetLoggingConfigRequest,
      Kaggle.Sdk.Admin.Protos.GetLoggingConfigResponse
    >("AdminService/GetLoggingConfig"),
    getSampleRequest: createRequestClient<
      Kaggle.Sdk.Admin.Protos.GetSampleRequestRequest,
      Kaggle.Sdk.Admin.Protos.GetSampleRequestResponse
    >("AdminService/GetSampleRequest"),
    getSiteConfigs: createRequestClient<
      Kaggle.Sdk.Admin.Protos.GetSiteConfigsRequest,
      Kaggle.Sdk.Admin.Protos.GetSiteConfigsResponse
    >("AdminService/GetSiteConfigs"),
    listRequestTypes: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ListRequestTypesRequest,
      Kaggle.Sdk.Admin.Protos.ListRequestTypesResponse
    >("AdminService/ListRequestTypes"),
    resetSearchIndexes: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ResetSearchIndexesRequest,
      google.protobuf.Empty
    >("AdminService/ResetSearchIndexes"),
    resetSearchIndex: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ResetSearchIndexRequest,
      google.protobuf.Empty
    >("AdminService/ResetSearchIndex"),
    updateLoggingConfig: createRequestClient<
      Kaggle.Sdk.Admin.Protos.UpdateLoggingConfigRequest,
      google.protobuf.Empty
    >("AdminService/UpdateLoggingConfig"),
    updateSiteConfig: createRequestClient<
      Kaggle.Sdk.Admin.Protos.UpdateSiteConfigRequest,
      google.protobuf.Empty
    >("AdminService/UpdateSiteConfig"),
  },
  rateLimitService: {
    // Lists rate limit definitions.
    listRateLimits: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ListRateLimitsRequest,
      Kaggle.Sdk.Admin.Protos.ListRateLimitsResponse
    >("RateLimitService/ListRateLimits"),
    // Lists all rate limits statuses (that optionally match filters).
    listRateLimitStatuses: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ListRateLimitStatusesRequest,
      Kaggle.Sdk.Admin.Protos.ListRateLimitStatusesResponse
    >("RateLimitService/ListRateLimitStatuses"),
    // Resets a single rate limit status by its key.
    resetRateLimitStatus: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ResetRateLimitStatusRequest,
      Kaggle.Sdk.Admin.Protos.ResetRateLimitStatusResponse
    >("RateLimitService/ResetRateLimitStatus"),
    // Resets multiple rate limit statuses.
    batchResetRateLimitStatuses: createRequestClient<
      Kaggle.Sdk.Admin.Protos.BatchResetRateLimitStatusesRequest,
      Kaggle.Sdk.Admin.Protos.BatchResetRateLimitStatusesResponse
    >("RateLimitService/BatchResetRateLimitStatuses"),
  },
  // Services related exclusively to the "Genie" admin section.
  genieService: {
    // Create a token that can be used to impersonate another user.
    createDelegatedUserAccessToken: createRequestClient<
      Kaggle.Sdk.Admin.Protos.CreateDelegatedUserAccessTokenRequest,
      Kaggle.Sdk.Admin.Protos.CreateDelegatedUserAccessTokenResponse
    >("GenieService/CreateDelegatedUserAccessToken"),
  },
  // Admin service used for banning IP addresses (i.e. for malicious users).
  ipBanService: {
    // Lists all active IP bans that are being enforced.
    listIpBans: createRequestClient<
      Kaggle.Sdk.Admin.Protos.ListIpBansRequest,
      Kaggle.Sdk.Admin.Protos.ListIpBansResponse
    >("IpBanService/ListIpBans"),
    // Bans a particular IP range.
    createIpBan: createRequestClient<
      Kaggle.Sdk.Admin.Protos.CreateIpBanRequest,
      Kaggle.Sdk.Admin.Protos.IpBan
    >("IpBanService/CreateIpBan"),
    // Unbans an existing IP range.
    deleteIpBan: createRequestClient<
      Kaggle.Sdk.Admin.Protos.DeleteIpBanRequest,
      google.protobuf.Empty
    >("IpBanService/DeleteIpBan"),
    // Test to see if IP address(es) is/are banned.
    testIpBans: createRequestClient<
      Kaggle.Sdk.Admin.Protos.TestIpBansRequest,
      Kaggle.Sdk.Admin.Protos.TestIpBansResponse
    >("IpBanService/TestIpBans"),
  },
  loggingService: {
    // Creates a sample log message (useful for testing log reporters).
    createLogMessage: createRequestClient<
      Kaggle.Sdk.Admin.Protos.CreateLogMessageRequest,
      Kaggle.Sdk.Admin.Protos.CreateLogMessageResponse
    >("LoggingService/CreateLogMessage"),
  },
};
export const educationClient = {
  educationService: {
    addLessonsToTrack: createRequestClient<
      Kaggle.Sdk.Education.Protos.AddLessonsToTrackRequest,
      Kaggle.Sdk.Education.Protos.LearnTrack
    >("EducationService/AddLessonsToTrack"),
    getCertificateUploadUrl: createRequestClient<
      Kaggle.Sdk.Education.Protos.GetCertificateUploadUrlRequest,
      Kaggle.Sdk.Education.Protos.GetCertificateUploadUrlResponse
    >("EducationService/GetCertificateUploadUrl"),
    getExerciseVersions: createRequestClient<
      Kaggle.Sdk.Education.Protos.GetExerciseVersionsRequest,
      Kaggle.Sdk.Education.Protos.GetExerciseVersionsResponse
    >("EducationService/GetExerciseVersions"),
    getTracks: createRequestClient<
      Kaggle.Sdk.Education.Protos.GetTracksRequest,
      Kaggle.Sdk.Education.Protos.GetTracksResponse
    >("EducationService/GetTracks"),
    getTrack: createRequestClient<
      Kaggle.Sdk.Education.Protos.GetTrackRequest,
      Kaggle.Sdk.Education.Protos.LearnTrack
    >("EducationService/GetTrack"),
    reorderTracks: createRequestClient<
      Kaggle.Sdk.Education.Protos.ReorderTracksRequest,
      Kaggle.Sdk.Education.Protos.ReorderTracksResponse
    >("EducationService/ReorderTracks"),
    rescoreExerciseVersion: createRequestClient<
      Kaggle.Sdk.Education.Protos.RescoreExerciseVersionRequest,
      Kaggle.Sdk.Education.Protos.RescoreResponse
    >("EducationService/RescoreExerciseVersion"),
    trackEducation: createRequestClient<
      Kaggle.Sdk.Education.Protos.TrackEducationRequest,
      google.protobuf.Empty
    >("EducationService/TrackEducation"),
    trackExerciseInteraction: createRequestClient<
      Kaggle.Sdk.Education.Protos.TrackExerciseInteractionRequest,
      Kaggle.Sdk.Education.Protos.TrackExerciseInteractionResponse
    >("EducationService/TrackExerciseInteraction"),
    editLesson: createRequestClient<
      Kaggle.Sdk.Education.Protos.EditLessonRequest,
      Kaggle.Sdk.Education.Protos.LearnLesson
    >("EducationService/EditLesson"),
  },
};
export const emailsClient = {
  emailService: {
    sendPrivateDatasetSummaryEmail: createRequestClient<
      Kaggle.Sdk.Emails.Protos.SendPrivateDatasetSummaryEmailRequest,
      Kaggle.Sdk.Emails.Protos.SendEmailResponse
    >("EmailService/SendPrivateDatasetSummaryEmail"),
  },
};
